﻿/**
 * @license AngularJS v1.5.7
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* jshint ignore:start */
var noop        = angular.noop;
var copy        = angular.copy;
var extend      = angular.extend;
var jqLite      = angular.element;
var forEach     = angular.forEach;
var isArray     = angular.isArray;
var isString    = angular.isString;
var isObject    = angular.isObject;
var isUndefined = angular.isUndefined;
var isDefined   = angular.isDefined;
var isFunction  = angular.isFunction;
var isElement   = angular.isElement;

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var ADD_CLASS_SUFFIX = '-add';
var REMOVE_CLASS_SUFFIX = '-remove';
var EVENT_CLASS_PREFIX = 'ng-';
var ACTIVE_CLASS_SUFFIX = '-active';
var PREPARE_CLASS_SUFFIX = '-prepare';

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if (isUndefined(window.ontransitionend) && isDefined(window.onwebkittransitionend)) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if (isUndefined(window.onanimationend) && isDefined(window.onwebkitanimationend)) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var isPromiseLike = function(p) {
  return p && p.then ? true : false;
};

var ngMinErr = angular.$$minErr('ng');
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return element;
        break;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
        break;
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType == ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  }
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationDetails(element, oldAnimation, newAnimation) {
  var target = oldAnimation.options || {};
  var newOptions = newAnimation.options || {};

  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  if (newOptions.preparationClasses) {
    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
    delete newOptions.preparationClasses;
  }

  // noop is basically when there is no callback; otherwise something has been set
  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;

  extend(target, newOptions);

  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
  if (realDomOperation) {
    target.domOperation = realDomOperation;
  }

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  oldAnimation.addClass = target.addClass;
  oldAnimation.removeClass = target.removeClass;

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof angular.element) ? element[0] : element;
}

function applyGeneratedPreparationClasses(element, event, options) {
  var classes = '';
  if (event) {
    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
  }
  if (options.addClass) {
    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
  }
  if (options.removeClass) {
    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
  }
  if (classes.length) {
    options.preparationClasses = classes;
    element.addClass(classes);
  }
}

function clearGeneratedClasses(element, options) {
  if (options.preparationClasses) {
    element.removeClass(options.preparationClasses);
    options.preparationClasses = null;
  }
  if (options.activeClasses) {
    element.removeClass(options.activeClasses);
    options.activeClasses = null;
  }
}

function blockTransitions(node, duration) {
  // we use a negative delay value since it performs blocking
  // yet it doesn't kill any existing transitions running on the
  // same element which makes this safe for class-based animations
  var value = duration ? '-' + duration + 's' : '';
  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
  return [TRANSITION_DELAY_PROP, value];
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function concatWithSpace(a,b) {
  if (!a) return b;
  if (!b) return a;
  return a + ' ' + b;
}

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var queue, cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    queue = queue.concat(tasks);
    nextTick();
  }

  queue = scheduler.queue = [];

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!queue.length) return;

    var items = queue.shift();
    for (var i = 0; i < items.length; i++) {
      items[i]();
    }

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }
}];

/**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimteChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="mainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('mainController', function() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */
var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
  return {
    link: function(scope, element, attrs) {
      var val = attrs.ngAnimateChildren;
      if (angular.isString(val) && val.length === 0) { //empty attribute
        element.data(NG_ANIMATE_CHILDREN_DATA, true);
      } else {
        // Interpolate and set the value, so that it is available to
        // animations that run right after compilation
        setData($interpolate(val)(scope));
        attrs.$observe('ngAnimateChildren', setData);
      }

      function setData(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      }
    }
  };
}];

var ANIMATE_TIMER_KEY = '$$animateCss';

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## Usage
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */
var ONE_SECOND = 1000;
var BASE_TEN = 10;

var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for negative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) == 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

function createLocalCacheLookup() {
  var cache = Object.create(null);
  return {
    flush: function() {
      cache = Object.create(null);
    },

    count: function(key) {
      var entry = cache[key];
      return entry ? entry.total : 0;
    },

    get: function(key) {
      var entry = cache[key];
      return entry && entry.value;
    },

    put: function(key, value) {
      if (!cache[key]) {
        cache[key] = { total: 1, value: value };
      } else {
        cache[key].total++;
      }
    }
  };
}

// we do not reassign an already present style value since
// if we detect the style property value again we may be
// detecting styles that were added via the `from` styles.
// We make use of `isDefined` here since an empty string
// or null value (which is what getPropertyValue will return
// for a non-existing style) will still be marked as a valid
// value for the style (a falsy value implies that the style
// is to be removed at the end of the animation). If we had a simple
// "OR" statement then it would not be enough to catch that.
function registerRestorableStyles(backup, node, properties) {
  forEach(properties, function(prop) {
    backup[prop] = isDefined(backup[prop])
        ? backup[prop]
        : node.style.getPropertyValue(prop);
  });
}

var $AnimateCssProvider = ['$animateProvider', function($animateProvider) {
  var gcsLookup = createLocalCacheLookup();
  var gcsStaggerLookup = createLocalCacheLookup();

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    var parentCounter = 0;
    function gcsHashFn(node, extraClasses) {
      var KEY = "$$ngAnimateParentKey";
      var parentNode = node.parentNode;
      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
    }

    function computeCachedCssStyles(node, className, cacheKey, properties) {
      var timings = gcsLookup.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an internal tally of how many duplicate animations are detected.
      gcsLookup.put(cacheKey, timings);
      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if (gcsLookup.count(cacheKey) > 0) {
        stagger = gcsStaggerLookup.get(cacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          gcsStaggerLookup.put(cacheKey, stagger);
        }
      }

      return stagger || {};
    }

    var cancelLastRAFRequest;
    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        gcsLookup.flush();
        gcsStaggerLookup.flush();

        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
        var pageWidth = $$forceReflow();

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](pageWidth);
        }
        rafWaitQueue.length = 0;
      });
    }

    function computeTimings(node, className, cacheKey) {
      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    return function init(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = prepareAnimationOptions(copy(options));
      }

      var restoreStyles = {};
      var node = getDomNode(element);
      if (!node
          || !node.parentNode
          || !$$animateQueue.enabled()) {
        return closeAndReturnNoopAnimator();
      }

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;
      var startTime;
      var events = [];

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
      }

      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + preparationClasses;
      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

      // there is no way we can trigger an animation if no styles and
      // no classes are being applied which would then trigger a transition,
      // unless there a is raw keyframe value that is applied to the element.
      if (!containsKeyframeAnimation
           && !hasToStyles
           && !preparationClasses) {
        return closeAndReturnNoopAnimator();
      }

      var cacheKey, stagger;
      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        cacheKey = gcsHashFn(node, fullClassName);
        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      if (!options.$$skipPreparationClasses) {
        $$jqLite.addClass(element, preparationClasses);
      }

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : gcsLookup.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst && !options.skipBlocking) {
        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty == 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      if (options.delay != null) {
        var delayStyle;
        if (typeof options.delay !== "boolean") {
          delayStyle = parseFloat(options.delay);
          // number in options.delay means we have to recalculate the delay for the closing timeout
          maxDelay = Math.max(delayStyle, 0);
        }

        if (flags.applyTransitionDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle));
        }

        if (flags.applyAnimationDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
        }
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      if (options.from) {
        if (options.cleanupStyles) {
          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
        }
        applyAnimationFromStyles(element, options);
      }

      if (flags.blockTransition || flags.blockKeyframeAnimation) {
        applyBlocking(maxDuration);
      } else if (!options.skipBlocking) {
        blockTransitions(node, false);
      }

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) { // jshint ignore:line
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        if (!options.$$skipPreparationClasses) {
          $$jqLite.removeClass(element, preparationClasses);
        }
        $$jqLite.removeClass(element, activeClasses);

        blockKeyframeAnimations(node, false);
        blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        if (Object.keys(restoreStyles).length) {
          forEach(restoreStyles, function(value, prop) {
            value ? node.style.setProperty(prop, value)
                  : node.style.removeProperty(prop);
          });
        }

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        if (events && events.length) {
          // Remove the transitionend / animationend listener(s)
          element.off(events.join(' '), onAnimationProgress);
        }

        //Cancel the fallback closing timeout and remove the timer data
        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
        if (animationTimerData) {
          $timeout.cancel(animationTimerData[0].timer);
          element.removeData(ANIMATE_TIMER_KEY);
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        // should flush the cache animation
        waitUntilQuiet(noop);
        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function onAnimationProgress(event) {
        event.stopPropagation();
        var ev = event.originalEvent || event;

        // we now always use `Date.now()` due to the recent changes with
        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
        var timeStamp = ev.$manualTimeStamp || Date.now();

        /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */
        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

        /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */
        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
          // we set this flag to ensure that if the transition is paused then, when resumed,
          // the animation will automatically close itself since transitions cannot be paused.
          animationCompleted = true;
          close();
        }
      }

      function start() {
        if (animationClosed) return;
        if (!node.parentNode) {
          close();
          return;
        }

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              animationPaused
                  ? temporaryStyles.push(value)
                  : removeFromArray(temporaryStyles, value);
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intentional stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.className + ' ' + preparationClasses;
            cacheKey = gcsHashFn(node, fullClassName);

            timings = computeTimings(node, fullClassName, cacheKey);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== "boolean" && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);
            timings.animationDelay = relativeDelay;
            delayStyle = getCssDelayStyle(relativeDelay, true);
            temporaryStyles.push(delayStyle);
            node.style[delayStyle[0]] = delayStyle[1];
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
          var endTime = startTime + timerTime;

          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
          var setupFallbackTimer = true;
          if (animationsData.length) {
            var currentTimerData = animationsData[0];
            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
            if (setupFallbackTimer) {
              $timeout.cancel(currentTimerData.timer);
            } else {
              animationsData.push(close);
            }
          }

          if (setupFallbackTimer) {
            var timer = $timeout(onAnimationExpired, timerTime, false);
            animationsData[0] = {
              timer: timer,
              expectedEndTime: endTime
            };
            animationsData.push(close);
            element.data(ANIMATE_TIMER_KEY, animationsData);
          }

          if (events.length) {
            element.on(events.join(' '), onAnimationProgress);
          }

          if (options.to) {
            if (options.cleanupStyles) {
              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
            }
            applyAnimationToStyles(element, options);
          }
        }

        function onAnimationExpired() {
          var animationsData = element.data(ANIMATE_TIMER_KEY);

          // this will be false in the event that the element was
          // removed from the DOM (via a leave animation or something
          // similar)
          if (animationsData) {
            for (var i = 1; i < animationsData.length; i++) {
              animationsData[i]();
            }
            element.removeData(ANIMATE_TIMER_KEY);
          }
        }
      }
    };
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  function isDocumentFragment(node) {
    return node.parentNode && node.parentNode.nodeType === 11;
  }

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = $document[0].body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
    );

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coords object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from, noop);
      var toAnimation = prepareRegularAnimation(to, noop);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        options.event = animationDetails.event;
        options.structural = true;
        options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        if (animationDetails.event === 'leave') {
          options.onDone = options.domOperation;
        }
      }

      // We assign the preparationClasses as the actual animation event since
      // the internals of $animateCss will just suffix the event token values
      // with `-active` to trigger the animation.
      if (options.preparationClasses) {
        options.event = concatWithSpace(options.event, options.preparationClasses);
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      var animationClosed = false;

      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event == 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      function close() {
        animationClosed = true;
        applyOptions();
        applyAnimationStyles(element, options);
      }

      var runner;

      return {
        $$willAnimate: true,
        end: function() {
          if (runner) {
            runner.end();
          } else {
            close();
            runner = new $$AnimateRunner();
            runner.complete(true);
          }
          return runner;
        },
        start: function() {
          if (runner) {
            return runner;
          }

          runner = new $$AnimateRunner();
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          runner.setHost({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            close(success);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a,b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          runners.length ? $$AnimateRunner.all(runners, callback) : callback();

          return function endFn(reject) {
            forEach(runners, function(runner) {
              reject ? runner.cancel() : runner.end();
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i=0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;
  var ONE_SPACE = ' ';

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function makeTruthyCssClassMap(classString) {
    if (!classString) {
      return null;
    }

    var keys = classString.split(ONE_SPACE);
    var map = Object.create(null);

    forEach(keys, function(key) {
      map[key] = true;
    });
    return map;
  }

  function hasMatchingClasses(newClassString, currentClassString) {
    if (newClassString && currentClassString) {
      var currentClassMap = makeTruthyCssClassMap(currentClassString);
      return newClassString.split(ONE_SPACE).some(function(className) {
        return currentClassMap[className];
      });
    }
  }

  function isAllowed(ruleType, element, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(element, currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(animation, and) {
    var a = (animation.addClass || '').length > 0;
    var b = (animation.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(element, newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event == 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // if there is an ongoing current animation then don't even bother running the class-based animation
    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // cancel the animation if classes added / removed in both animation cancel each other out,
    // but only if the current animation isn't structural

    if (currentAnimation.structural) return false;

    var nA = newAnimation.addClass;
    var nR = newAnimation.removeClass;
    var cA = currentAnimation.addClass;
    var cR = currentAnimation.removeClass;

    // early detection to save the global CPU shortage :)
    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
      return false;
    }

    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$HashMap',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$HashMap,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow) {

    var activeAnimationsLookup = new $$HashMap();
    var disabledElementsLookup = new $$HashMap();
    var animationsEnabled = null;

    function postDigestTaskFactory() {
      var postDigestCalled = false;
      return function(fn) {
        // we only issue a call to postDigest before
        // it has first passed. This prevents any callbacks
        // from not firing once the animation has completed
        // since it will be out of the digest cycle.
        if (postDigestCalled) {
          fn();
        } else {
          $rootScope.$$postDigest(function() {
            postDigestCalled = true;
            fn();
          });
        }
      };
    }

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var callbackRegistry = {};

    // remember that the classNameFilter is set during the provider/config
    // stage therefore we can optimize here and setup a helper function
    var classNameFilter = $animateProvider.classNameFilter();
    var isAnimatableClassName = !classNameFilter
              ? function() { return true; }
              : function(className) {
                return classNameFilter.test(className);
              };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationDetails(element, animation) {
      return mergeAnimationDetails(element, animation, {});
    }

    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var contains = window.Node.prototype.contains || function(arg) {
      // jshint bitwise: false
      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
      // jshint bitwise: true
    };

    function findCallbacks(parent, element, event) {
      var targetNode = getDomNode(element);
      var targetParentNode = getDomNode(parent);

      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (contains.call(entry.node, targetNode)) {
            matches.push(entry.callback);
          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function filterFromRegistry(list, matchContainer, matchCallback) {
      var containerNode = extractElementNode(matchContainer);
      return list.filter(function(entry) {
        var isMatch = entry.node === containerNode &&
                        (!matchCallback || entry.callback === matchCallback);
        return !isMatch;
      });
    }

    function cleanupEventListeners(phase, element) {
      if (phase === 'close' && !element[0].parentNode) {
        // If the element is not attached to a parentNode, it has been removed by
        // the domOperation, and we can safely remove the event callbacks
        $animate.off(element);
      }
    }

    var $animate = {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });

        // Remove the callback when the element is removed from the DOM
        jqLite(container).on('$destroy', function() {
          var animationDetails = activeAnimationsLookup.get(node);

          if (!animationDetails) {
            // If there's an animation ongoing, the callback calling code will remove
            // the event listeners. If we'd remove here, the callbacks would be removed
            // before the animation ends
            $animate.off(event, container, callback);
          }
        });
      },

      off: function(event, container, callback) {
        if (arguments.length === 1 && !angular.isString(arguments[0])) {
          container = arguments[0];
          for (var eventType in callbackRegistry) {
            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
          }

          return;
        }

        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);
            var recordExists = disabledElementsLookup.get(node);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !recordExists;
            } else {
              // (element, bool) - Element setter
              disabledElementsLookup.put(node, !bool);
            }
          }
        }

        return bool;
      }
    };

    return $animate;

    function queueAnimation(element, event, initialOptions) {
      // we always make a copy of the options since
      // there should never be any side effects on
      // the input data when running `$animateCss`.
      var options = copy(initialOptions);

      var node, parent;
      element = stripCommentsFromElement(element);
      if (element) {
        node = getDomNode(element);
        parent = element.parent();
      }

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // this is used to trigger callbacks in postDigest mode
      var runInNextPostDigestOrNow = postDigestTaskFactory();

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (options.addClass && !isString(options.addClass)) {
        options.addClass = null;
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.removeClass && !isString(options.removeClass)) {
        options.removeClass = null;
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      // there are situations where a directive issues an animation for
      // a jqLite wrapper that contains only comment nodes... If this
      // happens then there is no way we can perform an animation
      if (!node) {
        close();
        return runner;
      }

      var className = [node.className, options.addClass, options.removeClass].join(' ');
      if (!isAnimatableClassName(className)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      var documentHidden = $document[0].hidden;

      // this is a hard disable of all animations for the application or on
      // the element itself, therefore  there is no need to continue further
      // past this point if not enabled
      // Animations are also disabled if the document is currently hidden (page is not visible
      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state != PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(element, parent, event);
      }

      if (skipAnimations) {
        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
        if (documentHidden) notifyProgress(runner, event, 'start');
        close();
        if (documentHidden) notifyProgress(runner, event, 'close');
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(element);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        addClass: options.addClass,
        removeClass: options.removeClass,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', element, newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationDetails(element, existingAnimation, newAnimation);
            return existingAnimation.runner;
          }
        }
        var cancelAnimationFlag = isAllowed('cancel', element, newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the new animation options into existing animation options
            mergeAnimationDetails(element, existingAnimation, newAnimation);

            return existingAnimation.runner;
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', element, newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationDetails(element, newAnimation);
            } else {
              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);

              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationDetails(element, existingAnimation, newAnimation);

              //we return the same runner since only the option values of this animation will
              //be fed into the `existingAnimation`.
              return existingAnimation.runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationDetails(element, newAnimation);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(element);
        return runner;
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(element, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(element);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
            ? 'setClass'
            : animationDetails.event;

        markElementAnimationState(element, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', {});

        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(getDomNode(element));
          }
          notifyProgress(runner, event, 'close', {});
        });
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        runInNextPostDigestOrNow(function() {
          var callbacks = findCallbacks(parent, element, event);
          if (callbacks.length) {
            // do not optimize this call here to RAF because
            // we don't know how heavy the callback code here will
            // be and if this code is buffered then this can
            // lead to a performance regression.
            $$rAF(function() {
              forEach(callbacks, function(callback) {
                callback(element, phase, data);
              });
              cleanupEventListeners(phase, element);
            });
          } else {
            cleanupEventListeners(phase, element);
          }
        });
        runner.progress(event, phase, data);
      }

      function close(reject) { // jshint ignore:line
        clearGeneratedClasses(element, options);
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(element) {
      var node = getDomNode(element);
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME));
        var animationDetails = activeAnimationsLookup.get(child);
        if (animationDetails) {
          switch (state) {
            case RUNNING_STATE:
              animationDetails.runner.end();
              /* falls through */
            case PRE_DIGEST_STATE:
              activeAnimationsLookup.remove(child);
              break;
          }
        }
      });
    }

    function clearElementAnimationState(element) {
      var node = getDomNode(element);
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.remove(node);
    }

    function isMatchingElement(nodeOrElmA, nodeOrElmB) {
      return getDomNode(nodeOrElmA) === getDomNode(nodeOrElmB);
    }

    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */
    function areAnimationsAllowed(element, parentElement, event) {
      var bodyElement = jqLite($document[0].body);
      var bodyElementDetected = isMatchingElement(element, bodyElement) || element[0].nodeName === 'HTML';
      var rootElementDetected = isMatchingElement(element, $rootElement);
      var parentAnimationDetected = false;
      var animateChildren;
      var elementDisabled = disabledElementsLookup.get(getDomNode(element));

      var parentHost = jqLite.data(element[0], NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentElement = parentHost;
      }

      parentElement = getDomNode(parentElement);

      while (parentElement) {
        if (!rootElementDetected) {
          // angular doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootElementDetected = isMatchingElement(parentElement, $rootElement);
        }

        if (parentElement.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentElement) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          var parentElementDisabled = disabledElementsLookup.get(parentElement);

          if (parentElementDisabled === true && elementDisabled !== false) {
            // disable animations if the user hasn't explicitly enabled animations on the
            // current element
            elementDisabled = true;
            // element is disabled via parent element, no need to check anything else
            break;
          } else if (parentElementDisabled === false) {
            elementDisabled = false;
          }
          parentAnimationDetected = details.structural;
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = jqLite.data(parentElement, NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!bodyElementDetected) {
          // we also need to ensure that the element is or will be a part of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyElementDetected = isMatchingElement(parentElement, bodyElement);
        }

        if (bodyElementDetected && rootElementDetected) {
          // If both body and root have been found, any other checks are pointless,
          // as no animation data should live outside the application
          break;
        }

        if (!rootElementDetected) {
          // If no rootElement is detected, check if the parentElement is pinned to another element
          parentHost = jqLite.data(parentElement, NG_ANIMATE_PIN_DATA);
          if (parentHost) {
            // The pin target element becomes the next parent element
            parentElement = getDomNode(parentHost);
            continue;
          }
        }

        parentElement = parentElement.parentNode;
      }

      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
      return allowAnimation && rootElementDetected && bodyElementDetected;
    }

    function markElementAnimationState(element, state, details) {
      details = details || {};
      details.state = state;

      var node = getDomNode(element);
      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.put(node, newValue);
    }
  }];
}];

var $$AnimationProvider = ['$animateProvider', function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$HashMap', '$$rAFScheduler',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$HashMap,   $$rAFScheduler) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function sortAnimations(animations) {
      var tree = { children: [] };
      var i, lookup = new $$HashMap();

      // this is done first beforehand so that the hashmap
      // is filled with a list of the elements that will be animated
      for (i = 0; i < animations.length; i++) {
        var animation = animations[i];
        lookup.put(animation.domNode, animations[i] = {
          domNode: animation.domNode,
          fn: animation.fn,
          children: []
        });
      }

      for (i = 0; i < animations.length; i++) {
        processNode(animations[i]);
      }

      return flatten(tree);

      function processNode(entry) {
        if (entry.processed) return entry;
        entry.processed = true;

        var elementNode = entry.domNode;
        var parentNode = elementNode.parentNode;
        lookup.put(elementNode, entry);

        var parentEntry;
        while (parentNode) {
          parentEntry = lookup.get(parentNode);
          if (parentEntry) {
            if (!parentEntry.processed) {
              parentEntry = processNode(parentEntry);
            }
            break;
          }
          parentNode = parentNode.parentNode;
        }

        (parentEntry || tree).children.push(entry);
        return entry;
      }

      function flatten(tree) {
        var result = [];
        var queue = [];
        var i;

        for (i = 0; i < tree.children.length; i++) {
          queue.push(tree.children[i]);
        }

        var remainingLevelEntries = queue.length;
        var nextLevelEntries = 0;
        var row = [];

        for (i = 0; i < queue.length; i++) {
          var entry = queue[i];
          if (remainingLevelEntries <= 0) {
            remainingLevelEntries = nextLevelEntries;
            nextLevelEntries = 0;
            result.push(row);
            row = [];
          }
          row.push(entry.fn);
          entry.children.forEach(function(childEntry) {
            nextLevelEntries++;
            queue.push(childEntry);
          });
          remainingLevelEntries--;
        }

        if (row.length) {
          result.push(row);
        }

        return result;
      }
    }

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      setRunner(element, runner);

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      var prepareClassName;
      if (isStructural) {
        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
        $$jqLite.addClass(element, prepareClassName);
      }

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          } else {
            entry.close();
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        var groupedAnimations = groupAnimations(animations);
        var toBeSortedAnimations = [];

        forEach(groupedAnimations, function(animationEntry) {
          toBeSortedAnimations.push({
            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
            fn: function triggerAnimationStart() {
              // it's important that we apply the `ng-animate` CSS class and the
              // temporary classes before we do any driver invoking since these
              // CSS classes may be required for proper CSS detection.
              animationEntry.beforeStart();

              var startAnimationFn, closeFn = animationEntry.close;

              // in the event that the element was removed before the digest runs or
              // during the RAF sequencing then we should not trigger the animation.
              var targetElement = animationEntry.anchors
                  ? (animationEntry.from.element || animationEntry.to.element)
                  : animationEntry.element;

              if (getRunner(targetElement)) {
                var operation = invokeFirstDriver(animationEntry);
                if (operation) {
                  startAnimationFn = operation.start;
                }
              }

              if (!startAnimationFn) {
                closeFn();
              } else {
                var animationRunner = startAnimationFn();
                animationRunner.done(function(status) {
                  closeFn(!status);
                });
                updateAnimationRunners(animationEntry, animationRunner);
              }
            }
          });
        });

        // we need to sort each of the animations in order of parent to child
        // relationships. This ensures that the child classes are applied at the
        // right time.
        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effectively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        element.addClass(NG_ANIMATE_CLASSNAME);
        if (tempClasses) {
          $$jqLite.addClass(element, tempClasses);
        }
        if (prepareClassName) {
          $$jqLite.removeClass(element, prepareClassName);
          prepareClassName = null;
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          var runner = getRunner(element);
          if (runner) runner.setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) { // jshint ignore:line
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        element.removeClass(NG_ANIMATE_CLASSNAME);
        runner.complete(!rejected);
      }
    };
  }];
}];

/**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */
var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 600, // we use 600 here to ensure that the directive is caught before others
    link: function(scope, $element, attrs, ctrl, $transclude) {
      var previousElement, previousScope;
      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
        if (previousElement) {
          $animate.leave(previousElement);
        }
        if (previousScope) {
          previousScope.$destroy();
          previousScope = null;
        }
        if (value || value === 0) {
          previousScope = scope.$new();
          $transclude(previousScope, function(element) {
            previousElement = element;
            $animate.enter(element, null, $element);
          });
        }
      });
    }
  };
}];

/* global angularAnimateModule: true,

   ngAnimateSwapDirective,
   $$AnimateAsyncRunFactory,
   $$rAFSchedulerFactory,
   $$AnimateChildrenDirective,
   $$AnimateQueueProvider,
   $$AnimationProvider,
   $AnimateCssProvider,
   $$AnimateCssDriverProvider,
   $$AnimateJsProvider,
   $$AnimateJsDriverProvider,
*/

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
 *
 * <div doc-module-components="ngAnimate"></div>
 *
 * # Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                                                | Supported Animations                                                     |
 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
 *
 * (More information can be found by visiting each the documentation associated with each directive.)
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by Angular when an the underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 *
 * ```
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that angular
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id:1, title: "Miss Beulah Roob" },
            { id:2, title: "Trent Morissette" },
            { id:3, title: "Miss Ava Pouros" },
            { id:4, title: "Rod Pouros" },
            { id:5, title: "Abdul Rice" },
            { id:6, title: "Laurie Rutherford Sr." },
            { id:7, title: "Nakia McLaughlin" },
            { id:8, title: "Jordon Blanda DVM" },
            { id:9, title: "Rhoda Hand" },
            { id:10, title: "Alexandrea Sauer" }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams', function($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
 */

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [])
  .directive('ngAnimateSwap', ngAnimateSwapDirective)

  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);

!function(t){function e(n){if(i[n])return i[n].exports;var r=i[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n=window.webpackJsonp;window.webpackJsonp=function(i,o,a){for(var s,c,u,l=0,d=[];l<i.length;l++)c=i[l],r[c]&&d.push(r[c][0]),r[c]=0;for(s in o)Object.prototype.hasOwnProperty.call(o,s)&&(t[s]=o[s]);for(n&&n(i,o,a);d.length;)d.shift()();if(a)for(l=0;l<a.length;l++)u=e(e.s=a[l]);return u};var i={},r={1:0};e.m=t,e.c=i,e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e.oe=function(t){throw console.error(t),t}}([function(t,e,n){"use strict";var i=n(2),r=n(21),o=n(11),a=n(12),s=n(18),c=function t(e,n,c){var u,l,d,f,p=e&t.F,h=e&t.G,v=e&t.S,g=e&t.P,y=e&t.B,m=h?i:v?i[n]||(i[n]={}):(i[n]||{}).prototype,b=h?r:r[n]||(r[n]={}),k=b.prototype||(b.prototype={});h&&(c=n);for(u in c)l=!p&&m&&void 0!==m[u],d=(l?m:c)[u],f=y&&l?s(d,i):g&&"function"==typeof d?s(Function.call,d):d,m&&a(m,u,d,e&t.U),b[u]!=d&&o(b,u,f),g&&k[u]!=d&&(k[u]=d)};i.core=r,c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,t.exports=c},function(t,e,n){"use strict";var i=n(4);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){"use strict";var i=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=i)},function(t,e,n){"use strict";t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){"use strict";var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};t.exports=function(t){return"object"===(void 0===t?"undefined":i(t))?null!==t:"function"==typeof t}},function(t,e,n){"use strict";var i=n(49)("wks"),r=n(33),o=n(2).Symbol,a="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=a&&o[t]||(a?o:r)("Symbol."+t))}).store=i},function(t,e,n){"use strict";var i=n(1),r=n(93),o=n(22),a=Object.defineProperty;e.f=n(7)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return a(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){"use strict";t.exports=!n(3)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,n){"use strict";var i=n(24),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){"use strict";var i=n(23);t.exports=function(t){return Object(i(t))}},function(t,e,n){"use strict";t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){"use strict";var i=n(6),r=n(32);t.exports=n(7)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){"use strict";var i=n(2),r=n(11),o=n(16),a=n(33)("src"),s=Function.toString,c=(""+s).split("toString");n(21).inspectSource=function(t){return s.call(t)},(t.exports=function(t,e,n,s){var u="function"==typeof n;u&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(u&&(o(n,a)||r(n,a,t[e]?""+t[e]:c.join(String(e)))),t===i?t[e]=n:s?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[a]||s.call(this)})},function(t,e,n){"use strict";var i=n(47),r=n(23);t.exports=function(t){return i(r(t))}},function(t,e,n){"use strict";var i=n(48),r=n(32),o=n(13),a=n(22),s=n(16),c=n(93),u=Object.getOwnPropertyDescriptor;e.f=n(7)?u:function(t,e){if(t=o(t),e=a(e,!0),c)try{return u(t,e)}catch(t){}if(s(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){"use strict";var i=n(0),r=n(3),o=n(23),a=/"/g,s=function(t,e,n,i){var r=String(o(t)),s="<"+e;return""!==n&&(s+=" "+n+'="'+String(i).replace(a,"&quot;")+'"'),s+">"+r+"</"+e+">"};t.exports=function(t,e){var n={};n[t]=e(s),i(i.P+i.F*r(function(){var e=""[t]('"');return e!==e.toLowerCase()||e.split('"').length>3}),"String",n)}},function(t,e,n){"use strict";var i={}.hasOwnProperty;t.exports=function(t,e){return i.call(t,e)}},function(t,e,n){"use strict";var i=n(16),r=n(9),o=n(65)("IE_PROTO"),a=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){"use strict";var i=n(10);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){"use strict";var i={}.toString;t.exports=function(t){return i.call(t).slice(8,-1)}},function(t,e,n){"use strict";var i=n(3);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){"use strict";var i=t.exports={version:"2.5.4"};"number"==typeof __e&&(__e=i)},function(t,e,n){"use strict";var i=n(4);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){"use strict";t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:i)(t)}},function(t,e,n){"use strict";var i=n(0),r=n(21),o=n(3);t.exports=function(t,e){var n=(r.Object||{})[t]||Object[t],a={};a[t]=e(n),i(i.S+i.F*o(function(){n(1)}),"Object",a)}},function(t,e,n){"use strict";var i=n(18),r=n(47),o=n(9),a=n(8),s=n(82);t.exports=function(t,e){var n=1==t,c=2==t,u=3==t,l=4==t,d=6==t,f=5==t||d,p=e||s;return function(e,s,h){for(var v,g,y=o(e),m=r(y),b=i(s,h,3),k=a(m.length),w=0,S=n?p(e,k):c?p(e,0):void 0;k>w;w++)if((f||w in m)&&(v=m[w],g=b(v,w,y),t))if(n)S[w]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return w;case 2:S.push(v)}else if(l)return!1;return d?-1:u||l?l:S}}},function(t,e,n){"use strict";var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};if(n(7)){var r=n(34),o=n(2),a=n(3),s=n(0),c=n(59),u=n(88),l=n(18),d=n(39),f=n(32),p=n(11),h=n(41),v=n(24),g=n(8),y=n(136),m=n(36),b=n(22),k=n(16),w=n(43),S=n(4),x=n(9),T=n(79),M=n(30),_=n(17),D=n(37).f,$=n(81),O=n(33),C=n(5),P=n(26),E=n(50),A=n(57),N=n(84),F=n(45),I=n(54),L=n(38),j=n(83),R=n(126),z=n(6),H=n(14),W=z.f,B=H.f,U=o.RangeError,Y=o.TypeError,V=o.Uint8Array,q=Array.prototype,G=u.ArrayBuffer,X=u.DataView,J=P(0),K=P(2),Z=P(3),Q=P(4),tt=P(5),et=P(6),nt=E(!0),it=E(!1),rt=N.values,ot=N.keys,at=N.entries,st=q.lastIndexOf,ct=q.reduce,ut=q.reduceRight,lt=q.join,dt=q.sort,ft=q.slice,pt=q.toString,ht=q.toLocaleString,vt=C("iterator"),gt=C("toStringTag"),yt=O("typed_constructor"),mt=O("def_constructor"),bt=c.CONSTR,kt=c.TYPED,wt=c.VIEW,St=P(1,function(t,e){return Dt(A(t,t[mt]),e)}),xt=a(function(){return 1===new V(new Uint16Array([1]).buffer)[0]}),Tt=!!V&&!!V.prototype.set&&a(function(){new V(1).set({})}),Mt=function(t,e){var n=v(t);if(n<0||n%e)throw U("Wrong offset!");return n},_t=function(t){if(S(t)&&kt in t)return t;throw Y(t+" is not a typed array!")},Dt=function(t,e){if(!(S(t)&&yt in t))throw Y("It is not a typed array constructor!");return new t(e)},$t=function(t,e){return Ot(A(t,t[mt]),e)},Ot=function(t,e){for(var n=0,i=e.length,r=Dt(t,i);i>n;)r[n]=e[n++];return r},Ct=function(t,e,n){W(t,e,{get:function(){return this._d[n]}})},Pt=function(t){var e,n,i,r,o,a,s=x(t),c=arguments.length,u=c>1?arguments[1]:void 0,d=void 0!==u,f=$(s);if(void 0!=f&&!T(f)){for(a=f.call(s),i=[],e=0;!(o=a.next()).done;e++)i.push(o.value);s=i}for(d&&c>2&&(u=l(u,arguments[2],2)),e=0,n=g(s.length),r=Dt(this,n);n>e;e++)r[e]=d?u(s[e],e):s[e];return r},Et=function(){for(var t=0,e=arguments.length,n=Dt(this,e);e>t;)n[t]=arguments[t++];return n},At=!!V&&a(function(){ht.call(new V(1))}),Nt=function(){return ht.apply(At?ft.call(_t(this)):_t(this),arguments)},Ft={copyWithin:function(t,e){return R.call(_t(this),t,e,arguments.length>2?arguments[2]:void 0)},every:function(t){return Q(_t(this),t,arguments.length>1?arguments[1]:void 0)},fill:function(t){return j.apply(_t(this),arguments)},filter:function(t){return $t(this,K(_t(this),t,arguments.length>1?arguments[1]:void 0))},find:function(t){return tt(_t(this),t,arguments.length>1?arguments[1]:void 0)},findIndex:function(t){return et(_t(this),t,arguments.length>1?arguments[1]:void 0)},forEach:function(t){J(_t(this),t,arguments.length>1?arguments[1]:void 0)},indexOf:function(t){return it(_t(this),t,arguments.length>1?arguments[1]:void 0)},includes:function(t){return nt(_t(this),t,arguments.length>1?arguments[1]:void 0)},join:function(t){return lt.apply(_t(this),arguments)},lastIndexOf:function(t){return st.apply(_t(this),arguments)},map:function(t){return St(_t(this),t,arguments.length>1?arguments[1]:void 0)},reduce:function(t){return ct.apply(_t(this),arguments)},reduceRight:function(t){return ut.apply(_t(this),arguments)},reverse:function(){for(var t,e=this,n=_t(e).length,i=Math.floor(n/2),r=0;r<i;)t=e[r],e[r++]=e[--n],e[n]=t;return e},some:function(t){return Z(_t(this),t,arguments.length>1?arguments[1]:void 0)},sort:function(t){return dt.call(_t(this),t)},subarray:function(t,e){var n=_t(this),i=n.length,r=m(t,i);return new(A(n,n[mt]))(n.buffer,n.byteOffset+r*n.BYTES_PER_ELEMENT,g((void 0===e?i:m(e,i))-r))}},It=function(t,e){return $t(this,ft.call(_t(this),t,e))},Lt=function(t){_t(this);var e=Mt(arguments[1],1),n=this.length,i=x(t),r=g(i.length),o=0;if(r+e>n)throw U("Wrong length!");for(;o<r;)this[e+o]=i[o++]},jt={entries:function(){return at.call(_t(this))},keys:function(){return ot.call(_t(this))},values:function(){return rt.call(_t(this))}},Rt=function(t,e){return S(t)&&t[kt]&&"symbol"!=(void 0===e?"undefined":i(e))&&e in t&&String(+e)==String(e)},zt=function(t,e){return Rt(t,e=b(e,!0))?f(2,t[e]):B(t,e)},Ht=function(t,e,n){return!(Rt(t,e=b(e,!0))&&S(n)&&k(n,"value"))||k(n,"get")||k(n,"set")||n.configurable||k(n,"writable")&&!n.writable||k(n,"enumerable")&&!n.enumerable?W(t,e,n):(t[e]=n.value,t)};bt||(H.f=zt,z.f=Ht),s(s.S+s.F*!bt,"Object",{getOwnPropertyDescriptor:zt,defineProperty:Ht}),a(function(){pt.call({})})&&(pt=ht=function(){return lt.call(this)});var Wt=h({},Ft);h(Wt,jt),p(Wt,vt,jt.values),h(Wt,{slice:It,set:Lt,constructor:function(){},toString:pt,toLocaleString:Nt}),Ct(Wt,"buffer","b"),Ct(Wt,"byteOffset","o"),Ct(Wt,"byteLength","l"),Ct(Wt,"length","e"),W(Wt,gt,{get:function(){return this[kt]}}),t.exports=function(t,e,n,i){i=!!i;var u=t+(i?"Clamped":"")+"Array",l="get"+t,f="set"+t,h=o[u],v=h||{},m=h&&_(h),b=!h||!c.ABV,k={},x=h&&h.prototype,T=function(t,n){var i=t._d;return i.v[l](n*e+i.o,xt)},$=function(t,n,r){var o=t._d;i&&(r=(r=Math.round(r))<0?0:r>255?255:255&r),o.v[f](n*e+o.o,r,xt)},O=function(t,e){W(t,e,{get:function(){return T(this,e)},set:function(t){return $(this,e,t)},enumerable:!0})};b?(h=n(function(t,n,i,r){d(t,h,u,"_d");var o,a,s,c,l=0,f=0;if(S(n)){if(!(n instanceof G||"ArrayBuffer"==(c=w(n))||"SharedArrayBuffer"==c))return kt in n?Ot(h,n):Pt.call(h,n);o=n,f=Mt(i,e);var v=n.byteLength;if(void 0===r){if(v%e)throw U("Wrong length!");if((a=v-f)<0)throw U("Wrong length!")}else if((a=g(r)*e)+f>v)throw U("Wrong length!");s=a/e}else s=y(n),a=s*e,o=new G(a);for(p(t,"_d",{b:o,o:f,l:a,e:s,v:new X(o)});l<s;)O(t,l++)}),x=h.prototype=M(Wt),p(x,"constructor",h)):a(function(){h(1)})&&a(function(){new h(-1)})&&I(function(t){new h,new h(null),new h(1.5),new h(t)},!0)||(h=n(function(t,n,i,r){d(t,h,u);var o;return S(n)?n instanceof G||"ArrayBuffer"==(o=w(n))||"SharedArrayBuffer"==o?void 0!==r?new v(n,Mt(i,e),r):void 0!==i?new v(n,Mt(i,e)):new v(n):kt in n?Ot(h,n):Pt.call(h,n):new v(y(n))}),J(m!==Function.prototype?D(v).concat(D(m)):D(v),function(t){t in h||p(h,t,v[t])}),h.prototype=x,r||(x.constructor=h));var C=x[vt],P=!!C&&("values"==C.name||void 0==C.name),E=jt.values;p(h,yt,!0),p(x,kt,u),p(x,wt,!0),p(x,mt,h),(i?new h(1)[gt]==u:gt in x)||W(x,gt,{get:function(){return u}}),k[u]=h,s(s.G+s.W+s.F*(h!=v),k),s(s.S,u,{BYTES_PER_ELEMENT:e}),s(s.S+s.F*a(function(){v.of.call(h,1)}),u,{from:Pt,of:Et}),"BYTES_PER_ELEMENT"in x||p(x,"BYTES_PER_ELEMENT",e),s(s.P,u,Ft),L(u),s(s.P+s.F*Tt,u,{set:Lt}),s(s.P+s.F*!P,u,jt),r||x.toString==pt||(x.toString=pt),s(s.P+s.F*a(function(){new h(1).slice()}),u,{slice:It}),s(s.P+s.F*(a(function(){return[1,2].toLocaleString()!=new h([1,2]).toLocaleString()})||!a(function(){x.toLocaleString.call([1,2])})),u,{toLocaleString:Nt}),F[u]=P?C:E,r||P||p(x,vt,E)}}else t.exports=function(){}},function(t,e,n){"use strict";var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},r=n(131),o=n(0),a=n(49)("metadata"),s=a.store||(a.store=new(n(134))),c=function(t,e,n){var i=s.get(t);if(!i){if(!n)return;s.set(t,i=new r)}var o=i.get(e);if(!o){if(!n)return;i.set(e,o=new r)}return o},u=function(t,e,n){var i=c(e,n,!1);return void 0!==i&&i.has(t)},l=function(t,e,n){var i=c(e,n,!1);return void 0===i?void 0:i.get(t)},d=function(t,e,n,i){c(n,i,!0).set(t,e)},f=function(t,e){var n=c(t,e,!1),i=[];return n&&n.forEach(function(t,e){i.push(e)}),i},p=function(t){return void 0===t||"symbol"==(void 0===t?"undefined":i(t))?t:String(t)},h=function(t){o(o.S,"Reflect",t)};t.exports={store:s,map:c,has:u,get:l,set:d,keys:f,key:p,exp:h}},function(t,e,n){"use strict";var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},r=n(33)("meta"),o=n(4),a=n(16),s=n(6).f,c=0,u=Object.isExtensible||function(){return!0},l=!n(3)(function(){return u(Object.preventExtensions({}))}),d=function(t){s(t,r,{value:{i:"O"+ ++c,w:{}}})},f=function(t,e){if(!o(t))return"symbol"==(void 0===t?"undefined":i(t))?t:("string"==typeof t?"S":"P")+t;if(!a(t,r)){if(!u(t))return"F";if(!e)return"E";d(t)}return t[r].i},p=function(t,e){if(!a(t,r)){if(!u(t))return!0;if(!e)return!1;d(t)}return t[r].w},h=function(t){return l&&v.NEED&&u(t)&&!a(t,r)&&d(t),t},v=t.exports={KEY:r,NEED:!1,fastKey:f,getWeak:p,onFreeze:h}},function(t,e,n){"use strict";var i=n(1),r=n(96),o=n(66),a=n(65)("IE_PROTO"),s=function(){},c=function(){var t,e=n(63)("iframe"),i=o.length;for(e.style.display="none",n(67).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),c=t.F;i--;)delete c.prototype[o[i]];return c()};t.exports=Object.create||function(t,e){var n;return null!==t?(s.prototype=i(t),n=new s,s.prototype=null,n[a]=t):n=c(),void 0===e?n:r(n,e)}},function(t,e,n){"use strict";var i=n(5)("unscopables"),r=Array.prototype;void 0==r[i]&&n(11)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){"use strict";t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){"use strict";var i=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++i+r).toString(36))}},function(t,e,n){"use strict";t.exports=!1},function(t,e,n){"use strict";var i=n(95),r=n(66);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){"use strict";var i=n(24),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){"use strict";var i=n(95),r=n(66).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){"use strict";var i=n(2),r=n(6),o=n(7),a=n(5)("species");t.exports=function(t){var e=i[t];o&&e&&!e[a]&&r.f(e,a,{configurable:!0,get:function(){return this}})}},function(t,e,n){"use strict";t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){"use strict";var i=n(18),r=n(124),o=n(79),a=n(1),s=n(8),c=n(81),u={},l={},d=t.exports=function(t,e,n,d,f){var p,h,v,g,y=f?function(){return t}:c(t),m=i(n,d,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(p=s(t.length);p>b;b++)if((g=e?m(a(h=t[b])[0],h[1]):m(t[b]))===u||g===l)return g}else for(v=y.call(t);!(h=v.next()).done;)if((g=r(v,m,h.value,e))===u||g===l)return g};d.BREAK=u,d.RETURN=l},function(t,e,n){"use strict";var i=n(12);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){"use strict";var i=n(6).f,r=n(16),o=n(5)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){"use strict";var i=n(19),r=n(5)("toStringTag"),o="Arguments"==i(function(){return arguments}()),a=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,s;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=a(e=Object(t),r))?n:o?i(e):"Object"==(s=i(e))&&"function"==typeof e.callee?"Arguments":s}},function(t,e,n){"use strict";var i=n(0),r=n(23),o=n(3),a=n(69),s="["+a+"]",c="​",u=RegExp("^"+s+s+"*"),l=RegExp(s+s+"*$"),d=function(t,e,n){var r={},s=o(function(){return!!a[t]()||c[t]()!=c}),u=r[t]=s?e(f):a[t];n&&(r[n]=u),i(i.P+i.F*s,"String",r)},f=d.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(u,"")),2&e&&(t=t.replace(l,"")),t};t.exports=d},function(t,e,n){"use strict";t.exports={}},function(t,e,n){"use strict";var i=n(4);t.exports=function(t,e){if(!i(t)||t._t!==e)throw TypeError("Incompatible receiver, "+e+" required!");return t}},function(t,e,n){"use strict";var i=n(19);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e,n){"use strict";e.f={}.propertyIsEnumerable},function(t,e,n){"use strict";var i=n(2),r=i["__core-js_shared__"]||(i["__core-js_shared__"]={});t.exports=function(t){return r[t]||(r[t]={})}},function(t,e,n){"use strict";var i=n(13),r=n(8),o=n(36);t.exports=function(t){return function(e,n,a){var s,c=i(e),u=r(c.length),l=o(a,u);if(t&&n!=n){for(;u>l;)if((s=c[l++])!=s)return!0}else for(;u>l;l++)if((t||l in c)&&c[l]===n)return t||l||0;return!t&&-1}}},function(t,e,n){"use strict";e.f=Object.getOwnPropertySymbols},function(t,e,n){"use strict";var i=n(19);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";var i=n(4),r=n(19),o=n(5)("match");t.exports=function(t){var e;return i(t)&&(void 0!==(e=t[o])?!!e:"RegExp"==r(t))}},function(t,e,n){"use strict";var i=n(5)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],a=o[i]();a.next=function(){return{done:n=!0}},o[i]=function(){return a},t(o)}catch(t){}return n}},function(t,e,n){"use strict";var i=n(1);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){"use strict";var i=n(11),r=n(12),o=n(3),a=n(23),s=n(5);t.exports=function(t,e,n){var c=s(t),u=n(a,c,""[t]),l=u[0],d=u[1];o(function(){var e={};return e[c]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,l),i(RegExp.prototype,c,2==e?function(t,e){return d.call(t,this,e)}:function(t){return d.call(t,this)}))}},function(t,e,n){"use strict";var i=n(1),r=n(10),o=n(5)("species");t.exports=function(t,e){var n,a=i(t).constructor;return void 0===a||void 0==(n=i(a)[o])?e:r(n)}},function(t,e,n){"use strict";var i=n(2),r=n(0),o=n(12),a=n(41),s=n(29),c=n(40),u=n(39),l=n(4),d=n(3),f=n(54),p=n(42),h=n(70);t.exports=function(t,e,n,v,g,y){var m=i[t],b=m,k=g?"set":"add",w=b&&b.prototype,S={},x=function(t){var e=w[t];o(w,t,"delete"==t?function(t){return!(y&&!l(t))&&e.call(this,0===t?0:t)}:"has"==t?function(t){return!(y&&!l(t))&&e.call(this,0===t?0:t)}:"get"==t?function(t){return y&&!l(t)?void 0:e.call(this,0===t?0:t)}:"add"==t?function(t){return e.call(this,0===t?0:t),this}:function(t,n){return e.call(this,0===t?0:t,n),this})};if("function"==typeof b&&(y||w.forEach&&!d(function(){(new b).entries().next()}))){var T=new b,M=T[k](y?{}:-0,1)!=T,_=d(function(){T.has(1)}),D=f(function(t){new b(t)}),$=!y&&d(function(){for(var t=new b,e=5;e--;)t[k](e,e);return!t.has(-0)});D||(b=e(function(e,n){u(e,b,t);var i=h(new m,e,b);return void 0!=n&&c(n,g,i[k],i),i}),b.prototype=w,w.constructor=b),(_||$)&&(x("delete"),x("has"),g&&x("get")),($||M)&&x(k),y&&w.clear&&delete w.clear}else b=v.getConstructor(e,t,g,k),a(b.prototype,n),s.NEED=!0;return p(b,t),S[t]=b,r(r.G+r.W+r.F*(b!=m),S),y||v.setStrong(b,t,g),b}},function(t,e,n){"use strict";for(var i,r=n(2),o=n(11),a=n(33),s=a("typed_array"),c=a("view"),u=!(!r.ArrayBuffer||!r.DataView),l=u,d=0,f="Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");d<9;)(i=r[f[d++]])?(o(i.prototype,s,!0),o(i.prototype,c,!0)):l=!1;t.exports={ABV:u,CONSTR:l,TYPED:s,VIEW:c}},function(t,e,n){"use strict";t.exports=n(34)||!n(3)(function(){var t=Math.random();__defineSetter__.call(null,t,function(){}),delete n(2)[t]})},function(t,e,n){"use strict";var i=n(0);t.exports=function(t){i(i.S,t,{of:function(){for(var t=arguments.length,e=new Array(t);t--;)e[t]=arguments[t];return new this(e)}})}},function(t,e,n){"use strict";var i=n(0),r=n(10),o=n(18),a=n(40);t.exports=function(t){i(i.S,t,{from:function(t){var e,n,i,s,c=arguments[1];return r(this),e=void 0!==c,e&&r(c),void 0==t?new this:(n=[],e?(i=0,s=o(c,arguments[2],2),a(t,!1,function(t){n.push(s(t,i++))})):a(t,!1,n.push,n),new this(n))}})}},function(t,e,n){"use strict";var i=n(4),r=n(2).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e,n){"use strict";var i=n(2),r=n(21),o=n(34),a=n(94),s=n(6).f;t.exports=function(t){var e=r.Symbol||(r.Symbol=o?{}:i.Symbol||{});"_"==t.charAt(0)||t in e||s(e,t,{value:a.f(t)})}},function(t,e,n){"use strict";var i=n(49)("keys"),r=n(33);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){"use strict";t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){"use strict";var i=n(2).document;t.exports=i&&i.documentElement},function(t,e,n){"use strict";var i=n(4),r=n(1),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(18)(Function.call,n(14).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){"use strict";var i=n(4),r=n(68).set;t.exports=function(t,e,n){var o,a=e.constructor;return a!==n&&"function"==typeof a&&(o=a.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e,n){"use strict";var i=n(24),r=n(23);t.exports=function(t){var e=String(r(this)),n="",o=i(t);if(o<0||o==1/0)throw RangeError("Count can't be negative");for(;o>0;(o>>>=1)&&(e+=e))1&o&&(n+=e);return n}},function(t,e,n){"use strict";t.exports=Math.sign||function(t){return 0==(t=+t)||t!=t?t:t<0?-1:1}},function(t,e,n){"use strict";var i=Math.expm1;t.exports=!i||i(10)>22025.465794806718||i(10)<22025.465794806718||-2e-17!=i(-2e-17)?function(t){return 0==(t=+t)?t:t>-1e-6&&t<1e-6?t+t*t/2:Math.exp(t)-1}:i},function(t,e,n){"use strict";var i=n(24),r=n(23);t.exports=function(t){return function(e,n){var o,a,s=String(r(e)),c=i(n),u=s.length;return c<0||c>=u?t?"":void 0:(o=s.charCodeAt(c),o<55296||o>56319||c+1===u||(a=s.charCodeAt(c+1))<56320||a>57343?t?s.charAt(c):o:t?s.slice(c,c+2):a-56320+(o-55296<<10)+65536)}}},function(t,e,n){"use strict";var i=n(34),r=n(0),o=n(12),a=n(11),s=n(45),c=n(76),u=n(42),l=n(17),d=n(5)("iterator"),f=!([].keys&&"next"in[].keys()),p=function(){return this};t.exports=function(t,e,n,h,v,g,y){c(n,e,h);var m,b,k,w=function(t){if(!f&&t in M)return M[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},S=e+" Iterator",x="values"==v,T=!1,M=t.prototype,_=M[d]||M["@@iterator"]||v&&M[v],D=_||w(v),$=v?x?w("entries"):D:void 0,O="Array"==e?M.entries||_:_;if(O&&(k=l(O.call(new t)))!==Object.prototype&&k.next&&(u(k,S,!0),i||"function"==typeof k[d]||a(k,d,p)),x&&_&&"values"!==_.name&&(T=!0,D=function(){return _.call(this)}),i&&!y||!f&&!T&&M[d]||a(M,d,D),s[e]=D,s[S]=p,v)if(m={values:x?D:w("values"),keys:g?D:w("keys"),entries:$},y)for(b in m)b in M||o(M,b,m[b]);else r(r.P+r.F*(f||T),e,m);return m}},function(t,e,n){"use strict";var i=n(30),r=n(32),o=n(42),a={};n(11)(a,n(5)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(a,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(53),r=n(23);t.exports=function(t,e,n){if(i(e))throw TypeError("String#"+n+" doesn't accept regex!");return String(r(t))}},function(t,e,n){"use strict";var i=n(5)("match");t.exports=function(t){var e=/./;try{"/./"[t](e)}catch(n){try{return e[i]=!1,!"/./"[t](e)}catch(t){}}return!0}},function(t,e,n){"use strict";var i=n(45),r=n(5)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){"use strict";var i=n(6),r=n(32);t.exports=function(t,e,n){e in t?i.f(t,e,r(0,n)):t[e]=n}},function(t,e,n){"use strict";var i=n(43),r=n(5)("iterator"),o=n(45);t.exports=n(21).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(227);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(9),r=n(36),o=n(8);t.exports=function(t){for(var e=i(this),n=o(e.length),a=arguments.length,s=r(a>1?arguments[1]:void 0,n),c=a>2?arguments[2]:void 0,u=void 0===c?n:r(c,n);u>s;)e[s++]=t;return e}},function(t,e,n){"use strict";var i=n(31),r=n(127),o=n(45),a=n(13);t.exports=n(75)(Array,"Array",function(t,e){this._t=a(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i,r,o,a=n(18),s=n(117),c=n(67),u=n(63),l=n(2),d=l.process,f=l.setImmediate,p=l.clearImmediate,h=l.MessageChannel,v=l.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};f&&p||(f=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){s("function"==typeof t?t:Function(t),e)},i(g),g},p=function(t){delete y[t]},"process"==n(19)(d)?i=function(t){d.nextTick(a(m,t,1))}:v&&v.now?i=function(t){v.now(a(m,t,1))}:h?(r=new h,o=r.port2,r.port1.onmessage=b,i=a(o.postMessage,o,1)):l.addEventListener&&"function"==typeof postMessage&&!l.importScripts?(i=function(t){l.postMessage(t+"","*")},l.addEventListener("message",b,!1)):i="onreadystatechange"in u("script")?function(t){c.appendChild(u("script")).onreadystatechange=function(){c.removeChild(this),m.call(t)}}:function(t){setTimeout(a(m,t,1),0)}),t.exports={set:f,clear:p}},function(t,e,n){"use strict";var i=n(2),r=n(85).set,o=i.MutationObserver||i.WebKitMutationObserver,a=i.process,s=i.Promise,c="process"==n(19)(a);t.exports=function(){var t,e,n,u=function(){var i,r;for(c&&(i=a.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(c)n=function(){a.nextTick(u)};else if(!o||i.navigator&&i.navigator.standalone)if(s&&s.resolve){var l=s.resolve();n=function(){l.then(u)}}else n=function(){r.call(i,u)};else{var d=!0,f=document.createTextNode("");new o(u).observe(f,{characterData:!0}),n=function(){f.data=d=!d}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(10);t.exports.f=function(t){return new i(t)}},function(t,e,n){"use strict";function i(t,e,n){var i,r,o,a=new Array(n),s=8*n-e-1,c=(1<<s)-1,u=c>>1,l=23===e?j(2,-24)-j(2,-77):0,d=0,f=t<0||0===t&&1/t<0?1:0;for(t=L(t),t!=t||t===F?(r=t!=t?1:0,i=c):(i=R(z(t)/H),t*(o=j(2,-i))<1&&(i--,o*=2),t+=i+u>=1?l/o:l*j(2,1-u),t*o>=2&&(i++,o/=2),i+u>=c?(r=0,i=c):i+u>=1?(r=(t*o-1)*j(2,e),i+=u):(r=t*j(2,u-1)*j(2,e),i=0));e>=8;a[d++]=255&r,r/=256,e-=8);for(i=i<<e|r,s+=e;s>0;a[d++]=255&i,i/=256,s-=8);return a[--d]|=128*f,a}function r(t,e,n){var i,r=8*n-e-1,o=(1<<r)-1,a=o>>1,s=r-7,c=n-1,u=t[c--],l=127&u;for(u>>=7;s>0;l=256*l+t[c],c--,s-=8);for(i=l&(1<<-s)-1,l>>=-s,s+=e;s>0;i=256*i+t[c],c--,s-=8);if(0===l)l=1-a;else{if(l===o)return i?NaN:u?-F:F;i+=j(2,e),l-=a}return(u?-1:1)*i*j(2,l-e)}function o(t){return t[3]<<24|t[2]<<16|t[1]<<8|t[0]}function a(t){return[255&t]}function s(t){return[255&t,t>>8&255]}function c(t){return[255&t,t>>8&255,t>>16&255,t>>24&255]}function u(t){return i(t,52,8)}function l(t){return i(t,23,4)}function d(t,e,n){_(t[O],e,{get:function(){return this[n]}})}function f(t,e,n,i){var r=+n,o=T(r);if(o+e>t[B])throw N(C);var a=t[W]._b,s=o+t[U],c=a.slice(s,s+e);return i?c:c.reverse()}function p(t,e,n,i,r,o){var a=+n,s=T(a);if(s+e>t[B])throw N(C);for(var c=t[W]._b,u=s+t[U],l=i(+r),d=0;d<e;d++)c[u+d]=l[o?d:e-d-1]}var h=n(2),v=n(7),g=n(34),y=n(59),m=n(11),b=n(41),k=n(3),w=n(39),S=n(24),x=n(8),T=n(136),M=n(37).f,_=n(6).f,D=n(83),$=n(42),O="prototype",C="Wrong index!",P=h.ArrayBuffer,E=h.DataView,A=h.Math,N=h.RangeError,F=h.Infinity,I=P,L=A.abs,j=A.pow,R=A.floor,z=A.log,H=A.LN2,W=v?"_b":"buffer",B=v?"_l":"byteLength",U=v?"_o":"byteOffset";if(y.ABV){if(!k(function(){P(1)})||!k(function(){new P(-1)})||k(function(){return new P,new P(1.5),new P(NaN),"ArrayBuffer"!=P.name})){P=function(t){return w(this,P),new I(T(t))};for(var Y,V=P[O]=I[O],q=M(I),G=0;q.length>G;)(Y=q[G++])in P||m(P,Y,I[Y]);g||(V.constructor=P)}var X=new E(new P(2)),J=E[O].setInt8;X.setInt8(0,2147483648),X.setInt8(1,2147483649),!X.getInt8(0)&&X.getInt8(1)||b(E[O],{setInt8:function(t,e){J.call(this,t,e<<24>>24)},setUint8:function(t,e){J.call(this,t,e<<24>>24)}},!0)}else P=function(t){w(this,P,"ArrayBuffer");var e=T(t);this._b=D.call(new Array(e),0),this[B]=e},E=function(t,e,n){w(this,E,"DataView"),w(t,P,"DataView");var i=t[B],r=S(e);if(r<0||r>i)throw N("Wrong offset!");if(n=void 0===n?i-r:x(n),r+n>i)throw N("Wrong length!");this[W]=t,this[U]=r,this[B]=n},v&&(d(P,"byteLength","_l"),d(E,"buffer","_b"),d(E,"byteLength","_l"),d(E,"byteOffset","_o")),b(E[O],{getInt8:function(t){return f(this,1,t)[0]<<24>>24},getUint8:function(t){return f(this,1,t)[0]},getInt16:function(t){var e=f(this,2,t,arguments[1]);return(e[1]<<8|e[0])<<16>>16},getUint16:function(t){var e=f(this,2,t,arguments[1]);return e[1]<<8|e[0]},getInt32:function(t){return o(f(this,4,t,arguments[1]))},getUint32:function(t){return o(f(this,4,t,arguments[1]))>>>0},getFloat32:function(t){return r(f(this,4,t,arguments[1]),23,4)},getFloat64:function(t){return r(f(this,8,t,arguments[1]),52,8)},setInt8:function(t,e){p(this,1,t,a,e)},setUint8:function(t,e){p(this,1,t,a,e)},setInt16:function(t,e){p(this,2,t,s,e,arguments[2])},setUint16:function(t,e){p(this,2,t,s,e,arguments[2])},setInt32:function(t,e){p(this,4,t,c,e,arguments[2])},setUint32:function(t,e){p(this,4,t,c,e,arguments[2])},setFloat32:function(t,e){p(this,4,t,l,e,arguments[2])},setFloat64:function(t,e){p(this,8,t,u,e,arguments[2])}});$(P,"ArrayBuffer"),$(E,"DataView"),m(E[O],y.VIEW,!0),e.ArrayBuffer=P,e.DataView=E},function(t,e,n){"use strict";var i=n(37),r=n(51),o=n(1),a=n(2).Reflect;t.exports=a&&a.ownKeys||function(t){var e=i.f(o(t)),n=r.f;return n?e.concat(n(t)):e}},function(t,e,n){"use strict";var i=n(2),r=i.navigator;t.exports=r&&r.userAgent||""},,function(t,e,n){"use strict";var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},r=n(2),o=n(16),a=n(7),s=n(0),c=n(12),u=n(29).KEY,l=n(3),d=n(49),f=n(42),p=n(33),h=n(5),v=n(94),g=n(64),y=n(155),m=n(52),b=n(1),k=n(4),w=n(13),S=n(22),x=n(32),T=n(30),M=n(97),_=n(14),D=n(6),$=n(35),O=_.f,C=D.f,P=M.f,E=r.Symbol,A=r.JSON,N=A&&A.stringify,F=h("_hidden"),I=h("toPrimitive"),L={}.propertyIsEnumerable,j=d("symbol-registry"),R=d("symbols"),z=d("op-symbols"),H=Object.prototype,W="function"==typeof E,B=r.QObject,U=!B||!B.prototype||!B.prototype.findChild,Y=a&&l(function(){return 7!=T(C({},"a",{get:function(){return C(this,"a",{value:7}).a}})).a})?function(t,e,n){var i=O(H,e);i&&delete H[e],C(t,e,n),i&&t!==H&&C(H,e,i)}:C,V=function(t){var e=R[t]=T(E.prototype);return e._k=t,e},q=W&&"symbol"==i(E.iterator)?function(t){return"symbol"==(void 0===t?"undefined":i(t))}:function(t){return t instanceof E},G=function(t,e,n){return t===H&&G(z,e,n),b(t),e=S(e,!0),b(n),o(R,e)?(n.enumerable?(o(t,F)&&t[F][e]&&(t[F][e]=!1),n=T(n,{enumerable:x(0,!1)})):(o(t,F)||C(t,F,x(1,{})),t[F][e]=!0),Y(t,e,n)):C(t,e,n)},X=function(t,e){b(t);for(var n,i=y(e=w(e)),r=0,o=i.length;o>r;)G(t,n=i[r++],e[n]);return t},J=function(t,e){return void 0===e?T(t):X(T(t),e)},K=function(t){var e=L.call(this,t=S(t,!0));return!(this===H&&o(R,t)&&!o(z,t))&&(!(e||!o(this,t)||!o(R,t)||o(this,F)&&this[F][t])||e)},Z=function(t,e){if(t=w(t),e=S(e,!0),t!==H||!o(R,e)||o(z,e)){var n=O(t,e);return!n||!o(R,e)||o(t,F)&&t[F][e]||(n.enumerable=!0),n}},Q=function(t){for(var e,n=P(w(t)),i=[],r=0;n.length>r;)o(R,e=n[r++])||e==F||e==u||i.push(e);return i},tt=function(t){for(var e,n=t===H,i=P(n?z:w(t)),r=[],a=0;i.length>a;)!o(R,e=i[a++])||n&&!o(H,e)||r.push(R[e]);return r};W||(E=function(){if(this instanceof E)throw TypeError("Symbol is not a constructor!");var t=p(arguments.length>0?arguments[0]:void 0),e=function e(n){this===H&&e.call(z,n),o(this,F)&&o(this[F],t)&&(this[F][t]=!1),Y(this,t,x(1,n))};return a&&U&&Y(H,t,{configurable:!0,set:e}),V(t)},c(E.prototype,"toString",function(){return this._k}),_.f=Z,D.f=G,n(37).f=M.f=Q,n(48).f=K,n(51).f=tt,a&&!n(34)&&c(H,"propertyIsEnumerable",K,!0),v.f=function(t){return V(h(t))}),s(s.G+s.W+s.F*!W,{Symbol:E});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)h(et[nt++]);for(var it=$(h.store),rt=0;it.length>rt;)g(it[rt++]);s(s.S+s.F*!W,"Symbol",{for:function(t){return o(j,t+="")?j[t]:j[t]=E(t)},keyFor:function(t){if(!q(t))throw TypeError(t+" is not a symbol!");for(var e in j)if(j[e]===t)return e},useSetter:function(){U=!0},useSimple:function(){U=!1}}),s(s.S+s.F*!W,"Object",{create:J,defineProperty:G,defineProperties:X,getOwnPropertyDescriptor:Z,getOwnPropertyNames:Q,getOwnPropertySymbols:tt}),A&&s(s.S+s.F*(!W||l(function(){var t=E();return"[null]"!=N([t])||"{}"!=N({a:t})||"{}"!=N(Object(t))})),"JSON",{stringify:function(t){for(var e,n,i=[t],r=1;arguments.length>r;)i.push(arguments[r++]);if(n=e=i[1],(k(e)||void 0!==t)&&!q(t))return m(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!q(e))return e}),i[1]=e,N.apply(A,i)}}),E.prototype[I]||n(11)(E.prototype,I,E.prototype.valueOf),f(E,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(t,e,n){"use strict";t.exports=!n(7)&&!n(3)(function(){return 7!=Object.defineProperty(n(63)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){"use strict";e.f=n(5)},function(t,e,n){"use strict";var i=n(16),r=n(13),o=n(50)(!1),a=n(65)("IE_PROTO");t.exports=function(t,e){var n,s=r(t),c=0,u=[];for(n in s)n!=a&&i(s,n)&&u.push(n);for(;e.length>c;)i(s,n=e[c++])&&(~o(u,n)||u.push(n));return u}},function(t,e,n){"use strict";var i=n(6),r=n(1),o=n(35);t.exports=n(7)?Object.defineProperties:function(t,e){r(t);for(var n,a=o(e),s=a.length,c=0;s>c;)i.f(t,n=a[c++],e[n]);return t}},function(t,e,n){"use strict";var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},r=n(13),o=n(37).f,a={}.toString,s="object"==("undefined"==typeof window?"undefined":i(window))&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],c=function(t){try{return o(t)}catch(t){return s.slice()}};t.exports.f=function(t){return s&&"[object Window]"==a.call(t)?c(t):o(r(t))}},function(t,e,n){"use strict";var i=n(0);i(i.S,"Object",{create:n(30)})},function(t,e,n){"use strict";var i=n(0);i(i.S+i.F*!n(7),"Object",{defineProperty:n(6).f})},function(t,e,n){"use strict";var i=n(0);i(i.S+i.F*!n(7),"Object",{defineProperties:n(96)})},function(t,e,n){"use strict";var i=n(13),r=n(14).f;n(25)("getOwnPropertyDescriptor",function(){return function(t,e){return r(i(t),e)}})},function(t,e,n){"use strict";var i=n(9),r=n(17);n(25)("getPrototypeOf",function(){return function(t){return r(i(t))}})},function(t,e,n){"use strict";var i=n(9),r=n(35);n(25)("keys",function(){return function(t){return r(i(t))}})},function(t,e,n){"use strict";n(25)("getOwnPropertyNames",function(){return n(97).f})},function(t,e,n){"use strict";var i=n(4),r=n(29).onFreeze;n(25)("freeze",function(t){return function(e){return t&&i(e)?t(r(e)):e}})},function(t,e,n){"use strict";var i=n(4),r=n(29).onFreeze;n(25)("seal",function(t){return function(e){return t&&i(e)?t(r(e)):e}})},function(t,e,n){"use strict";var i=n(4),r=n(29).onFreeze;n(25)("preventExtensions",function(t){return function(e){return t&&i(e)?t(r(e)):e}})},function(t,e,n){"use strict";var i=n(4);n(25)("isFrozen",function(t){return function(e){return!i(e)||!!t&&t(e)}})},function(t,e,n){"use strict";var i=n(4);n(25)("isSealed",function(t){return function(e){return!i(e)||!!t&&t(e)}})},function(t,e,n){"use strict";var i=n(4);n(25)("isExtensible",function(t){return function(e){return!!i(e)&&(!t||t(e))}})},function(t,e,n){"use strict";var i=n(0);i(i.S+i.F,"Object",{assign:n(112)})},function(t,e,n){"use strict";var i=n(35),r=n(51),o=n(48),a=n(9),s=n(47),c=Object.assign;t.exports=!c||n(3)(function(){var t={},e={},n=Symbol(),i="abcdefghijklmnopqrst";return t[n]=7,i.split("").forEach(function(t){e[t]=t}),7!=c({},t)[n]||Object.keys(c({},e)).join("")!=i})?function(t,e){for(var n=a(t),c=arguments.length,u=1,l=r.f,d=o.f;c>u;)for(var f,p=s(arguments[u++]),h=l?i(p).concat(l(p)):i(p),v=h.length,g=0;v>g;)d.call(p,f=h[g++])&&(n[f]=p[f]);return n}:c},function(t,e,n){"use strict";var i=n(0);i(i.S,"Object",{is:n(156)})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Object",{setPrototypeOf:n(68).set})},function(t,e,n){"use strict";var i=n(43),r={};r[n(5)("toStringTag")]="z",r+""!="[object z]"&&n(12)(Object.prototype,"toString",function(){return"[object "+i(this)+"]"},!0)},function(t,e,n){"use strict";var i=n(10),r=n(4),o=n(117),a=[].slice,s={},c=function(t,e,n){if(!(e in s)){for(var i=[],r=0;r<e;r++)i[r]="a["+r+"]";s[e]=Function("F,a","return new F("+i.join(",")+")")}return s[e](t,n)};t.exports=Function.bind||function(t){var e=i(this),n=a.call(arguments,1),s=function i(){var r=n.concat(a.call(arguments));return this instanceof i?c(e,r.length,r):o(e,r,t)};return r(e.prototype)&&(s.prototype=e.prototype),s}},function(t,e,n){"use strict";t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){"use strict";var i=n(2).parseInt,r=n(44).trim,o=n(69),a=/^[-+]?0[xX]/;t.exports=8!==i(o+"08")||22!==i(o+"0x16")?function(t,e){var n=r(String(t),3);return i(n,e>>>0||(a.test(n)?16:10))}:i},function(t,e,n){"use strict";var i=n(2).parseFloat,r=n(44).trim;t.exports=1/i(n(69)+"-0")!=-1/0?function(t){var e=r(String(t),3),n=i(e);return 0===n&&"-"==e.charAt(0)?-0:n}:i},function(t,e,n){"use strict";var i=n(19);t.exports=function(t,e){if("number"!=typeof t&&"Number"!=i(t))throw TypeError(e);return+t}},function(t,e,n){"use strict";var i=n(4),r=Math.floor;t.exports=function(t){return!i(t)&&isFinite(t)&&r(t)===t}},function(t,e,n){"use strict";t.exports=Math.log1p||function(t){return(t=+t)>-1e-8&&t<1e-8?t-t*t/2:Math.log(1+t)}},function(t,e,n){"use strict";var i=n(72),r=Math.pow,o=r(2,-52),a=r(2,-23),s=r(2,127)*(2-a),c=r(2,-126),u=function(t){return t+1/o-1/o};t.exports=Math.fround||function(t){var e,n,r=Math.abs(t),l=i(t);return r<c?l*u(r/c/a)*c*a:(e=(1+a/o)*r,n=e-(e-r),n>s||n!=n?l*(1/0):l*n)}},function(t,e,n){"use strict";var i=n(1);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(10),r=n(9),o=n(47),a=n(8);t.exports=function(t,e,n,s,c){i(e);var u=r(t),l=o(u),d=a(u.length),f=c?d-1:0,p=c?-1:1;if(n<2)for(;;){if(f in l){s=l[f],f+=p;break}if(f+=p,c?f<0:d<=f)throw TypeError("Reduce of empty array with no initial value")}for(;c?f>=0:d>f;f+=p)f in l&&(s=e(s,l[f],f,u));return s}},function(t,e,n){"use strict";var i=n(9),r=n(36),o=n(8);t.exports=[].copyWithin||function(t,e){var n=i(this),a=o(n.length),s=r(t,a),c=r(e,a),u=arguments.length>2?arguments[2]:void 0,l=Math.min((void 0===u?a:r(u,a))-c,a-s),d=1;for(c<s&&s<c+l&&(d=-1,c+=l-1,s+=l-1);l-- >0;)c in n?n[s]=n[c]:delete n[s],s+=d,c+=d;return n}},function(t,e,n){"use strict";t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){"use strict";n(7)&&"g"!=/./g.flags&&n(6).f(RegExp.prototype,"flags",{configurable:!0,get:n(55)})},function(t,e,n){"use strict";t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){"use strict";var i=n(1),r=n(4),o=n(87);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){"use strict";var i=n(132),r=n(46);t.exports=n(58)("Map",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{get:function(t){var e=i.getEntry(r(this,"Map"),t);return e&&e.v},set:function(t,e){return i.def(r(this,"Map"),0===t?0:t,e)}},i,!0)},function(t,e,n){"use strict";var i=n(6).f,r=n(30),o=n(41),a=n(18),s=n(39),c=n(40),u=n(75),l=n(127),d=n(38),f=n(7),p=n(29).fastKey,h=n(46),v=f?"_s":"size",g=function(t,e){var n,i=p(e);if("F"!==i)return t._i[i];for(n=t._f;n;n=n.n)if(n.k==e)return n};t.exports={getConstructor:function(t,e,n,u){var l=t(function(t,i){s(t,l,e,"_i"),t._t=e,t._i=r(null),t._f=void 0,t._l=void 0,t[v]=0,void 0!=i&&c(i,n,t[u],t)});return o(l.prototype,{clear:function(){for(var t=h(this,e),n=t._i,i=t._f;i;i=i.n)i.r=!0,i.p&&(i.p=i.p.n=void 0),delete n[i.i];t._f=t._l=void 0,t[v]=0},delete:function(t){var n=h(this,e),i=g(n,t);if(i){var r=i.n,o=i.p;delete n._i[i.i],i.r=!0,o&&(o.n=r),r&&(r.p=o),n._f==i&&(n._f=r),n._l==i&&(n._l=o),n[v]--}return!!i},forEach:function(t){h(this,e);for(var n,i=a(t,arguments.length>1?arguments[1]:void 0,3);n=n?n.n:this._f;)for(i(n.v,n.k,this);n&&n.r;)n=n.p},has:function(t){return!!g(h(this,e),t)}}),f&&i(l.prototype,"size",{get:function(){return h(this,e)[v]}}),l},def:function(t,e,n){var i,r,o=g(t,e);return o?o.v=n:(t._l=o={i:r=p(e,!0),k:e,v:n,p:i=t._l,n:void 0,r:!1},t._f||(t._f=o),i&&(i.n=o),t[v]++,"F"!==r&&(t._i[r]=o)),t},getEntry:g,setStrong:function(t,e,n){u(t,e,function(t,n){this._t=h(t,e),this._k=n,this._l=void 0},function(){for(var t=this,e=t._k,n=t._l;n&&n.r;)n=n.p;return t._t&&(t._l=n=n?n.n:t._t._f)?"keys"==e?l(0,n.k):"values"==e?l(0,n.v):l(0,[n.k,n.v]):(t._t=void 0,l(1))},n?"entries":"values",!n,!0),d(e)}}},function(t,e,n){"use strict";var i=n(132),r=n(46);t.exports=n(58)("Set",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return i.def(r(this,"Set"),t=0===t?0:t,t)}},i)},function(t,e,n){"use strict";var i,r=n(26)(0),o=n(12),a=n(29),s=n(112),c=n(135),u=n(4),l=n(3),d=n(46),f=a.getWeak,p=Object.isExtensible,h=c.ufstore,v={},g=function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},y={get:function(t){if(u(t)){var e=f(t);return!0===e?h(d(this,"WeakMap")).get(t):e?e[this._i]:void 0}},set:function(t,e){return c.def(d(this,"WeakMap"),t,e)}},m=t.exports=n(58)("WeakMap",g,y,c,!0,!0);l(function(){return 7!=(new m).set((Object.freeze||Object)(v),7).get(v)})&&(i=c.getConstructor(g,"WeakMap"),s(i.prototype,y),a.NEED=!0,r(["delete","has","get","set"],function(t){var e=m.prototype,n=e[t];o(e,t,function(e,r){if(u(e)&&!p(e)){this._f||(this._f=new i);var o=this._f[t](e,r);return"set"==t?this:o}return n.call(this,e,r)})}))},function(t,e,n){"use strict";var i=n(41),r=n(29).getWeak,o=n(1),a=n(4),s=n(39),c=n(40),u=n(26),l=n(16),d=n(46),f=u(5),p=u(6),h=0,v=function(t){return t._l||(t._l=new g)},g=function(){this.a=[]},y=function(t,e){return f(t.a,function(t){return t[0]===e})};g.prototype={get:function(t){var e=y(this,t);if(e)return e[1]},has:function(t){return!!y(this,t)},set:function(t,e){var n=y(this,t);n?n[1]=e:this.a.push([t,e])},delete:function(t){var e=p(this.a,function(e){return e[0]===t});return~e&&this.a.splice(e,1),!!~e}},t.exports={getConstructor:function(t,e,n,o){var u=t(function(t,i){s(t,u,e,"_i"),t._t=e,t._i=h++,t._l=void 0,void 0!=i&&c(i,n,t[o],t)});return i(u.prototype,{delete:function(t){if(!a(t))return!1;var n=r(t);return!0===n?v(d(this,e)).delete(t):n&&l(n,this._i)&&delete n[this._i]},has:function(t){if(!a(t))return!1;var n=r(t);return!0===n?v(d(this,e)).has(t):n&&l(n,this._i)}}),u},def:function(t,e,n){var i=r(o(e),!0);return!0===i?v(t).set(e,n):i[t._i]=n,t},ufstore:v}},function(t,e,n){"use strict";var i=n(24),r=n(8);t.exports=function(t){if(void 0===t)return 0;var e=i(t),n=r(e);if(e!==n)throw RangeError("Wrong length!");return n}},function(t,e,n){"use strict";function i(t,e,n,u,l,d,f,p){for(var h,v,g=l,y=0,m=!!f&&s(f,p,3);y<u;){if(y in n){if(h=m?m(n[y],y,e):n[y],v=!1,o(h)&&(v=h[c],v=void 0!==v?!!v:r(h)),v&&d>0)g=i(t,e,h,a(h.length),g,d-1)-1;else{if(g>=9007199254740991)throw TypeError();t[g]=h}g++}y++}return g}var r=n(52),o=n(4),a=n(8),s=n(18),c=n(5)("isConcatSpreadable");t.exports=i},function(t,e,n){"use strict";var i=n(8),r=n(71),o=n(23);t.exports=function(t,e,n,a){var s=String(o(t)),c=s.length,u=void 0===n?" ":String(n),l=i(e);if(l<=c||""==u)return s;var d=l-c,f=r.call(u,Math.ceil(d/u.length));return f.length>d&&(f=f.slice(0,d)),a?f+s:s+f}},function(t,e,n){"use strict";var i=n(0),r=n(89),o=n(13),a=n(14),s=n(80);i(i.S,"Object",{getOwnPropertyDescriptors:function(t){for(var e,n,i=o(t),c=a.f,u=r(i),l={},d=0;u.length>d;)void 0!==(n=c(i,e=u[d++]))&&s(l,e,n);return l}})},function(t,e,n){"use strict";var i=n(0),r=n(141)(!1);i(i.S,"Object",{values:function(t){return r(t)}})},function(t,e,n){"use strict";var i=n(35),r=n(13),o=n(48).f;t.exports=function(t){return function(e){for(var n,a=r(e),s=i(a),c=s.length,u=0,l=[];c>u;)o.call(a,n=s[u++])&&l.push(t?[n,a[n]]:a[n]);return l}}},function(t,e,n){"use strict";var i=n(0),r=n(141)(!0);i(i.S,"Object",{entries:function(t){return r(t)}})},function(t,e,n){"use strict";var i=n(0),r=n(9),o=n(10),a=n(6);n(7)&&i(i.P+n(60),"Object",{__defineGetter__:function(t,e){a.f(r(this),t,{get:o(e),enumerable:!0,configurable:!0})}})},function(t,e,n){"use strict";var i=n(0),r=n(9),o=n(10),a=n(6);n(7)&&i(i.P+n(60),"Object",{__defineSetter__:function(t,e){a.f(r(this),t,{set:o(e),enumerable:!0,configurable:!0})}})},function(t,e,n){"use strict";var i=n(0),r=n(9),o=n(22),a=n(17),s=n(14).f;n(7)&&i(i.P+n(60),"Object",{__lookupGetter__:function(t){var e,n=r(this),i=o(t,!0);do{if(e=s(n,i))return e.get}while(n=a(n))}})},function(t,e,n){"use strict";var i=n(0),r=n(9),o=n(22),a=n(17),s=n(14).f;n(7)&&i(i.P+n(60),"Object",{__lookupSetter__:function(t){var e,n=r(this),i=o(t,!0);do{if(e=s(n,i))return e.set}while(n=a(n))}})},function(t,e,n){"use strict";var i=n(43),r=n(148);t.exports=function(t){return function(){if(i(this)!=t)throw TypeError(t+"#toJSON isn't generic");return r(this)}}},function(t,e,n){"use strict";var i=n(40);t.exports=function(t,e){var n=[];return i(t,!1,n.push,n,e),n}},function(t,e,n){"use strict";t.exports=Math.scale||function(t,e,n,i,r){return 0===arguments.length||t!=t||e!=e||n!=n||i!=i||r!=r?NaN:t===1/0||t===-1/0?t:(t-e)*(r-i)/(n-e)+i}},function(t,e,n){"use strict";var i=n(6),r=n(14),o=n(89),a=n(13);t.exports=function(t,e){for(var n,s=o(a(e)),c=s.length,u=0;c>u;)i.f(t,n=s[u++],r.f(e,n));return t}},,function(t,e,n){"use strict";(function(t){var n,i,r,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};!function(a,s){if("object"===o(e)&&"object"===o(t))t.exports=s();else{i=[],n=s,void 0!==(r="function"==typeof n?n.apply(e,i):n)&&(t.exports=r)}}(0,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={exports:{},id:i,loaded:!1};return t[i].call(r.exports,r,r.exports,e),r.loaded=!0,r.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){t.exports="ngFileSaver",angular.module("ngFileSaver",[]).factory("FileSaver",["Blob","SaveAs","FileSaverUtils",n(1)]).factory("FileSaverUtils",[n(2)]).factory("Blob",["$window",n(3)]).factory("SaveAs",[n(5)])},function(t,e){t.exports=function(t,e,n){function i(t,i,r){try{e(t,i,r)}catch(t){n.handleErrors(t.message)}}return{saveAs:function(t,e,r){return n.isBlobInstance(t)||n.handleErrors("Data argument should be a blob instance"),n.isString(e)||n.handleErrors("Filename argument should be a string"),i(t,e,r)}}}},function(t,e){t.exports=function(){return{handleErrors:function(t){throw new Error(t)},isString:function(t){return"string"==typeof t||t instanceof String},isUndefined:function(t){return void 0===t},isBlobInstance:function(t){return t instanceof Blob}}}},function(t,e,n){n(4),t.exports=function(t){return t.Blob}},function(t,e){/*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */
!function(t){if(t.URL=t.URL||t.webkitURL,t.Blob&&t.URL)try{return void new Blob}catch(t){}var e=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||function(t){var e=function(t){return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1]},n=function(){this.data=[]},i=function(t,e,n){this.data=t,this.size=t.length,this.type=e,this.encoding=n},r=n.prototype,o=i.prototype,a=t.FileReaderSync,s=function(t){this.code=this[this.name=t]},c="NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "),u=c.length,l=t.URL||t.webkitURL||t,d=l.createObjectURL,f=l.revokeObjectURL,p=l,h=t.btoa,v=t.atob,g=t.ArrayBuffer,y=t.Uint8Array,m=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;for(i.fake=o.fake=!0;u--;)s.prototype[c[u]]=u+1;return l.createObjectURL||(p=t.URL=function(t){var e,n=document.createElementNS("http://www.w3.org/1999/xhtml","a");return n.href=t,"origin"in n||("data:"===n.protocol.toLowerCase()?n.origin=null:(e=t.match(m),n.origin=e&&e[1])),n}),p.createObjectURL=function(t){var e,n=t.type;return null===n&&(n="application/octet-stream"),t instanceof i?(e="data:"+n,"base64"===t.encoding?e+";base64,"+t.data:"URI"===t.encoding?e+","+decodeURIComponent(t.data):h?e+";base64,"+h(t.data):e+","+encodeURIComponent(t.data)):d?d.call(l,t):void 0},p.revokeObjectURL=function(t){"data:"!==t.substring(0,5)&&f&&f.call(l,t)},r.append=function(t){var n=this.data;if(y&&(t instanceof g||t instanceof y)){for(var r="",o=new y(t),c=0,u=o.length;c<u;c++)r+=String.fromCharCode(o[c]);n.push(r)}else if("Blob"===e(t)||"File"===e(t)){if(!a)throw new s("NOT_READABLE_ERR");var l=new a;n.push(l.readAsBinaryString(t))}else t instanceof i?"base64"===t.encoding&&v?n.push(v(t.data)):"URI"===t.encoding?n.push(decodeURIComponent(t.data)):"raw"===t.encoding&&n.push(t.data):("string"!=typeof t&&(t+=""),n.push(unescape(encodeURIComponent(t))))},r.getBlob=function(t){return arguments.length||(t=null),new i(this.data.join(""),t,"raw")},r.toString=function(){return"[object BlobBuilder]"},o.slice=function(t,e,n){var r=arguments.length;return r<3&&(n=null),new i(this.data.slice(t,r>1?e:this.data.length),n,this.encoding)},o.toString=function(){return"[object Blob]"},o.close=function(){this.size=0,delete this.data},n}(t);t.Blob=function(t,n){var i=n?n.type||"":"",r=new e;if(t)for(var o=0,a=t.length;o<a;o++)Uint8Array&&t[o]instanceof Uint8Array?r.append(t[o].buffer):r.append(t[o]);var s=r.getBlob(i);return!s.slice&&s.webkitSlice&&(s.slice=s.webkitSlice),s};var n=Object.getPrototypeOf||function(t){return t.__proto__};t.Blob.prototype=n(new t.Blob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||this.content||this)},function(t,e,n){t.exports=function(){return n(6).saveAs||function(){}}},function(t,e,n){var i,r=r||function(t){if(!(void 0===t||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var e=t.document,n=function(){return t.URL||t.webkitURL||t},i=e.createElementNS("http://www.w3.org/1999/xhtml","a"),r="download"in i,o=function(t){var e=new MouseEvent("click");t.dispatchEvent(e)},a=/constructor/i.test(t.HTMLElement)||t.safari,s=/CriOS\/[\d]+/.test(navigator.userAgent),c=function(e){(t.setImmediate||t.setTimeout)(function(){throw e},0)},u=function(t){var e=function(){"string"==typeof t?n().revokeObjectURL(t):t.remove()};setTimeout(e,4e4)},l=function(t,e,n){e=[].concat(e);for(var i=e.length;i--;){var r=t["on"+e[i]];if("function"==typeof r)try{r.call(t,n||t)}catch(t){c(t)}}},d=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},f=function(e,c,f){f||(e=d(e));var p,h=this,v=e.type,g="application/octet-stream"===v,y=function(){l(h,"writestart progress write writeend".split(" "))};if(h.readyState=h.INIT,r)return p=n().createObjectURL(e),void setTimeout(function(){i.href=p,i.download=c,o(i),y(),u(p),h.readyState=h.DONE});!function(){if((s||g&&a)&&t.FileReader){var i=new FileReader;return i.onloadend=function(){var e=s?i.result:i.result.replace(/^data:[^;]*;/,"data:attachment/file;");t.open(e,"_blank")||(t.location.href=e),e=void 0,h.readyState=h.DONE,y()},i.readAsDataURL(e),void(h.readyState=h.INIT)}if(p||(p=n().createObjectURL(e)),g)t.location.href=p;else{t.open(p,"_blank")||(t.location.href=p)}h.readyState=h.DONE,y(),u(p)}()},p=f.prototype,h=function(t,e,n){return new f(t,e||t.name||"download",n)};return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=d(t)),navigator.msSaveOrOpenBlob(t,e)}:(p.abort=function(){},p.readyState=p.INIT=0,p.WRITING=1,p.DONE=2,p.error=p.onwritestart=p.onprogress=p.onwrite=p.onabort=p.onerror=p.onwriteend=null,h)}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||this.content);void 0!==t&&t.exports?t.exports.saveAs=r:null!==n(7)&&null!==n(8)&&void 0!==(i=function(){return r}.call(e,n,e,t))&&(t.exports=i)},function(t,e){t.exports=function(){throw new Error("define cannot be used indirect")}},function(t,e){(function(e){t.exports=e}).call(e,{})}])})}).call(e,n(349)(t))},,function(t,e,n){"use strict";n(92),n(98),n(99),n(100),n(101),n(102),n(103),n(104),n(105),n(106),n(107),n(108),n(109),n(110),n(111),n(113),n(114),n(115),n(157),n(158),n(159),n(160),n(161),n(162),n(163),n(164),n(165),n(166),n(167),n(168),n(169),n(170),n(171),n(172),n(173),n(174),n(175),n(176),n(177),n(178),n(179),n(180),n(181),n(182),n(183),n(184),n(185),n(186),n(187),n(188),n(189),n(190),n(191),n(192),n(193),n(194),n(195),n(196),n(197),n(198),n(199),n(200),n(201),n(202),n(203),n(204),n(205),n(206),n(207),n(208),n(209),n(210),n(211),n(212),n(213),n(214),n(215),n(217),n(218),n(220),n(221),n(222),n(223),n(224),n(225),n(226),n(228),n(229),n(230),n(231),n(232),n(233),n(234),n(235),n(236),n(237),n(238),n(239),n(240),n(84),n(241),n(242),n(128),n(243),n(244),n(245),n(246),n(247),n(131),n(133),n(134),n(248),n(249),n(250),n(251),n(252),n(253),n(254),n(255),n(256),n(257),n(258),n(259),n(260),n(261),n(262),n(263),n(264),n(265),n(266),n(267),n(268),n(269),n(270),n(271),n(272),n(273),n(274),n(275),n(276),n(277),n(278),n(279),n(280),n(281),n(282),n(283),n(284),n(139),n(140),n(142),n(143),n(144),n(145),n(146),n(285),n(286),n(287),n(288),n(289),n(290),n(291),n(292),n(293),n(294),n(295),n(296),n(297),n(298),n(299),n(300),n(301),n(302),n(303),n(304),n(305),n(306),n(307),n(308),n(309),n(310),n(311),n(312),n(313),n(314),n(315),n(316),n(317),n(318),n(319),n(320),n(321),n(322),n(323),n(324),n(325),t.exports=n(21)},function(t,e,n){"use strict";var i=n(35),r=n(51),o=n(48);t.exports=function(t){var e=i(t),n=r.f;if(n)for(var a,s=n(t),c=o.f,u=0;s.length>u;)c.call(t,a=s[u++])&&e.push(a);return e}},function(t,e,n){"use strict";t.exports=Object.is||function(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}},function(t,e,n){"use strict";var i=n(0);i(i.P,"Function",{bind:n(116)})},function(t,e,n){"use strict";var i=n(6).f,r=Function.prototype,o=/^\s*function ([^ (]*)/;"name"in r||n(7)&&i(r,"name",{configurable:!0,get:function(){try{return(""+this).match(o)[1]}catch(t){return""}}})},function(t,e,n){"use strict";var i=n(4),r=n(17),o=n(5)("hasInstance"),a=Function.prototype;o in a||n(6).f(a,o,{value:function(t){if("function"!=typeof this||!i(t))return!1;if(!i(this.prototype))return t instanceof this;for(;t=r(t);)if(this.prototype===t)return!0;return!1}})},function(t,e,n){"use strict";var i=n(0),r=n(118);i(i.G+i.F*(parseInt!=r),{parseInt:r})},function(t,e,n){"use strict";var i=n(0),r=n(119);i(i.G+i.F*(parseFloat!=r),{parseFloat:r})},function(t,e,n){"use strict";var i=n(2),r=n(16),o=n(19),a=n(70),s=n(22),c=n(3),u=n(37).f,l=n(14).f,d=n(6).f,f=n(44).trim,p=i.Number,h=p,v=p.prototype,g="Number"==o(n(30)(v)),y="trim"in String.prototype,m=function(t){var e=s(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():f(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var a,c=e.slice(2),u=0,l=c.length;u<l;u++)if((a=c.charCodeAt(u))<48||a>r)return NaN;return parseInt(c,i)}}return+e};if(!p(" 0o1")||!p("0b1")||p("+0x1")){p=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof p&&(g?c(function(){v.valueOf.call(n)}):"Number"!=o(n))?a(new h(m(e)),n,p):m(e)};for(var b,k=n(7)?u(h):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),w=0;k.length>w;w++)r(h,b=k[w])&&!r(p,b)&&d(p,b,l(h,b));p.prototype=v,v.constructor=p,n(12)(i,"Number",p)}},function(t,e,n){"use strict";var i=n(0),r=n(24),o=n(120),a=n(71),s=1..toFixed,c=Math.floor,u=[0,0,0,0,0,0],l="Number.toFixed: incorrect invocation!",d=function(t,e){for(var n=-1,i=e;++n<6;)i+=t*u[n],u[n]=i%1e7,i=c(i/1e7)},f=function(t){for(var e=6,n=0;--e>=0;)n+=u[e],u[e]=c(n/t),n=n%t*1e7},p=function(){for(var t=6,e="";--t>=0;)if(""!==e||0===t||0!==u[t]){var n=String(u[t]);e=""===e?n:e+a.call("0",7-n.length)+n}return e},h=function t(e,n,i){return 0===n?i:n%2==1?t(e,n-1,i*e):t(e*e,n/2,i)},v=function(t){for(var e=0,n=t;n>=4096;)e+=12,n/=4096;for(;n>=2;)e+=1,n/=2;return e};i(i.P+i.F*(!!s&&("0.000"!==8e-5.toFixed(3)||"1"!==.9.toFixed(0)||"1.25"!==1.255.toFixed(2)||"1000000000000000128"!==(0xde0b6b3a7640080).toFixed(0))||!n(3)(function(){s.call({})})),"Number",{toFixed:function(t){var e,n,i,s,c=o(this,l),u=r(t),g="",y="0";if(u<0||u>20)throw RangeError(l);if(c!=c)return"NaN";if(c<=-1e21||c>=1e21)return String(c);if(c<0&&(g="-",c=-c),c>1e-21)if(e=v(c*h(2,69,1))-69,n=e<0?c*h(2,-e,1):c/h(2,e,1),n*=4503599627370496,(e=52-e)>0){for(d(0,n),i=u;i>=7;)d(1e7,0),i-=7;for(d(h(10,i,1),0),i=e-1;i>=23;)f(1<<23),i-=23;f(1<<i),d(1,1),f(2),y=p()}else d(0,n),d(1<<-e,0),y=p()+a.call("0",u);return u>0?(s=y.length,y=g+(s<=u?"0."+a.call("0",u-s)+y:y.slice(0,s-u)+"."+y.slice(s-u))):y=g+y,y}})},function(t,e,n){"use strict";var i=n(0),r=n(3),o=n(120),a=1..toPrecision;i(i.P+i.F*(r(function(){return"1"!==a.call(1,void 0)})||!r(function(){a.call({})})),"Number",{toPrecision:function(t){var e=o(this,"Number#toPrecision: incorrect invocation!");return void 0===t?a.call(e):a.call(e,t)}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Number",{EPSILON:Math.pow(2,-52)})},function(t,e,n){"use strict";var i=n(0),r=n(2).isFinite;i(i.S,"Number",{isFinite:function(t){return"number"==typeof t&&r(t)}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Number",{isInteger:n(121)})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Number",{isNaN:function(t){return t!=t}})},function(t,e,n){"use strict";var i=n(0),r=n(121),o=Math.abs;i(i.S,"Number",{isSafeInteger:function(t){return r(t)&&o(t)<=9007199254740991}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Number",{MAX_SAFE_INTEGER:9007199254740991})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Number",{MIN_SAFE_INTEGER:-9007199254740991})},function(t,e,n){"use strict";var i=n(0),r=n(119);i(i.S+i.F*(Number.parseFloat!=r),"Number",{parseFloat:r})},function(t,e,n){"use strict";var i=n(0),r=n(118);i(i.S+i.F*(Number.parseInt!=r),"Number",{parseInt:r})},function(t,e,n){"use strict";var i=n(0),r=n(122),o=Math.sqrt,a=Math.acosh;i(i.S+i.F*!(a&&710==Math.floor(a(Number.MAX_VALUE))&&a(1/0)==1/0),"Math",{acosh:function(t){return(t=+t)<1?NaN:t>94906265.62425156?Math.log(t)+Math.LN2:r(t-1+o(t-1)*o(t+1))}})},function(t,e,n){"use strict";function i(t){return isFinite(t=+t)&&0!=t?t<0?-i(-t):Math.log(t+Math.sqrt(t*t+1)):t}var r=n(0),o=Math.asinh;r(r.S+r.F*!(o&&1/o(0)>0),"Math",{asinh:i})},function(t,e,n){"use strict";var i=n(0),r=Math.atanh;i(i.S+i.F*!(r&&1/r(-0)<0),"Math",{atanh:function(t){return 0==(t=+t)?t:Math.log((1+t)/(1-t))/2}})},function(t,e,n){"use strict";var i=n(0),r=n(72);i(i.S,"Math",{cbrt:function(t){return r(t=+t)*Math.pow(Math.abs(t),1/3)}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{clz32:function(t){return(t>>>=0)?31-Math.floor(Math.log(t+.5)*Math.LOG2E):32}})},function(t,e,n){"use strict";var i=n(0),r=Math.exp;i(i.S,"Math",{cosh:function(t){return(r(t=+t)+r(-t))/2}})},function(t,e,n){"use strict";var i=n(0),r=n(73);i(i.S+i.F*(r!=Math.expm1),"Math",{expm1:r})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{fround:n(123)})},function(t,e,n){"use strict";var i=n(0),r=Math.abs;i(i.S,"Math",{hypot:function(t,e){for(var n,i,o=0,a=0,s=arguments.length,c=0;a<s;)n=r(arguments[a++]),c<n?(i=c/n,o=o*i*i+1,c=n):n>0?(i=n/c,o+=i*i):o+=n;return c===1/0?1/0:c*Math.sqrt(o)}})},function(t,e,n){"use strict";var i=n(0),r=Math.imul;i(i.S+i.F*n(3)(function(){return-5!=r(4294967295,5)||2!=r.length}),"Math",{imul:function(t,e){var n=+t,i=+e,r=65535&n,o=65535&i;return 0|r*o+((65535&n>>>16)*o+r*(65535&i>>>16)<<16>>>0)}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{log10:function(t){return Math.log(t)*Math.LOG10E}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{log1p:n(122)})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{log2:function(t){return Math.log(t)/Math.LN2}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{sign:n(72)})},function(t,e,n){"use strict";var i=n(0),r=n(73),o=Math.exp;i(i.S+i.F*n(3)(function(){return-2e-17!=!Math.sinh(-2e-17)}),"Math",{sinh:function(t){return Math.abs(t=+t)<1?(r(t)-r(-t))/2:(o(t-1)-o(-t-1))*(Math.E/2)}})},function(t,e,n){"use strict";var i=n(0),r=n(73),o=Math.exp;i(i.S,"Math",{tanh:function(t){var e=r(t=+t),n=r(-t);return e==1/0?1:n==1/0?-1:(e-n)/(o(t)+o(-t))}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{trunc:function(t){return(t>0?Math.floor:Math.ceil)(t)}})},function(t,e,n){"use strict";var i=n(0),r=n(36),o=String.fromCharCode,a=String.fromCodePoint;i(i.S+i.F*(!!a&&1!=a.length),"String",{fromCodePoint:function(t){for(var e,n=[],i=arguments.length,a=0;i>a;){if(e=+arguments[a++],r(e,1114111)!==e)throw RangeError(e+" is not a valid code point");n.push(e<65536?o(e):o(55296+((e-=65536)>>10),e%1024+56320))}return n.join("")}})},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(8);i(i.S,"String",{raw:function(t){for(var e=r(t.raw),n=o(e.length),i=arguments.length,a=[],s=0;n>s;)a.push(String(e[s++])),s<i&&a.push(String(arguments[s]));return a.join("")}})},function(t,e,n){"use strict";n(44)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){"use strict";var i=n(74)(!0);n(75)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=i(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){"use strict";var i=n(0),r=n(74)(!1);i(i.P,"String",{codePointAt:function(t){return r(this,t)}})},function(t,e,n){"use strict";var i=n(0),r=n(8),o=n(77),a="".endsWith;i(i.P+i.F*n(78)("endsWith"),"String",{endsWith:function(t){var e=o(this,t,"endsWith"),n=arguments.length>1?arguments[1]:void 0,i=r(e.length),s=void 0===n?i:Math.min(r(n),i),c=String(t);return a?a.call(e,c,s):e.slice(s-c.length,s)===c}})},function(t,e,n){"use strict";var i=n(0),r=n(77);i(i.P+i.F*n(78)("includes"),"String",{includes:function(t){return!!~r(this,t,"includes").indexOf(t,arguments.length>1?arguments[1]:void 0)}})},function(t,e,n){"use strict";var i=n(0);i(i.P,"String",{repeat:n(71)})},function(t,e,n){"use strict";var i=n(0),r=n(8),o=n(77),a="".startsWith;i(i.P+i.F*n(78)("startsWith"),"String",{startsWith:function(t){var e=o(this,t,"startsWith"),n=r(Math.min(arguments.length>1?arguments[1]:void 0,e.length)),i=String(t);return a?a.call(e,i,n):e.slice(n,n+i.length)===i}})},function(t,e,n){"use strict";n(15)("anchor",function(t){return function(e){return t(this,"a","name",e)}})},function(t,e,n){"use strict";n(15)("big",function(t){return function(){return t(this,"big","","")}})},function(t,e,n){"use strict";n(15)("blink",function(t){return function(){return t(this,"blink","","")}})},function(t,e,n){"use strict";n(15)("bold",function(t){return function(){return t(this,"b","","")}})},function(t,e,n){"use strict";n(15)("fixed",function(t){return function(){return t(this,"tt","","")}})},function(t,e,n){"use strict";n(15)("fontcolor",function(t){return function(e){return t(this,"font","color",e)}})},function(t,e,n){"use strict";n(15)("fontsize",function(t){return function(e){return t(this,"font","size",e)}})},function(t,e,n){"use strict";n(15)("italics",function(t){return function(){return t(this,"i","","")}})},function(t,e,n){"use strict";n(15)("link",function(t){return function(e){return t(this,"a","href",e)}})},function(t,e,n){"use strict";n(15)("small",function(t){return function(){return t(this,"small","","")}})},function(t,e,n){"use strict";n(15)("strike",function(t){return function(){return t(this,"strike","","")}})},function(t,e,n){"use strict";n(15)("sub",function(t){return function(){return t(this,"sub","","")}})},function(t,e,n){"use strict";n(15)("sup",function(t){return function(){return t(this,"sup","","")}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Date",{now:function(){return(new Date).getTime()}})},function(t,e,n){"use strict";var i=n(0),r=n(9),o=n(22);i(i.P+i.F*n(3)(function(){return null!==new Date(NaN).toJSON()||1!==Date.prototype.toJSON.call({toISOString:function(){return 1}})}),"Date",{toJSON:function(t){var e=r(this),n=o(e);return"number"!=typeof n||isFinite(n)?e.toISOString():null}})},function(t,e,n){"use strict";var i=n(0),r=n(216);i(i.P+i.F*(Date.prototype.toISOString!==r),"Date",{toISOString:r})},function(t,e,n){"use strict";var i=n(3),r=Date.prototype.getTime,o=Date.prototype.toISOString,a=function(t){return t>9?t:"0"+t};t.exports=i(function(){return"0385-07-25T07:06:39.999Z"!=o.call(new Date(-5e13-1))})||!i(function(){o.call(new Date(NaN))})?function(){if(!isFinite(r.call(this)))throw RangeError("Invalid time value");var t=this,e=t.getUTCFullYear(),n=t.getUTCMilliseconds(),i=e<0?"-":e>9999?"+":"";return i+("00000"+Math.abs(e)).slice(i?-6:-4)+"-"+a(t.getUTCMonth()+1)+"-"+a(t.getUTCDate())+"T"+a(t.getUTCHours())+":"+a(t.getUTCMinutes())+":"+a(t.getUTCSeconds())+"."+(n>99?n:"0"+a(n))+"Z"}:o},function(t,e,n){"use strict";var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(12)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){"use strict";var i=n(5)("toPrimitive"),r=Date.prototype;i in r||n(11)(r,i,n(219))},function(t,e,n){"use strict";var i=n(1),r=n(22);t.exports=function(t){if("string"!==t&&"number"!==t&&"default"!==t)throw TypeError("Incorrect hint");return r(i(this),"number"!=t)}},function(t,e,n){"use strict";var i=n(0);i(i.S,"Array",{isArray:n(52)})},function(t,e,n){"use strict";var i=n(18),r=n(0),o=n(9),a=n(124),s=n(79),c=n(8),u=n(80),l=n(81);r(r.S+r.F*!n(54)(function(t){Array.from(t)}),"Array",{from:function(t){var e,n,r,d,f=o(t),p="function"==typeof this?this:Array,h=arguments.length,v=h>1?arguments[1]:void 0,g=void 0!==v,y=0,m=l(f);if(g&&(v=i(v,h>2?arguments[2]:void 0,2)),void 0==m||p==Array&&s(m))for(e=c(f.length),n=new p(e);e>y;y++)u(n,y,g?v(f[y],y):f[y]);else for(d=m.call(f),n=new p;!(r=d.next()).done;y++)u(n,y,g?a(d,v,[r.value,y],!0):r.value);return n.length=y,n}})},function(t,e,n){"use strict";var i=n(0),r=n(80);i(i.S+i.F*n(3)(function(){function t(){}return!(Array.of.call(t)instanceof t)}),"Array",{of:function(){for(var t=0,e=arguments.length,n=new("function"==typeof this?this:Array)(e);e>t;)r(n,t,arguments[t++]);return n.length=e,n}})},function(t,e,n){"use strict";var i=n(0),r=n(13),o=[].join;i(i.P+i.F*(n(47)!=Object||!n(20)(o)),"Array",{join:function(t){return o.call(r(this),void 0===t?",":t)}})},function(t,e,n){"use strict";var i=n(0),r=n(67),o=n(19),a=n(36),s=n(8),c=[].slice;i(i.P+i.F*n(3)(function(){r&&c.call(r)}),"Array",{slice:function(t,e){var n=s(this.length),i=o(this);if(e=void 0===e?n:e,"Array"==i)return c.call(this,t,e);for(var r=a(t,n),u=a(e,n),l=s(u-r),d=new Array(l),f=0;f<l;f++)d[f]="String"==i?this.charAt(r+f):this[r+f];return d}})},function(t,e,n){"use strict";var i=n(0),r=n(10),o=n(9),a=n(3),s=[].sort,c=[1,2,3];i(i.P+i.F*(a(function(){c.sort(void 0)})||!a(function(){c.sort(null)})||!n(20)(s)),"Array",{sort:function(t){return void 0===t?s.call(o(this)):s.call(o(this),r(t))}})},function(t,e,n){"use strict";var i=n(0),r=n(26)(0),o=n(20)([].forEach,!0);i(i.P+i.F*!o,"Array",{forEach:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(4),r=n(52),o=n(5)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){"use strict";var i=n(0),r=n(26)(1);i(i.P+i.F*!n(20)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(0),r=n(26)(2);i(i.P+i.F*!n(20)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(0),r=n(26)(3);i(i.P+i.F*!n(20)([].some,!0),"Array",{some:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(0),r=n(26)(4);i(i.P+i.F*!n(20)([].every,!0),"Array",{every:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(0),r=n(125);i(i.P+i.F*!n(20)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){"use strict";var i=n(0),r=n(125);i(i.P+i.F*!n(20)([].reduceRight,!0),"Array",{reduceRight:function(t){return r(this,t,arguments.length,arguments[1],!0)}})},function(t,e,n){"use strict";var i=n(0),r=n(50)(!1),o=[].indexOf,a=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(a||!n(20)(o)),"Array",{indexOf:function(t){return a?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(24),a=n(8),s=[].lastIndexOf,c=!!s&&1/[1].lastIndexOf(1,-0)<0;i(i.P+i.F*(c||!n(20)(s)),"Array",{lastIndexOf:function(t){if(c)return s.apply(this,arguments)||0;var e=r(this),n=a(e.length),i=n-1;for(arguments.length>1&&(i=Math.min(i,o(arguments[1]))),i<0&&(i=n+i);i>=0;i--)if(i in e&&e[i]===t)return i||0;return-1}})},function(t,e,n){"use strict";var i=n(0);i(i.P,"Array",{copyWithin:n(126)}),n(31)("copyWithin")},function(t,e,n){"use strict";var i=n(0);i(i.P,"Array",{fill:n(83)}),n(31)("fill")},function(t,e,n){"use strict";var i=n(0),r=n(26)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(31)("find")},function(t,e,n){"use strict";var i=n(0),r=n(26)(6),o="findIndex",a=!0;o in[]&&Array(1)[o](function(){a=!1}),i(i.P+i.F*a,"Array",{findIndex:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(31)(o)},function(t,e,n){"use strict";n(38)("Array")},function(t,e,n){"use strict";var i=n(2),r=n(70),o=n(6).f,a=n(37).f,s=n(53),c=n(55),u=i.RegExp,l=u,d=u.prototype,f=/a/g,p=/a/g,h=new u(f)!==f;if(n(7)&&(!h||n(3)(function(){return p[n(5)("match")]=!1,u(f)!=f||u(p)==p||"/a/i"!=u(f,"i")}))){u=function(t,e){var n=this instanceof u,i=s(t),o=void 0===e;return!n&&i&&t.constructor===u&&o?t:r(h?new l(i&&!o?t.source:t,e):l((i=t instanceof u)?t.source:t,i&&o?c.call(t):e),n?this:d,u)};for(var v=a(l),g=0;v.length>g;)!function(t){t in u||o(u,t,{configurable:!0,get:function(){return l[t]},set:function(e){l[t]=e}})}(v[g++]);d.constructor=u,u.prototype=d,n(12)(i,"RegExp",u)}n(38)("RegExp")},function(t,e,n){"use strict";n(128);var i=n(1),r=n(55),o=n(7),a=/./.toString,s=function(t){n(12)(RegExp.prototype,"toString",t,!0)};n(3)(function(){return"/a/b"!=a.call({source:"a",flags:"b"})})?s(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=a.name&&s(function(){return a.call(this)})},function(t,e,n){"use strict";n(56)("match",1,function(t,e,n){return[function(n){var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(56)("replace",2,function(t,e,n){return[function(i,r){var o=t(this),a=void 0==i?void 0:i[e];return void 0!==a?a.call(i,o,r):n.call(String(o),i,r)},n]})},function(t,e,n){"use strict";n(56)("search",1,function(t,e,n){return[function(n){var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(56)("split",2,function(t,e,i){var r=n(53),o=i,a=[].push,s="length";if("c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1)[s]||2!="ab".split(/(?:ab)*/)[s]||4!=".".split(/(.?)(.?)/)[s]||".".split(/()()/)[s]>1||"".split(/.?/)[s]){var c=void 0===/()??/.exec("")[1];i=function(t,e){var n=String(this);if(void 0===t&&0===e)return[];if(!r(t))return o.call(n,t,e);var i,u,l,d,f,p=[],h=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),v=0,g=void 0===e?4294967295:e>>>0,y=new RegExp(t.source,h+"g");for(c||(i=new RegExp("^"+y.source+"$(?!\\s)",h));(u=y.exec(n))&&!((l=u.index+u[0][s])>v&&(p.push(n.slice(v,u.index)),!c&&u[s]>1&&u[0].replace(i,function(){for(f=1;f<arguments[s]-2;f++)void 0===arguments[f]&&(u[f]=void 0)}),u[s]>1&&u.index<n[s]&&a.apply(p,u.slice(1)),d=u[0][s],v=l,p[s]>=g));)y.lastIndex===u.index&&y.lastIndex++;return v===n[s]?!d&&y.test("")||p.push(""):p.push(n.slice(v)),p[s]>g?p.slice(0,g):p}}else"0".split(void 0,0)[s]&&(i=function(t,e){return void 0===t&&0===e?[]:o.call(this,t,e)});return[function(n,r){var o=t(this),a=void 0==n?void 0:n[e];return void 0!==a?a.call(n,o,r):i.call(String(o),n,r)},i]})},function(t,e,n){"use strict";var i,r,o,a,s=n(34),c=n(2),u=n(18),l=n(43),d=n(0),f=n(4),p=n(10),h=n(39),v=n(40),g=n(57),y=n(85).set,m=n(86)(),b=n(87),k=n(129),w=n(130),S=c.TypeError,x=c.process,T=c.Promise,M="process"==l(x),_=function(){},D=r=b.f,$=!!function(){try{var t=T.resolve(1),e=(t.constructor={})[n(5)("species")]=function(t){t(_,_)};return(M||"function"==typeof PromiseRejectionEvent)&&t.then(_)instanceof e}catch(t){}}(),O=function(t){var e;return!(!f(t)||"function"!=typeof(e=t.then))&&e},C=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,a,s=r?e.ok:e.fail,c=e.resolve,u=e.reject,l=e.domain;try{s?(r||(2==t._h&&A(t),t._h=1),!0===s?n=i:(l&&l.enter(),n=s(i),l&&(l.exit(),a=!0)),n===e.promise?u(S("Promise-chain cycle")):(o=O(n))?o.call(n,c,u):c(n)):u(i)}catch(t){l&&!a&&l.exit(),u(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&P(t)})}},P=function(t){y.call(c,function(){var e,n,i,r=t._v,o=E(t);if(o&&(e=k(function(){M?x.emit("unhandledRejection",r,t):(n=c.onunhandledrejection)?n({promise:t,reason:r}):(i=c.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=M||E(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},E=function(t){return 1!==t._h&&0===(t._a||t._c).length},A=function(t){y.call(c,function(){var e;M?x.emit("rejectionHandled",t):(e=c.onrejectionhandled)&&e({promise:t,reason:t._v})})},N=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),C(e,!0))},F=function t(e){var n,i=this;if(!i._d){i._d=!0,i=i._w||i;try{if(i===e)throw S("Promise can't be resolved itself");(n=O(e))?m(function(){var r={_w:i,_d:!1};try{n.call(e,u(t,r,1),u(N,r,1))}catch(t){N.call(r,t)}}):(i._v=e,i._s=1,C(i,!1))}catch(t){N.call({_w:i,_d:!1},t)}}};$||(T=function(t){h(this,T,"Promise","_h"),p(t),i.call(this);try{t(u(F,this,1),u(N,this,1))}catch(t){N.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(41)(T.prototype,{then:function(t,e){var n=D(g(this,T));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=M?x.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&C(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=u(F,t,1),this.reject=u(N,t,1)},b.f=D=function(t){return t===T||t===a?new o(t):r(t)}),d(d.G+d.W+d.F*!$,{Promise:T}),n(42)(T,"Promise"),n(38)("Promise"),a=n(21).Promise,d(d.S+d.F*!$,"Promise",{reject:function(t){var e=D(this);return(0,e.reject)(t),e.promise}}),d(d.S+d.F*(s||!$),"Promise",{resolve:function(t){return w(s&&this===a?T:this,t)}}),d(d.S+d.F*!($&&n(54)(function(t){T.all(t).catch(_)})),"Promise",{all:function(t){var e=this,n=D(e),i=n.resolve,r=n.reject,o=k(function(){var n=[],o=0,a=1;v(t,!1,function(t){var s=o++,c=!1;n.push(void 0),a++,e.resolve(t).then(function(t){c||(c=!0,n[s]=t,--a||i(n))},r)}),--a||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=D(e),i=n.reject,r=k(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(135),r=n(46);n(58)("WeakSet",function(t){return function(){return t(this,arguments.length>0?arguments[0]:void 0)}},{add:function(t){return i.def(r(this,"WeakSet"),t,!0)}},i,!1,!0)},function(t,e,n){"use strict";var i=n(0),r=n(59),o=n(88),a=n(1),s=n(36),c=n(8),u=n(4),l=n(2).ArrayBuffer,d=n(57),f=o.ArrayBuffer,p=o.DataView,h=r.ABV&&l.isView,v=f.prototype.slice,g=r.VIEW;i(i.G+i.W+i.F*(l!==f),{ArrayBuffer:f}),i(i.S+i.F*!r.CONSTR,"ArrayBuffer",{isView:function(t){return h&&h(t)||u(t)&&g in t}}),i(i.P+i.U+i.F*n(3)(function(){return!new f(2).slice(1,void 0).byteLength}),"ArrayBuffer",{slice:function(t,e){if(void 0!==v&&void 0===e)return v.call(a(this),t);for(var n=a(this).byteLength,i=s(t,n),r=s(void 0===e?n:e,n),o=new(d(this,f))(c(r-i)),u=new p(this),l=new p(o),h=0;i<r;)l.setUint8(h++,u.getUint8(i++));return o}}),n(38)("ArrayBuffer")},function(t,e,n){"use strict";var i=n(0);i(i.G+i.W+i.F*!n(59).ABV,{DataView:n(88).DataView})},function(t,e,n){"use strict";n(27)("Int8",1,function(t){return function(e,n,i){return t(this,e,n,i)}})},function(t,e,n){"use strict";n(27)("Uint8",1,function(t){return function(e,n,i){return t(this,e,n,i)}})},function(t,e,n){"use strict";n(27)("Uint8",1,function(t){return function(e,n,i){return t(this,e,n,i)}},!0)},function(t,e,n){"use strict";n(27)("Int16",2,function(t){return function(e,n,i){return t(this,e,n,i)}})},function(t,e,n){"use strict";n(27)("Uint16",2,function(t){return function(e,n,i){return t(this,e,n,i)}})},function(t,e,n){"use strict";n(27)("Int32",4,function(t){return function(e,n,i){return t(this,e,n,i)}})},function(t,e,n){"use strict";n(27)("Uint32",4,function(t){return function(e,n,i){return t(this,e,n,i)}})},function(t,e,n){"use strict";n(27)("Float32",4,function(t){return function(e,n,i){return t(this,e,n,i)}})},function(t,e,n){"use strict";n(27)("Float64",8,function(t){return function(e,n,i){return t(this,e,n,i)}})},function(t,e,n){"use strict";var i=n(0),r=n(10),o=n(1),a=(n(2).Reflect||{}).apply,s=Function.apply;i(i.S+i.F*!n(3)(function(){a(function(){})}),"Reflect",{apply:function(t,e,n){var i=r(t),c=o(n);return a?a(i,e,c):s.call(i,e,c)}})},function(t,e,n){"use strict";var i=n(0),r=n(30),o=n(10),a=n(1),s=n(4),c=n(3),u=n(116),l=(n(2).Reflect||{}).construct,d=c(function(){function t(){}return!(l(function(){},[],t)instanceof t)}),f=!c(function(){l(function(){})});i(i.S+i.F*(d||f),"Reflect",{construct:function(t,e){o(t),a(e);var n=arguments.length<3?t:o(arguments[2]);if(f&&!d)return l(t,e,n);if(t==n){switch(e.length){case 0:return new t;case 1:return new t(e[0]);case 2:return new t(e[0],e[1]);case 3:return new t(e[0],e[1],e[2]);case 4:return new t(e[0],e[1],e[2],e[3])}var i=[null];return i.push.apply(i,e),new(u.apply(t,i))}var c=n.prototype,p=r(s(c)?c:Object.prototype),h=Function.apply.call(t,p,e);return s(h)?h:p}})},function(t,e,n){"use strict";var i=n(6),r=n(0),o=n(1),a=n(22);r(r.S+r.F*n(3)(function(){Reflect.defineProperty(i.f({},1,{value:1}),1,{value:2})}),"Reflect",{defineProperty:function(t,e,n){o(t),e=a(e,!0),o(n);try{return i.f(t,e,n),!0}catch(t){return!1}}})},function(t,e,n){"use strict";var i=n(0),r=n(14).f,o=n(1);i(i.S,"Reflect",{deleteProperty:function(t,e){var n=r(o(t),e);return!(n&&!n.configurable)&&delete t[e]}})},function(t,e,n){"use strict";var i=n(0),r=n(1),o=function(t){this._t=r(t),this._i=0;var e,n=this._k=[];for(e in t)n.push(e)};n(76)(o,"Object",function(){var t,e=this,n=e._k;do{if(e._i>=n.length)return{value:void 0,done:!0}}while(!((t=n[e._i++])in e._t));return{value:t,done:!1}}),i(i.S,"Reflect",{enumerate:function(t){return new o(t)}})},function(t,e,n){"use strict";function i(t,e){var n,s,l=arguments.length<3?t:arguments[2];return u(t)===l?t[e]:(n=r.f(t,e))?a(n,"value")?n.value:void 0!==n.get?n.get.call(l):void 0:c(s=o(t))?i(s,e,l):void 0}var r=n(14),o=n(17),a=n(16),s=n(0),c=n(4),u=n(1);s(s.S,"Reflect",{get:i})},function(t,e,n){"use strict";var i=n(14),r=n(0),o=n(1);r(r.S,"Reflect",{getOwnPropertyDescriptor:function(t,e){return i.f(o(t),e)}})},function(t,e,n){"use strict";var i=n(0),r=n(17),o=n(1);i(i.S,"Reflect",{getPrototypeOf:function(t){return r(o(t))}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Reflect",{has:function(t,e){return e in t}})},function(t,e,n){"use strict";var i=n(0),r=n(1),o=Object.isExtensible;i(i.S,"Reflect",{isExtensible:function(t){return r(t),!o||o(t)}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Reflect",{ownKeys:n(89)})},function(t,e,n){"use strict";var i=n(0),r=n(1),o=Object.preventExtensions;i(i.S,"Reflect",{preventExtensions:function(t){r(t);try{return o&&o(t),!0}catch(t){return!1}}})},function(t,e,n){"use strict";function i(t,e,n){var c,f,p=arguments.length<4?t:arguments[3],h=o.f(l(t),e);if(!h){if(d(f=a(t)))return i(f,e,n,p);h=u(0)}return s(h,"value")?!(!1===h.writable||!d(p))&&(c=o.f(p,e)||u(0),c.value=n,r.f(p,e,c),!0):void 0!==h.set&&(h.set.call(p,n),!0)}var r=n(6),o=n(14),a=n(17),s=n(16),c=n(0),u=n(32),l=n(1),d=n(4);c(c.S,"Reflect",{set:i})},function(t,e,n){"use strict";var i=n(0),r=n(68);r&&i(i.S,"Reflect",{setPrototypeOf:function(t,e){r.check(t,e);try{return r.set(t,e),!0}catch(t){return!1}}})},function(t,e,n){"use strict";var i=n(0),r=n(50)(!0);i(i.P,"Array",{includes:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(31)("includes")},function(t,e,n){"use strict";var i=n(0),r=n(137),o=n(9),a=n(8),s=n(10),c=n(82);i(i.P,"Array",{flatMap:function(t){var e,n,i=o(this);return s(t),e=a(i.length),n=c(i,0),r(n,i,i,e,0,1,t,arguments[1]),n}}),n(31)("flatMap")},function(t,e,n){"use strict";var i=n(0),r=n(137),o=n(9),a=n(8),s=n(24),c=n(82);i(i.P,"Array",{flatten:function(){var t=arguments[0],e=o(this),n=a(e.length),i=c(e,0);return r(i,e,e,n,0,void 0===t?1:s(t)),i}}),n(31)("flatten")},function(t,e,n){"use strict";var i=n(0),r=n(74)(!0);i(i.P,"String",{at:function(t){return r(this,t)}})},function(t,e,n){"use strict";var i=n(0),r=n(138),o=n(90);i(i.P+i.F*/Version\/10\.\d+(\.\d+)? Safari\//.test(o),"String",{padStart:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0,!0)}})},function(t,e,n){"use strict";var i=n(0),r=n(138),o=n(90);i(i.P+i.F*/Version\/10\.\d+(\.\d+)? Safari\//.test(o),"String",{padEnd:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0,!1)}})},function(t,e,n){"use strict";n(44)("trimLeft",function(t){return function(){return t(this,1)}},"trimStart")},function(t,e,n){"use strict";n(44)("trimRight",function(t){return function(){return t(this,2)}},"trimEnd")},function(t,e,n){"use strict";var i=n(0),r=n(23),o=n(8),a=n(53),s=n(55),c=RegExp.prototype,u=function(t,e){this._r=t,this._s=e};n(76)(u,"RegExp String",function(){var t=this._r.exec(this._s);return{value:t,done:null===t}}),i(i.P,"String",{matchAll:function(t){if(r(this),!a(t))throw TypeError(t+" is not a regexp!");var e=String(this),n="flags"in c?String(t.flags):s.call(t),i=new RegExp(t.source,~n.indexOf("g")?n:"g"+n);return i.lastIndex=o(t.lastIndex),new u(i,e)}})},function(t,e,n){"use strict";n(64)("asyncIterator")},function(t,e,n){"use strict";n(64)("observable")},function(t,e,n){"use strict";var i=n(0);i(i.P+i.R,"Map",{toJSON:n(147)("Map")})},function(t,e,n){"use strict";var i=n(0);i(i.P+i.R,"Set",{toJSON:n(147)("Set")})},function(t,e,n){"use strict";n(61)("Map")},function(t,e,n){"use strict";n(61)("Set")},function(t,e,n){"use strict";n(61)("WeakMap")},function(t,e,n){"use strict";n(61)("WeakSet")},function(t,e,n){"use strict";n(62)("Map")},function(t,e,n){"use strict";n(62)("Set")},function(t,e,n){"use strict";n(62)("WeakMap")},function(t,e,n){"use strict";n(62)("WeakSet")},function(t,e,n){"use strict";var i=n(0);i(i.G,{global:n(2)})},function(t,e,n){"use strict";var i=n(0);i(i.S,"System",{global:n(2)})},function(t,e,n){"use strict";var i=n(0),r=n(19);i(i.S,"Error",{isError:function(t){return"Error"===r(t)}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{clamp:function(t,e,n){return Math.min(n,Math.max(e,t))}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{DEG_PER_RAD:Math.PI/180})},function(t,e,n){"use strict";var i=n(0),r=180/Math.PI;i(i.S,"Math",{degrees:function(t){return t*r}})},function(t,e,n){"use strict";var i=n(0),r=n(149),o=n(123);i(i.S,"Math",{fscale:function(t,e,n,i,a){return o(r(t,e,n,i,a))}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{iaddh:function(t,e,n,i){var r=t>>>0,o=e>>>0,a=n>>>0;return o+(i>>>0)+((r&a|(r|a)&~(r+a>>>0))>>>31)|0}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{isubh:function(t,e,n,i){var r=t>>>0,o=e>>>0,a=n>>>0;return o-(i>>>0)-((~r&a|~(r^a)&r-a>>>0)>>>31)|0}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{imulh:function(t,e){var n=+t,i=+e,r=65535&n,o=65535&i,a=n>>16,s=i>>16,c=(a*o>>>0)+(r*o>>>16);return a*s+(c>>16)+((r*s>>>0)+(65535&c)>>16)}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{RAD_PER_DEG:180/Math.PI})},function(t,e,n){"use strict";var i=n(0),r=Math.PI/180;i(i.S,"Math",{radians:function(t){return t*r}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{scale:n(149)})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{umulh:function(t,e){var n=+t,i=+e,r=65535&n,o=65535&i,a=n>>>16,s=i>>>16,c=(a*o>>>0)+(r*o>>>16);return a*s+(c>>>16)+((r*s>>>0)+(65535&c)>>>16)}})},function(t,e,n){"use strict";var i=n(0);i(i.S,"Math",{signbit:function(t){return(t=+t)!=t?t:0==t?1/t==1/0:t>0}})},function(t,e,n){"use strict";var i=n(0),r=n(21),o=n(2),a=n(57),s=n(130);i(i.P+i.R,"Promise",{finally:function(t){var e=a(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return s(e,t()).then(function(){return n})}:t,n?function(n){return s(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";var i=n(0),r=n(87),o=n(129);i(i.S,"Promise",{try:function(t){var e=r.f(this),n=o(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},function(t,e,n){"use strict";var i=n(28),r=n(1),o=i.key,a=i.set;i.exp({defineMetadata:function(t,e,n,i){a(t,e,r(n),o(i))}})},function(t,e,n){"use strict";var i=n(28),r=n(1),o=i.key,a=i.map,s=i.store;i.exp({deleteMetadata:function(t,e){var n=arguments.length<3?void 0:o(arguments[2]),i=a(r(e),n,!1);if(void 0===i||!i.delete(t))return!1;if(i.size)return!0;var c=s.get(e);return c.delete(n),!!c.size||s.delete(e)}})},function(t,e,n){"use strict";var i=n(28),r=n(1),o=n(17),a=i.has,s=i.get,c=i.key,u=function t(e,n,i){if(a(e,n,i))return s(e,n,i);var r=o(n);return null!==r?t(e,r,i):void 0};i.exp({getMetadata:function(t,e){return u(t,r(e),arguments.length<3?void 0:c(arguments[2]))}})},function(t,e,n){"use strict";var i=n(133),r=n(148),o=n(28),a=n(1),s=n(17),c=o.keys,u=o.key,l=function t(e,n){var o=c(e,n),a=s(e);if(null===a)return o;var u=t(a,n);return u.length?o.length?r(new i(o.concat(u))):u:o};o.exp({getMetadataKeys:function(t){return l(a(t),arguments.length<2?void 0:u(arguments[1]))}})},function(t,e,n){"use strict";var i=n(28),r=n(1),o=i.get,a=i.key;i.exp({getOwnMetadata:function(t,e){return o(t,r(e),arguments.length<3?void 0:a(arguments[2]))}})},function(t,e,n){"use strict";var i=n(28),r=n(1),o=i.keys,a=i.key;i.exp({getOwnMetadataKeys:function(t){return o(r(t),arguments.length<2?void 0:a(arguments[1]))}})},function(t,e,n){"use strict";var i=n(28),r=n(1),o=n(17),a=i.has,s=i.key,c=function t(e,n,i){if(a(e,n,i))return!0;var r=o(n);return null!==r&&t(e,r,i)};i.exp({hasMetadata:function(t,e){return c(t,r(e),arguments.length<3?void 0:s(arguments[2]))}})},function(t,e,n){"use strict";var i=n(28),r=n(1),o=i.has,a=i.key;i.exp({hasOwnMetadata:function(t,e){return o(t,r(e),arguments.length<3?void 0:a(arguments[2]))}})},function(t,e,n){"use strict";var i=n(28),r=n(1),o=n(10),a=i.key,s=i.set;i.exp({metadata:function(t,e){return function(n,i){s(t,e,(void 0!==i?r:o)(n),a(i))}}})},function(t,e,n){"use strict";var i=n(0),r=n(86)(),o=n(2).process,a="process"==n(19)(o);i(i.G,{asap:function(t){var e=a&&o.domain;r(e?e.bind(t):t)}})},function(t,e,n){"use strict";var i=n(0),r=n(2),o=n(21),a=n(86)(),s=n(5)("observable"),c=n(10),u=n(1),l=n(39),d=n(41),f=n(11),p=n(40),h=p.RETURN,v=function(t){return null==t?void 0:c(t)},g=function(t){var e=t._c;e&&(t._c=void 0,e())},y=function(t){return void 0===t._o},m=function(t){y(t)||(t._o=void 0,g(t))},b=function(t,e){u(t),this._c=void 0,this._o=t,t=new k(this);try{var n=e(t),i=n;null!=n&&("function"==typeof n.unsubscribe?n=function(){i.unsubscribe()}:c(n),this._c=n)}catch(e){return void t.error(e)}y(this)&&g(this)};b.prototype=d({},{unsubscribe:function(){m(this)}});var k=function(t){this._s=t};k.prototype=d({},{next:function(t){var e=this._s;if(!y(e)){var n=e._o;try{var i=v(n.next);if(i)return i.call(n,t)}catch(t){try{m(e)}finally{throw t}}}},error:function(t){var e=this._s;if(y(e))throw t;var n=e._o;e._o=void 0;try{var i=v(n.error);if(!i)throw t;t=i.call(n,t)}catch(t){try{g(e)}finally{throw t}}return g(e),t},complete:function(t){var e=this._s;if(!y(e)){var n=e._o;e._o=void 0;try{var i=v(n.complete);t=i?i.call(n,t):void 0}catch(t){try{g(e)}finally{throw t}}return g(e),t}}});var w=function(t){l(this,w,"Observable","_f")._f=c(t)};d(w.prototype,{subscribe:function(t){return new b(t,this._f)},forEach:function(t){var e=this;return new(o.Promise||r.Promise)(function(n,i){c(t);var r=e.subscribe({next:function(e){try{return t(e)}catch(t){i(t),r.unsubscribe()}},error:i,complete:n})})}}),d(w,{from:function(t){var e="function"==typeof this?this:w,n=v(u(t)[s]);if(n){var i=u(n.call(t));return i.constructor===e?i:new e(function(t){return i.subscribe(t)})}return new e(function(e){var n=!1;return a(function(){if(!n){try{if(p(t,!1,function(t){if(e.next(t),n)return h})===h)return}catch(t){if(n)throw t;return void e.error(t)}e.complete()}}),function(){n=!0}})},of:function(){for(var t=0,e=arguments.length,n=new Array(e);t<e;)n[t]=arguments[t++];return new("function"==typeof this?this:w)(function(t){var e=!1;return a(function(){if(!e){for(var i=0;i<n.length;++i)if(t.next(n[i]),e)return;t.complete()}}),function(){e=!0}})}}),f(w.prototype,s,function(){return this}),i(i.G,{Observable:w}),n(38)("Observable")},function(t,e,n){"use strict";var i=n(2),r=n(0),o=n(90),a=[].slice,s=/MSIE .\./.test(o),c=function(t){return function(e,n){var i=arguments.length>2,r=!!i&&a.call(arguments,2);return t(i?function(){("function"==typeof e?e:Function(e)).apply(this,r)}:e,n)}};r(r.G+r.B+r.F*s,{setTimeout:c(i.setTimeout),setInterval:c(i.setInterval)})},function(t,e,n){"use strict";var i=n(0),r=n(85);i(i.G+i.B,{setImmediate:r.set,clearImmediate:r.clear})},function(t,e,n){"use strict";for(var i=n(84),r=n(35),o=n(12),a=n(2),s=n(11),c=n(45),u=n(5),l=u("iterator"),d=u("toStringTag"),f=c.Array,p={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},h=r(p),v=0;v<h.length;v++){var g,y=h[v],m=p[y],b=a[y],k=b&&b.prototype;if(k&&(k[l]||s(k,l,f),k[d]||s(k,d,y),c[y]=f,m))for(g in i)k[g]||o(k,g,i[g],!0)}},function(t,e,n){"use strict";n(92),n(98),n(99),n(100),n(101),n(102),n(103),n(104),n(105),n(106),n(107),n(108),n(109),n(110),n(111),n(113),n(114),n(115),n(139),n(140),n(142),n(143),n(144),n(145),n(146),n(327),n(328),n(329),n(330),t.exports=n(21).Object},function(t,e,n){"use strict";var i=n(0);i(i.S+i.F,"Object",{isObject:n(4)})},function(t,e,n){"use strict";var i=n(0);i(i.S+i.F,"Object",{classof:n(43)})},function(t,e,n){"use strict";var i=n(0),r=n(150);i(i.S+i.F,"Object",{define:r})},function(t,e,n){"use strict";var i=n(0),r=n(150),o=n(30);i(i.S+i.F,"Object",{make:function(t,e){return r(o(t),e)}})},function(t,e){},function(t,e,n){"use strict";function i(t,e){var n=t[1]||"",i=t[3];if(!i)return n;if(e&&"function"==typeof btoa){var o=r(i);return[n].concat(i.sources.map(function(t){return"/*# sourceURL="+i.sourceRoot+t+" */"})).concat([o]).join("\n")}return[n].join("\n")}function r(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var n=i(e,t);return e[2]?"@media "+e[2]+"{"+n+"}":n}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var i={},r=0;r<this.length;r++){var o=this[r][0];"number"==typeof o&&(i[o]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&i[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(t,e,n){"use strict";var i,r,o,a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};!function(a){r=[n(334)],i=a,void 0!==(o="function"==typeof i?i.apply(e,r):i)&&(t.exports=o)}(function(t){var e=window.Slick||{};e=function(){function e(e,i){var r,o=this;o.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:t(e),appendDots:t(e),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,n){return t('<button type="button" />').text(n+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},o.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},t.extend(o,o.initials),o.activeBreakpoint=null,o.animType=null,o.animProp=null,o.breakpoints=[],o.breakpointSettings=[],o.cssTransitions=!1,o.focussed=!1,o.interrupted=!1,o.hidden="hidden",o.paused=!0,o.positionProp=null,o.respondTo=null,o.rowCount=1,o.shouldClick=!0,o.$slider=t(e),o.$slidesCache=null,o.transformType=null,o.transitionType=null,o.visibilityChange="visibilitychange",o.windowWidth=0,o.windowTimer=null,r=t(e).data("slick")||{},o.options=t.extend({},o.defaults,i,r),o.currentSlide=o.options.initialSlide,o.originalSettings=o.options,void 0!==document.mozHidden?(o.hidden="mozHidden",o.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(o.hidden="webkitHidden",o.visibilityChange="webkitvisibilitychange"),o.autoPlay=t.proxy(o.autoPlay,o),o.autoPlayClear=t.proxy(o.autoPlayClear,o),o.autoPlayIterator=t.proxy(o.autoPlayIterator,o),o.changeSlide=t.proxy(o.changeSlide,o),o.clickHandler=t.proxy(o.clickHandler,o),o.selectHandler=t.proxy(o.selectHandler,o),o.setPosition=t.proxy(o.setPosition,o),o.swipeHandler=t.proxy(o.swipeHandler,o),o.dragHandler=t.proxy(o.dragHandler,o),o.keyHandler=t.proxy(o.keyHandler,o),o.instanceUid=n++,o.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,o.registerBreakpoints(),o.init(!0)}var n=0;return e}(),e.prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,n,i){var r=this;if("boolean"==typeof n)i=n,n=null;else if(n<0||n>=r.slideCount)return!1;r.unload(),"number"==typeof n?0===n&&0===r.$slides.length?t(e).appendTo(r.$slideTrack):i?t(e).insertBefore(r.$slides.eq(n)):t(e).insertAfter(r.$slides.eq(n)):!0===i?t(e).prependTo(r.$slideTrack):t(e).appendTo(r.$slideTrack),r.$slides=r.$slideTrack.children(this.options.slide),r.$slideTrack.children(this.options.slide).detach(),r.$slideTrack.append(r.$slides),r.$slides.each(function(e,n){t(n).attr("data-slick-index",e)}),r.$slidesCache=r.$slides,r.reinit()},e.prototype.animateHeight=function(){var t=this;if(1===t.options.slidesToShow&&!0===t.options.adaptiveHeight&&!1===t.options.vertical){var e=t.$slides.eq(t.currentSlide).outerHeight(!0);t.$list.animate({height:e},t.options.speed)}},e.prototype.animateSlide=function(e,n){var i={},r=this;r.animateHeight(),!0===r.options.rtl&&!1===r.options.vertical&&(e=-e),!1===r.transformsEnabled?!1===r.options.vertical?r.$slideTrack.animate({left:e},r.options.speed,r.options.easing,n):r.$slideTrack.animate({top:e},r.options.speed,r.options.easing,n):!1===r.cssTransitions?(!0===r.options.rtl&&(r.currentLeft=-r.currentLeft),t({animStart:r.currentLeft}).animate({animStart:e},{duration:r.options.speed,easing:r.options.easing,step:function(t){t=Math.ceil(t),!1===r.options.vertical?(i[r.animType]="translate("+t+"px, 0px)",r.$slideTrack.css(i)):(i[r.animType]="translate(0px,"+t+"px)",r.$slideTrack.css(i))},complete:function(){n&&n.call()}})):(r.applyTransition(),e=Math.ceil(e),!1===r.options.vertical?i[r.animType]="translate3d("+e+"px, 0px, 0px)":i[r.animType]="translate3d(0px,"+e+"px, 0px)",r.$slideTrack.css(i),n&&setTimeout(function(){r.disableTransition(),n.call()},r.options.speed))},e.prototype.getNavTarget=function(){var e=this,n=e.options.asNavFor;return n&&null!==n&&(n=t(n).not(e.$slider)),n},e.prototype.asNavFor=function(e){var n=this,i=n.getNavTarget();null!==i&&"object"===(void 0===i?"undefined":a(i))&&i.each(function(){var n=t(this).slick("getSlick");n.unslicked||n.slideHandler(e,!0)})},e.prototype.applyTransition=function(t){var e=this,n={};!1===e.options.fade?n[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:n[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(n):e.$slides.eq(t).css(n)},e.prototype.autoPlay=function(){var t=this;t.autoPlayClear(),t.slideCount>t.options.slidesToShow&&(t.autoPlayTimer=setInterval(t.autoPlayIterator,t.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var t=this;t.autoPlayTimer&&clearInterval(t.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var t=this,e=t.currentSlide+t.options.slidesToScroll;t.paused||t.interrupted||t.focussed||(!1===t.options.infinite&&(1===t.direction&&t.currentSlide+1===t.slideCount-1?t.direction=0:0===t.direction&&(e=t.currentSlide-t.options.slidesToScroll,t.currentSlide-1==0&&(t.direction=1))),t.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=t(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=t(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,n,i=this;if(!0===i.options.dots&&i.slideCount>i.options.slidesToShow){for(i.$slider.addClass("slick-dotted"),n=t("<ul />").addClass(i.options.dotsClass),e=0;e<=i.getDotCount();e+=1)n.append(t("<li />").append(i.options.customPaging.call(this,i,e)));i.$dots=n.appendTo(i.options.appendDots),i.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,n){t(n).attr("data-slick-index",e).data("originalStyling",t(n).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?t('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),t("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var t,e,n,i,r,o,a,s=this;if(i=document.createDocumentFragment(),o=s.$slider.children(),s.options.rows>0){for(a=s.options.slidesPerRow*s.options.rows,r=Math.ceil(o.length/a),t=0;t<r;t++){var c=document.createElement("div");for(e=0;e<s.options.rows;e++){var u=document.createElement("div");for(n=0;n<s.options.slidesPerRow;n++){var l=t*a+(e*s.options.slidesPerRow+n);o.get(l)&&u.appendChild(o.get(l))}c.appendChild(u)}i.appendChild(c)}s.$slider.empty().append(i),s.$slider.children().children().children().css({width:100/s.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,n){var i,r,o,a=this,s=!1,c=a.$slider.width(),u=window.innerWidth||t(window).width();if("window"===a.respondTo?o=u:"slider"===a.respondTo?o=c:"min"===a.respondTo&&(o=Math.min(u,c)),a.options.responsive&&a.options.responsive.length&&null!==a.options.responsive){r=null;for(i in a.breakpoints)a.breakpoints.hasOwnProperty(i)&&(!1===a.originalSettings.mobileFirst?o<a.breakpoints[i]&&(r=a.breakpoints[i]):o>a.breakpoints[i]&&(r=a.breakpoints[i]));null!==r?null!==a.activeBreakpoint?(r!==a.activeBreakpoint||n)&&(a.activeBreakpoint=r,"unslick"===a.breakpointSettings[r]?a.unslick(r):(a.options=t.extend({},a.originalSettings,a.breakpointSettings[r]),!0===e&&(a.currentSlide=a.options.initialSlide),a.refresh(e)),s=r):(a.activeBreakpoint=r,"unslick"===a.breakpointSettings[r]?a.unslick(r):(a.options=t.extend({},a.originalSettings,a.breakpointSettings[r]),!0===e&&(a.currentSlide=a.options.initialSlide),a.refresh(e)),s=r):null!==a.activeBreakpoint&&(a.activeBreakpoint=null,a.options=a.originalSettings,!0===e&&(a.currentSlide=a.options.initialSlide),a.refresh(e),s=r),e||!1===s||a.$slider.trigger("breakpoint",[a,s])}},e.prototype.changeSlide=function(e,n){var i,r,o,a=this,s=t(e.currentTarget);switch(s.is("a")&&e.preventDefault(),s.is("li")||(s=s.closest("li")),o=a.slideCount%a.options.slidesToScroll!=0,i=o?0:(a.slideCount-a.currentSlide)%a.options.slidesToScroll,e.data.message){case"previous":r=0===i?a.options.slidesToScroll:a.options.slidesToShow-i,a.slideCount>a.options.slidesToShow&&a.slideHandler(a.currentSlide-r,!1,n);break;case"next":r=0===i?a.options.slidesToScroll:i,a.slideCount>a.options.slidesToShow&&a.slideHandler(a.currentSlide+r,!1,n);break;case"index":var c=0===e.data.index?0:e.data.index||s.index()*a.options.slidesToScroll;a.slideHandler(a.checkNavigable(c),!1,n),s.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(t){var e,n,i=this;if(e=i.getNavigableIndexes(),n=0,t>e[e.length-1])t=e[e.length-1];else for(var r in e){if(t<e[r]){t=n;break}n=e[r]}return t},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(t("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",t.proxy(e.interrupt,e,!0)).off("mouseleave.slick",t.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),t(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&t(e.$slideTrack).children().off("click.slick",e.selectHandler),t(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),t(window).off("resize.slick.slick-"+e.instanceUid,e.resize),t("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),t(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",t.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",t.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var t,e=this;e.options.rows>0&&(t=e.$slides.children().children(),t.removeAttr("style"),e.$slider.empty().append(t))},e.prototype.clickHandler=function(t){!1===this.shouldClick&&(t.stopImmediatePropagation(),t.stopPropagation(),t.preventDefault())},e.prototype.destroy=function(e){var n=this;n.autoPlayClear(),n.touchObject={},n.cleanUpEvents(),t(".slick-cloned",n.$slider).detach(),n.$dots&&n.$dots.remove(),n.$prevArrow&&n.$prevArrow.length&&(n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),n.htmlExpr.test(n.options.prevArrow)&&n.$prevArrow.remove()),n.$nextArrow&&n.$nextArrow.length&&(n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),n.htmlExpr.test(n.options.nextArrow)&&n.$nextArrow.remove()),n.$slides&&(n.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){t(this).attr("style",t(this).data("originalStyling"))}),n.$slideTrack.children(this.options.slide).detach(),n.$slideTrack.detach(),n.$list.detach(),n.$slider.append(n.$slides)),n.cleanUpRows(),n.$slider.removeClass("slick-slider"),n.$slider.removeClass("slick-initialized"),n.$slider.removeClass("slick-dotted"),n.unslicked=!0,e||n.$slider.trigger("destroy",[n])},e.prototype.disableTransition=function(t){var e=this,n={};n[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(n):e.$slides.eq(t).css(n)},e.prototype.fadeSlide=function(t,e){var n=this;!1===n.cssTransitions?(n.$slides.eq(t).css({zIndex:n.options.zIndex}),n.$slides.eq(t).animate({opacity:1},n.options.speed,n.options.easing,e)):(n.applyTransition(t),n.$slides.eq(t).css({opacity:1,zIndex:n.options.zIndex}),e&&setTimeout(function(){n.disableTransition(t),e.call()},n.options.speed))},e.prototype.fadeSlideOut=function(t){var e=this;!1===e.cssTransitions?e.$slides.eq(t).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(t),e.$slides.eq(t).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(t){var e=this;null!==t&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(t).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(n){n.stopImmediatePropagation();var i=t(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=i.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var t=this,e=0,n=0,i=0;if(!0===t.options.infinite)if(t.slideCount<=t.options.slidesToShow)++i;else for(;e<t.slideCount;)++i,e=n+t.options.slidesToScroll,n+=t.options.slidesToScroll<=t.options.slidesToShow?t.options.slidesToScroll:t.options.slidesToShow;else if(!0===t.options.centerMode)i=t.slideCount;else if(t.options.asNavFor)for(;e<t.slideCount;)++i,e=n+t.options.slidesToScroll,n+=t.options.slidesToScroll<=t.options.slidesToShow?t.options.slidesToScroll:t.options.slidesToShow;else i=1+Math.ceil((t.slideCount-t.options.slidesToShow)/t.options.slidesToScroll);return i-1},e.prototype.getLeft=function(t){var e,n,i,r,o=this,a=0;return o.slideOffset=0,n=o.$slides.first().outerHeight(!0),!0===o.options.infinite?(o.slideCount>o.options.slidesToShow&&(o.slideOffset=o.slideWidth*o.options.slidesToShow*-1,r=-1,!0===o.options.vertical&&!0===o.options.centerMode&&(2===o.options.slidesToShow?r=-1.5:1===o.options.slidesToShow&&(r=-2)),a=n*o.options.slidesToShow*r),o.slideCount%o.options.slidesToScroll!=0&&t+o.options.slidesToScroll>o.slideCount&&o.slideCount>o.options.slidesToShow&&(t>o.slideCount?(o.slideOffset=(o.options.slidesToShow-(t-o.slideCount))*o.slideWidth*-1,a=(o.options.slidesToShow-(t-o.slideCount))*n*-1):(o.slideOffset=o.slideCount%o.options.slidesToScroll*o.slideWidth*-1,a=o.slideCount%o.options.slidesToScroll*n*-1))):t+o.options.slidesToShow>o.slideCount&&(o.slideOffset=(t+o.options.slidesToShow-o.slideCount)*o.slideWidth,a=(t+o.options.slidesToShow-o.slideCount)*n),o.slideCount<=o.options.slidesToShow&&(o.slideOffset=0,a=0),!0===o.options.centerMode&&o.slideCount<=o.options.slidesToShow?o.slideOffset=o.slideWidth*Math.floor(o.options.slidesToShow)/2-o.slideWidth*o.slideCount/2:!0===o.options.centerMode&&!0===o.options.infinite?o.slideOffset+=o.slideWidth*Math.floor(o.options.slidesToShow/2)-o.slideWidth:!0===o.options.centerMode&&(o.slideOffset=0,o.slideOffset+=o.slideWidth*Math.floor(o.options.slidesToShow/2)),e=!1===o.options.vertical?t*o.slideWidth*-1+o.slideOffset:t*n*-1+a,!0===o.options.variableWidth&&(i=o.slideCount<=o.options.slidesToShow||!1===o.options.infinite?o.$slideTrack.children(".slick-slide").eq(t):o.$slideTrack.children(".slick-slide").eq(t+o.options.slidesToShow),e=!0===o.options.rtl?i[0]?-1*(o.$slideTrack.width()-i[0].offsetLeft-i.width()):0:i[0]?-1*i[0].offsetLeft:0,!0===o.options.centerMode&&(i=o.slideCount<=o.options.slidesToShow||!1===o.options.infinite?o.$slideTrack.children(".slick-slide").eq(t):o.$slideTrack.children(".slick-slide").eq(t+o.options.slidesToShow+1),e=!0===o.options.rtl?i[0]?-1*(o.$slideTrack.width()-i[0].offsetLeft-i.width()):0:i[0]?-1*i[0].offsetLeft:0,e+=(o.$list.width()-i.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(t){return this.options[t]},e.prototype.getNavigableIndexes=function(){var t,e=this,n=0,i=0,r=[];for(!1===e.options.infinite?t=e.slideCount:(n=-1*e.options.slidesToScroll,i=-1*e.options.slidesToScroll,t=2*e.slideCount);n<t;)r.push(n),n=i+e.options.slidesToScroll,i+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return r},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,n,i=this;return n=!0===i.options.centerMode?i.slideWidth*Math.floor(i.options.slidesToShow/2):0,!0===i.options.swipeToSlide?(i.$slideTrack.find(".slick-slide").each(function(r,o){if(o.offsetLeft-n+t(o).outerWidth()/2>-1*i.swipeLeft)return e=o,!1}),Math.abs(t(e).attr("data-slick-index")-i.currentSlide)||1):i.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(t,e){this.changeSlide({data:{message:"index",index:parseInt(t)}},e)},e.prototype.init=function(e){var n=this;t(n.$slider).hasClass("slick-initialized")||(t(n.$slider).addClass("slick-initialized"),n.buildRows(),n.buildOut(),n.setProps(),n.startLoad(),n.loadSlider(),n.initializeEvents(),n.updateArrows(),n.updateDots(),n.checkResponsive(!0),n.focusHandler()),e&&n.$slider.trigger("init",[n]),!0===n.options.accessibility&&n.initADA(),n.options.autoplay&&(n.paused=!1,n.autoPlay())},e.prototype.initADA=function(){var e=this,n=Math.ceil(e.slideCount/e.options.slidesToShow),i=e.getNavigableIndexes().filter(function(t){return t>=0&&t<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(n){var r=i.indexOf(n);if(t(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+n,tabindex:-1}),-1!==r){var o="slick-slide-control"+e.instanceUid+r;t("#"+o).length&&t(this).attr({"aria-describedby":o})}}),e.$dots.attr("role","tablist").find("li").each(function(r){var o=i[r];t(this).attr({role:"presentation"}),t(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+r,"aria-controls":"slick-slide"+e.instanceUid+o,"aria-label":r+1+" of "+n,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var r=e.currentSlide,o=r+e.options.slidesToShow;r<o;r++)e.options.focusOnChange?e.$slides.eq(r).attr({tabindex:"0"}):e.$slides.eq(r).removeAttr("tabindex");e.activateADA()},e.prototype.initArrowEvents=function(){var t=this;!0===t.options.arrows&&t.slideCount>t.options.slidesToShow&&(t.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},t.changeSlide),t.$nextArrow.off("click.slick").on("click.slick",{message:"next"},t.changeSlide),!0===t.options.accessibility&&(t.$prevArrow.on("keydown.slick",t.keyHandler),t.$nextArrow.on("keydown.slick",t.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&e.slideCount>e.options.slidesToShow&&(t("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&e.slideCount>e.options.slidesToShow&&t("li",e.$dots).on("mouseenter.slick",t.proxy(e.interrupt,e,!0)).on("mouseleave.slick",t.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",t.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",t.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),t(document).on(e.visibilityChange,t.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&t(e.$slideTrack).children().on("click.slick",e.selectHandler),t(window).on("orientationchange.slick.slick-"+e.instanceUid,t.proxy(e.orientationChange,e)),t(window).on("resize.slick.slick-"+e.instanceUid,t.proxy(e.resize,e)),t("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),t(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),t(e.setPosition)},e.prototype.initUI=function(){var t=this;!0===t.options.arrows&&t.slideCount>t.options.slidesToShow&&(t.$prevArrow.show(),t.$nextArrow.show()),!0===t.options.dots&&t.slideCount>t.options.slidesToShow&&t.$dots.show()},e.prototype.keyHandler=function(t){var e=this;t.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===t.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===t.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){t("img[data-lazy]",e).each(function(){var e=t(this),n=t(this).attr("data-lazy"),i=t(this).attr("data-srcset"),r=t(this).attr("data-sizes")||a.$slider.attr("data-sizes"),o=document.createElement("img");o.onload=function(){e.animate({opacity:0},100,function(){i&&(e.attr("srcset",i),r&&e.attr("sizes",r)),e.attr("src",n).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),a.$slider.trigger("lazyLoaded",[a,e,n])})},o.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),a.$slider.trigger("lazyLoadError",[a,e,n])},o.src=n})}var n,i,r,o,a=this;if(!0===a.options.centerMode?!0===a.options.infinite?(r=a.currentSlide+(a.options.slidesToShow/2+1),o=r+a.options.slidesToShow+2):(r=Math.max(0,a.currentSlide-(a.options.slidesToShow/2+1)),o=a.options.slidesToShow/2+1+2+a.currentSlide):(r=a.options.infinite?a.options.slidesToShow+a.currentSlide:a.currentSlide,o=Math.ceil(r+a.options.slidesToShow),!0===a.options.fade&&(r>0&&r--,o<=a.slideCount&&o++)),n=a.$slider.find(".slick-slide").slice(r,o),"anticipated"===a.options.lazyLoad)for(var s=r-1,c=o,u=a.$slider.find(".slick-slide"),l=0;l<a.options.slidesToScroll;l++)s<0&&(s=a.slideCount-1),n=n.add(u.eq(s)),n=n.add(u.eq(c)),s--,c++;e(n),a.slideCount<=a.options.slidesToShow?(i=a.$slider.find(".slick-slide"),e(i)):a.currentSlide>=a.slideCount-a.options.slidesToShow?(i=a.$slider.find(".slick-cloned").slice(0,a.options.slidesToShow),e(i)):0===a.currentSlide&&(i=a.$slider.find(".slick-cloned").slice(-1*a.options.slidesToShow),e(i))},e.prototype.loadSlider=function(){var t=this;t.setPosition(),t.$slideTrack.css({opacity:1}),t.$slider.removeClass("slick-loading"),t.initUI(),"progressive"===t.options.lazyLoad&&t.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var t=this;t.checkResponsive(),t.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var t=this;t.autoPlayClear(),t.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var t=this;t.autoPlay(),t.options.autoplay=!0,t.paused=!1,t.focussed=!1,t.interrupted=!1},e.prototype.postSlide=function(e){var n=this;if(!n.unslicked&&(n.$slider.trigger("afterChange",[n,e]),n.animating=!1,n.slideCount>n.options.slidesToShow&&n.setPosition(),n.swipeLeft=null,n.options.autoplay&&n.autoPlay(),!0===n.options.accessibility&&(n.initADA(),n.options.focusOnChange))){t(n.$slides.get(n.currentSlide)).attr("tabindex",0).focus()}},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(t){t.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var n,i,r,o,a,s=this,c=t("img[data-lazy]",s.$slider);c.length?(n=c.first(),i=n.attr("data-lazy"),r=n.attr("data-srcset"),o=n.attr("data-sizes")||s.$slider.attr("data-sizes"),a=document.createElement("img"),a.onload=function(){r&&(n.attr("srcset",r),o&&n.attr("sizes",o)),n.attr("src",i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===s.options.adaptiveHeight&&s.setPosition(),s.$slider.trigger("lazyLoaded",[s,n,i]),s.progressiveLazyLoad()},a.onerror=function(){e<3?setTimeout(function(){s.progressiveLazyLoad(e+1)},500):(n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),s.$slider.trigger("lazyLoadError",[s,n,i]),s.progressiveLazyLoad())},a.src=i):s.$slider.trigger("allImagesLoaded",[s])},e.prototype.refresh=function(e){var n,i,r=this;i=r.slideCount-r.options.slidesToShow,!r.options.infinite&&r.currentSlide>i&&(r.currentSlide=i),r.slideCount<=r.options.slidesToShow&&(r.currentSlide=0),n=r.currentSlide,r.destroy(!0),t.extend(r,r.initials,{currentSlide:n}),r.init(),e||r.changeSlide({data:{message:"index",index:n}},!1)},e.prototype.registerBreakpoints=function(){var e,n,i,r=this,o=r.options.responsive||null;if("array"===t.type(o)&&o.length){r.respondTo=r.options.respondTo||"window";for(e in o)if(i=r.breakpoints.length-1,o.hasOwnProperty(e)){for(n=o[e].breakpoint;i>=0;)r.breakpoints[i]&&r.breakpoints[i]===n&&r.breakpoints.splice(i,1),i--;r.breakpoints.push(n),r.breakpointSettings[n]=o[e].settings}r.breakpoints.sort(function(t,e){return r.options.mobileFirst?t-e:e-t})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&t(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;t(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=t(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(t,e,n){var i=this;if("boolean"==typeof t?(e=t,t=!0===e?0:i.slideCount-1):t=!0===e?--t:t,i.slideCount<1||t<0||t>i.slideCount-1)return!1;i.unload(),!0===n?i.$slideTrack.children().remove():i.$slideTrack.children(this.options.slide).eq(t).remove(),i.$slides=i.$slideTrack.children(this.options.slide),i.$slideTrack.children(this.options.slide).detach(),i.$slideTrack.append(i.$slides),i.$slidesCache=i.$slides,i.reinit()},e.prototype.setCSS=function(t){var e,n,i=this,r={};!0===i.options.rtl&&(t=-t),e="left"==i.positionProp?Math.ceil(t)+"px":"0px",n="top"==i.positionProp?Math.ceil(t)+"px":"0px",r[i.positionProp]=t,!1===i.transformsEnabled?i.$slideTrack.css(r):(r={},!1===i.cssTransitions?(r[i.animType]="translate("+e+", "+n+")",i.$slideTrack.css(r)):(r[i.animType]="translate3d("+e+", "+n+", 0px)",i.$slideTrack.css(r)))},e.prototype.setDimensions=function(){var t=this;!1===t.options.vertical?!0===t.options.centerMode&&t.$list.css({padding:"0px "+t.options.centerPadding}):(t.$list.height(t.$slides.first().outerHeight(!0)*t.options.slidesToShow),!0===t.options.centerMode&&t.$list.css({padding:t.options.centerPadding+" 0px"})),t.listWidth=t.$list.width(),t.listHeight=t.$list.height(),!1===t.options.vertical&&!1===t.options.variableWidth?(t.slideWidth=Math.ceil(t.listWidth/t.options.slidesToShow),t.$slideTrack.width(Math.ceil(t.slideWidth*t.$slideTrack.children(".slick-slide").length))):!0===t.options.variableWidth?t.$slideTrack.width(5e3*t.slideCount):(t.slideWidth=Math.ceil(t.listWidth),t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0)*t.$slideTrack.children(".slick-slide").length)));var e=t.$slides.first().outerWidth(!0)-t.$slides.first().width();!1===t.options.variableWidth&&t.$slideTrack.children(".slick-slide").width(t.slideWidth-e)},e.prototype.setFade=function(){var e,n=this;n.$slides.each(function(i,r){e=n.slideWidth*i*-1,!0===n.options.rtl?t(r).css({position:"relative",right:e,top:0,zIndex:n.options.zIndex-2,opacity:0}):t(r).css({position:"relative",left:e,top:0,zIndex:n.options.zIndex-2,opacity:0})}),n.$slides.eq(n.currentSlide).css({zIndex:n.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var t=this;if(1===t.options.slidesToShow&&!0===t.options.adaptiveHeight&&!1===t.options.vertical){var e=t.$slides.eq(t.currentSlide).outerHeight(!0);t.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,n,i,r,o,a=this,s=!1;if("object"===t.type(arguments[0])?(i=arguments[0],s=arguments[1],o="multiple"):"string"===t.type(arguments[0])&&(i=arguments[0],r=arguments[1],s=arguments[2],"responsive"===arguments[0]&&"array"===t.type(arguments[1])?o="responsive":void 0!==arguments[1]&&(o="single")),"single"===o)a.options[i]=r;else if("multiple"===o)t.each(i,function(t,e){a.options[t]=e});else if("responsive"===o)for(n in r)if("array"!==t.type(a.options.responsive))a.options.responsive=[r[n]];else{for(e=a.options.responsive.length-1;e>=0;)a.options.responsive[e].breakpoint===r[n].breakpoint&&a.options.responsive.splice(e,1),e--;a.options.responsive.push(r[n])}s&&(a.unload(),a.reinit())},e.prototype.setPosition=function(){var t=this;t.setDimensions(),t.setHeight(),!1===t.options.fade?t.setCSS(t.getLeft(t.currentSlide)):t.setFade(),t.$slider.trigger("setPosition",[t])},e.prototype.setProps=function(){var t=this,e=document.body.style;t.positionProp=!0===t.options.vertical?"top":"left","top"===t.positionProp?t.$slider.addClass("slick-vertical"):t.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===t.options.useCSS&&(t.cssTransitions=!0),t.options.fade&&("number"==typeof t.options.zIndex?t.options.zIndex<3&&(t.options.zIndex=3):t.options.zIndex=t.defaults.zIndex),void 0!==e.OTransform&&(t.animType="OTransform",t.transformType="-o-transform",t.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(t.animType=!1)),void 0!==e.MozTransform&&(t.animType="MozTransform",t.transformType="-moz-transform",t.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(t.animType=!1)),void 0!==e.webkitTransform&&(t.animType="webkitTransform",t.transformType="-webkit-transform",t.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(t.animType=!1)),void 0!==e.msTransform&&(t.animType="msTransform",t.transformType="-ms-transform",t.transitionType="msTransition",void 0===e.msTransform&&(t.animType=!1)),void 0!==e.transform&&!1!==t.animType&&(t.animType="transform",t.transformType="transform",t.transitionType="transition"),t.transformsEnabled=t.options.useTransform&&null!==t.animType&&!1!==t.animType},e.prototype.setSlideClasses=function(t){var e,n,i,r,o=this;if(n=o.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),o.$slides.eq(t).addClass("slick-current"),!0===o.options.centerMode){var a=o.options.slidesToShow%2==0?1:0;e=Math.floor(o.options.slidesToShow/2),!0===o.options.infinite&&(t>=e&&t<=o.slideCount-1-e?o.$slides.slice(t-e+a,t+e+1).addClass("slick-active").attr("aria-hidden","false"):(i=o.options.slidesToShow+t,n.slice(i-e+1+a,i+e+2).addClass("slick-active").attr("aria-hidden","false")),0===t?n.eq(n.length-1-o.options.slidesToShow).addClass("slick-center"):t===o.slideCount-1&&n.eq(o.options.slidesToShow).addClass("slick-center")),o.$slides.eq(t).addClass("slick-center")}else t>=0&&t<=o.slideCount-o.options.slidesToShow?o.$slides.slice(t,t+o.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):n.length<=o.options.slidesToShow?n.addClass("slick-active").attr("aria-hidden","false"):(r=o.slideCount%o.options.slidesToShow,i=!0===o.options.infinite?o.options.slidesToShow+t:t,o.options.slidesToShow==o.options.slidesToScroll&&o.slideCount-t<o.options.slidesToShow?n.slice(i-(o.options.slidesToShow-r),i+r).addClass("slick-active").attr("aria-hidden","false"):n.slice(i,i+o.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==o.options.lazyLoad&&"anticipated"!==o.options.lazyLoad||o.lazyLoad()},e.prototype.setupInfinite=function(){var e,n,i,r=this;if(!0===r.options.fade&&(r.options.centerMode=!1),!0===r.options.infinite&&!1===r.options.fade&&(n=null,r.slideCount>r.options.slidesToShow)){for(i=!0===r.options.centerMode?r.options.slidesToShow+1:r.options.slidesToShow,e=r.slideCount;e>r.slideCount-i;e-=1)n=e-1,t(r.$slides[n]).clone(!0).attr("id","").attr("data-slick-index",n-r.slideCount).prependTo(r.$slideTrack).addClass("slick-cloned");for(e=0;e<i+r.slideCount;e+=1)n=e,t(r.$slides[n]).clone(!0).attr("id","").attr("data-slick-index",n+r.slideCount).appendTo(r.$slideTrack).addClass("slick-cloned");r.$slideTrack.find(".slick-cloned").find("[id]").each(function(){t(this).attr("id","")})}},e.prototype.interrupt=function(t){var e=this;t||e.autoPlay(),e.interrupted=t},e.prototype.selectHandler=function(e){var n=this,i=t(e.target).is(".slick-slide")?t(e.target):t(e.target).parents(".slick-slide"),r=parseInt(i.attr("data-slick-index"));if(r||(r=0),n.slideCount<=n.options.slidesToShow)return void n.slideHandler(r,!1,!0);n.slideHandler(r)},e.prototype.slideHandler=function(t,e,n){var i,r,o,a,s,c=null,u=this;if(e=e||!1,!(!0===u.animating&&!0===u.options.waitForAnimate||!0===u.options.fade&&u.currentSlide===t)){if(!1===e&&u.asNavFor(t),i=t,c=u.getLeft(i),a=u.getLeft(u.currentSlide),u.currentLeft=null===u.swipeLeft?a:u.swipeLeft,!1===u.options.infinite&&!1===u.options.centerMode&&(t<0||t>u.getDotCount()*u.options.slidesToScroll))return void(!1===u.options.fade&&(i=u.currentSlide,!0!==n&&u.slideCount>u.options.slidesToShow?u.animateSlide(a,function(){u.postSlide(i)}):u.postSlide(i)));if(!1===u.options.infinite&&!0===u.options.centerMode&&(t<0||t>u.slideCount-u.options.slidesToScroll))return void(!1===u.options.fade&&(i=u.currentSlide,!0!==n&&u.slideCount>u.options.slidesToShow?u.animateSlide(a,function(){u.postSlide(i)}):u.postSlide(i)));if(u.options.autoplay&&clearInterval(u.autoPlayTimer),r=i<0?u.slideCount%u.options.slidesToScroll!=0?u.slideCount-u.slideCount%u.options.slidesToScroll:u.slideCount+i:i>=u.slideCount?u.slideCount%u.options.slidesToScroll!=0?0:i-u.slideCount:i,u.animating=!0,u.$slider.trigger("beforeChange",[u,u.currentSlide,r]),o=u.currentSlide,u.currentSlide=r,u.setSlideClasses(u.currentSlide),u.options.asNavFor&&(s=u.getNavTarget(),s=s.slick("getSlick"),s.slideCount<=s.options.slidesToShow&&s.setSlideClasses(u.currentSlide)),u.updateDots(),u.updateArrows(),!0===u.options.fade)return!0!==n?(u.fadeSlideOut(o),u.fadeSlide(r,function(){u.postSlide(r)})):u.postSlide(r),void u.animateHeight();!0!==n&&u.slideCount>u.options.slidesToShow?u.animateSlide(c,function(){u.postSlide(r)}):u.postSlide(r)}},e.prototype.startLoad=function(){var t=this;!0===t.options.arrows&&t.slideCount>t.options.slidesToShow&&(t.$prevArrow.hide(),t.$nextArrow.hide()),!0===t.options.dots&&t.slideCount>t.options.slidesToShow&&t.$dots.hide(),t.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var t,e,n,i,r=this;return t=r.touchObject.startX-r.touchObject.curX,e=r.touchObject.startY-r.touchObject.curY,n=Math.atan2(e,t),i=Math.round(180*n/Math.PI),i<0&&(i=360-Math.abs(i)),i<=45&&i>=0?!1===r.options.rtl?"left":"right":i<=360&&i>=315?!1===r.options.rtl?"left":"right":i>=135&&i<=225?!1===r.options.rtl?"right":"left":!0===r.options.verticalSwiping?i>=35&&i<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(t){var e,n,i=this;if(i.dragging=!1,i.swiping=!1,i.scrolling)return i.scrolling=!1,!1;if(i.interrupted=!1,i.shouldClick=!(i.touchObject.swipeLength>10),void 0===i.touchObject.curX)return!1;if(!0===i.touchObject.edgeHit&&i.$slider.trigger("edge",[i,i.swipeDirection()]),i.touchObject.swipeLength>=i.touchObject.minSwipe){switch(n=i.swipeDirection()){case"left":case"down":e=i.options.swipeToSlide?i.checkNavigable(i.currentSlide+i.getSlideCount()):i.currentSlide+i.getSlideCount(),i.currentDirection=0;break;case"right":case"up":e=i.options.swipeToSlide?i.checkNavigable(i.currentSlide-i.getSlideCount()):i.currentSlide-i.getSlideCount(),i.currentDirection=1}"vertical"!=n&&(i.slideHandler(e),i.touchObject={},i.$slider.trigger("swipe",[i,n]))}else i.touchObject.startX!==i.touchObject.curX&&(i.slideHandler(i.currentSlide),i.touchObject={})},e.prototype.swipeHandler=function(t){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==t.type.indexOf("mouse")))switch(e.touchObject.fingerCount=t.originalEvent&&void 0!==t.originalEvent.touches?t.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),t.data.action){case"start":e.swipeStart(t);break;case"move":e.swipeMove(t);break;case"end":e.swipeEnd(t)}},e.prototype.swipeMove=function(t){var e,n,i,r,o,a,s=this;return o=void 0!==t.originalEvent?t.originalEvent.touches:null,!(!s.dragging||s.scrolling||o&&1!==o.length)&&(e=s.getLeft(s.currentSlide),s.touchObject.curX=void 0!==o?o[0].pageX:t.clientX,s.touchObject.curY=void 0!==o?o[0].pageY:t.clientY,s.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(s.touchObject.curX-s.touchObject.startX,2))),a=Math.round(Math.sqrt(Math.pow(s.touchObject.curY-s.touchObject.startY,2))),!s.options.verticalSwiping&&!s.swiping&&a>4?(s.scrolling=!0,!1):(!0===s.options.verticalSwiping&&(s.touchObject.swipeLength=a),n=s.swipeDirection(),void 0!==t.originalEvent&&s.touchObject.swipeLength>4&&(s.swiping=!0,t.preventDefault()),r=(!1===s.options.rtl?1:-1)*(s.touchObject.curX>s.touchObject.startX?1:-1),!0===s.options.verticalSwiping&&(r=s.touchObject.curY>s.touchObject.startY?1:-1),i=s.touchObject.swipeLength,s.touchObject.edgeHit=!1,!1===s.options.infinite&&(0===s.currentSlide&&"right"===n||s.currentSlide>=s.getDotCount()&&"left"===n)&&(i=s.touchObject.swipeLength*s.options.edgeFriction,s.touchObject.edgeHit=!0),!1===s.options.vertical?s.swipeLeft=e+i*r:s.swipeLeft=e+i*(s.$list.height()/s.listWidth)*r,!0===s.options.verticalSwiping&&(s.swipeLeft=e+i*r),!0!==s.options.fade&&!1!==s.options.touchMove&&(!0===s.animating?(s.swipeLeft=null,!1):void s.setCSS(s.swipeLeft))))},e.prototype.swipeStart=function(t){var e,n=this;if(n.interrupted=!0,1!==n.touchObject.fingerCount||n.slideCount<=n.options.slidesToShow)return n.touchObject={},!1;void 0!==t.originalEvent&&void 0!==t.originalEvent.touches&&(e=t.originalEvent.touches[0]),n.touchObject.startX=n.touchObject.curX=void 0!==e?e.pageX:t.clientX,n.touchObject.startY=n.touchObject.curY=void 0!==e?e.pageY:t.clientY,n.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var t=this;null!==t.$slidesCache&&(t.unload(),t.$slideTrack.children(this.options.slide).detach(),t.$slidesCache.appendTo(t.$slideTrack),t.reinit())},e.prototype.unload=function(){var e=this;t(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(t){var e=this;e.$slider.trigger("unslick",[e,t]),e.destroy()},e.prototype.updateArrows=function(){var t=this;Math.floor(t.options.slidesToShow/2),!0===t.options.arrows&&t.slideCount>t.options.slidesToShow&&!t.options.infinite&&(t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===t.currentSlide?(t.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):t.currentSlide>=t.slideCount-t.options.slidesToShow&&!1===t.options.centerMode?(t.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):t.currentSlide>=t.slideCount-1&&!0===t.options.centerMode&&(t.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var t=this;null!==t.$dots&&(t.$dots.find("li").removeClass("slick-active").end(),t.$dots.find("li").eq(Math.floor(t.currentSlide/t.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var t=this;t.options.autoplay&&(document[t.hidden]?t.interrupted=!0:t.interrupted=!1)},t.fn.slick=function(){var t,n,i=this,r=arguments[0],o=Array.prototype.slice.call(arguments,1),s=i.length;for(t=0;t<s;t++)if("object"==(void 0===r?"undefined":a(r))||void 0===r?i[t].slick=new e(i[t],r):n=i[t].slick[r].apply(i[t].slick,o),void 0!==n)return n;return i}})},,,,,function(t,e,n){"use strict";n(339),t.exports="smart-table"},function(t,e,n){"use strict";/** 
* @version 2.1.10
* @license MIT
*/
!function(t,e){t.module("smart-table",[]).run(["$templateCache",function(t){t.put("template/smart-table/pagination.html",'<nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="#" ng-click="selectPage(page); $event.preventDefault(); $event.stopPropagation();">{{page}}</a></li></ul></nav>')}]),t.module("smart-table").constant("stConfig",{pagination:{template:"template/smart-table/pagination.html",itemsByPage:10,displayedPages:5},search:{delay:400,inputEvent:"input",trimSearch:!1},select:{mode:"single",selectedClass:"st-selected"},sort:{ascentClass:"st-sort-ascent",descentClass:"st-sort-descent",descendingFirst:!1,skipNatural:!1,delay:300},pipe:{delay:100}}),t.module("smart-table").controller("stTableController",["$scope","$parse","$filter","$attrs",function(e,n,i,r){function o(t){return t?[].concat(t):[]}function a(){g=o(c(e)),!0===m&&b.pipe()}function s(t,e){if(-1!=e.indexOf(".")){var i=e.split("."),r=i.pop(),o=i.join("."),a=n(o)(t);delete a[r],0==Object.keys(a).length&&s(t,o)}else delete t[e]}var c,u,l,d=r.stTable,f=n(d),p=f.assign,h=i("orderBy"),v=i("filter"),g=o(f(e)),y={sort:{},search:{},pagination:{start:0,totalItemCount:0}},m=!0,b=this;r.stSafeSrc&&(c=n(r.stSafeSrc),e.$watch(function(){var t=c(e);/** 
* @version 2.1.10
* @license MIT
*/
return t&&t.length?t[0]:void 0},function(t,e){t!==e&&a()}),e.$watch(function(){var t=c(e);return t?t.length:0},function(t,e){t!==g.length&&a()}),e.$watch(function(){return c(e)},function(t,e){t!==e&&(y.pagination.start=0,a())})),this.sortBy=function(e,n){return y.sort.predicate=e,y.sort.reverse=!0===n,t.isFunction(e)?y.sort.functionName=e.name:delete y.sort.functionName,y.pagination.start=0,this.pipe()},this.search=function(t,e,i){var r=y.search.predicateObject||{},o=e||"$";return n(o).assign(r,t),t||s(r,o),y.search.predicateObject=r,y.pagination.start=0,this.pipe()},this.pipe=function(){var t,n=y.pagination;u=y.search.predicateObject?v(g,y.search.predicateObject):g,y.sort.predicate&&(u=h(u,y.sort.predicate,y.sort.reverse)),n.totalItemCount=u.length,void 0!==n.number&&(n.numberOfPages=u.length>0?Math.ceil(u.length/n.number):1,n.start=n.start>=u.length?(n.numberOfPages-1)*n.number:n.start,t=u.slice(n.start,n.start+parseInt(n.number))),p(e,t||u)},this.select=function(t,n){var i=o(f(e)),r=i.indexOf(t);-1!==r&&("single"===n?(t.isSelected=!0!==t.isSelected,l&&(l.isSelected=!1),l=!0===t.isSelected?t:void 0):i[r].isSelected=!i[r].isSelected)},this.slice=function(t,e){return y.pagination.start=t,y.pagination.number=e,this.pipe()},this.tableState=function(){return y},this.getFilteredCollection=function(){return u||g},this.setFilterFunction=function(t){v=i(t)},this.setSortFunction=function(t){h=i(t)},this.preventPipeOnWatch=function(){m=!1}}]).directive("stTable",function(){return{restrict:"A",controller:"stTableController",link:function(t,e,n,i){n.stSetFilter&&i.setFilterFunction(n.stSetFilter),n.stSetSort&&i.setSortFunction(n.stSetSort)}}}),t.module("smart-table").directive("stSearch",["stConfig","$timeout","$parse",function(e,n,i){return{require:"^stTable",link:function(r,o,a,s){var c=s,u=null,l=a.stDelay||e.search.delay,d=a.stInputEvent||e.search.inputEvent,f=a.trimSearch||e.search.trimSearch;a.$observe("stSearch",function(e,n){var i=o[0].value;e!==n&&i&&(s.tableState().search={},i=t.isString(i)&&f?i.trim():i,c.search(i,e))}),r.$watch(function(){return s.tableState().search},function(t,e){var n=a.stSearch||"$";t.predicateObject&&i(n)(t.predicateObject)!==o[0].value&&(o[0].value=i(n)(t.predicateObject)||"")},!0),o.bind(d,function(e){e=e.originalEvent||e,null!==u&&n.cancel(u),u=n(function(){var n=e.target.value;n=t.isString(n)&&f?n.trim():n,c.search(n,a.stSearch||""),u=null},l)})}}}]),t.module("smart-table").directive("stSelectRow",["stConfig",function(t){return{restrict:"A",require:"^stTable",scope:{row:"=stSelectRow"},link:function(e,n,i,r){var o=i.stSelectMode||t.select.mode;n.bind("click",function(){e.$apply(function(){r.select(e.row,o)})}),e.$watch("row.isSelected",function(e){!0===e?n.addClass(t.select.selectedClass):n.removeClass(t.select.selectedClass)})}}}]),t.module("smart-table").directive("stSort",["stConfig","$parse","$timeout",function(e,n,i){return{restrict:"A",require:"^stTable",link:function(r,o,a,s){function c(){y?f=0===f?2:f-1:f++;var e;l=t.isFunction(d(r))||t.isArray(d(r))?d(r):a.stSort,f%3==0&&!0!=!!g?(f=0,s.tableState().sort={},s.tableState().pagination.start=0,e=s.pipe.bind(s)):e=s.sortBy.bind(s,l,f%2==0),null!==m&&i.cancel(m),b<0?e():m=i(function(){e()},b)}var u,l=a.stSort,d=n(l),f=0,p=a.stClassAscent||e.sort.ascentClass,h=a.stClassDescent||e.sort.descentClass,v=[p,h],g=void 0!==a.stSkipNatural?a.stSkipNatural:e.sort.skipNatural,y=void 0!==a.stDescendingFirst?a.stDescendingFirst:e.sort.descendingFirst,m=null,b=a.stDelay||e.sort.delay;o.attr("role","columnheader").attr("aria-sort","none"),a.stSortDefault&&(u=void 0!==r.$eval(a.stSortDefault)?r.$eval(a.stSortDefault):a.stSortDefault),o.bind("click",function(){l&&r.$apply(c)}),u&&(f="reverse"===u?1:0,c()),r.$watch(function(){return s.tableState().sort},function(t){t.predicate!==l?(f=0,o.removeClass(p).removeClass(h).attr("aria-sort","none")):(f=!0===t.reverse?2:1,o.removeClass(v[f%2]).addClass(v[f-1]).attr("aria-sort",t.reverse?"ascending":"descending"))},!0)}}}]),t.module("smart-table").directive("stPagination",["stConfig",function(t){return{restrict:"EA",require:"^stTable",scope:{stItemsByPage:"=?",stDisplayedPages:"=?",stPageChange:"&"},templateUrl:function(e,n){return n.stTemplate?n.stTemplate:t.pagination.template},link:function(e,n,i,r){function o(){var t,n,i=r.tableState().pagination,o=1,a=e.currentPage;for(e.totalItemCount=i.totalItemCount,e.currentPage=Math.floor(i.start/i.number)+1,o=Math.max(o,e.currentPage-Math.abs(Math.floor(e.stDisplayedPages/2))),t=o+e.stDisplayedPages,t>i.numberOfPages&&(t=i.numberOfPages+1,o=Math.max(1,t-e.stDisplayedPages)),e.pages=[],e.numPages=i.numberOfPages,n=o;n<t;n++)e.pages.push(n);a!==e.currentPage&&e.stPageChange({newPage:e.currentPage})}e.stItemsByPage=e.stItemsByPage?+e.stItemsByPage:t.pagination.itemsByPage,e.stDisplayedPages=e.stDisplayedPages?+e.stDisplayedPages:t.pagination.displayedPages,e.currentPage=1,e.pages=[],e.$watch(function(){return r.tableState().pagination},o,!0),e.$watch("stItemsByPage",function(t,n){t!==n&&e.selectPage(1)}),e.$watch("stDisplayedPages",o),e.selectPage=function(t){t>0&&t<=e.numPages&&r.slice((t-1)*e.stItemsByPage,e.stItemsByPage)},r.tableState().pagination.number||r.slice(0,e.stItemsByPage)}}}]),t.module("smart-table").directive("stPipe",["stConfig","$timeout",function(e,n){return{require:"stTable",scope:{stPipe:"="},link:{pre:function(i,r,o,a){var s=null;t.isFunction(i.stPipe)&&(a.preventPipeOnWatch(),a.pipe=function(){return null!==s&&n.cancel(s),s=n(function(){i.stPipe(a.tableState(),a)},e.pipe.delay)})},post:function(t,e,n,i){i.pipe()}}}}])}(angular)},function(t,e,n){"use strict";/*!
 * Angular Datepicker v2.1.23
 *
 * Released by 720kb.net under the MIT license
 * www.opensource.org/licenses/MIT
 *
 * 2017-06-28
 */
!function(t,e){var n=function(){if(e.userAgent&&(e.userAgent.match(/Android/i)||e.userAgent.match(/webOS/i)||e.userAgent.match(/iPhone/i)||e.userAgent.match(/iPad/i)||e.userAgent.match(/iPod/i)||e.userAgent.match(/BlackBerry/i)||e.userAgent.match(/Windows Phone/i)))return!0}(),i=function(t,e,i){return i&&(n=!1),n?['<div class="_720kb-datepicker-calendar-header">','<div class="_720kb-datepicker-calendar-header-middle _720kb-datepicker-mobile-item _720kb-datepicker-calendar-month">','<select ng-model="month" title="{{ dateMonthTitle }}" ng-change="selectedMonthHandle(month)">','<option ng-repeat="item in months" ng-selected="item === month" ng-disabled=\'!isSelectableMaxDate(item + " " + day + ", " + year) || !isSelectableMinDate(item + " " + day + ", " + year)\' ng-value="$index + 1" value="$index + 1">',"{{ item }}","</option>","</select>","</div>","</div>",'<div class="_720kb-datepicker-calendar-header">','<div class="_720kb-datepicker-calendar-header-middle _720kb-datepicker-mobile-item _720kb-datepicker-calendar-month">','<select ng-model="mobileYear" title="{{ dateYearTitle }}" ng-change="setNewYear(mobileYear)">','<option ng-repeat="item in paginationYears track by $index" ng-selected="year === item" ng-disabled="!isSelectableMinYear(item) || !isSelectableMaxYear(item)" ng-value="item" value="item">',"{{ item }}","</option>","</select>","</div>","</div>"]:['<div class="_720kb-datepicker-calendar-header">','<div class="_720kb-datepicker-calendar-header-left">','<a class="_720kb-datepicker-calendar-month-button" href="javascript:void(0)" ng-class="{\'_720kb-datepicker-item-hidden\': !willPrevMonthBeSelectable()}" ng-click="prevMonth()" title="{{ buttonPrevTitle }}">',t,"</a>","</div>",'<div class="_720kb-datepicker-calendar-header-middle _720kb-datepicker-calendar-month">',"{{month}}&nbsp;",'<a href="javascript:void(0)" ng-click="paginateYears(year); showYearsPagination = !showYearsPagination;">',"<span>","{{year}}","<i ng-class=\"{'_720kb-datepicker-calendar-header-closed-pagination': !showYearsPagination, '_720kb-datepicker-calendar-header-opened-pagination': showYearsPagination}\"></i>","</span>","</a>","</div>",'<div class="_720kb-datepicker-calendar-header-right">','<a class="_720kb-datepicker-calendar-month-button" ng-class="{\'_720kb-datepicker-item-hidden\': !willNextMonthBeSelectable()}" href="javascript:void(0)" ng-click="nextMonth()" title="{{ buttonNextTitle }}">',e,"</a>","</div>","</div>"]},r=function(t,e){return['<div class="_720kb-datepicker-calendar-header" ng-show="showYearsPagination">','<div class="_720kb-datepicker-calendar-years-pagination">','<a ng-class="{\'_720kb-datepicker-active\': y === year, \'_720kb-datepicker-disabled\': !isSelectableMaxYear(y) || !isSelectableMinYear(y)}" href="javascript:void(0)" ng-click="setNewYear(y)" ng-repeat="y in paginationYears track by $index">',"{{y}}","</a>","</div>",'<div class="_720kb-datepicker-calendar-years-pagination-pages">','<a href="javascript:void(0)" ng-click="paginateYears(paginationYears[0])" ng-class="{\'_720kb-datepicker-item-hidden\': paginationYearsPrevDisabled}">',t,"</a>",'<a href="javascript:void(0)" ng-click="paginateYears(paginationYears[paginationYears.length -1 ])" ng-class="{\'_720kb-datepicker-item-hidden\': paginationYearsNextDisabled}">',e,"</a>","</div>","</div>"]},o=function(t,e,n){var o=['<div class="_720kb-datepicker-calendar {{datepickerClass}} {{datepickerID}}" ng-class="{\'_720kb-datepicker-forced-to-open\': checkVisibility()}" ng-blur="hideCalendar()">',"</div>"],a=i(t,e,n),s=r(t,e),c=['<div class="_720kb-datepicker-calendar-days-header">','<div ng-repeat="d in daysInString">',"{{d}}","</div>","</div>"],u=['<div class="_720kb-datepicker-calendar-body">','<a href="javascript:void(0)" ng-repeat="px in prevMonthDays" class="_720kb-datepicker-calendar-day _720kb-datepicker-disabled">',"{{px}}","</a>","<a href=\"javascript:void(0)\" ng-repeat=\"item in days\" ng-click=\"setDatepickerDay(item)\" ng-class=\"{'_720kb-datepicker-active': selectedDay === item && selectedMonth === monthNumber && selectedYear === year, '_720kb-datepicker-disabled': !isSelectableMinDate(year + '/' + monthNumber + '/' + item ) || !isSelectableMaxDate(year + '/' + monthNumber + '/' + item) || !isSelectableDate(monthNumber, year, item) || !isSelectableDay(monthNumber, year, item),'_720kb-datepicker-today': item === today.getDate() && monthNumber === (today.getMonth() + 1) && year === today.getFullYear() && !selectedDay}\" class=\"_720kb-datepicker-calendar-day\">","{{item}}","</a>",'<a href="javascript:void(0)" ng-repeat="nx in nextMonthDays" class="_720kb-datepicker-calendar-day _720kb-datepicker-disabled">',"{{nx}}","</a>","</div>"],l=function(t){o.splice(o.length-1,0,t)};return a.forEach(l),s.forEach(l),c.forEach(l),u.forEach(l),o.join("")},a=function(e,i,r,a,s,c){return{restrict:"AEC",scope:{dateSet:"@",dateMinLimit:"@",dateMaxLimit:"@",dateMonthTitle:"@",dateYearTitle:"@",buttonNextTitle:"@",buttonPrevTitle:"@",dateDisabledDates:"@",dateEnabledDates:"@",dateDisabledWeekdays:"@",dateSetHidden:"@",dateTyper:"@",dateWeekStartDay:"@",datepickerAppendTo:"@",datepickerToggle:"@",datepickerClass:"@",datepickerShow:"@"},link:function(u,l,d){var f,p,h,v=d.selector,g=t.element(v?l[0].querySelector("."+v):l[0].children[0]),y=d.buttonPrev||'<b class="_720kb-datepicker-default-button">&lang;</b>',m=d.buttonNext||'<b class="_720kb-datepicker-default-button">&rang;</b>',b=d.dateFormat,k=u.$eval(u.dateDisabledDates),w=u.$eval(u.dateEnabledDates),S=u.$eval(u.dateDisabledWeekdays),x=new Date,T=!1,M=!1,_=void 0!==d.datepickerMobile&&"false"!==d.datepickerMobile,D=r.DATETIME_FORMATS,$=o(y,m,_),O=function(){T||M||!f||u.hideCalendar()},C=function(t,e){var n,i,r,o,a,s=new Date(e,t,0).getDate(),c=new Date(e+"/"+t+"/1").getDay(),l=new Date(e+"/"+t+"/"+s).getDay(),d=[],f=[];for(u.days=[],u.dateWeekStartDay=u.validateWeekDay(u.dateWeekStartDay),a=(u.dateWeekStartDay+6)%7,n=1;n<=s;n+=1)u.days.push(n);if(c===u.dateWeekStartDay)u.prevMonthDays=[];else{for(r=c-u.dateWeekStartDay,c<u.dateWeekStartDay&&(r+=7),o=1===Number(t)?12:t-1,n=1;n<=new Date(e,o,0).getDate();n+=1)d.push(n);u.prevMonthDays=d.slice(-r)}if(l===a)u.nextMonthDays=[];else{for(i=6-l+u.dateWeekStartDay,l<u.dateWeekStartDay&&(i-=7),n=1;n<=i;n+=1)f.push(n);u.nextMonthDays=f}},P=function(){u.month=a("date")(new Date(u.dateMinLimit),"MMMM"),u.monthNumber=Number(a("date")(new Date(u.dateMinLimit),"MM")),u.day=Number(a("date")(new Date(u.dateMinLimit),"dd")),u.year=Number(a("date")(new Date(u.dateMinLimit),"yyyy")),C(u.monthNumber,u.year)},E=function(){u.month=a("date")(new Date(u.dateMaxLimit),"MMMM"),u.monthNumber=Number(a("date")(new Date(u.dateMaxLimit),"MM")),u.day=Number(a("date")(new Date(u.dateMaxLimit),"dd")),u.year=Number(a("date")(new Date(u.dateMaxLimit),"yyyy")),C(u.monthNumber,u.year)},A=function(){u.year=Number(u.year)-1},N=function(){u.year=Number(u.year)+1},F=function(t,e){var n,i,r,o,a,s,c,u,l,d=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|MMMM|MMM|MM|M|dd?d?|yy?yy?y?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;for(s=0;s<D.MONTH.length;s+=1){if(u=D.MONTH[s],l=D.SHORTMONTH[s],-1!==t.indexOf(u)){t=t.replace(u,s+1);break}if(-1!==t.indexOf(l)){t=t.replace(l,s+1);break}}for(i=t.split(/\D/).filter(function(t){return t.length>0}),n=e.match(d).filter(function(t){return null!==t.match(/^[a-zA-Z]+$/i)}),s=0;s<n.length;s+=1)switch(c=n[s],!0){case-1!==c.indexOf("d"):o=i[s-(n.length-i.length)];break;case-1!==c.indexOf("M"):r=i[s-(n.length-i.length)];break;case-1!==c.indexOf("y"):a=i[s-(n.length-i.length)]}return new Date(a+"/"+r+"/"+o)},I=function(){if(!u.isSelectableMinDate(u.year+"/"+u.monthNumber+"/"+u.day)||!u.isSelectableMaxDate(u.year+"/"+u.monthNumber+"/"+u.day))return!1;var t=new Date(u.year+"/"+u.monthNumber+"/"+u.day);d.dateFormat?g.val(a("date")(t,b)):g.val(t),g.triggerHandler("input"),g.triggerHandler("change")},L={add:function(t,e){var n;t.className.indexOf(e)>-1||((n=t.className.split(" ")).push(e),t.className=n.join(" "))},remove:function(t,e){var n,i;if(-1!==t.className.indexOf(e)){for(i=t.className.split(" "),n=0;n<i.length;n+=1)if(i[n]===e){i=i.slice(0,n).concat(i.slice(n+1));break}t.className=i.join(" ")}}},j=function(){p=e.document.getElementsByClassName("_720kb-datepicker-calendar"),t.forEach(p,function(t,e){p[e].classList?p[e].classList.remove("_720kb-datepicker-open"):L.remove(p[e],"_720kb-datepicker-open")}),f.classList?(f.classList.add("_720kb-datepicker-open"),x=b?F(g[0].value.toString(),b):new Date(g[0].value.toString()),u.selectedMonth=Number(a("date")(x,"MM")),u.selectedDay=Number(a("date")(x,"dd")),u.selectedYear=Number(a("date")(x,"yyyy"))):L.add(f,"_720kb-datepicker-open"),u.today=new Date,c(function(){u.selectedDay?(u.year=u.selectedYear,u.monthNumber=u.selectedMonth):(u.year=u.today.getFullYear(),u.monthNumber=u.today.getMonth()+1),u.month=a("date")(new Date(u.year,u.monthNumber-1),"MMMM"),C(u.monthNumber,u.year)},0)},R=function(){return!!u.datepickerShow&&(x=b?F(g[0].value.toString(),b):new Date(g[0].value.toString()),u.selectedMonth=Number(a("date")(x,"MM")),u.selectedDay=Number(a("date")(x,"dd")),u.selectedYear=Number(a("date")(x,"yyyy")),u.$eval(u.datepickerShow))},z=u.$watch("dateSet",function(t){t&&!isNaN(Date.parse(t))&&(x=new Date(t),u.month=a("date")(x,"MMMM"),u.monthNumber=Number(a("date")(x,"MM")),u.day=Number(a("date")(x,"dd")),u.year=Number(a("date")(x,"yyyy")),C(u.monthNumber,u.year),"true"!==u.dateSetHidden&&I())}),H=u.$watch("dateMinLimit",function(t){t&&P()}),W=u.$watch("dateMaxLimit",function(t){t&&E()}),B=u.$watch("dateFormat",function(t){t&&I()}),U=u.$watch("dateDisabledDates",function(t){t&&(k=u.$eval(t),u.isSelectableDate(u.monthNumber,u.year,u.day)||(g.val(""),g.triggerHandler("input"),g.triggerHandler("change")))}),Y=u.$watch("dateEnabledDates",function(t){t&&(w=u.$eval(t),u.isSelectableDate(u.monthNumber,u.year,u.day)||(g.val(""),g.triggerHandler("input"),g.triggerHandler("change")))});for(u.nextMonth=function(){12===u.monthNumber?(u.monthNumber=1,N()):u.monthNumber+=1,u.dateMaxLimit&&(u.isSelectableMaxDate(u.year+"/"+u.monthNumber+"/"+u.days[0])||E()),u.month=a("date")(new Date(u.year,u.monthNumber-1),"MMMM"),C(u.monthNumber,u.year),u.day=void 0},u.willPrevMonthBeSelectable=function(){var t=u.monthNumber,e=u.year,n=a("date")(new Date(new Date(e+"/"+t+"/01").getTime()-864e5),"dd");return 1===t?(t=12,e-=1):t-=1,!(u.dateMinLimit&&!u.isSelectableMinDate(e+"/"+t+"/"+n))},u.willNextMonthBeSelectable=function(){var t=u.monthNumber,e=u.year;return 12===t?(t=1,e+=1):t+=1,!(u.dateMaxLimit&&!u.isSelectableMaxDate(e+"/"+t+"/01"))},u.prevMonth=function(){1===u.monthNumber?(u.monthNumber=12,A()):u.monthNumber-=1,u.dateMinLimit&&(u.isSelectableMinDate(u.year+"/"+u.monthNumber+"/"+u.days[u.days.length-1])||P()),u.month=a("date")(new Date(u.year,u.monthNumber-1),"MMMM"),C(u.monthNumber,u.year),u.day=void 0},u.selectedMonthHandle=function(t){u.monthNumber=Number(a("date")(new Date(t+"/01/2000"),"MM")),C(u.monthNumber,u.year),I()},u.setNewYear=function(t){if(n||(u.day=void 0),u.dateMaxLimit&&u.year<Number(t)){if(!u.isSelectableMaxYear(t))return}else if(u.dateMinLimit&&u.year>Number(t)&&!u.isSelectableMinYear(t))return;u.paginateYears(t),u.showYearsPagination=!1,c(function(){u.year=Number(t),C(u.monthNumber,u.year)},0)},u.hideCalendar=function(){f.classList?f.classList.remove("_720kb-datepicker-open"):L.remove(f,"_720kb-datepicker-open")},u.setDatepickerDay=function(t){u.isSelectableDay(u.monthNumber,u.year,t)&&u.isSelectableDate(u.monthNumber,u.year,t)&&u.isSelectableMaxDate(u.year+"/"+u.monthNumber+"/"+t)&&u.isSelectableMinDate(u.year+"/"+u.monthNumber+"/"+t)&&(u.day=Number(t),u.selectedDay=u.day,u.selectedMonth=u.monthNumber,u.selectedYear=u.year,I(),d.hasOwnProperty("dateRefocus")&&g[0].focus(),u.hideCalendar())},u.paginateYears=function(t){var e,i=[],r=10,o=10;for(u.paginationYears=[],n&&(r=50,o=50,u.dateMinLimit&&u.dateMaxLimit&&(r=(t=new Date(u.dateMaxLimit).getFullYear())-new Date(u.dateMinLimit).getFullYear(),o=1)),e=r;e>0;e-=1)i.push(Number(t)-e);for(e=0;e<o;e+=1)i.push(Number(t)+e);"true"===u.dateTyper&&g.on("keyup blur",function(){if(g[0].value&&g[0].value.length&&g[0].value.length>0)try{(x=b?F(g[0].value.toString(),b):new Date(g[0].value.toString())).getFullYear()&&!isNaN(x.getDay())&&!isNaN(x.getMonth())&&u.isSelectableDay(x.getMonth(),x.getFullYear(),x.getDay())&&u.isSelectableDate(x.getMonth(),x.getFullYear(),x.getDay())&&u.isSelectableMaxDate(x)&&u.isSelectableMinDate(x)&&u.$apply(function(){u.month=a("date")(x,"MMMM"),u.monthNumber=Number(a("date")(x,"MM")),u.day=Number(a("date")(x,"dd")),4===x.getFullYear().toString().length&&(u.year=Number(a("date")(x,"yyyy"))),C(u.monthNumber,u.year)})}catch(t){return t}}),u.dateMaxLimit&&i&&i.length&&!u.isSelectableMaxYear(Number(i[i.length-1])+1)?u.paginationYearsNextDisabled=!0:u.paginationYearsNextDisabled=!1,u.dateMinLimit&&i&&i.length&&!u.isSelectableMinYear(Number(i[0])-1)?u.paginationYearsPrevDisabled=!0:u.paginationYearsPrevDisabled=!1,u.paginationYears=i},u.isSelectableDay=function(t,e,n){var i=0;if(S&&S.length>0)for(i;i<=S.length;i+=1)if(S[i]===new Date(t+"/"+n+"/"+e).getDay())return!1;return!0},u.isSelectableDate=function(t,e,n){var i=0;if(k&&k.length>0)for(i;i<=k.length;i+=1)if(new Date(k[i]).getTime()===new Date(t+"/"+n+"/"+e).getTime())return!1;if(w){for(i;i<=w.length;i+=1)if(new Date(w[i]).getTime()===new Date(t+"/"+n+"/"+e).getTime())return!0;return!1}return!0},u.isSelectableMinDate=function(t){return!(u.dateMinLimit&&new Date(u.dateMinLimit)&&new Date(t).getTime()<new Date(u.dateMinLimit).getTime())},u.isSelectableMaxDate=function(t){return!(u.dateMaxLimit&&new Date(u.dateMaxLimit)&&new Date(t).getTime()>new Date(u.dateMaxLimit).getTime())},u.isSelectableMaxYear=function(t){return!(u.dateMaxLimit&&t>new Date(u.dateMaxLimit).getFullYear())},u.isSelectableMinYear=function(t){return!(u.dateMinLimit&&t<new Date(u.dateMinLimit).getFullYear())},u.validateWeekDay=function(t){var e=Number(t,10);return(!e||e<0||e>6)&&(e=0),e},$=$.replace(/{{/g,s.startSymbol()).replace(/}}/g,s.endSymbol()),u.dateMonthTitle=u.dateMonthTitle||"Select month",u.dateYearTitle=u.dateYearTitle||"Select year",u.buttonNextTitle=u.buttonNextTitle||"Next",u.buttonPrevTitle=u.buttonPrevTitle||"Prev",u.month=a("date")(x,"MMMM"),u.monthNumber=Number(a("date")(x,"MM")),u.day=Number(a("date")(x,"dd")),u.dateWeekStartDay=u.validateWeekDay(u.dateWeekStartDay),u.dateMaxLimit?u.year=Number(a("date")(new Date(u.dateMaxLimit),"yyyy")):u.year=Number(a("date")(x,"yyyy")),u.months=D.MONTH,u.daysInString=[],h=u.dateWeekStartDay;h<=u.dateWeekStartDay+6;h+=1)u.daysInString.push(h%7);u.daysInString=u.daysInString.map(function(t){return a("date")(new Date(new Date("06/08/2014").valueOf()+864e5*t),"EEE")}),u.datepickerAppendTo&&-1!==u.datepickerAppendTo.indexOf(".")?(u.datepickerID="datepicker-id-"+(new Date).getTime()+(Math.floor(6*Math.random())+8),t.element(document.getElementsByClassName(u.datepickerAppendTo.replace(".",""))[0]).append(i(t.element($))(u,function(e){f=t.element(e)[0]}))):u.datepickerAppendTo&&-1!==u.datepickerAppendTo.indexOf("#")?(u.datepickerID="datepicker-id-"+(new Date).getTime()+(Math.floor(6*Math.random())+8),t.element(document.getElementById(u.datepickerAppendTo.replace("#",""))).append(i(t.element($))(u,function(e){f=t.element(e)[0]}))):u.datepickerAppendTo&&"body"===u.datepickerAppendTo?(u.datepickerID="datepicker-id-"+((new Date).getTime()+(Math.floor(6*Math.random())+8)),t.element(document).find("body").append(i(t.element($))(u,function(e){f=t.element(e)[0]}))):(g.after(i(t.element($))(u)),f=l[0].querySelector("._720kb-datepicker-calendar")),function(){return!u.datepickerToggle||u.$eval(u.datepickerToggle)}()&&g.on("focus click focusin",function(){M=!0,T||M||!f?j():u.hideCalendar()}),g.on("focusout blur",function(){M=!1}),t.element(f).on("mouseenter",function(){T=!0}),t.element(f).on("mouseleave",function(){T=!1}),t.element(f).on("focusin",function(){T=!0}),t.element(e).on("click focus focusin",O),(u.dateMinLimit&&!u.isSelectableMinYear(u.year)||!u.isSelectableMinDate(u.year+"/"+u.monthNumber+"/"+u.day))&&P(),(u.dateMaxLimit&&!u.isSelectableMaxYear(u.year)||!u.isSelectableMaxDate(u.year+"/"+u.monthNumber+"/"+u.day))&&E(),u.paginateYears(u.year),C(u.monthNumber,u.year),u.checkVisibility=R,u.$on("$destroy",function(){z(),H(),W(),B(),U(),Y(),g.off("focus click focusout blur"),t.element(f).off("mouseenter mouseleave focusin"),t.element(e).off("click focus focusin",O)})}}};t.module("720kb.datepicker",[]).directive("datepicker",["$window","$compile","$locale","$filter","$interpolate","$timeout",a])}(angular,navigator)},function(t,e,n){"use strict";!function(){angular.module("angularjs-datetime-picker",[]);var t=function(t){"string"==typeof t&&(t=new Date(t));var e=new Date(t.getFullYear(),0,1),n=new Date(t.getFullYear(),6,1),i=Math.max(e.getTimezoneOffset(),n.getTimezoneOffset()),r=t.getTimezoneOffset()<i,o=r?i-60:i;return(o>=0?"-":"+")+("0"+o/60).slice(-2)+":"+("0"+o%60).slice(-2)},e=function(t,e,n){var i=n("DatetimePickerCtrl");return{open:function(t){i.openDatetimePicker(t)},close:function(){i.closeDatetimePicker()}}};e.$inject=["$compile","$document","$controller"],angular.module("angularjs-datetime-picker").factory("DatetimePicker",e);var n=function(t,e){var n,i=this,r=function(t){t&&t.remove(),e[0].body.removeEventListener("click",i.closeDatetimePicker)};this.openDatetimePicker=function(i){this.closeDatetimePicker();var r=angular.element("<div datetime-picker-popup ng-cloak></div>");i.dateFormat&&r.attr("date-format",i.dateFormat),i.ngModel&&r.attr("ng-model",i.ngModel),i.year&&r.attr("year",parseInt(i.year)),i.month&&r.attr("month",parseInt(i.month)),i.day&&r.attr("day",parseInt(i.day)),i.hour&&r.attr("hour",parseInt(i.hour)),i.minute&&r.attr("minute",parseInt(i.minute)),""!==i.dateOnly&&!0!==i.dateOnly||r.attr("date-only","true"),"false"===i.closeOnSelect&&r.attr("close-on-select","false");var o=i.triggerEl;i.scope=i.scope||angular.element(o).scope(),n=t(r)(i.scope)[0],n.triggerEl=i.triggerEl,e[0].body.appendChild(n);var a=o.getBoundingClientRect();n.style.position="absolute",n.style.left=a.left+window.scrollX+"px",i.scope.$apply();var s=n.getBoundingClientRect();a.top<300||window.innerHeight-a.bottom>300?n.style.top=a.bottom+window.scrollY+"px":n.style.top=a.top-s.height+window.scrollY+"px",e[0].body.addEventListener("click",this.closeDatetimePicker)},this.closeDatetimePicker=function(t){var n=t&&t.target,i=e[0].querySelector("div[datetime-picker-popup]");t&&n?n.hasAttribute("datetime-picker")||i&&i.contains(n)||r(i):r(i)}};n.$inject=["$compile","$document"],angular.module("angularjs-datetime-picker").controller("DatetimePickerCtrl",n);var i=['<div class="angularjs-datetime-picker">','  <div class="adp-month">','    <button type="button" class="adp-prev" ng-click="addMonth(-1)">&laquo;</button>','    <span title="{{months[mv.month].fullName}}">{{months[mv.month].shortName}}</span> {{mv.year}}','    <button type="button" class="adp-next" ng-click="addMonth(1)">&raquo;</button>',"  </div>",'  <div class="adp-days" ng-click="setDate($event)">','    <div class="adp-day-of-week" ng-repeat="dayOfWeek in ::daysOfWeek" title="{{dayOfWeek.fullName}}">{{::dayOfWeek.firstLetter}}</div>','    <div class="adp-day" ng-repeat="day in mv.leadingDays">{{::day}}</div>','    <div class="adp-day selectable" ng-repeat="day in mv.days" ','      ng-class="{selected: (day == selectedDay)}">{{::day}}</div>','    <div class="adp-day" ng-repeat="day in mv.trailingDays">{{::day}}</div>',"  </div>",'  <div class="adp-days" id="adp-time"> ','    Time : {{("0"+inputHour).slice(-2)}} : {{("0"+inputMinute).slice(-2)}} <br/>','    <label>Hour:</label> <input type="range" min="0" max="23" ng-model="inputHour" ng-change="updateNgModel()" />','    <label>Min.:</label> <input type="range" min="0" max="59" ng-model="inputMinute"  ng-change="updateNgModel()"/> ',"  </div> ","</div>"].join("\n"),r=function(e,n){var r,o,a,s,c=function(){r=[],o=[],a=[],s=0;for(var t=1;t<=31;t++)r.push(t);for(var t=0;t<12;t++)o.push({fullName:e.DATETIME_FORMATS.MONTH[t],shortName:e.DATETIME_FORMATS.SHORTMONTH[t]});for(var t=0;t<7;t++){var n=e.DATETIME_FORMATS.DAY[(t+s)%7];a.push({fullName:n,firstLetter:n.substr(0,2)})}s=e.DATETIME_FORMATS.FIRSTDAYOFWEEK||0},u=function(t,e){e>11?t++:e<0&&t--,e=(e+12)%12;var n=new Date(t,e,1),i=new Date(t,e+1,0),o=new Date(t,e,0),a=i.getDate(),c=o.getDate(),u=n.getDay(),l=(u-s+7)%7||7,d=r.slice(0,42-(l+a));return d.length>7&&(d=d.slice(0,d.length-7)),{year:t,month:e,days:r.slice(0,a),leadingDays:r.slice(-l-(31-c),c),trailingDays:d}};return{restrict:"A",template:i,controller:"DatetimePickerCtrl",replace:!0,scope:{year:"=",month:"=",day:"=",hour:"=",minute:"=",dateOnly:"=",closeOnSelect:"="},link:function(e,i,r,s){c();var l=r.dateFormat||"short";e.months=o,e.daysOfWeek=a,e.inputHour,e.inputMinute,!0===e.dateOnly&&(i[0].querySelector("#adp-time").style.display="none"),e.$applyAsync(function(){if(s.triggerEl=angular.element(i[0].triggerEl),r.ngModel){var n=""+s.triggerEl.scope().$eval(r.ngModel);if(n){n.match(/[0-9]{2}:/)||(n+=" 00:00:00"),n=n.replace(/([0-9]{2}-[0-9]{2})-([0-9]{4})/,"$2-$1"),n=n.replace(/([\/-][0-9]{2,4})\ ([0-9]{2}\:[0-9]{2}\:)/,"$1T$2"),n=n.replace(/EDT|EST|CDT|CST|MDT|PDT|PST|UT|GMT/g,""),n=n.replace(/\s*\(\)\s*/,""),n=n.replace(/[\-\+][0-9]{2}:?[0-9]{2}$/,""),n+=t(n);var o=new Date(n);e.selectedDate=new Date(o.getFullYear(),o.getMonth(),o.getDate(),o.getHours(),o.getMinutes(),o.getSeconds())}}if(!e.selectedDate||isNaN(e.selectedDate.getTime())){var a=new Date,c=e.year||a.getFullYear(),l=e.month?e.month-1:a.getMonth(),d=e.day||a.getDate(),f=e.hour||a.getHours(),p=e.minute||a.getMinutes();e.selectedDate=new Date(c,l,d,f,p,0)}e.inputHour=e.selectedDate.getHours(),e.inputMinute=e.selectedDate.getMinutes(),e.mv=u(e.selectedDate.getFullYear(),e.selectedDate.getMonth()),e.mv.year==e.selectedDate.getFullYear()&&e.mv.month==e.selectedDate.getMonth()?e.selectedDay=e.selectedDate.getDate():e.selectedDay=null}),e.addMonth=function(t){e.mv=u(e.mv.year,e.mv.month+t)},e.setDate=function(t){var n=angular.element(t.target)[0];n.className.indexOf("selectable")&&(e.updateNgModel(parseInt(n.innerHTML)),!1!==e.closeOnSelect&&s.closeDatetimePicker())},e.updateNgModel=function(t){if(t=t||e.selectedDate.getDate(),e.selectedDate=new Date(e.mv.year,e.mv.month,t,e.inputHour,e.inputMinute,0),e.selectedDay=e.selectedDate.getDate(),r.ngModel){var i,o=s.triggerEl.scope();i=o.$eval(r.ngModel)&&"Date"===o.$eval(r.ngModel).constructor.name?new Date(n(e.selectedDate,l)):n(e.selectedDate,l),o.$eval(r.ngModel+"= date",{date:i})}},e.$on("$destroy",s.closeDatetimePicker)}}};r.$inject=["$locale","dateFilter"],angular.module("angularjs-datetime-picker").directive("datetimePickerPopup",r);var o=function(t,e){return{require:"ngModel",link:function(t,n,i,r){t.$watch(i.ngModel,function(t){if(t&&""!=t){var e=new Date(t);r.$setValidity("date",!!e);var n=new Date;i.hasOwnProperty("futureOnly")&&r.$setValidity("future-only",!(e<n))}}),n[0].addEventListener("click",function(){e.open({triggerEl:n[0],dateFormat:i.dateFormat,ngModel:i.ngModel,year:i.year,month:i.month,day:i.day,hour:i.hour,minute:i.minute,dateOnly:i.dateOnly,futureOnly:i.futureOnly,closeOnSelect:i.closeOnSelect})})}}};o.$inject=["$parse","DatetimePicker"],angular.module("angularjs-datetime-picker").directive("datetimePicker",o)}()},function(t,e,n){"use strict";n(343),t.exports="ngSanitize"},function(t,e,n){"use strict";/**
 * @license AngularJS v1.5.7
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
!function(t,e){function n(){var t=!1;this.$get=["$$sanitizeUri",function(n){return t&&e.extend(S,k),function(t){var e=[];return o(t,c(e,function(t,e){return!/^unsafe:/.test(n(t,e))})),e.join("")}}],this.enableSvg=function(n){return e.isDefined(n)?(t=n,this):t}}function i(t){var n=[];return c(n,e.noop).chars(t),n.join("")}function r(t,n){var i,r={},o=t.split(",");for(i=0;i<o.length;i++)r[n?e.lowercase(o[i]):o[i]]=!0;return r}function o(e,n){null===e||void 0===e?e="":"string"!=typeof e&&(e=""+e),l.innerHTML=e;var i=5;do{if(0===i)throw d("uinput","Failed to sanitize html because the input is unstable");i--,t.document.documentMode&&u(l),e=l.innerHTML,l.innerHTML=e}while(e!==l.innerHTML);for(var r=l.firstChild;r;){switch(r.nodeType){case 1:n.start(r.nodeName.toLowerCase(),a(r.attributes));break;case 3:n.chars(r.textContent)}var o;if(!((o=r.firstChild)||(1==r.nodeType&&n.end(r.nodeName.toLowerCase()),o=r.nextSibling)))for(;null==o&&(r=r.parentNode)!==l;)o=r.nextSibling,1==r.nodeType&&n.end(r.nodeName.toLowerCase());r=o}for(;r=l.firstChild;)l.removeChild(r)}function a(t){for(var e={},n=0,i=t.length;n<i;n++){var r=t[n];e[r.name]=r.value}return e}function s(t){return t.replace(/&/g,"&amp;").replace(f,function(t){return"&#"+(1024*(t.charCodeAt(0)-55296)+(t.charCodeAt(1)-56320)+65536)+";"}).replace(p,function(t){return"&#"+t.charCodeAt(0)+";"}).replace(/</g,"&lt;").replace(/>/g,"&gt;")}function c(t,n){var i=!1,r=e.bind(t,t.push);return{start:function(t,o){t=e.lowercase(t),!i&&w[t]&&(i=t),i||!0!==S[t]||(r("<"),r(t),e.forEach(o,function(i,o){var a=e.lowercase(o),c="img"===t&&"src"===a||"background"===a;!0!==_[a]||!0===x[a]&&!n(i,c)||(r(" "),r(o),r('="'),r(s(i)),r('"'))}),r(">"))},end:function(t){t=e.lowercase(t),i||!0!==S[t]||!0===h[t]||(r("</"),r(t),r(">")),t==i&&(i=!1)},chars:function(t){i||r(s(t))}}}function u(e){if(e.nodeType===t.Node.ELEMENT_NODE)for(var n=e.attributes,i=0,r=n.length;i<r;i++){var o=n[i],a=o.name.toLowerCase();"xmlns:ns1"!==a&&0!==a.lastIndexOf("ns1:",0)||(e.removeAttributeNode(o),i--,r--)}var s=e.firstChild;s&&u(s),(s=e.nextSibling)&&u(s)}var l,d=e.$$minErr("$sanitize"),f=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,p=/([^\#-~ |!])/g,h=r("area,br,col,hr,img,wbr"),v=r("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),g=r("rp,rt"),y=e.extend({},g,v),m=e.extend({},v,r("address,article,aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul")),b=e.extend({},g,r("a,abbr,acronym,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,samp,small,span,strike,strong,sub,sup,time,tt,u,var")),k=r("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,stop,svg,switch,text,title,tspan"),w=r("script,style"),S=e.extend({},h,m,b,y),x=r("background,cite,href,longdesc,src,xlink:href"),T=r("abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,valign,value,vspace,width"),M=r("accent-height,accumulate,additive,alphabetic,arabic-form,ascent,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan",!0),_=e.extend({},x,M,T);!function(t){var e;if(!t.document||!t.document.implementation)throw d("noinert","Can't create an inert html document");e=t.document.implementation.createHTMLDocument("inert");var n=e.documentElement||e.getDocumentElement(),i=n.getElementsByTagName("body");if(1===i.length)l=i[0];else{var r=e.createElement("html");l=e.createElement("body"),r.appendChild(l),e.appendChild(r)}}(t),e.module("ngSanitize",[]).provider("$sanitize",n),e.module("ngSanitize").filter("linky",["$sanitize",function(t){var n=/((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,r=/^mailto:/i,o=e.$$minErr("linky"),a=e.isString;return function(s,c,u){function l(t){t&&g.push(i(t))}if(null==s||""===s)return s;if(!a(s))throw o("notstring","Expected string but received: {0}",s);for(var d,f,p,h=e.isFunction(u)?u:e.isObject(u)?function(){return u}:function(){return{}},v=s,g=[];d=v.match(n);)f=d[0],d[2]||d[4]||(f=(d[3]?"http://":"mailto:")+f),p=d.index,l(v.substr(0,p)),function(t,n){var i,r=h(t);g.push("<a ");for(i in r)g.push(i+'="'+r[i]+'" ');!e.isDefined(c)||"target"in r||g.push('target="',c,'" '),g.push('href="',t.replace(/"/g,"&quot;"),'">'),l(n),g.push("</a>")}(f,d[0].replace(r,"")),v=v.substring(p+d[0].length);return l(v),t(g.join(""))}}])}(window,window.angular)},,,,,,function(t,e,n){"use strict";t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};Object.defineProperty(e,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"===r(Symbol.iterator)?function(t){return void 0===t?"undefined":r(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":void 0===t?"undefined":r(t)},a=n(405),s=i(a),c=n(406),u=i(c),l=n(408),d=i(l),f=void 0;e.default=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=(0,s.default)();if(f||(f=(0,u.default)(i)),e.events)throw new Error("Event handlers cannot be overwritten.");if("string"==typeof t&&!document.getElementById(t))throw new Error('Element "'+t+'" does not exist.');e.events=d.default.proxyEvents(i);var r=new Promise(function(n){if("object"===(void 0===t?"undefined":o(t))&&t.playVideo instanceof Function){n(t)}else f.then(function(r){var o=new r.Player(t,e);return i.on("ready",function(){n(o)}),null})}),a=d.default.promisifyPlayer(r,n);return a.on=i.on,a.off=i.off,a},t.exports=e.default},function(t,e,n){"use strict";var i;/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
i=function(){var t={},e={};return t.on=function(t,n){var i={name:t,handler:n};return e[t]=e[t]||[],e[t].unshift(i),i},t.off=function(t){var n=e[t.name].indexOf(t);-1!==n&&e[t.name].splice(n,1)},t.trigger=function(t,n){var i,r=e[t];if(r)for(i=r.length;i--;)r[i].handler(n)},t},t.exports=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(407),r=function(t){return t&&t.__esModule?t:{default:t}}(i);e.default=function(t){return new Promise(function(e){if(window.YT&&window.YT.Player&&window.YT.Player instanceof Function)return void e(window.YT);var n="http:"===window.location.protocol?"http:":"https:";(0,r.default)(n+"//www.youtube.com/iframe_api",function(e){e&&t.trigger("error",e)});var i=window.onYouTubeIframeAPIReady;window.onYouTubeIframeAPIReady=function(){i&&i(),e(window.YT)}})},t.exports=e.default},function(t,e,n){"use strict";function i(t,e){for(var n in e)t.setAttribute(n,e[n])}function r(t,e){t.onload=function(){this.onerror=this.onload=null,e(null,t)},t.onerror=function(){this.onerror=this.onload=null,e(new Error("Failed to load "+this.src),t)}}function o(t,e){t.onreadystatechange=function(){"complete"!=this.readyState&&"loaded"!=this.readyState||(this.onreadystatechange=null,e(null,t))}}t.exports=function(t,e,n){var a=document.head||document.getElementsByTagName("head")[0],s=document.createElement("script");"function"==typeof e&&(n=e,e={}),e=e||{},n=n||function(){},s.type=e.type||"text/javascript",s.charset=e.charset||"utf8",s.async=!("async"in e)||!!e.async,s.src=t,e.attrs&&i(s,e.attrs),e.text&&(s.text=""+e.text),("onload"in s?r:o)(s,n),s.onload||r(s,n),a.appendChild(s)}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var r=n(409),o=i(r),a=n(413),s=i(a),c=n(414),u=i(c),l=n(415),d=i(l),f=(0,o.default)("youtube-player"),p={};p.proxyEvents=function(t){var e={},n=!0,i=!1,r=void 0;try{for(var o,a=u.default[Symbol.iterator]();!(n=(o=a.next()).done);n=!0){var s=o.value;!function(n){var i="on"+n.slice(0,1).toUpperCase()+n.slice(1);e[i]=function(e){f('event "%s"',i,e),t.trigger(n,e)}}(s)}}catch(t){i=!0,r=t}finally{try{!n&&a.return&&a.return()}finally{if(i)throw r}}return e},p.promisifyPlayer=function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n={},i=!0,r=!1,o=void 0;try{for(var a,c=s.default[Symbol.iterator]();!(i=(a=c.next()).done);i=!0){var u=a.value;!function(i){e&&d.default[i]?n[i]=function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return t.then(function(t){var e=d.default[i],r=t.getPlayerState(),o=t[i].apply(t,n);return e.stateChangeRequired||Array.isArray(e.acceptableStates)&&-1===e.acceptableStates.indexOf(r)?new Promise(function(n){var i=function i(){var r=t.getPlayerState(),o=void 0;"number"==typeof e.timeout&&(o=setTimeout(function(){t.removeEventListener("onStateChange",i),n()},e.timeout)),Array.isArray(e.acceptableStates)&&-1!==e.acceptableStates.indexOf(r)&&(t.removeEventListener("onStateChange",i),clearTimeout(o),n())};t.addEventListener("onStateChange",i)}).then(function(){return o}):o})}:n[i]=function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return t.then(function(t){return t[i].apply(t,n)})}}(u)}}catch(t){r=!0,o=t}finally{try{!i&&c.return&&c.return()}finally{if(r)throw o}}return n},e.default=p,t.exports=e.default},function(t,e,n){"use strict";(function(i){function r(){return!("undefined"==typeof window||!window.process||"renderer"!==window.process.type)||("undefined"!=typeof document&&document.documentElement&&document.documentElement.style&&document.documentElement.style.WebkitAppearance||"undefined"!=typeof window&&window.console&&(window.console.firebug||window.console.exception&&window.console.table)||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))}function o(t){var n=this.useColors;if(t[0]=(n?"%c":"")+this.namespace+(n?" %c":" ")+t[0]+(n?"%c ":" ")+"+"+e.humanize(this.diff),n){var i="color: "+this.color;t.splice(1,0,i,"color: inherit");var r=0,o=0;t[0].replace(/%[a-zA-Z%]/g,function(t){"%%"!==t&&(r++,"%c"===t&&(o=r))}),t.splice(o,0,i)}}function a(){return"object"===("undefined"==typeof console?"undefined":u(console))&&console.log&&Function.prototype.apply.call(console.log,console,arguments)}function s(t){try{null==t?e.storage.removeItem("debug"):e.storage.debug=t}catch(t){}}function c(){var t;try{t=e.storage.debug}catch(t){}return!t&&void 0!==i&&"env"in i&&(t=Object({NODE_ENV:"production"}).DEBUG),t}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e=t.exports=n(411),e.log=a,e.formatArgs=o,e.save=s,e.load=c,e.useColors=r,e.storage="undefined"!=typeof chrome&&void 0!==chrome.storage?chrome.storage.local:function(){try{return window.localStorage}catch(t){}}(),e.colors=["lightseagreen","forestgreen","goldenrod","dodgerblue","darkorchid","crimson"],e.formatters.j=function(t){try{return JSON.stringify(t)}catch(t){return"[UnexpectedJSONParseError]: "+t.message}},e.enable(c())}).call(e,n(410))},function(t,e,n){"use strict";function i(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(t){if(d===setTimeout)return setTimeout(t,0);if((d===i||!d)&&setTimeout)return d=setTimeout,setTimeout(t,0);try{return d(t,0)}catch(e){try{return d.call(null,t,0)}catch(e){return d.call(this,t,0)}}}function a(t){if(f===clearTimeout)return clearTimeout(t);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function s(){g&&h&&(g=!1,h.length?v=h.concat(v):y=-1,v.length&&c())}function c(){if(!g){var t=o(s);g=!0;for(var e=v.length;e;){for(h=v,v=[];++y<e;)h&&h[y].run();y=-1,e=v.length}h=null,g=!1,a(t)}}function u(t,e){this.fun=t,this.array=e}function l(){}var d,f,p=t.exports={};!function(){try{d="function"==typeof setTimeout?setTimeout:i}catch(t){d=i}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(t){f=r}}();var h,v=[],g=!1,y=-1;p.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];v.push(new u(t,e)),1!==v.length||g||o(c)},u.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(t){return[]},p.binding=function(t){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(t){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(t,e,n){"use strict";function i(t){var n,i=0;for(n in t)i=(i<<5)-i+t.charCodeAt(n),i|=0;return e.colors[Math.abs(i)%e.colors.length]}function r(t){function n(){if(n.enabled){var t=n,i=+new Date,r=i-(u||i);t.diff=r,t.prev=u,t.curr=i,u=i;for(var o=new Array(arguments.length),a=0;a<o.length;a++)o[a]=arguments[a];o[0]=e.coerce(o[0]),"string"!=typeof o[0]&&o.unshift("%O");var s=0;o[0]=o[0].replace(/%([a-zA-Z%])/g,function(n,i){if("%%"===n)return n;s++;var r=e.formatters[i];if("function"==typeof r){var a=o[s];n=r.call(t,a),o.splice(s,1),s--}return n}),e.formatArgs.call(t,o);(n.log||e.log||console.log.bind(console)).apply(t,o)}}return n.namespace=t,n.enabled=e.enabled(t),n.useColors=e.useColors(),n.color=i(t),"function"==typeof e.init&&e.init(n),n}function o(t){e.save(t),e.names=[],e.skips=[];for(var n=("string"==typeof t?t:"").split(/[\s,]+/),i=n.length,r=0;r<i;r++)n[r]&&(t=n[r].replace(/\*/g,".*?"),"-"===t[0]?e.skips.push(new RegExp("^"+t.substr(1)+"$")):e.names.push(new RegExp("^"+t+"$")))}function a(){e.enable("")}function s(t){var n,i;for(n=0,i=e.skips.length;n<i;n++)if(e.skips[n].test(t))return!1;for(n=0,i=e.names.length;n<i;n++)if(e.names[n].test(t))return!0;return!1}function c(t){return t instanceof Error?t.stack||t.message:t}e=t.exports=r.debug=r.default=r,e.coerce=c,e.disable=a,e.enable=o,e.enabled=s,e.humanize=n(412),e.names=[],e.skips=[],e.formatters={};var u},function(t,e,n){"use strict";function i(t){if(t=String(t),!(t.length>100)){var e=/^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t);if(e){var n=parseFloat(e[1]);switch((e[2]||"ms").toLowerCase()){case"years":case"year":case"yrs":case"yr":case"y":return n*f;case"days":case"day":case"d":return n*d;case"hours":case"hour":case"hrs":case"hr":case"h":return n*l;case"minutes":case"minute":case"mins":case"min":case"m":return n*u;case"seconds":case"second":case"secs":case"sec":case"s":return n*c;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return n;default:return}}}}function r(t){return t>=d?Math.round(t/d)+"d":t>=l?Math.round(t/l)+"h":t>=u?Math.round(t/u)+"m":t>=c?Math.round(t/c)+"s":t+"ms"}function o(t){return a(t,d,"day")||a(t,l,"hour")||a(t,u,"minute")||a(t,c,"second")||t+" ms"}function a(t,e,n){if(!(t<e))return t<1.5*e?Math.floor(t/e)+" "+n:Math.ceil(t/e)+" "+n+"s"}var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},c=1e3,u=60*c,l=60*u,d=24*l,f=365.25*d;t.exports=function(t,e){e=e||{};var n=void 0===t?"undefined":s(t);if("string"===n&&t.length>0)return i(t);if("number"===n&&!1===isNaN(t))return e.long?o(t):r(t);throw new Error("val is not a non-empty string or a valid number. val="+JSON.stringify(t))}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=["cueVideoById","loadVideoById","cueVideoByUrl","loadVideoByUrl","playVideo","pauseVideo","stopVideo","getVideoLoadedFraction","cuePlaylist","loadPlaylist","nextVideo","previousVideo","playVideoAt","setShuffle","setLoop","getPlaylist","getPlaylistIndex","setOption","mute","unMute","isMuted","setVolume","getVolume","seekTo","getPlayerState","getPlaybackRate","setPlaybackRate","getAvailablePlaybackRates","getPlaybackQuality","setPlaybackQuality","getAvailableQualityLevels","getCurrentTime","getDuration","removeEventListener","getVideoUrl","getVideoEmbedCode","getOptions","getOption","addEventListener","destroy","setSize","getIframe"],t.exports=e.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=["ready","stateChange","playbackQualityChange","playbackRateChange","error","apiChange","volumeChange"],t.exports=e.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(416),r=function(t){return t&&t.__esModule?t:{default:t}}(i);e.default={pauseVideo:{acceptableStates:[r.default.ENDED,r.default.PAUSED],stateChangeRequired:!1},playVideo:{acceptableStates:[r.default.ENDED,r.default.PLAYING],stateChangeRequired:!1},seekTo:{acceptableStates:[r.default.ENDED,r.default.PLAYING,r.default.PAUSED],stateChangeRequired:!0,timeout:3e3}},t.exports=e.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={BUFFERING:3,ENDED:0,PAUSED:2,PLAYING:1,UNSTARTED:-1,VIDEO_CUED:5},t.exports=e.default},,,function(t,e,n){e=t.exports=n(332)(!1),e.push([t.i,'.datepicker a,[datepicker] a,datepicker a{color:inherit;text-decoration:none}.datepicker a:hover,[datepicker] a:hover,datepicker a:hover{text-decoration:none}.datepicker select,.datepicker select:focus,.datepicker select:hover,[datepicker] select,[datepicker] select:focus,[datepicker] select:hover,datepicker select,datepicker select:focus,datepicker select:hover{width:100%;overflow:hidden;background:none;color:#fff;background-color:#138efa;border-radius:2px;border:0;margin-top:5px}._720kb-datepicker-calendar-body,._720kb-datepicker-calendar-days-header,._720kb-datepicker-calendar-header,._720kb-datepicker-calendar-years-pagination-pages,.datepicker,[datepicker],datepicker{font-family:Helvetica Neue,Arial,sans-serif;font-size:13.5px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin:0 auto;float:left;clear:right;position:relative}._720kb-datepicker-calendar{background:#fff;color:#333;position:absolute;z-index:999;min-width:220px;margin:0 auto;width:101%;-webkit-box-shadow:0 0 0 1px rgba(0,0,0,.1) inset;-moz-box-shadow:0 0 0 1px rgba(0,0,0,.1) inset;box-shadow:inset 0 0 0 1px rgba(0,0,0,.1);visibility:hidden;overflow:hidden;margin-left:-.5%;padding:0 0 2%;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px}._720kb-datepicker-calendar._720kb-datepicker-forced-to-open,._720kb-datepicker-calendar._720kb-datepicker-open{visibility:visible}._720kb-datepicker-calendar-header{text-align:center;font-size:15px;line-height:40px}._720kb-datepicker-calendar-header:nth-child(odd){background:#138efa}._720kb-datepicker-calendar-header:nth-child(2n){background:#7bc6fc}._720kb-datepicker-calendar-header-left,._720kb-datepicker-calendar-header-middle,._720kb-datepicker-calendar-header-right{width:15%;float:left}._720kb-datepicker-calendar-header-middle{width:70%}._720kb-datepicker-calendar-header-closed-pagination:after{content:" \\25BE"}._720kb-datepicker-calendar-header-opened-pagination:after{content:" \\25BE";margin-left:4px;position:relative;bottom:-3px;display:inline-block;-webkit-transform:rotate(180deg);-moz-transform:rotate(180deg);-o-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}._720kb-datepicker-calendar-body{width:96%;margin:2%;text-align:center}._720kb-datepicker-calendar-day{cursor:pointer;font-size:12.5px;width:12.2%;margin:5px 1%;padding:1.5% 0;float:left;-webkit-border-radius:1px;-moz-border-radius:1px;border-radius:1px}._720kb-datepicker-calendar-day._720kb-datepicker-active,._720kb-datepicker-calendar-day:hover{background:rgba(0,0,0,.03)}._720kb-datepicker-calendar-header a,._720kb-datepicker-calendar-header a:hover{text-decoration:none;padding:3% 9% 4%;font-size:13.5px;color:rgba(0,0,0,.55);font-weight:700;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px}._720kb-datepicker-calendar-header a:hover{color:rgba(0,0,0,.9);background:hsla(0,0%,100%,.45)}._720kb-datepicker-calendar-month{color:#fff}._720kb-datepicker-calendar-month span{font-size:13px;color:rgba(0,0,0,.4)}._720kb-datepicker-calendar-month a span i{font-style:normal;font-size:15px}._720kb-datepicker-calendar-month a,._720kb-datepicker-calendar-month a:hover{padding:3px;margin-left:1%}._720kb-datepicker-calendar-years-pagination{padding:2% 0 0;float:left;clear:right;width:100%}._720kb-datepicker-calendar-years-pagination a,._720kb-datepicker-calendar-years-pagination a:hover{font-size:12px;padding:0 7px;font-weight:400;margin:3px 1% 0;line-height:20px;display:inline-block}._720kb-datepicker-calendar-years-pagination a._720kb-datepicker-active{color:rgba(0,0,0,.9);font-weight:500;background:hsla(0,0%,100%,.45)}._720kb-datepicker-calendar-years-pagination-pages a,._720kb-datepicker-calendar-years-pagination-pages a:hover{padding:5px 10px}._720kb-datepicker-calendar-days-header{max-width:100%;margin:0 auto;padding:0 2%;background:rgba(19,142,250,.08);border-bottom:1px solid rgba(0,0,0,.02)}._720kb-datepicker-calendar-days-header div{width:14.18%;font-weight:500;font-size:11.5px;padding:10px 0;float:left;text-align:center;color:rgba(0,0,0,.7)}._720kb-datepicker-calendar-days ._720kb-datepicker-default-button{font-size:18.5px;position:relative;bottom:-.5px}._720kb-datepicker-default-button{padding:0 4.5px}._720kb-datepicker-calendar-header-middle._720kb-datepicker-mobile-item{width:95%;float:none;margin:0 auto}._720kb-datepicker-item-hidden{visibility:hidden}._720kb-datepicker-calendar-day._720kb-datepicker-disabled,._720kb-datepicker-calendar-day._720kb-datepicker-disabled:hover,._720kb-datepicker-calendar-years-pagination a._720kb-datepicker-active._720kb-datepicker-disabled,._720kb-datepicker-calendar-years-pagination a._720kb-datepicker-active._720kb-datepicker-disabled:hover,._720kb-datepicker-calendar-years-pagination a._720kb-datepicker-disabled,._720kb-datepicker-calendar-years-pagination a._720kb-datepicker-disabled:hover{color:rgba(0,0,0,.2);background:rgba(25,2,0,.02);cursor:default}',""])}]);

//Polyfill
//forEach polyfill

(function () {
    if (typeof NodeList.prototype.forEach === "function") return false;
    NodeList.prototype.forEach = Array.prototype.forEach;
})();

$('document').ready(function () {
    //Overlays
    //Add .overlay to link and data-partial with partial you want to load
    if ($('.chapter__link').length !== 0) {
        window.app.overlayTingle($('.overlay, .chapter__link'), function () {
            window.app.requiredInputValidator();
        });
    }

    $('.setting__link').on('click', function () {
        if (typeof tingle == "undefined") {
            return;
        }


        var overlay = new tingle.modal();

        var partial = $(this).data("partial");

        overlay.open();

        $.ajax({
            url: partial,
            success: function (result) {
                overlay.setContent(result);
            },
            complete: function () {

                window.app.requiredInputValidator();
                //Check if switch exists for settings__link overlay and apply change event
                if ($('#subscription-check').length !== 0) {
                    var $subscriptionCheck = $('#subscription-check');
                    var $switchContainer = $subscriptionCheck.parent().parent();

                    inputSwitchCheck();

                    $subscriptionCheck.on('change', function () {
                        inputSwitchCheck();
                    });

                    function inputSwitchCheck() {
                        //If checked, disable fields in container
                        if ($subscriptionCheck[0].checked) {
                            $switchContainer.find('.input-checkbox__wrapper').addClass('input-checkbox__wrapper--disabled');
                            $switchContainer.find('.input-checkbox').attr('disabled', true);
                        } else {
                            $switchContainer.find('.input-checkbox__wrapper').removeClass('input-checkbox__wrapper--disabled');
                            $switchContainer.find('.input-checkbox').attr('disabled', false);
                        }
                    }
                }

                $('.setting-edit__link').on('click', function () {
                    overlay.close();
                    return false;
                });

                $('.input-check__tooltip').on('click', function () {
                    var $this = $(this);

                    if ($this.hasClass('input-check__tooltip--active')) {
                        $this.removeClass('input-check__tooltip--active')
                    } else {
                        //Checks all tooltips in the DOM, removes active state and applies active to currently clicked one
                        $('.input-check__tooltip').removeClass('input-check__tooltip--active');
                        $this.addClass('input-check__tooltip--active')
                    }
                    //Stops the click from propagating up the chain
                    return false;
                });

                window.app.browseByAjax($('.tingle-modal .form__btn'),
                    $('.tingle-modal input, .tingle-modal select'),
                    'click',
                    function (response) {
                        //successCallback
                        if (response.success) {
                            // refresh the page
                            location.reload();
                        } else {
                            var $errElement = $('.tingle-modal .notification--error');
                            var errorsString = '';

                            for (var i = 0; i < response.errors.length; i++) {
                                errorsString += '<p>' + response.errors[i] + '</p>';
                            }

                            $errElement.html(errorsString);
                            $errElement.addClass('notification--active');

                        }
                    },
                    function (response) {
                        //errorCallback
                        // if a server error occurred, do not show details to user, just activate the error notification
                        $('.tingle-modal .notification--error').addClass('notification--active');
                    });
            }
        });
        return false;
    });

    //Method for input value checks. Only use for non angular apps.
    if ($('.angularApp').length === 0) {
        window.app.requiredInputValidator();
    }

    //Check for conference nav tab
    if ($('.conference-nav-tab').length !== 0) {
        var $conferenceNavTab = $('.conference-nav-tab');
        $(document).on('scroll', function () {
            var windowY = $(window).scrollTop();
            if (($('.hero__wrapper').position().top + $('.hero__wrapper').innerHeight()) < windowY) {
                $conferenceNavTab.addClass('conference-nav-tab--fixed');
                if ($('.training-week').length) {
                    switch ($(window).width() > 1023) {
                        case true:
                            $('.tw-pin').addClass('tw-pin--fixed').css("top", $conferenceNavTab.height());
                            break;
                        case false:
                            $('.tw-pin').addClass('tw-pin--fixed').css("top", 0);
                            break;
                    }
                }
            } else {
                $conferenceNavTab.removeClass('conference-nav-tab--fixed');
                if ($('.training-week').length) {
                    $('.tw-pin').removeClass('tw-pin--fixed').css("top", 0);
                }
            }
        });
    }
    //Fetch a shallow nodelist of elements to apply event listeners to
    //Going too deep won't allow for modules inside themselves
    if ($('.nav-tab__link').length !== 0) {
        //Fetching a nodelist of the navTabLists and applying an event trigger
        $('.nav-tab__link').on('click', function (event) {
            var navTabLinks = document.querySelectorAll('[data-nav-tab-name="' + this.getAttribute('data-nav-tab-name') + '"]');

            navTabLinks.forEach(function (navTabLink) {
                if (navTabLink.getAttribute('data-nav-tab') === event.currentTarget.getAttribute('data-nav-tab')) {
                    if (window.innerHeight < window.DesktopHeight || window.innerWidth < window.DesktopWidth) {
                        $(navTabLink).toggleClass('nav-tab__link--active');
                    } else {
                        $(navTabLink).addClass('nav-tab__link--active');
                    }
                } else {
                    navTabLink.classList.remove('nav-tab__link--active');
                }
            });

            //Repositions screen to retain it's position as the DOM repaints

            return false;
        });
    }

    //Handles the display toggle for the full content of the product's description
    //Style is found is product.scss and handles the visuals
    //Can be converted into a generic function is used else where on site
    $('.product-description').on('click', function () {
        var $this = $(this);

        if ($this.hasClass('product-description--show')) {
            $('.product-copy__wrapper').removeClass('product-copy__wrapper--show');
            $this.removeClass('product-description--show');
        } else {
            $this.addClass('product-description--show');
            $('.product-copy__wrapper').addClass('product-copy__wrapper--show');
        }
        return false;
    });

    //Check if there is a video takeover before running scoped code
    if ($('.conference-media__video').length !== 0) {

        //Find video to takeover and duplicate it for popup content
        var $conferenceVideoArray = $('.conference-media__video');

        //Use to handle multiple video take overs
        $conferenceVideoArray.each(function (index, element) {
            var conferenceVideoClone = $(element).clone();
            var $conferenceVideo = $(element);

            //When user clicks video, active TingleJS
            $(element).on('click', function () {

                //Utilize tingle to create popup
                var overlay = new tingle.modal({

                    onClose: function () {
                        overlay.setContent('');
                    }

                });

                conferenceVideoClone.addClass('conference-media__video--popup');

                //Fetch content and inject into modal
                overlay.setContent(conferenceVideoClone[0]);

                overlay.open();

                return false;
            });

        });

    }

    if ($('.conference-schedule__wrapper').length !== 0) {
        // TODO: refactor for dynamic support on NodeLists, very low priority
        $('.conference-schedule__wrapper').each(function (index, scheduleWrapper) {
            $(scheduleWrapper).find('.conference-schedule__container').each(function (index, scheduleContainer) {

                $(scheduleContainer).find('.conference-schedule__radio').on('change', function (event) {
                    $(scheduleWrapper).find('input[name="' + event.target.name + '"]').parents('.conference-schedule__container').removeClass('conference-schedule__container--active');

                    if (event.currentTarget.checked) {
                        $(scheduleContainer).addClass('conference-schedule__container--active');
                    }

                });

            });
        });
    }

    //Event handler for updating the states/provinces options
    if ($('.country').length !== 0) {
        $(document.body).on('change', ".country", function () {
            var countryVal = $(this).val();
            window.app.updateStateOptions(countryVal);
        });
    }

    //Handling the zoom functionality
    //Problem: When figure-zoom clicked expand to screen
    //Using vanilla JS except event handler
    if ($('.figure-zoom').length !== 0) {
        //Function that checks if .overlay-zoom exists then creates
        overlayZoomCreation();

        var overlayZoom = document.querySelector('.overlay-zoom');
        var figureZoom = document.querySelector('.figure-zoom');

        //This might be more complex then it needs to be, but trying it out
        $('.figure-zoom, .overlay-zoom').on('click', function (event) {
            //Check what the element being clicked is and handle a specific function on it :D
            if (event.currentTarget.classList.contains('figure-zoom')) {
                var figureImageSrc = event.currentTarget.querySelector('.figure-zoom__image').getAttribute('data-src');
                //Right now this will overwrite the same src attribute
                //if this is an issue make a comparision before applying
                overlayZoom.querySelector('.overlay-zoom__image').setAttribute('src', figureImageSrc);
            } else if (event.target.classList.contains('overlay-zoom__image')) {
                //If image is clicked just exit instead of hiding when overlay is clicked
                return false;
            }

            //Applies classes for specific styling for handling the overlay
            if (overlayZoom.classList.contains('overlay-zoom--active')) {
                figureZoom.classList.remove('figure-zoom--active');
                overlayZoom.classList.remove('overlay-zoom--active');
            } else {
                figureZoom.classList.add('figure-zoom--active');
                overlayZoom.classList.add('overlay-zoom--active');
            }

        });

        //Hoisted function to run at the start to create overlay for zoom
        function overlayZoomCreation() {
            //There can only be one, if it doesn't exist create it
            if (document.querySelector('.overlay-zoom') === null) {
                //Creates the element to be appended in the body element
                var overlayZoom = document.createElement('div');
                //Gives it a class to handle animations and styling when active
                overlayZoom.classList.add('overlay-zoom');
                document.querySelector('main').appendChild(overlayZoom);
                overlayZoom.innerHTML = '<img class="overlay-zoom__image" src="" />';
                return overlayZoom;
            }
        }

    }

    //Handling all click events in content accordion
    document.querySelectorAll('.accordion').forEach(function (accordion) {
        accordion.addEventListener('click', function (event) {

            if (event.target.classList.contains('accordion__toggle')) {
                if (event.target.classList.contains('accordion__toggle--hide')) {
                    event.target.classList.remove('accordion__toggle--hide');
                } else {
                    event.target.classList.add('accordion__toggle--hide');
                }
            }

        });
    });

    document.querySelectorAll('.reset-password__input').forEach(function (resetPasswordInput) {
        resetPasswordInput.addEventListener('keyup', function (event) {

            document.querySelectorAll('.reset__verify').forEach(function (resetVerify) {
                regexValue = new RegExp(resetVerify.getAttribute('data-regex'));
                regexValue.test(resetPasswordInput.value) ? resetVerify.classList.add('reset__verify--valid') : resetVerify.classList.remove('reset__verify--valid');
            });

            var resetVerifyValid = document.querySelectorAll('.reset__verify--valid');

            this.form.querySelector('.form__btn').disabled = !(resetVerifyValid.length > 2 && document.querySelector('#reset-characters').classList.contains('reset__verify--valid'));

        });
    });

    //Settings these to automatically set them to display none
    window.app.elementHide('processing-icon__wrapper', false);

    //activations
    if (typeof isacaDp.feature.conferenceTabs != "undefined") {
        isacaDp.feature.conferenceTabs.init();
    }

    //Superscript all (R) symbols on page
    const countSubstrings = (str, searchValue) => {
        let count = 0,
            i = 0;
        while (true) {
            const r = str.indexOf(searchValue, i);
            if (r !== -1) [count, i] = [count + 1, r + 1];
            else return count;
        }
    };

    if ($('.superscript#TextSettings').length) {
        var pattern = '\u00AE';
        var replaceWith = '<sup>&reg;</sup>';
        var textString = '';
        // console.log("Pattern (unicode): " + pattern);
        $('.page-block > div p, .page-block > div span, .page-block > div li, .page-block > div h1, .page-block > div h2, .page-block > div h3, .page-block > div h4').each(function () {
            // console.log("--- This component: " + $(this).attr("class"));
            textString = $(this).html();
            // console.log("This component: " + $(this).prop("tagName"));
            // console.log("This text: " + textString);
            // console.log("How many patterns counted: " + countSubstrings(textString, pattern));
            if (countSubstrings(textString, pattern) > 0) {
                // console.log("This instance: " + $(this).prop('tagName'));
                $(this).html(textString.replaceAll(pattern, replaceWith)); // Apply superscripting
                // console.log("New text: " + $(this).html())
            }
        });
    }

    // Bind Main Search Box Tracking
    var $mainSearchBoxObj = $('#MinimalSearchbox');
    var $searchPageSearchBoxObj = null;
    setTimeout(function () {
        $searchPageSearchBoxObj = $('.magic-box-input input[type=text]');
        if ($searchPageSearchBoxObj.length) {
            // Bind both the click and enter key
            $('#search-page-searchbox .CoveoSearchButton').click(function () { gtmTrackSearch("main search page") });
            $searchPageSearchBoxObj.on('keydown', function (event) {
                if (event.key === 'Enter') {
                    gtmTrackSearch("main search page");
                }
            });
        }
    }, 500);

    if ($mainSearchBoxObj.length) {
        // Bind both the click and enter key
        $('#MinimalSearchButton').click(function () { gtmTrackSearch("global search") });
        $mainSearchBoxObj.on('keydown', function(event) {
            if (event.key === 'Enter') {
                gtmTrackSearch("global search");
            }
        });
    }
    
    // Bind Video Search Box Tracking
    var $videoSearchBoxObj = $('.video-tabs .search input[type=text]');
    if ($videoSearchBoxObj.length) {
        // Uses live search so bind on keyup after delay
        var doSearch = false;
        var searchDelay = true;
        var searchDelayTimeout = null;
        $videoSearchBoxObj.on('keyup', function (event) {
            clearTimeout(searchDelayTimeout);
            searchDelay = true;
            searchDelayTimeout = setTimeout(function () {
                searchDelay = false;
                if (doSearch) {
                    gtmTrackSearch("digital video search");
                }
            }, 1000);

            if (event.key != ' ' && $videoSearchBoxObj.val().replaceAll(" ", "").length > 1) {
                doSearch = true;
                if (!searchDelay) {
                    gtmTrackSearch("digital video search");
                }
            }
            else {
                doSearch = false;
            }

            if (doSearch && !searchDelay) {
                gtmTrackSearch("digital video search");
            }
        });
    }

    // Bind Promotion Tracking
    if ($('.track-promotion a').length) {
        $('.track-promotion a').click(function () { gtmTrackPromotions($(this)) });
    }

    // Bind Download Tracking
    if ($('.track-download').length) {
        $('.track-download a, .track-download input[type=submit]').click(function () { gtmTrackDownloads($(this)) });
    }

    // Bind Lead Form Tracking
    if ($('.c-btn.isaca-consent-btn.btn-primary').length) {
        $('.c-btn.isaca-consent-btn.btn-primary').click(function () { gtmTrackLeadForms($(this)) });
    }

    // Bind CLP Link Tracking
    if ($('.clp-link-track a').length) {
        $('.clp-link-track a').click(function () { gtmTrackClpLinks($(this)) });
    }

    // Bind Partner Logos Link Tracking
    if ($('.training-partner-click a').length) {
        $('.training-partner-click a').click(function () { gtmTrackPartnerLogoLinks($(this)) });
    }

    // Bind Blog Related Content Tracking
    if ($('.article_related_content a.hot-tile').length) {
        $('.article_related_content a.hot-tile').click(function () { gtmTrackBlogRelatedContent($(this)) });
    }
});

function mainReadCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


window.app = {
    updateStateOptions: function (countryVal) {

        var countries = $('#countriesWithSubdivisions').val();
        var dataUrl = $('#updateStateService').val();

        if (typeof countries === 'undefined' || typeof dataUrl === 'undefined') return;

        var countriesArr = countries.split(",");

        if (countriesArr.indexOf(countryVal) === -1) {
            $(".state__wrapper").hide();
            $(".state").prop('disabled', true);
            return;
        }

        $(".state__wrapper").show();
        $(".state").prop('disabled', false);

        //ajax to api
        $.ajax({
            url: dataUrl,
            type: 'GET',
            data: {
                countryCode: countryVal
            },
            dataType: 'json',
            beforeSend: function () {
                window.app.showLoading();
                $('.state').empty();
            },
            complete: function () {
                window.app.hideLoading();
            },
            success: function (statesData) {
                $('.state').append('<option value="" selected disabled></option>');
                $.each(statesData.Data, function (key, value) {
                    $('.state').append('<option value="' + value.code + '">' + value.displayName + '</option>'
                    )
                });
            },
            error: function (statesData) {
                // TODO: Setup proper error handling/messaging
                console.log('error: ' + statesData);
            }
        });
    },

    //Regex check for email addresses
    emailIsValid: function (email) {
        //Regex pattern in // format
        var emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        return emailRegex.test(email);
    },

    //This will become part of the front end validation setup
    //Includes anything related to form inputs, can be extruded out into smaller chunks
    requiredInputValidator: function () {
        if (document.querySelectorAll('input, select, textarea').length !== 0) {
            //Checks any input that is requires text input
            var inputNodeList = document.querySelectorAll('.input-select, .input-textarea, .input-checkbox, .input-radio__radio');
            var textNodeList = document.querySelectorAll('.input-text, .input-number');

            //Checking for education additions before running and help to scope vars
            if ($('.form__content-add').length !== 0) {
                var $educationAdd = $('.form__content-add');
                var $educationForm = $('.form-education__container:first-child').clone();
                //Regex to find first number
                var nameRegex = /\d+/;

                $educationAdd.on('click', function () {
                    var $tempClone = $educationForm.clone();
                    var $formEducationContainers = $('.form-education__container');
                    //Find inputs and purge values only with specific type, only applies to text/visible inputs
                    $tempClone.find('input[type="text"]').val('');

                    //Find the ID and for attributes in University/Degree and update it
                    //There has to be a better way to handle this :|
                    $($tempClone).find('input').each(function (index, element) {
                        //hidden type is being used as a way to track where the education goes in DB
                        //Retaining a 0 value so it inserts instead of updates
                        if (element.type === 'hidden') {
                            element.value = 0;
                        }

                        element.id = regexAttrReplace(element.id, $formEducationContainers);
                        //Search for the first digit and combine that with the current length for incremental name value
                        element.name = regexAttrReplace(element.name, $formEducationContainers);
                    });

                    //Name in label isn't a value attribute so skipping that here
                    $($tempClone).find('label').each(function (index, element) {
                        element.htmlFor = regexAttrReplace(element.htmlFor, $formEducationContainers);
                    });

                    //Create event handlers before injecting into the DOM
                    $tempClone.on('keyup blur change', function (event) {
                        window.app.inputToggle(event.target);
                        window.app.inputValidate(event.target);
                    });

                    //Find the for attribute for University and update it

                    $educationAdd.before($tempClone);

                    return false;
                });

                //Maintaining a scoped function since this pattern is used multiple times in the scope
                function regexAttrReplace(elementAttribute, formContainers) {
                    elementAttribute = elementAttribute.replace(nameRegex, formContainers.length + parseInt(nameRegex.exec(elementAttribute)[0]));
                    return elementAttribute;
                }

            }

            //The controls for text-inputs
            //Checking each input-text element and giving specific controls
            textNodeList.forEach(function (textElementNode) {
                window.app.inputControlCreate(textElementNode);
                //Check if type is email then run, if not skip
                //Check if value is filled, if not skip a validator check cause no interaction
                window.app.inputToggle(textElementNode);
                window.app.inputValidate(textElementNode);
            });

            inputNodeList.forEach(function (inputElementNode) {
                var eventTypeArray = ['keyup', 'blur', 'change'];
                window.app.inputToggle(inputElementNode);
                window.app.inputValidate(inputElementNode);

                eventTypeArray.forEach(function (eventType) {
                    inputElementNode.addEventListener(eventType, function (event) {
                        window.app.inputToggle(event.target);
                        window.app.inputValidate(event.target);
                    });
                })
            });

            textNodeList.forEach(function (textElementNode) {
                var eventTypeArray = ['keyup', 'blur', 'change'];
                window.app.inputToggle(textElementNode);
                window.app.inputValidate(textElementNode);

                eventTypeArray.forEach(function (eventType) {
                    textElementNode.addEventListener(eventType, function (event) {
                        window.app.inputToggle(event.target);
                        window.app.inputValidate(event.target);
                    });
                })
            });

            $('.control-clear').on('click', function (event) {
                var targetInputs = event.currentTarget.parentNode.parentNode.querySelectorAll('.input-text');

                targetInputs.forEach(function (targetInput) {
                    //Crawling up the DOM for the related control's input to clear
                    targetInput.value = '';
                    //Applies the correct class for the field
                    window.app.inputToggle(targetInput);
                    window.app.inputValidate(targetInput);
                });
            });

            //Handles showing passwords
            //Keeping this without variable so it constructs the event after it builds the controls
            $('.control-show').on('click', function (event) {
                if (event.target.classList.contains('control-show--hide')) {
                    event.target.classList.remove('control-show--hide');
                    //Checks the next input field and changes it's type
                    // If the first nextSibling is an INPUT element, it's type attribute is changed...
                    if ($(event.target.parentNode.nextSibling)[0].nodeName === 'INPUT') {
                        event.target.parentNode.nextSibling.type = 'password';
                        // ...else it was probably '#text', so we check if the nextSibling.nextSibling is the INPUT element and update
                    } else if ($(event.target.parentNode.nextSibling.nextSibling)[0].nodeName === 'INPUT') {
                        event.target.parentNode.nextSibling.nextSibling.type = 'password';
                    }
                } else {
                    event.target.classList.add('control-show--hide');
                    //Checks the next input field and changes it's type
                    // If the first nextSibling is an INPUT element, it's type attribute is changed...
                    if ($(event.target.parentNode.nextSibling)[0].nodeName === 'INPUT') {
                        event.target.parentNode.nextSibling.type = 'text';
                        // ...else it was probably '#text', so we check if the nextSibling.nextSibling is the INPUT element and update
                    } else if ($(event.target.parentNode.nextSibling.nextSibling)[0].nodeName === 'INPUT') {
                        event.target.parentNode.nextSibling.nextSibling.type = 'text';
                    }
                }
            });

            //User Profile
            $(".profile-avatar").on('click', function () {
                $("#profile-photo").trigger('click');
            });

            $("#profile-photo").change(function () {
                //Fetch mimetype from sitecore and check the file for matches
                //If null or empty string should return the default value for mimetype checks
                var mimeTypes = (this.getAttribute('data-mime-types')) ?
                    '^(.*(?=(' + this.getAttribute('data-mime-types').split(',').join('|') + ')$))[^.]*$' : //Sitecore MIME type allowed
                    '^(.*(?=(image/jpeg|image/png)$))[^.]*$'; //Default values
                var extensionRegex = new RegExp(mimeTypes, 'i');
                var formData = new FormData();
                var profilePhoto = $(this);

                if (this.files[0] === undefined || !extensionRegex.test(this.files[0].type)) {
                    window.app.showModalMessage('Must upload a valid image format: jpeg or png file', 'modal-message__wrapper--error');
                    setTimeout(function () {
                        window.app.hideModalMessage();
                    }, 2500);
                    return false;
                }

                formData.append("ProfilePhoto", this.files[0]);

                $.ajax({
                    url: profilePhoto.data('action'),
                    type: "POST",
                    data: formData,
                    cache: false,
                    dataType: 'json',
                    processData: false,
                    contentType: false,
                    beforeSend: function () {
                        window.app.showLoading();
                    },
                    complete: function () {
                        window.app.hideLoading();
                    },
                    success: function (data) {
                        if (data.newUrl !== undefined) {
                            if ($('.profile-avatar__image').length === 0) {
                                var htmlString = '<div class="profile-avatar__image" style="background-image: url(' + data.newUrl + ')"></div><button class="profile-avatar__edit">&#xf040</button>';
                                $(".profile-avatar").html(htmlString);
                            } else {
                                $('.profile-avatar__image').css('background-image', 'url(' + data.newUrl + ')');
                            }
                        }
                    },
                    error: function (data) {
                        // TODO: Setup proper error handling/messaging
                        console.log(data);
                    }
                });
                return false;
            });

            document.querySelectorAll('form').forEach(function (form) {
                if (form.querySelector(".form__btn")) {
                    $(".form__btn")
                        .on('click', function () {
                            if (submitToggle(form)) {
                                return true;
                            } else {
                                $($(this).data('target')).toggleClass('-visible');
                                if (form.querySelector('.notification--error'))
                                    window.scrollTo(0, 0);
                                else if (form.querySelector('.input--error'))
                                    window.scrollTo(0, 0);
                                //show error
                                if (form.querySelector(".notification--error"))
                                    form.querySelector(".notification--error").classList.add("notification--active");
                            }
                        });
                }
            });

            //Checking all required fields before removing disabled class
            //Trying to scope this into form__wrapper and use classes so multiple inputs can happen on the same page
            function submitToggle(formElement) {
                var requiredInputs = formElement.querySelectorAll('*:required:not(:disabled)');

                requiredInputs.forEach(function (element) {

                    if (!element.classList.contains('input--valid') && !element.classList.contains('input-text--filled')) {
                        element.classList.add("input--error")
                    } else {
                        element.classList.remove("input--error");
                    }

                    if (element.parentNode.querySelector('.label-text')) {
                        element.classList.contains("input--error") ?
                            element.parentNode.querySelector('.label-text').classList.add("label-text--error") :
                            element.parentNode.querySelector('.label-text').classList.remove("label-text--error");
                    }
                });

                if (requiredInputs.length === formElement.querySelectorAll('.input--valid:required:not(:disabled)').length) return true;
            }

        }
    },

    inputToggle: function (inputElementNode) {
        //Created hoisted functions for handling input and select elementNode
        var elementFilled = function (elementExpression, elementNode) {
            elementExpression ?
                elementNode.classList.add('input--filled') : elementNode.classList.remove('input--filled');
        };

        var selectCheck = function (elementNode) {
            if (elementNode.selectedIndex !== -1) {
                elementFilled(elementNode.options[inputElementNode.selectedIndex].textContent.trim(), elementNode);
            } else {
                elementNode.classList.remove('input--filled');
            }
        };

        var inputCheck = function (elementNode) {
            if (!elementNode.parentNode.querySelector('.control-clear')) return false;
            var controlClear = elementNode.parentNode.querySelector('.control-clear');
            //If input is text and not empty apply class for styling
            elementFilled(elementNode.value !== '' || elementNode.type === 'date', elementNode);

            elementNode.disabled || !elementNode.value.trim() ?
                controlClear.classList.add('control-clear--hide') : controlClear.classList.remove('control-clear--hide');
        };

        if (inputElementNode.type === "select-multiple") {
            elementFilled(inputElementNode.querySelectorAll('option:checked').length, inputElementNode);
        }
        else if (inputElementNode.type === 'select-one') {
            selectCheck(inputElementNode);
        }
        else {
            inputCheck(inputElementNode);
        }
    },
    inputValidate: function (inputElementNode) {
        if (inputElementNode.selectedIndex !== -1) {
            //Check what type it is and run basic validation before BE validation
            if ((inputElementNode.value !== '' && (
                inputElementNode.type === 'text' ||
                inputElementNode.type === 'password' ||
                inputElementNode.type === 'tel' ||
                inputElementNode.type === 'url' ||
                inputElementNode.type === 'textarea')) ||
                (inputElementNode.checked === true && inputElementNode.type === 'checkbox') ||
                (parseInt(inputElementNode.value) >= parseInt(inputElementNode.min) && parseInt(inputElementNode.value) <= parseInt(inputElementNode.max)) ||
                (inputElementNode.type === 'select-one' && !inputElementNode.options[inputElementNode.selectedIndex].disabled && inputElementNode.options[inputElementNode.selectedIndex].value !== '') ||
                inputElementNode.type === 'email' && window.app.emailIsValid(inputElementNode.value)) {
                //Defining the select element in another else if statement cause different element from input
                inputElementNode.classList.add('input--valid');
            } else {
                inputElementNode.classList.remove('input--valid');
            }
        } else {
            inputElementNode.classList.remove('input--valid');
        }
    },
    inputControlCreate: function (inputElementNode) {
        if (inputElementNode.parentNode.querySelectorAll('.input-controls').length) return false;
        var inputTextControls = '<div class="input-controls">';
        //Adding controls for removing and showing password field
        if (inputElementNode.type === 'password') {
            inputTextControls += '<h6 class="control-show"></h6>';
        }
        inputTextControls += '<span class="control-clear control-clear--hide"></span>';
        if (inputElementNode.classList.contains('input-csc')) {
            inputTextControls += '<span class="control-csc"></span>';
        }
        inputTextControls += '</div>';
        inputElementNode.insertAdjacentHTML('beforebegin', inputTextControls);
    },
    multiselectControlCreate: function (select) {
        var $select = $(select);
        var $container = $select.parent();
        if ($container.find('.input-multiselect').length) {
            return false;
        }
        var $inputMultiselectOptions = $('<div class="input-multiselect-options"></div>').insertAfter($select);
        var $inputMultiselect = $('<div class="input-multiselect" tabIndex="0"></div>')
            .insertBefore($select)
            .on('mousedown focus', function (e) {
                if (e.type == "mousedown") {
                    $select.data('clicking', true);
                }
                else if ($select.data('clicking')) {
                    $select.data('clicking', false);
                    return;
                }
                var show = e.type == 'focus' || $inputMultiselectOptions.is(":hidden");
                if (show) {
                    $inputMultiselectOptions.css({
                        'width': $inputMultiselect.outerWidth(),
                        'top': $inputMultiselect.outerHeight(),
                    });
                }
                $inputMultiselectOptions.toggle(show);
            });
        $select
            .change(function (e) {
                $inputMultiselect.html($select.children("option:selected").map(function () {
                    return $(this).val();
                }).get().join(', '));
                $inputMultiselectOptions.css({
                    'width': $inputMultiselect.outerWidth(),
                    'top': $inputMultiselect.outerHeight(),
                });
                window.app.inputToggle(select);
                window.app.inputValidate(select);
            })
            .children().each(function () {
                var $option = $(this);
                var id = $select.attr('id') + "-" + $option.val();
                var $selector = $('<label for="' + id + '" class="input-checkbox__wrapper"><div class="input-checkbox__container"></div><p class="checkbox__copy">' + $option.html() + '</p></label>').appendTo($inputMultiselectOptions);
                $('<input id="' + id + '" value="' + $option.val() + '" class="input-checkbox srt srt--conference-hidden-checkbox" type="checkbox">')
                    .prop("checked", $option.prop("selected"))
                    .click(function (e) {
                        $option.prop("selected", $(this).prop("checked"));
                        $select.change();
                    })
                    .prependTo($selector);
            });
        $(document).on('click focusin', function (e) {
            if (!$container.is(e.target) && !$container.has(e.target).length) {
                $inputMultiselectOptions.hide();
            }
        });
        $select.change();
    },
    //Controlling the Tingle overlay with a callback and might require slight adjustments to keep it condensed and scoped
    overlayTingle: function ($overlayElement, callback) {
        if (typeof tingle == "undefined") {
            return;
        }

        var overlay = new tingle.modal();

        $overlayElement.on('click', function () {

            var partial = $(this).data("partial");

            overlay.open();

            $.ajax({
                url: partial,
                success: function (result) {
                    overlay.setContent(result);
                },
                complete: callback
            });
            return false;
        });
    },
    //Cart add tooltip and more
    //You can run this with a set timeout to remove the class or run function on event trigger
    elementHide: function (elementQuery, show) {
        document.querySelectorAll('.' + elementQuery).forEach(function (elementPiece) {
            if (show) {
                elementPiece.style.display = '';
                setTimeout(function () {
                    elementPiece.classList.remove(elementQuery + '--hide');
                }, 100);
            } else {
                elementPiece.classList.add(elementQuery + '--hide');
                setTimeout(function () {
                    elementPiece.style.display = 'none';
                }, 250);
            }
        });
    },

    // convenience functions for displaying the loading/processing animation
    showLoading: function () {
        window.app.elementHide('processing-icon__wrapper', true);
    },
    hideLoading: function () {
        window.app.elementHide('processing-icon__wrapper', false);
    },
    //window.app.scrollToElement(document.querySelector('.element-class'), {behavior: 'instant', block: 'end'});
    scrollToElement: function (element, options) {
        //You can only scroll to one element
        if (typeof options !== 'object') options = {};
        options = {
            behavior: options.behavior || 'smooth',
            block: options.block || 'end',
            inline: options.inline || 'nearest'
        };
        element.scrollIntoView(options);
        if (window.pageXOffset > 0) window.scroll(0, window.pageYOffset);
    },
    //Problem: Show/create modal message
    showModalMessage: function (modalMessage, modalClass) {
        if (typeof modalMessage === 'undefined') modalMessage = 'Thanks your information has been updated!';
        if (typeof modalClass === 'undefined') modalClass = '';
        if (typeof modalMessage === 'string') modalMessage = [modalMessage];
        //Verify args for the right type, if not throw error
        //Check if modal element exists
        var modalCopyElements = '';

        if (document.querySelector('.modal-message__wrapper') === null) {
            //Create modal element
            var modalMessageElement = document.createElement('div');

            modalMessageElement.classList.add('modal-message__wrapper');
            document.body.appendChild(modalMessageElement);
        }
        //Always update the message before showing

        var modalMessageWrapper = document.querySelector('.modal-message__wrapper');

        if (modalClass) modalMessageWrapper.classList.add(modalClass);
        modalMessageWrapper.classList.remove('hide');

        modalMessage.forEach(function (modalCopy) {
            modalCopyElements += '<h5 class="modal-message__copy">' + modalCopy + '</h5>';
        });
        modalMessageWrapper.innerHTML = modalCopyElements;
        //Could use an observer to check for DOM mutation before adding class for animation
        window.setTimeout(function () {
            modalMessageWrapper.classList.add('modal-message__wrapper--active');
        }, 25);
    },
    //Problem: Show/create modal message
    hideModalMessage: function () {
        var modalMessageWrapper = document.querySelector('.modal-message__wrapper');
        if (modalMessageWrapper) {
            var modalMessageEvent = function () {
                modalMessageWrapper.classList.forEach(function (className) {
                    if (className !== 'modal-message__wrapper') modalMessageWrapper.classList.remove(className);
                });
                modalMessageWrapper.classList.add('hide');
                modalMessageWrapper.removeEventListener('transitionend', modalMessageEvent);
            };

            modalMessageWrapper.classList.remove('modal-message__wrapper--active');
            modalMessageWrapper.addEventListener('transitionend', modalMessageEvent);
        }
    },

    sessionsConferenceFilter: function (angularApp, filterString) {
        angularApp.sessionFiltersChecked(filterString);
    }
};

// Start OneTrust Cookie Banner and Preference Center

function initOptanonWrapper(OnetrustActiveGroups) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        "OnetrustActiveGroups": OnetrustActiveGroups
    });

    // Use the following code wherever setting or reading cookies
    // Make sure OnetrustActiveGroups is defined, otherwise proceed as normal with cookies
    if (typeof OnetrustActiveGroups === 'undefined') {
        // OnetrustActiveGroups has not been defined
    }
    // OnetrustActiveGroups is defined
    else {
        // Check if Functional Cookies (Group 2) are allowed
        if (OnetrustActiveGroups.indexOf(',2,') > -1) {
            // Cookie group 2 is allowed
        }
        // Check if Performance Cookies (Group 3) are allowed
        if (OnetrustActiveGroups.indexOf(',3') > -1) {
            // Cookie group 3 is allowed
        }
    }
}


// Start Search Tracking

function gtmTrackSearch(searchPlace) {
    var searchBoxText = "";

    switch (searchPlace) {
        case "global search":
            searchBoxText = $('#MinimalSearchbox').val().trim();

            if (searchBoxText != null && searchBoxText != '') {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'view_search_results',
                    'searchTerm': searchBoxText, // search query
                    'searchPlace': searchPlace // search location
                });
            }
            break;

        case "main search page":
            setTimeout(function () {
                searchBoxText = $('.magic-box-input input[type=text]').val().trim();

                if (searchBoxText != null && searchBoxText != '') {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'event': 'view_search_results',
                        'searchTerm': searchBoxText, // search query
                        'searchPlace': searchPlace // search location
                    });
                }
            }, 500);
            break;

        case "digital video search":
            searchBoxText = $('.video-tabs .search input[type=text]').val().trim();

            if (searchBoxText != null && searchBoxText != '') {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'view_search_results',
                    'searchTerm': searchBoxText, // search query
                    'searchPlace': searchPlace // search location
                });
            }
            break;
    }
}


// Start Promotion Tracking

function gtmTrackPromotions($this) {
    var $promotionObj = $this.closest('.track-promotion');

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'select_promotion',
        'ecommerce': {
            'items': [{
                'promotion_id': $promotionObj.attr('data-promotion-id'),
                'promotion_name': $promotionObj.attr('data-promotion-name'),
                'creative_name': $promotionObj.attr('data-creative-name'),
                'location_id': $promotionObj.attr('data-location-id')
            }]
        }
    });
}


// Start Downloads Tracking

function gtmTrackDownloads($this) {
    var $downloadObj = $this.closest('.track-download');
    var clickText = String.empty;
    var clickUrl = String.empty;
    var downloadName = String.empty;

    // Direct Downloads
    if ($downloadObj.find('.downloads-dynamic-list__item--button input[type=submit]').length) {
        clickText = $downloadObj.find('.downloads-dynamic-list__item--button input[type=submit]').val();
        clickUrl = $downloadObj.find('.downloads-dynamic-list__item--button input[name=productcode]').val();
        downloadName = $downloadObj.find('.downloads-dynamic-list__item--button input[name=filename]').val();
    }

    // RedShelf Downloads
    else if ($downloadObj.find('.downloads-dynamic-list__item--button a').length) {
        clickText = $downloadObj.find('.downloads-dynamic-list__item--button a').html();
        clickUrl = $downloadObj.find('.downloads-dynamic-list__item--button a').attr('href');
        downloadName = $downloadObj.find('.downloads-dynamic-list__item--title').html().replace(/(\r\n|\n|\r)/gm, "").trim();
    }

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'gated_file_download',
        'download_category': 'myisaca',
        'download_name': downloadName,
        'click_url': clickUrl,
        'click_text': clickText
    });
}

//Lead Form submission tracking

function gtmTrackLeadFormSubmission(formName, formId) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'generate_lead', 
        'form_name': formName, 
        'form_id': formId, 
        'form_location': window.location.href
    });
}

// Start Gated Asset Download (from Lead Forms) Tracking

function gtmTrackGatedAssetDownloads(downloadName, clickUrl, clickText) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'gated_file_download',
        'download_category': 'Lead Form',
        'download_name': downloadName,
        'click_url': clickUrl,
        'click_text': clickText
    });
}

// track clicks to open lead form
function gtmTrackOpenLeadformModal(formName, popupOpenTime) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'cta_popup_tracking_open',
        'page_location': window.location.href,
        'popup_name': formName,
        'popupOpenTime': popupOpenTime,
    });
}

// track time for lead form submission after opening the modal
function gtmTrackTimeForLeadFormSubmission(formName) {
    let formSubmissionTime = new Date();   
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'cta_popup_tracking_formsubmission',
        'page_location': window.location.href,
        'popup_name': formName,
        'formSubmissionTime': formSubmissionTime,
    });
}

// track clicks to close lead form
function gtmTrackCloseLeadformModal(formName, popupOpenTime, hasUserScrolled) {
    let popupCloseTime = new Date();
    const timeSpent = popupCloseTime - popupOpenTime;
    
    var formData = [];
    let formFields = document.querySelectorAll('.wFormContainer .section.group input:not(.wFormContainer .section.group.wf-acl-hidden input), .wFormContainer select')
    formFields.forEach(function (field) {
          field.addEventListener('change', handleFieldChange(field));        
    });

    function handleFieldChange(field) {             
        var fieldName = field.title || field.name;
        var fieldValue;

        if (field.type === 'checkbox') {
            fieldValue = field.checked ? 'true' : '';
        } else if (field.tagName === 'SELECT') {
            var selectedOption = field.options[field.selectedIndex];
            if (field.selectedIndex != 0)
                fieldValue = selectedOption ? selectedOption.textContent : '';
            else
                fieldValue = "";
        } else {
            fieldValue = field.value.trim();
        }
        if (fieldValue != "" && fieldValue != null) {
            formData.push({ [fieldName]: fieldValue });
        }     
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'cta_popup_tracking_closed',
        'page_location': window.location.href,
        'popup_name': formName,
        'popupOpenTime': timeSpent,
        'inputFields': formData,
        'scroll': hasUserScrolled,
    });
}

// track survey prompt opens
function gtmTrackOpenSurveyPrompt(formName, popupOpenTime, surveyTrigger) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'surveyprompt_tracking_open',
        'page_location': window.location.href,
        'popup_name': formName,
        'popupOpenTime': popupOpenTime,
        'survey_trigger': surveyTrigger
    });
}

// track survey prompt closes
function gtmTrackCloseSurveyPrompt(formName, popupOpenTime, hasUserScrolled) {
    let popupCloseTime = new Date();
    const timeSpent = popupCloseTime - popupOpenTime;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'surveyprompt_tracking_closed',
        'page_location': window.location.href,
        'popup_name': formName,
        'popupOpenTime': timeSpent,
        'scroll': hasUserScrolled,
    });
}

// Start Lead Form Tracking

function gtmTrackLeadForms($this) {
    const formActionBaseUrl = "https://www.pages01.net/isaca/EnterpriseSolutions/";
    const formName = $this.parents('form').attr('action').replace(formActionBaseUrl, "");

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'generate_lead',
        'form_name': formName
    });
}

// Start Partner Logos Link Tracking

function gtmTrackPartnerLogoLinks($this) {
    var $linkObj = $this;
    var partnerType = "";

    var partnerName = $linkObj.find('h3').length > 0 ? $linkObj.find('h3').html() :
        ($linkObj.find('h4').length > 0 ? $linkObj.find('h4').html() :
            ($linkObj.find('span').length > 0 ? $linkObj.find('span').html() : $linkObj.html()));

    if (partnerName != null && partnerName != '' && partnerName.indexOf('<') >= 0 && partnerName.indexOf('>') > 0) {
        var elem = $.parseHTML(partnerName);
        if (elem != null && elem.length > 0 && elem[0].tagName == 'IMG') {
            partnerName = elem[0].alt;
        }
    }

    $linkObj.parents().each(function () {
        if ($(this).children('h2').length > 0) {
            partnerType = $(this).children('h2').html();
            return false;
        }
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'training_partner_click',
        'partner_type': partnerType,    // e.g.  'Elite Organizations'
        'partner_name': partnerName,    // e.g.  ALC Training
        'partner_url': $linkObj.attr('href')
    });
}

// Start CLP Link Tracking

function gtmTrackClpLinks($this) {
    var $linkObj = $this;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'clp_link_click',
        'link_text': $linkObj.html(),
        'link_url': $linkObj.attr('href')
    });
}

// Start Blog Related Content Tracking

function gtmTrackBlogRelatedContent($this) {
    var $linkObj = $this;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'CTA_blog_clicks',
        'click_url': $linkObj.attr('href'),
        'page_location': window.location.href,
        'click_text': $linkObj.find('h3').text()
    });
}
/*! jQuery Validation Plugin - v1.17.0 - 7/29/2017
 * https://jqueryvalidation.org/
 * Copyright (c) 2017 Jörn Zaefferer; Licensed MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof module&&module.exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){a.extend(a.fn,{validate:function(b){if(!this.length)return void(b&&b.debug&&window.console&&console.warn("Nothing selected, can't validate, returning nothing."));var c=a.data(this[0],"validator");return c?c:(this.attr("novalidate","novalidate"),c=new a.validator(b,this[0]),a.data(this[0],"validator",c),c.settings.onsubmit&&(this.on("click.validate",":submit",function(b){c.submitButton=b.currentTarget,a(this).hasClass("cancel")&&(c.cancelSubmit=!0),void 0!==a(this).attr("formnovalidate")&&(c.cancelSubmit=!0)}),this.on("submit.validate",function(b){function d(){var d,e;return c.submitButton&&(c.settings.submitHandler||c.formSubmitted)&&(d=a("<input type='hidden'/>").attr("name",c.submitButton.name).val(a(c.submitButton).val()).appendTo(c.currentForm)),!c.settings.submitHandler||(e=c.settings.submitHandler.call(c,c.currentForm,b),d&&d.remove(),void 0!==e&&e)}return c.settings.debug&&b.preventDefault(),c.cancelSubmit?(c.cancelSubmit=!1,d()):c.form()?c.pendingRequest?(c.formSubmitted=!0,!1):d():(c.focusInvalid(),!1)})),c)},valid:function(){var b,c,d;return a(this[0]).is("form")?b=this.validate().form():(d=[],b=!0,c=a(this[0].form).validate(),this.each(function(){b=c.element(this)&&b,b||(d=d.concat(c.errorList))}),c.errorList=d),b},rules:function(b,c){var d,e,f,g,h,i,j=this[0];if(null!=j&&(!j.form&&j.hasAttribute("contenteditable")&&(j.form=this.closest("form")[0],j.name=this.attr("name")),null!=j.form)){if(b)switch(d=a.data(j.form,"validator").settings,e=d.rules,f=a.validator.staticRules(j),b){case"add":a.extend(f,a.validator.normalizeRule(c)),delete f.messages,e[j.name]=f,c.messages&&(d.messages[j.name]=a.extend(d.messages[j.name],c.messages));break;case"remove":return c?(i={},a.each(c.split(/\s/),function(a,b){i[b]=f[b],delete f[b]}),i):(delete e[j.name],f)}return g=a.validator.normalizeRules(a.extend({},a.validator.classRules(j),a.validator.attributeRules(j),a.validator.dataRules(j),a.validator.staticRules(j)),j),g.required&&(h=g.required,delete g.required,g=a.extend({required:h},g)),g.remote&&(h=g.remote,delete g.remote,g=a.extend(g,{remote:h})),g}}}),a.extend(a.expr.pseudos||a.expr[":"],{blank:function(b){return!a.trim(""+a(b).val())},filled:function(b){var c=a(b).val();return null!==c&&!!a.trim(""+c)},unchecked:function(b){return!a(b).prop("checked")}}),a.validator=function(b,c){this.settings=a.extend(!0,{},a.validator.defaults,b),this.currentForm=c,this.init()},a.validator.format=function(b,c){return 1===arguments.length?function(){var c=a.makeArray(arguments);return c.unshift(b),a.validator.format.apply(this,c)}:void 0===c?b:(arguments.length>2&&c.constructor!==Array&&(c=a.makeArray(arguments).slice(1)),c.constructor!==Array&&(c=[c]),a.each(c,function(a,c){b=b.replace(new RegExp("\\{"+a+"\\}","g"),function(){return c})}),b)},a.extend(a.validator,{defaults:{messages:{},groups:{},rules:{},errorClass:"error",pendingClass:"pending",validClass:"valid",errorElement:"label",focusCleanup:!1,focusInvalid:!0,errorContainer:a([]),errorLabelContainer:a([]),onsubmit:!0,ignore:":hidden",ignoreTitle:!1,onfocusin:function(a){this.lastActive=a,this.settings.focusCleanup&&(this.settings.unhighlight&&this.settings.unhighlight.call(this,a,this.settings.errorClass,this.settings.validClass),this.hideThese(this.errorsFor(a)))},onfocusout:function(a){this.checkable(a)||!(a.name in this.submitted)&&this.optional(a)||this.element(a)},onkeyup:function(b,c){var d=[16,17,18,20,35,36,37,38,39,40,45,144,225];9===c.which&&""===this.elementValue(b)||a.inArray(c.keyCode,d)!==-1||(b.name in this.submitted||b.name in this.invalid)&&this.element(b)},onclick:function(a){a.name in this.submitted?this.element(a):a.parentNode.name in this.submitted&&this.element(a.parentNode)},highlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).addClass(c).removeClass(d):a(b).addClass(c).removeClass(d)},unhighlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).removeClass(c).addClass(d):a(b).removeClass(c).addClass(d)}},setDefaults:function(b){a.extend(a.validator.defaults,b)},messages:{required:"This field is required.",remote:"Please fix this field.",email:"Please enter a valid email address.",url:"Please enter a valid URL.",date:"Please enter a valid date.",dateISO:"Please enter a valid date (ISO).",number:"Please enter a valid number.",digits:"Please enter only digits.",equalTo:"Please enter the same value again.",maxlength:a.validator.format("Please enter no more than {0} characters."),minlength:a.validator.format("Please enter at least {0} characters."),rangelength:a.validator.format("Please enter a value between {0} and {1} characters long."),range:a.validator.format("Please enter a value between {0} and {1}."),max:a.validator.format("Please enter a value less than or equal to {0}."),min:a.validator.format("Please enter a value greater than or equal to {0}."),step:a.validator.format("Please enter a multiple of {0}.")},autoCreateRanges:!1,prototype:{init:function(){function b(b){!this.form&&this.hasAttribute("contenteditable")&&(this.form=a(this).closest("form")[0],this.name=a(this).attr("name"));var c=a.data(this.form,"validator"),d="on"+b.type.replace(/^validate/,""),e=c.settings;e[d]&&!a(this).is(e.ignore)&&e[d].call(c,this,b)}this.labelContainer=a(this.settings.errorLabelContainer),this.errorContext=this.labelContainer.length&&this.labelContainer||a(this.currentForm),this.containers=a(this.settings.errorContainer).add(this.settings.errorLabelContainer),this.submitted={},this.valueCache={},this.pendingRequest=0,this.pending={},this.invalid={},this.reset();var c,d=this.groups={};a.each(this.settings.groups,function(b,c){"string"==typeof c&&(c=c.split(/\s/)),a.each(c,function(a,c){d[c]=b})}),c=this.settings.rules,a.each(c,function(b,d){c[b]=a.validator.normalizeRule(d)}),a(this.currentForm).on("focusin.validate focusout.validate keyup.validate",":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']",b).on("click.validate","select, option, [type='radio'], [type='checkbox']",b),this.settings.invalidHandler&&a(this.currentForm).on("invalid-form.validate",this.settings.invalidHandler)},form:function(){return this.checkForm(),a.extend(this.submitted,this.errorMap),this.invalid=a.extend({},this.errorMap),this.valid()||a(this.currentForm).triggerHandler("invalid-form",[this]),this.showErrors(),this.valid()},checkForm:function(){this.prepareForm();for(var a=0,b=this.currentElements=this.elements();b[a];a++)this.check(b[a]);return this.valid()},element:function(b){var c,d,e=this.clean(b),f=this.validationTargetFor(e),g=this,h=!0;return void 0===f?delete this.invalid[e.name]:(this.prepareElement(f),this.currentElements=a(f),d=this.groups[f.name],d&&a.each(this.groups,function(a,b){b===d&&a!==f.name&&(e=g.validationTargetFor(g.clean(g.findByName(a))),e&&e.name in g.invalid&&(g.currentElements.push(e),h=g.check(e)&&h))}),c=this.check(f)!==!1,h=h&&c,c?this.invalid[f.name]=!1:this.invalid[f.name]=!0,this.numberOfInvalids()||(this.toHide=this.toHide.add(this.containers)),this.showErrors(),a(b).attr("aria-invalid",!c)),h},showErrors:function(b){if(b){var c=this;a.extend(this.errorMap,b),this.errorList=a.map(this.errorMap,function(a,b){return{message:a,element:c.findByName(b)[0]}}),this.successList=a.grep(this.successList,function(a){return!(a.name in b)})}this.settings.showErrors?this.settings.showErrors.call(this,this.errorMap,this.errorList):this.defaultShowErrors()},resetForm:function(){a.fn.resetForm&&a(this.currentForm).resetForm(),this.invalid={},this.submitted={},this.prepareForm(),this.hideErrors();var b=this.elements().removeData("previousValue").removeAttr("aria-invalid");this.resetElements(b)},resetElements:function(a){var b;if(this.settings.unhighlight)for(b=0;a[b];b++)this.settings.unhighlight.call(this,a[b],this.settings.errorClass,""),this.findByName(a[b].name).removeClass(this.settings.validClass);else a.removeClass(this.settings.errorClass).removeClass(this.settings.validClass)},numberOfInvalids:function(){return this.objectLength(this.invalid)},objectLength:function(a){var b,c=0;for(b in a)void 0!==a[b]&&null!==a[b]&&a[b]!==!1&&c++;return c},hideErrors:function(){this.hideThese(this.toHide)},hideThese:function(a){a.not(this.containers).text(""),this.addWrapper(a).hide()},valid:function(){return 0===this.size()},size:function(){return this.errorList.length},focusInvalid:function(){if(this.settings.focusInvalid)try{a(this.findLastActive()||this.errorList.length&&this.errorList[0].element||[]).filter(":visible").focus().trigger("focusin")}catch(b){}},findLastActive:function(){var b=this.lastActive;return b&&1===a.grep(this.errorList,function(a){return a.element.name===b.name}).length&&b},elements:function(){var b=this,c={};return a(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function(){var d=this.name||a(this).attr("name");return!d&&b.settings.debug&&window.console&&console.error("%o has no name assigned",this),this.hasAttribute("contenteditable")&&(this.form=a(this).closest("form")[0],this.name=d),!(d in c||!b.objectLength(a(this).rules()))&&(c[d]=!0,!0)})},clean:function(b){return a(b)[0]},errors:function(){var b=this.settings.errorClass.split(" ").join(".");return a(this.settings.errorElement+"."+b,this.errorContext)},resetInternals:function(){this.successList=[],this.errorList=[],this.errorMap={},this.toShow=a([]),this.toHide=a([])},reset:function(){this.resetInternals(),this.currentElements=a([])},prepareForm:function(){this.reset(),this.toHide=this.errors().add(this.containers)},prepareElement:function(a){this.reset(),this.toHide=this.errorsFor(a)},elementValue:function(b){var c,d,e=a(b),f=b.type;return"radio"===f||"checkbox"===f?this.findByName(b.name).filter(":checked").val():"number"===f&&"undefined"!=typeof b.validity?b.validity.badInput?"NaN":e.val():(c=b.hasAttribute("contenteditable")?e.text():e.val(),"file"===f?"C:\\fakepath\\"===c.substr(0,12)?c.substr(12):(d=c.lastIndexOf("/"),d>=0?c.substr(d+1):(d=c.lastIndexOf("\\"),d>=0?c.substr(d+1):c)):"string"==typeof c?c.replace(/\r/g,""):c)},check:function(b){b=this.validationTargetFor(this.clean(b));var c,d,e,f,g=a(b).rules(),h=a.map(g,function(a,b){return b}).length,i=!1,j=this.elementValue(b);if("function"==typeof g.normalizer?f=g.normalizer:"function"==typeof this.settings.normalizer&&(f=this.settings.normalizer),f){if(j=f.call(b,j),"string"!=typeof j)throw new TypeError("The normalizer should return a string value.");delete g.normalizer}for(d in g){e={method:d,parameters:g[d]};try{if(c=a.validator.methods[d].call(this,j,b,e.parameters),"dependency-mismatch"===c&&1===h){i=!0;continue}if(i=!1,"pending"===c)return void(this.toHide=this.toHide.not(this.errorsFor(b)));if(!c)return this.formatAndAdd(b,e),!1}catch(k){throw this.settings.debug&&window.console&&console.log("Exception occurred when checking element "+b.id+", check the '"+e.method+"' method.",k),k instanceof TypeError&&(k.message+=".  Exception occurred when checking element "+b.id+", check the '"+e.method+"' method."),k}}if(!i)return this.objectLength(g)&&this.successList.push(b),!0},customDataMessage:function(b,c){return a(b).data("msg"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase())||a(b).data("msg")},customMessage:function(a,b){var c=this.settings.messages[a];return c&&(c.constructor===String?c:c[b])},findDefined:function(){for(var a=0;a<arguments.length;a++)if(void 0!==arguments[a])return arguments[a]},defaultMessage:function(b,c){"string"==typeof c&&(c={method:c});var d=this.findDefined(this.customMessage(b.name,c.method),this.customDataMessage(b,c.method),!this.settings.ignoreTitle&&b.title||void 0,a.validator.messages[c.method],"<strong>Warning: No message defined for "+b.name+"</strong>"),e=/\$?\{(\d+)\}/g;return"function"==typeof d?d=d.call(this,c.parameters,b):e.test(d)&&(d=a.validator.format(d.replace(e,"{$1}"),c.parameters)),d},formatAndAdd:function(a,b){var c=this.defaultMessage(a,b);this.errorList.push({message:c,element:a,method:b.method}),this.errorMap[a.name]=c,this.submitted[a.name]=c},addWrapper:function(a){return this.settings.wrapper&&(a=a.add(a.parent(this.settings.wrapper))),a},defaultShowErrors:function(){var a,b,c;for(a=0;this.errorList[a];a++)c=this.errorList[a],this.settings.highlight&&this.settings.highlight.call(this,c.element,this.settings.errorClass,this.settings.validClass),this.showLabel(c.element,c.message);if(this.errorList.length&&(this.toShow=this.toShow.add(this.containers)),this.settings.success)for(a=0;this.successList[a];a++)this.showLabel(this.successList[a]);if(this.settings.unhighlight)for(a=0,b=this.validElements();b[a];a++)this.settings.unhighlight.call(this,b[a],this.settings.errorClass,this.settings.validClass);this.toHide=this.toHide.not(this.toShow),this.hideErrors(),this.addWrapper(this.toShow).show()},validElements:function(){return this.currentElements.not(this.invalidElements())},invalidElements:function(){return a(this.errorList).map(function(){return this.element})},showLabel:function(b,c){var d,e,f,g,h=this.errorsFor(b),i=this.idOrName(b),j=a(b).attr("aria-describedby");h.length?(h.removeClass(this.settings.validClass).addClass(this.settings.errorClass),h.html(c)):(h=a("<"+this.settings.errorElement+">").attr("id",i+"-error").addClass(this.settings.errorClass).html(c||""),d=h,this.settings.wrapper&&(d=h.hide().show().wrap("<"+this.settings.wrapper+"/>").parent()),this.labelContainer.length?this.labelContainer.append(d):this.settings.errorPlacement?this.settings.errorPlacement.call(this,d,a(b)):d.insertAfter(b),h.is("label")?h.attr("for",i):0===h.parents("label[for='"+this.escapeCssMeta(i)+"']").length&&(f=h.attr("id"),j?j.match(new RegExp("\\b"+this.escapeCssMeta(f)+"\\b"))||(j+=" "+f):j=f,a(b).attr("aria-describedby",j),e=this.groups[b.name],e&&(g=this,a.each(g.groups,function(b,c){c===e&&a("[name='"+g.escapeCssMeta(b)+"']",g.currentForm).attr("aria-describedby",h.attr("id"))})))),!c&&this.settings.success&&(h.text(""),"string"==typeof this.settings.success?h.addClass(this.settings.success):this.settings.success(h,b)),this.toShow=this.toShow.add(h)},errorsFor:function(b){var c=this.escapeCssMeta(this.idOrName(b)),d=a(b).attr("aria-describedby"),e="label[for='"+c+"'], label[for='"+c+"'] *";return d&&(e=e+", #"+this.escapeCssMeta(d).replace(/\s+/g,", #")),this.errors().filter(e)},escapeCssMeta:function(a){return a.replace(/([\\!"#$%&'()*+,.\/:;<=>?@\[\]^`{|}~])/g,"\\$1")},idOrName:function(a){return this.groups[a.name]||(this.checkable(a)?a.name:a.id||a.name)},validationTargetFor:function(b){return this.checkable(b)&&(b=this.findByName(b.name)),a(b).not(this.settings.ignore)[0]},checkable:function(a){return/radio|checkbox/i.test(a.type)},findByName:function(b){return a(this.currentForm).find("[name='"+this.escapeCssMeta(b)+"']")},getLength:function(b,c){switch(c.nodeName.toLowerCase()){case"select":return a("option:selected",c).length;case"input":if(this.checkable(c))return this.findByName(c.name).filter(":checked").length}return b.length},depend:function(a,b){return!this.dependTypes[typeof a]||this.dependTypes[typeof a](a,b)},dependTypes:{"boolean":function(a){return a},string:function(b,c){return!!a(b,c.form).length},"function":function(a,b){return a(b)}},optional:function(b){var c=this.elementValue(b);return!a.validator.methods.required.call(this,c,b)&&"dependency-mismatch"},startRequest:function(b){this.pending[b.name]||(this.pendingRequest++,a(b).addClass(this.settings.pendingClass),this.pending[b.name]=!0)},stopRequest:function(b,c){this.pendingRequest--,this.pendingRequest<0&&(this.pendingRequest=0),delete this.pending[b.name],a(b).removeClass(this.settings.pendingClass),c&&0===this.pendingRequest&&this.formSubmitted&&this.form()?(a(this.currentForm).submit(),this.submitButton&&a("input:hidden[name='"+this.submitButton.name+"']",this.currentForm).remove(),this.formSubmitted=!1):!c&&0===this.pendingRequest&&this.formSubmitted&&(a(this.currentForm).triggerHandler("invalid-form",[this]),this.formSubmitted=!1)},previousValue:function(b,c){return c="string"==typeof c&&c||"remote",a.data(b,"previousValue")||a.data(b,"previousValue",{old:null,valid:!0,message:this.defaultMessage(b,{method:c})})},destroy:function(){this.resetForm(),a(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur")}},classRuleSettings:{required:{required:!0},email:{email:!0},url:{url:!0},date:{date:!0},dateISO:{dateISO:!0},number:{number:!0},digits:{digits:!0},creditcard:{creditcard:!0}},addClassRules:function(b,c){b.constructor===String?this.classRuleSettings[b]=c:a.extend(this.classRuleSettings,b)},classRules:function(b){var c={},d=a(b).attr("class");return d&&a.each(d.split(" "),function(){this in a.validator.classRuleSettings&&a.extend(c,a.validator.classRuleSettings[this])}),c},normalizeAttributeRule:function(a,b,c,d){/min|max|step/.test(c)&&(null===b||/number|range|text/.test(b))&&(d=Number(d),isNaN(d)&&(d=void 0)),d||0===d?a[c]=d:b===c&&"range"!==b&&(a[c]=!0)},attributeRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)"required"===c?(d=b.getAttribute(c),""===d&&(d=!0),d=!!d):d=f.attr(c),this.normalizeAttributeRule(e,g,c,d);return e.maxlength&&/-1|2147483647|524288/.test(e.maxlength)&&delete e.maxlength,e},dataRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)d=f.data("rule"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase()),this.normalizeAttributeRule(e,g,c,d);return e},staticRules:function(b){var c={},d=a.data(b.form,"validator");return d.settings.rules&&(c=a.validator.normalizeRule(d.settings.rules[b.name])||{}),c},normalizeRules:function(b,c){return a.each(b,function(d,e){if(e===!1)return void delete b[d];if(e.param||e.depends){var f=!0;switch(typeof e.depends){case"string":f=!!a(e.depends,c.form).length;break;case"function":f=e.depends.call(c,c)}f?b[d]=void 0===e.param||e.param:(a.data(c.form,"validator").resetElements(a(c)),delete b[d])}}),a.each(b,function(d,e){b[d]=a.isFunction(e)&&"normalizer"!==d?e(c):e}),a.each(["minlength","maxlength"],function(){b[this]&&(b[this]=Number(b[this]))}),a.each(["rangelength","range"],function(){var c;b[this]&&(a.isArray(b[this])?b[this]=[Number(b[this][0]),Number(b[this][1])]:"string"==typeof b[this]&&(c=b[this].replace(/[\[\]]/g,"").split(/[\s,]+/),b[this]=[Number(c[0]),Number(c[1])]))}),a.validator.autoCreateRanges&&(null!=b.min&&null!=b.max&&(b.range=[b.min,b.max],delete b.min,delete b.max),null!=b.minlength&&null!=b.maxlength&&(b.rangelength=[b.minlength,b.maxlength],delete b.minlength,delete b.maxlength)),b},normalizeRule:function(b){if("string"==typeof b){var c={};a.each(b.split(/\s/),function(){c[this]=!0}),b=c}return b},addMethod:function(b,c,d){a.validator.methods[b]=c,a.validator.messages[b]=void 0!==d?d:a.validator.messages[b],c.length<3&&a.validator.addClassRules(b,a.validator.normalizeRule(b))},methods:{required:function(b,c,d){if(!this.depend(d,c))return"dependency-mismatch";if("select"===c.nodeName.toLowerCase()){var e=a(c).val();return e&&e.length>0}return this.checkable(c)?this.getLength(b,c)>0:b.length>0},email:function(a,b){return this.optional(b)||/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(a)},url:function(a,b){return this.optional(b)||/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[\/?#]\S*)?$/i.test(a)},date:function(a,b){return this.optional(b)||!/Invalid|NaN/.test(new Date(a).toString())},dateISO:function(a,b){return this.optional(b)||/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a)},number:function(a,b){return this.optional(b)||/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a)},digits:function(a,b){return this.optional(b)||/^\d+$/.test(a)},minlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d},maxlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e<=d},rangelength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(b,c);return this.optional(c)||e>=d[0]&&e<=d[1]},min:function(a,b,c){return this.optional(b)||a>=c},max:function(a,b,c){return this.optional(b)||a<=c},range:function(a,b,c){return this.optional(b)||a>=c[0]&&a<=c[1]},step:function(b,c,d){var e,f=a(c).attr("type"),g="Step attribute on input type "+f+" is not supported.",h=["text","number","range"],i=new RegExp("\\b"+f+"\\b"),j=f&&!i.test(h.join()),k=function(a){var b=(""+a).match(/(?:\.(\d+))?$/);return b&&b[1]?b[1].length:0},l=function(a){return Math.round(a*Math.pow(10,e))},m=!0;if(j)throw new Error(g);return e=k(d),(k(b)>e||l(b)%l(d)!==0)&&(m=!1),this.optional(c)||m},equalTo:function(b,c,d){var e=a(d);return this.settings.onfocusout&&e.not(".validate-equalTo-blur").length&&e.addClass("validate-equalTo-blur").on("blur.validate-equalTo",function(){a(c).valid()}),b===e.val()},remote:function(b,c,d,e){if(this.optional(c))return"dependency-mismatch";e="string"==typeof e&&e||"remote";var f,g,h,i=this.previousValue(c,e);return this.settings.messages[c.name]||(this.settings.messages[c.name]={}),i.originalMessage=i.originalMessage||this.settings.messages[c.name][e],this.settings.messages[c.name][e]=i.message,d="string"==typeof d&&{url:d}||d,h=a.param(a.extend({data:b},d.data)),i.old===h?i.valid:(i.old=h,f=this,this.startRequest(c),g={},g[c.name]=b,a.ajax(a.extend(!0,{mode:"abort",port:"validate"+c.name,dataType:"json",data:g,context:f.currentForm,success:function(a){var d,g,h,j=a===!0||"true"===a;f.settings.messages[c.name][e]=i.originalMessage,j?(h=f.formSubmitted,f.resetInternals(),f.toHide=f.errorsFor(c),f.formSubmitted=h,f.successList.push(c),f.invalid[c.name]=!1,f.showErrors()):(d={},g=a||f.defaultMessage(c,{method:e,parameters:b}),d[c.name]=i.message=g,f.invalid[c.name]=!0,f.showErrors(d)),i.valid=j,f.stopRequest(c,j)}},d)),"pending")}}});var b,c={};return a.ajaxPrefilter?a.ajaxPrefilter(function(a,b,d){var e=a.port;"abort"===a.mode&&(c[e]&&c[e].abort(),c[e]=d)}):(b=a.ajax,a.ajax=function(d){var e=("mode"in d?d:a.ajaxSettings).mode,f=("port"in d?d:a.ajaxSettings).port;return"abort"===e?(c[f]&&c[f].abort(),c[f]=b.apply(this,arguments),c[f]):b.apply(this,arguments)}),a});
/* NUGET: BEGIN LICENSE TEXT
 *
 * Microsoft grants you the right to use these script files for the sole
 * purpose of either: (i) interacting through your browser with the Microsoft
 * website or online service, subject to the applicable licensing or use
 * terms; or (ii) using the files as included with a Microsoft product subject
 * to that product's license terms. Microsoft reserves all other rights to the
 * files not expressly granted by Microsoft, whether by implication, estoppel
 * or otherwise. Insofar as a script file is dual licensed under GPL,
 * Microsoft neither took the code under GPL nor distributes it thereunder but
 * under the terms set out in this paragraph. All notices and licenses
 * below are for informational purposes only.
 *
 * NUGET: END LICENSE TEXT */
/* NUGET: BEGIN LICENSE TEXT
 *
 * Microsoft grants you the right to use these script files for the sole
 * purpose of either: (i) interacting through your browser with the Microsoft
 * website or online service, subject to the applicable licensing or use
 * terms; or (ii) using the files as included with a Microsoft product subject
 * to that product's license terms. Microsoft reserves all other rights to the
 * files not expressly granted by Microsoft, whether by implication, estoppel
 * or otherwise. Insofar as a script file is dual licensed under GPL,
 * Microsoft neither took the code under GPL nor distributes it thereunder but
 * under the terms set out in this paragraph. All notices and licenses
 * below are for informational purposes only.
 *
 * NUGET: END LICENSE TEXT */
/*
** Unobtrusive validation support library for jQuery and jQuery Validate
** Copyright (C) Microsoft Corporation. All rights reserved.
*/
(function(a){var d=a.validator,b,e="unobtrusiveValidation";function c(a,b,c){a.rules[b]=c;if(a.message)a.messages[b]=a.message}function j(a){return a.replace(/^\s+|\s+$/g,"").split(/\s*,\s*/g)}function f(a){return a.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g,"\\$1")}function h(a){return a.substr(0,a.lastIndexOf(".")+1)}function g(a,b){if(a.indexOf("*.")===0)a=a.replace("*.",b);return a}function m(c,e){var b=a(this).find("[data-valmsg-for='"+f(e[0].name)+"']"),d=b.attr("data-valmsg-replace"),g=d?a.parseJSON(d)!==false:null;b.removeClass("field-validation-valid").addClass("field-validation-error");c.data("unobtrusiveContainer",b);if(g){b.empty();c.removeClass("input-validation-error").appendTo(b)}else c.hide()}function l(e,d){var c=a(this).find("[data-valmsg-summary=true]"),b=c.find("ul");if(b&&b.length&&d.errorList.length){b.empty();c.addClass("validation-summary-errors").removeClass("validation-summary-valid");a.each(d.errorList,function(){a("<li />").html(this.message).appendTo(b)})}}function k(d){var b=d.data("unobtrusiveContainer"),c=b.attr("data-valmsg-replace"),e=c?a.parseJSON(c):null;if(b){b.addClass("field-validation-valid").removeClass("field-validation-error");d.removeData("unobtrusiveContainer");e&&b.empty()}}function n(){var b=a(this),c="__jquery_unobtrusive_validation_form_reset";if(b.data(c))return;b.data(c,true);try{b.data("validator").resetForm()}finally{b.removeData(c)}b.find(".validation-summary-errors").addClass("validation-summary-valid").removeClass("validation-summary-errors");b.find(".field-validation-error").addClass("field-validation-valid").removeClass("field-validation-error").removeData("unobtrusiveContainer").find(">*").removeData("unobtrusiveContainer")}function i(b){var c=a(b),f=c.data(e),i=a.proxy(n,b),g=d.unobtrusive.options||{},h=function(e,d){var c=g[e];c&&a.isFunction(c)&&c.apply(b,d)};if(!f){f={options:{errorClass:g.errorClass||"input-validation-error",errorElement:g.errorElement||"span",errorPlacement:function(){m.apply(b,arguments);h("errorPlacement",arguments)},invalidHandler:function(){l.apply(b,arguments);h("invalidHandler",arguments)},messages:{},rules:{},success:function(){k.apply(b,arguments);h("success",arguments)}},attachValidation:function(){c.off("reset."+e,i).on("reset."+e,i).validate(this.options)},validate:function(){c.validate();return c.valid()}};c.data(e,f)}return f}d.unobtrusive={adapters:[],parseElement:function(b,h){var d=a(b),f=d.parents("form")[0],c,e,g;if(!f)return;c=i(f);c.options.rules[b.name]=e={};c.options.messages[b.name]=g={};a.each(this.adapters,function(){var c="data-val-"+this.name,i=d.attr(c),h={};if(i!==undefined){c+="-";a.each(this.params,function(){h[this]=d.attr(c+this)});this.adapt({element:b,form:f,message:i,params:h,rules:e,messages:g})}});a.extend(e,{__dummy__:true});!h&&c.attachValidation()},parse:function(c){var b=a(c),e=b.parents().addBack().filter("form").add(b.find("form")).has("[data-val=true]");b.find("[data-val=true]").each(function(){d.unobtrusive.parseElement(this,true)});e.each(function(){var a=i(this);a&&a.attachValidation()})}};b=d.unobtrusive.adapters;b.add=function(c,a,b){if(!b){b=a;a=[]}this.push({name:c,params:a,adapt:b});return this};b.addBool=function(a,b){return this.add(a,function(d){c(d,b||a,true)})};b.addMinMax=function(e,g,f,a,d,b){return this.add(e,[d||"min",b||"max"],function(b){var e=b.params.min,d=b.params.max;if(e&&d)c(b,a,[e,d]);else if(e)c(b,g,e);else d&&c(b,f,d)})};b.addSingleVal=function(a,b,d){return this.add(a,[b||"val"],function(e){c(e,d||a,e.params[b])})};d.addMethod("__dummy__",function(){return true});d.addMethod("regex",function(b,c,d){var a;if(this.optional(c))return true;a=(new RegExp(d)).exec(b);return a&&a.index===0&&a[0].length===b.length});d.addMethod("nonalphamin",function(c,d,b){var a;if(b){a=c.match(/\W/g);a=a&&a.length>=b}return a});if(d.methods.extension){b.addSingleVal("accept","mimtype");b.addSingleVal("extension","extension")}else b.addSingleVal("extension","extension","accept");b.addSingleVal("regex","pattern");b.addBool("creditcard").addBool("date").addBool("digits").addBool("email").addBool("number").addBool("url");b.addMinMax("length","minlength","maxlength","rangelength").addMinMax("range","min","max","range");b.addMinMax("minlength","minlength").addMinMax("maxlength","minlength","maxlength");b.add("equalto",["other"],function(b){var i=h(b.element.name),j=b.params.other,d=g(j,i),e=a(b.form).find(":input").filter("[name='"+f(d)+"']")[0];c(b,"equalTo",e)});b.add("required",function(a){(a.element.tagName.toUpperCase()!=="INPUT"||a.element.type.toUpperCase()!=="CHECKBOX")&&c(a,"required",true)});b.add("remote",["url","type","additionalfields"],function(b){var d={url:b.params.url,type:b.params.type||"GET",data:{}},e=h(b.element.name);a.each(j(b.params.additionalfields||b.element.name),function(i,h){var c=g(h,e);d.data[c]=function(){var d=a(b.form).find(":input").filter("[name='"+f(c)+"']");return d.is(":checkbox")?d.filter(":checked").val()||d.filter(":hidden").val()||"":d.is(":radio")?d.filter(":checked").val()||"":d.val()}});c(b,"remote",d)});b.add("password",["min","nonalphamin","regex"],function(a){a.params.min&&c(a,"minlength",a.params.min);a.params.nonalphamin&&c(a,"nonalphamin",a.params.nonalphamin);a.params.regex&&c(a,"regex",a.params.regex)});a(function(){d.unobtrusive.parse(document)})})(jQuery);
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-flexboxtweener-pointerevents-touchevents-setclasses !*/
!function(e,n,t){function o(e,n){return typeof e===n}function r(){var e,n,t,r,i,s,a;for(var f in w)if(w.hasOwnProperty(f)){if(e=[],n=w[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(r=o(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)s=e[i],a=s.split("."),1===a.length?Modernizr[a[0]]=r:(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=r),g.push((r?"":"no-")+a.join("-"))}}function i(e){var n=b.className,t=Modernizr._config.classPrefix||"";if(x&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),x?b.className.baseVal=n:b.className=n)}function s(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):x?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function a(){var e=n.body;return e||(e=s(x?"svg":"body"),e.fake=!0),e}function f(e,t,o,r){var i,f,l,u,c="modernizr",d=s("div"),p=a();if(parseInt(o,10))for(;o--;)l=s("div"),l.id=r?r[o]:c+(o+1),d.appendChild(l);return i=s("style"),i.type="text/css",i.id="s"+c,(p.fake?p:d).appendChild(i),p.appendChild(d),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(n.createTextNode(e)),d.id=c,p.fake&&(p.style.background="",p.style.overflow="hidden",u=b.style.overflow,b.style.overflow="hidden",b.appendChild(p)),f=t(d,e),p.fake?(p.parentNode.removeChild(p),b.style.overflow=u,b.offsetHeight):d.parentNode.removeChild(d),!!f}function l(e,n){return!!~(""+e).indexOf(n)}function u(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function c(e,n){return function(){return e.apply(n,arguments)}}function d(e,n,t){var r;for(var i in e)if(e[i]in n)return t===!1?e[i]:(r=n[e[i]],o(r,"function")?c(r,t||n):r);return!1}function p(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function m(n,o){var r=n.length;if("CSS"in e&&"supports"in e.CSS){for(;r--;)if(e.CSS.supports(p(n[r]),o))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];r--;)i.push("("+p(n[r])+":"+o+")");return i=i.join(" or "),f("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==getComputedStyle(e,null).position})}return t}function v(e,n,r,i){function a(){c&&(delete j.style,delete j.modElem)}if(i=o(i,"undefined")?!1:i,!o(r,"undefined")){var f=m(e,r);if(!o(f,"undefined"))return f}for(var c,d,p,v,h,y=["modernizr","tspan","samp"];!j.style&&y.length;)c=!0,j.modElem=s(y.shift()),j.style=j.modElem.style;for(p=e.length,d=0;p>d;d++)if(v=e[d],h=j.style[v],l(v,"-")&&(v=u(v)),j.style[v]!==t){if(i||o(r,"undefined"))return a(),"pfx"==n?v:!0;try{j.style[v]=r}catch(g){}if(j.style[v]!=h)return a(),"pfx"==n?v:!0}return a(),!1}function h(e,n,t,r,i){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+P.join(s+" ")+s).split(" ");return o(n,"string")||o(n,"undefined")?v(a,n,r,i):(a=(e+" "+E.join(s+" ")+s).split(" "),d(a,n,t))}function y(e,n,o){return h(e,t,t,n,o)}var g=[],w=[],C={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){w.push({name:e,fn:n,options:t})},addAsyncTest:function(e){w.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=C,Modernizr=new Modernizr;var b=n.documentElement,x="svg"===b.nodeName.toLowerCase(),_=C._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];C._prefixes=_;var S="Moz O ms Webkit",E=C._config.usePrefixes?S.toLowerCase().split(" "):[];C._domPrefixes=E;var T=function(){function e(e,n){var r;return e?(n&&"string"!=typeof n||(n=s(n||"div")),e="on"+e,r=e in n,!r&&o&&(n.setAttribute||(n=s("div")),n.setAttribute(e,""),r="function"==typeof n[e],n[e]!==t&&(n[e]=t),n.removeAttribute(e)),r):!1}var o=!("onblur"in n.documentElement);return e}();C.hasEvent=T,Modernizr.addTest("pointerevents",function(){var e=!1,n=E.length;for(e=Modernizr.hasEvent("pointerdown");n--&&!e;)T(E[n]+"pointerdown")&&(e=!0);return e});var z=C.testStyles=f;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",_.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");z(o,function(e){t=9===e.offsetTop})}return t});var P=C._config.usePrefixes?S.split(" "):[];C._cssomPrefixes=P;var A={elem:s("modernizr")};Modernizr._q.push(function(){delete A.elem});var j={style:A.elem.style};Modernizr._q.unshift(function(){delete j.style}),C.testAllProps=h,C.testAllProps=y,Modernizr.addTest("flexboxtweener",y("flexAlign","end",!0)),r(),i(g),delete C.addTest,delete C.addAsyncTest;for(var N=0;N<Modernizr._q.length;N++)Modernizr._q[N]();e.Modernizr=Modernizr}(window,document);
!function (i) { "use strict"; "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery) }(function (i) { "use strict"; var e = window.Slick || {}; (e = function () { var e = 0; return function (t, o) { var s, n = this; n.defaults = { accessibility: !0, adaptiveHeight: !1, appendArrows: i(t), appendDots: i(t), arrows: !0, asNavFor: null, prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>', nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>', autoplay: !1, autoplaySpeed: 3e3, centerMode: !1, centerPadding: "50px", cssEase: "ease", customPaging: function (e, t) { return i('<button type="button" />').text(t + 1) }, dots: !1, dotsClass: "slick-dots", draggable: !0, easing: "linear", edgeFriction: .35, fade: !1, focusOnSelect: !1, focusOnChange: !1, infinite: !0, initialSlide: 0, lazyLoad: "ondemand", mobileFirst: !1, pauseOnHover: !0, pauseOnFocus: !0, pauseOnDotsHover: !1, respondTo: "window", responsive: null, rows: 1, rtl: !1, slide: "", slidesPerRow: 1, slidesToShow: 1, slidesToScroll: 1, speed: 500, swipe: !0, swipeToSlide: !1, touchMove: !0, touchThreshold: 5, useCSS: !0, useTransform: !0, variableWidth: !1, vertical: !1, verticalSwiping: !1, waitForAnimate: !0, zIndex: 1e3 }, n.initials = { animating: !1, dragging: !1, autoPlayTimer: null, currentDirection: 0, currentLeft: null, currentSlide: 0, direction: 1, $dots: null, listWidth: null, listHeight: null, loadIndex: 0, $nextArrow: null, $prevArrow: null, scrolling: !1, slideCount: null, slideWidth: null, $slideTrack: null, $slides: null, sliding: !1, slideOffset: 0, swipeLeft: null, swiping: !1, $list: null, touchObject: {}, transformsEnabled: !1, unslicked: !1 }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0) } }()).prototype.activateADA = function () { this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" }) }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) { var s = this; if ("boolean" == typeof t) o = t, t = null; else if (t < 0 || t >= s.slideCount) return !1; s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) { i(t).attr("data-slick-index", e) }), s.$slidesCache = s.$slides, s.reinit() }, e.prototype.animateHeight = function () { var i = this; if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) { var e = i.$slides.eq(i.currentSlide).outerHeight(!0); i.$list.animate({ height: e }, i.options.speed) } }, e.prototype.animateSlide = function (e, t) { var o = {}, s = this; s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({ left: e }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({ top: e }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({ animStart: s.currentLeft }).animate({ animStart: e }, { duration: s.options.speed, easing: s.options.easing, step: function (i) { i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o)) }, complete: function () { t && t.call() } })) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () { s.disableTransition(), t.call() }, s.options.speed)) }, e.prototype.getNavTarget = function () { var e = this, t = e.options.asNavFor; return t && null !== t && (t = i(t).not(e.$slider)), t }, e.prototype.asNavFor = function (e) { var t = this.getNavTarget(); null !== t && "object" == typeof t && t.each(function () { var t = i(this).slick("getSlick"); t.unslicked || t.slideHandler(e, !0) }) }, e.prototype.applyTransition = function (i) { var e = this, t = {}; !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t) }, e.prototype.autoPlay = function () { var i = this; i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed)) }, e.prototype.autoPlayClear = function () { var i = this; i.autoPlayTimer && clearInterval(i.autoPlayTimer) }, e.prototype.autoPlayIterator = function () { var i = this, e = i.currentSlide + i.options.slidesToScroll; i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e)) }, e.prototype.buildArrows = function () { var e = this; !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" })) }, e.prototype.buildDots = function () { var e, t, o = this; if (!0 === o.options.dots) { for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1)t.append(i("<li />").append(o.options.customPaging.call(this, o, e))); o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active") } }, e.prototype.buildOut = function () { var e = this; e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) { i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "") }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable") }, e.prototype.buildRows = function () { var i, e, t, o, s, n, r, l = this; if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) { for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) { var d = document.createElement("div"); for (e = 0; e < l.options.rows; e++) { var a = document.createElement("div"); for (t = 0; t < l.options.slidesPerRow; t++) { var c = i * r + (e * l.options.slidesPerRow + t); n.get(c) && a.appendChild(n.get(c)) } d.appendChild(a) } o.appendChild(d) } l.$slider.empty().append(o), l.$slider.children().children().children().css({ width: 100 / l.options.slidesPerRow + "%", display: "inline-block" }) } }, e.prototype.checkResponsive = function (e, t) { var o, s, n, r = this, l = !1, d = r.$slider.width(), a = window.innerWidth || i(window).width(); if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) { s = null; for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o])); null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l]) } }, e.prototype.changeSlide = function (e, t) { var o, s, n, r = this, l = i(e.currentTarget); switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll != 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) { case "previous": s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t); break; case "next": s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t); break; case "index": var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll; r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus"); break; default: return } }, e.prototype.checkNavigable = function (i) { var e, t; if (e = this.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1]; else for (var o in e) { if (i < e[o]) { i = t; break } t = e[o] } return i }, e.prototype.cleanUpEvents = function () { var e = this; e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition) }, e.prototype.cleanUpSlideEvents = function () { var e = this; e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1)) }, e.prototype.cleanUpRows = function () { var i, e = this; e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i)) }, e.prototype.clickHandler = function (i) { !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault()) }, e.prototype.destroy = function (e) { var t = this; t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () { i(this).attr("style", i(this).data("originalStyling")) }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t]) }, e.prototype.disableTransition = function (i) { var e = this, t = {}; t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t) }, e.prototype.fadeSlide = function (i, e) { var t = this; !1 === t.cssTransitions ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }), t.$slides.eq(i).animate({ opacity: 1 }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }), e && setTimeout(function () { t.disableTransition(i), e.call() }, t.options.speed)) }, e.prototype.fadeSlideOut = function (i) { var e = this; !1 === e.cssTransitions ? e.$slides.eq(i).animate({ opacity: 0, zIndex: e.options.zIndex - 2 }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 })) }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) { var e = this; null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit()) }, e.prototype.focusHandler = function () { var e = this; e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) { t.stopImmediatePropagation(); var o = i(this); setTimeout(function () { e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay()) }, 0) }) }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () { return this.currentSlide }, e.prototype.getDotCount = function () { var i = this, e = 0, t = 0, o = 0; if (!0 === i.options.infinite) if (i.slideCount <= i.options.slidesToShow) ++o; else for (; e < i.slideCount;)++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow; else if (!0 === i.options.centerMode) o = i.slideCount; else if (i.options.asNavFor) for (; e < i.slideCount;)++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow; else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll); return o - 1 }, e.prototype.getLeft = function (i) { var e, t, o, s, n = this, r = 0; return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e }, e.prototype.getOption = e.prototype.slickGetOption = function (i) { return this.options[i] }, e.prototype.getNavigableIndexes = function () { var i, e = this, t = 0, o = 0, s = []; for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;)s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow; return s }, e.prototype.getSlick = function () { return this }, e.prototype.getSlideCount = function () { var e, t, o = this; return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) { if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1 }), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) { this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e) }, e.prototype.init = function (e) { var t = this; i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay()) }, e.prototype.initADA = function () { var e = this, t = Math.ceil(e.slideCount / e.options.slidesToShow), o = e.getNavigableIndexes().filter(function (i) { return i >= 0 && i < e.slideCount }); e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) { var s = o.indexOf(t); i(this).attr({ role: "tabpanel", id: "slick-slide" + e.instanceUid + t, tabindex: -1 }), -1 !== s && i(this).attr({ "aria-describedby": "slick-slide-control" + e.instanceUid + s }) }), e.$dots.attr("role", "tablist").find("li").each(function (s) { var n = o[s]; i(this).attr({ role: "presentation" }), i(this).find("button").first().attr({ role: "tab", id: "slick-slide-control" + e.instanceUid + s, "aria-controls": "slick-slide" + e.instanceUid + n, "aria-label": s + 1 + " of " + t, "aria-selected": null, tabindex: "-1" }) }).eq(e.currentSlide).find("button").attr({ "aria-selected": "true", tabindex: "0" }).end()); for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++)e.$slides.eq(s).attr("tabindex", 0); e.activateADA() }, e.prototype.initArrowEvents = function () { var i = this; !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler))) }, e.prototype.initDotEvents = function () { var e = this; !0 === e.options.dots && (i("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1)) }, e.prototype.initSlideEvents = function () { var e = this; e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1))) }, e.prototype.initializeEvents = function () { var e = this; e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition) }, e.prototype.initUI = function () { var i = this; !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show() }, e.prototype.keyHandler = function (i) { var e = this; i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({ data: { message: !0 === e.options.rtl ? "next" : "previous" } }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({ data: { message: !0 === e.options.rtl ? "previous" : "next" } })) }, e.prototype.lazyLoad = function () { function e(e) { i("img[data-lazy]", e).each(function () { var e = i(this), t = i(this).attr("data-lazy"), o = i(this).attr("data-srcset"), s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"), r = document.createElement("img"); r.onload = function () { e.animate({ opacity: 0 }, 100, function () { o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({ opacity: 1 }, 200, function () { e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading") }), n.$slider.trigger("lazyLoaded", [n, e, t]) }) }, r.onerror = function () { e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t]) }, r.src = t }) } var t, o, s, n = this; if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(o + n.options.slidesToShow), !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)), t = n.$slider.find(".slick-slide").slice(o, s), "anticipated" === n.options.lazyLoad) for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++)r < 0 && (r = n.slideCount - 1), t = (t = t.add(d.eq(r))).add(d.eq(l)), r--, l++; e(t), n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow)) }, e.prototype.loadSlider = function () { var i = this; i.setPosition(), i.$slideTrack.css({ opacity: 1 }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad() }, e.prototype.next = e.prototype.slickNext = function () { this.changeSlide({ data: { message: "next" } }) }, e.prototype.orientationChange = function () { var i = this; i.checkResponsive(), i.setPosition() }, e.prototype.pause = e.prototype.slickPause = function () { var i = this; i.autoPlayClear(), i.paused = !0 }, e.prototype.play = e.prototype.slickPlay = function () { var i = this; i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1 }, e.prototype.postSlide = function (e) { var t = this; t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus())) }, e.prototype.prev = e.prototype.slickPrev = function () { this.changeSlide({ data: { message: "previous" } }) }, e.prototype.preventDefault = function (i) { i.preventDefault() }, e.prototype.progressiveLazyLoad = function (e) { e = e || 1; var t, o, s, n, r, l = this, d = i("img[data-lazy]", l.$slider); d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function () { s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === l.options.adaptiveHeight && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad() }, r.onerror = function () { e < 3 ? setTimeout(function () { l.progressiveLazyLoad(e + 1) }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad()) }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l]) }, e.prototype.refresh = function (e) { var t, o, s = this; o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, { currentSlide: t }), s.init(), e || s.changeSlide({ data: { message: "index", index: t } }, !1) }, e.prototype.registerBreakpoints = function () { var e, t, o, s = this, n = s.options.responsive || null; if ("array" === i.type(n) && n.length) { s.respondTo = s.options.respondTo || "window"; for (e in n) if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) { for (t = n[e].breakpoint; o >= 0;)s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--; s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings } s.breakpoints.sort(function (i, e) { return s.options.mobileFirst ? i - e : e - i }) } }, e.prototype.reinit = function () { var e = this; e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e]) }, e.prototype.resize = function () { var e = this; i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () { e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition() }, 50)) }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) { var o = this; if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1; o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit() }, e.prototype.setCSS = function (i) { var e, t, o = this, s = {}; !0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s))) }, e.prototype.setDimensions = function () { var i = this; !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({ padding: "0px " + i.options.centerPadding }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({ padding: i.options.centerPadding + " 0px" })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length))); var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width(); !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e) }, e.prototype.setFade = function () { var e, t = this; t.$slides.each(function (o, s) { e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({ position: "relative", right: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 }) : i(s).css({ position: "relative", left: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 }) }), t.$slides.eq(t.currentSlide).css({ zIndex: t.options.zIndex - 1, opacity: 1 }) }, e.prototype.setHeight = function () { var i = this; if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) { var e = i.$slides.eq(i.currentSlide).outerHeight(!0); i.$list.css("height", e) } }, e.prototype.setOption = e.prototype.slickSetOption = function () { var e, t, o, s, n, r = this, l = !1; if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s; else if ("multiple" === n) i.each(o, function (i, e) { r.options[i] = e }); else if ("responsive" === n) for (t in s) if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]]; else { for (e = r.options.responsive.length - 1; e >= 0;)r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--; r.options.responsive.push(s[t]) } l && (r.unload(), r.reinit()) }, e.prototype.setPosition = function () { var i = this; i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i]) }, e.prototype.setProps = function () { var i = this, e = document.body.style; i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType }, e.prototype.setSlideClasses = function (i) { var e, t, o, s, n = this; if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode) { var r = n.options.slidesToShow % 2 == 0 ? 1 : 0; e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center") } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")); "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad() }, e.prototype.setupInfinite = function () { var e, t, o, s = this; if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) { for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1)t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned"); for (e = 0; e < o + s.slideCount; e += 1)t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned"); s.$slideTrack.find(".slick-cloned").find("[id]").each(function () { i(this).attr("id", "") }) } }, e.prototype.interrupt = function (i) { var e = this; i || e.autoPlay(), e.interrupted = i }, e.prototype.selectHandler = function (e) { var t = this, o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"), s = parseInt(o.attr("data-slick-index")); s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s) }, e.prototype.slideHandler = function (i, e, t) { var o, s, n, r, l, d = null, a = this; if (e = e || !1, !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i)) if (!1 === e && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () { a.postSlide(o) }) : a.postSlide(o)); else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () { a.postSlide(o) }) : a.postSlide(o)); else { if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () { a.postSlide(s) })) : a.postSlide(s), void a.animateHeight(); !0 !== t ? a.animateSlide(d, function () { a.postSlide(s) }) : a.postSlide(s) } }, e.prototype.startLoad = function () { var i = this; !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading") }, e.prototype.swipeDirection = function () { var i, e, t, o, s = this; return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical" }, e.prototype.swipeEnd = function (i) { var e, t, o = this; if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1; if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1; if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) { switch (t = o.swipeDirection()) { case "left": case "down": e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0; break; case "right": case "up": e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1 }"vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t])) } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {}) }, e.prototype.swipeHandler = function (i) { var e = this; if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) { case "start": e.swipeStart(i); break; case "move": e.swipeMove(i); break; case "end": e.swipeEnd(i) } }, e.prototype.swipeMove = function (i) { var e, t, o, s, n, r, l = this; return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s), !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft)))) }, e.prototype.swipeStart = function (i) { var e, t = this; if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1; void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0 }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () { var i = this; null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit()) }, e.prototype.unload = function () { var e = this; i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "") }, e.prototype.unslick = function (i) { var e = this; e.$slider.trigger("unslick", [e, i]), e.destroy() }, e.prototype.updateArrows = function () { var i = this; Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))) }, e.prototype.updateDots = function () { var i = this; null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active")) }, e.prototype.visibility = function () { var i = this; i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1) }, i.fn.slick = function () { var i, t, o = this, s = arguments[0], n = Array.prototype.slice.call(arguments, 1), r = o.length; for (i = 0; i < r; i++)if ("object" == typeof s || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t; return o } });
﻿var SearchPageExtensions = {
    searchPageRoot: {},

    addEventHandlers: function () {
        $(".CoveoFacet[data-collapsible='true']").on("click", ".coveo-facet-header", function () {
            var collapsed = $(this).parent().attr("data-collapsed");
            var hidden = $(this).siblings(".coveo-facet-values").hasClass("coveo-facet-values-collapse");

            if (collapsed) {
                $(this).parent().removeAttr("data-collapsed");
            }

            if (hidden || collapsed) {
                $(this).removeClass("coveo-ascending").siblings().removeClass("coveo-facet-values-collapse");
                $(this).addClass("coveo-descending").siblings().addClass("coveo-facet-values-expand");
                $(".coveo-facet-header-settings-section", this).addClass("expanded");
            } else {
                $(this).removeClass("coveo-descending").siblings().removeClass("coveo-facet-values-expand");
                $(this).addClass("coveo-ascending").siblings().addClass("coveo-facet-values-collapse");
                $(".coveo-facet-header-settings-section", this).removeClass("expanded");
            }
        });

        $(".more-filters").on("click", "a", function (e) {
            e.preventDefault();
            window.location.href = $(this).attr("href") + window.location.hash;
        });
    },

    enableDisableAnalytics: function () {
        var regexp = new RegExp('(?:^|; )OptanonConsent=([^;]*)(?:$|; )');
        var match = document.cookie.match(regexp);
        var value = '';
        var consented = false;
        if (match) {
            var rawValue = match[1];
            try {
                value = decodeURIComponent(rawValue);
            } catch (ex) { }
        }
        if (value.length > 0 && value.indexOf(',3:1,') > 0) {
            consented = true;
        }

        Coveo.$(SearchPageExtensions.searchPageRoot).on("afterInitialization", function () {
            if (consented) {
                Coveo.enableAnalytics();
            } else {
                Coveo.clearLocalData();
                Coveo.disableAnalytics();
            }
        });
    },

    init: function () {
        this.searchPageRoot = Coveo.$(document).find('#coveob030db8f');
        this.addEventHandlers();
        this.enableDisableAnalytics();
    }
};

$(document).ready(function () {
    if (typeof (SearchPageExtensions) != "undefined" && typeof (Coveo) != "undefined" && $(".coveo-main-section").length > 0) {
        SearchPageExtensions.init();
    }
});

var MinimalSearch = (function (document) {
    var button = null;
    var container = null;
    var minimumQueryLength = 3;
    var query = "";
    var searchUrlBase = "";
    var searchUrl = "";
    var suggestions = null;
    var suggestionsPending = null;
    var textbox = null;
    var token = null;
    var tokenKey = "minimal-search-token";

    function getToken() {
        if (token === null) {
            if (isSessionStorageAvailable())
                token = sessionStorage.getItem(tokenKey);

            if (token === null) {
                fetch("/coveo/rest/token")
                    .then(response => {
                        return response.json();
                    }).then(data => {
                        token = data.token;

                        if (isSessionStorageAvailable()) {
                            sessionStorage.setItem(tokenKey, token);
                        }
                    }).catch(error => {
                        console.log("Search failed to retrieve token.  Autocomplete and suggestions disabled.");
                    })
            }
        }
    }

    function isSessionStorageAvailable() {
        var test = 'test';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }

    function queryEntry(e) {
        if (e == null || e.which !== 13) {
            query = textbox.value;
            searchUrl = searchUrlBase + encodeURIComponent(query);
            button.setAttribute("href", searchUrl);

            if (token == null) {
                getToken();
            } else if (query != null) {
                if (query.length >= minimumQueryLength) {
                    suggestionsPending = query;
                    showSuggestions(query);
                } else {
                    suggestions.classList.remove("minimal-suggestions-active");
                    suggestions.innerHTML = "";
                }
            }
        }
    }

    function showSuggestions(pendingQuery) {
        fetch("/coveo/rest/search/v2/querySuggest", {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
            method: "POST",
            body: JSON.stringify({
                "q": pendingQuery,
                "locale": "en",
                "searchHub": "MainSearchHub",
                "referrer": window.location.href,
                "count": 5,
                "enableWordCompletion": false
            })
        }).then(response => {
            return response.json();
        }).then(data => {
            if (data != null && data.completions != null && suggestionsPending == pendingQuery) {
                suggestions.classList.add("minimal-suggestions-active");
                suggestions.innerHTML = "";

                data.completions.map(function (suggestion) {
                    let link = document.createElement('a');
                    let encoded = encodeURIComponent(suggestion.expression);

                    link.setAttribute("href", searchUrlBase + encoded);
                    link.innerText = suggestion.expression;

                    suggestions.appendChild(link);
                });

                suggestionsPending = null;
            } else if (data != null && suggestionsPending == pendingQuery) {
                suggestions.classList.remove("minimal-suggestions-active");
                suggestions.innerHTML = "";
            }

        }).catch(error => {
            console.log("Search failed to retrieve suggestions.");
            console.log(error);
        })
    }

    function start() {
        button = document.getElementById('MinimalSearchButton');
        searchUrlBase = button.getAttribute("href").split("#")[0] + "#q=";
        textbox = document.getElementById('MinimalSearchbox');
        query = textbox.value;
        suggestions = document.querySelector('.minimal-suggestions');

        let today = new Date();
        tokenKey = tokenKey + '-' + today.getDate() + (today.getMonth() + 1) + today.getFullYear();

        // Update Search Button Link on Query Update
        textbox.addEventListener("keyup", queryEntry);

        // Search on Enter Key Press
        textbox.addEventListener("keydown", (e) => {
            if (e.which === 13) {
                window.location = button.getAttribute("href");
            }
        });
    }

    return {
        init: function () {
            container = document.querySelector(".minimal-search");

            if (container) {
                start();
            }
        }
    };
})(document);

if (document.readyState !== "loading") {
    MinimalSearch.init();
} else {
    document.addEventListener("DOMContentLoaded", function () {
        MinimalSearch.init();
    });
}

function TranslateNumberToDate(number) {
    if (number) {
        return number.slice(4, 6) + '/' + number.slice(6, 8) + '/' + number.slice(0, 4);
    }
    else {
        return '';
	}
}
﻿if (typeof isacaDp.feature.navigation == "undefined") {
    isacaDp.feature.navigation = {};
}

isacaDp.feature.navigation.browseCollectionCarousel = {
    init: function () {
        var $carousel = $(".browse-container.carousel").find('.browse-collection');

        $carousel.slick({
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
}

isacaDp.feature.navigation.itemTileCarousel = {
    init: function (id) {
        var $carousel = $("#" + id).find('.browse-collection');

        $carousel.slick({
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
}

isacaDp.feature.navigation.cartLink = {
    init: function () {
        var $cart = isacaDp.feature.navigation.shoppingCart;
        var cartLinkCounter = $(".cart-count");
        if (cartLinkCounter.length) {
            $.ajax({
                url: '/api/cart/getcartcount',
                type: 'GET',
                dataType: "json",
                success: function (result) {
                    if (result) {
                        cartLinkCounter.each(function () {
                            $(this).find('a').text("Cart (" + result.Count + ")");
                            $(this).attr('data-items', result.Count);
                        });
                    } else {
                        cartLinkCounter.each(function () {
                            $(this).find('a').text("Cart (0)");
                            $(this).attr('data-items', 0);
                        });
                    }
                },
                error: function (result) {
                    console.log(result);
                    //alert('Error retrieving cart data. Please try again.');
                }
            });
        } else if ((document.cookie.indexOf("-isaca-community-shopping-cart") > 0) && $("nav").hasClass("newmain")) {
            $("#empty-cart").hide();
            $("#full-cart").show();
        } else if (document.cookie.indexOf("-isaca-community-shopping-cart") > 0 && $("nav").hasClass("main")) {
            $(".show-cart .cart").attr("data-items", "+");
        }

        var ecomCartSection = $("#ecomm-empty-cart");
        if (ecomCartSection.length) {
            var ecomCartCookie = document.cookie.indexOf("ISACA_CART");
            if (ecomCartCookie === -1) {
                $.ajax({
                    url: '/api/navigation/getcartproductcount',
                    type: 'GET',
                    dataType: "json",
                    success: function (result) {
                        if (result) {
                            var count = decimalToInt(result.Count);
                            if (count <= 0) {
                                $("#ecomm-empty-cart").show();
                                $("#ecomm-full-cart").hide();
                            } else {
                                $('#cartProductCount').text(count);
                                $("#ecomm-empty-cart").hide();
                                $("#ecomm-full-cart").show();
                            }
                        }
                    },
                    error: function (result) {
                        $("#ecomm-empty-cart").show();
                        $("#ecomm-full-cart").hide();
                    }
                });
            } else if ((ecomCartCookie > 0) && $("nav").hasClass("newmain")) {
                var IsacaCartCookie = getCookieByName("ISACA_CART");
                var cartQuantity = JSON.parse(decodeURIComponent(IsacaCartCookie)).quantity;
                $('#cartProductCount').text(decimalToInt(cartQuantity));
                $("#ecomm-empty-cart").hide();
                $("#ecomm-full-cart").show();
            } 
        }
        
    }    
}

function decimalToInt(value) {
    // Converts a decimal (string or number) to an integer by truncating the decimal part
    var num = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(num)) return NaN;
    return Math.trunc(num);
}

function getCookieByName(name) {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
            return cookieValue.split(','); // Assuming values are comma-separated
        }
    }
    return []; // If cookie isn't found, return empty array
}

isacaDp.feature.navigation.navUI = {
    init: function () {
        let $navClassContainers = $('body, nav');
        let $nav = $('nav');
        let $navIA = $('nav.newmain');
        let $primaryNavTabs = $('nav .primary li');
        let $navExpandTabs = $('nav .menu li').not('nav .menu li ul li');
        let $navPanels = $('nav .panel');
        let $dashboardToggle = $('nav .dashboard-toggle');
        let $dashboard = $('nav .dashboard');
        let $joinRenewToggle = $('nav .joinrenew-toggle');
        let $joinRenew = $('nav .joinrenew');
        let $hamburger = $('nav .hamburger');
        let $searchToggle = $('nav .search-toggle');
        let $secondaryToggle = $('nav .secondary-toggle');
        let $secondarynav = $('nav .secondary-subnav');
        let $cartToggle = $('nav .cart-toggle');
        let $cartnav = $('nav .cart-panel');
        let userScrolling = true;
        const anchorLinks = document.querySelectorAll('a[href^="#"]');
        anchorLinks.forEach(function (anchor) {
            anchor.addEventListener('click', function () {
                userScrolling = false;
                $navIA.hide();
            })
        })

        let cookieName = "isaca-session";
        let prevScrollPos = window.pageYOffset;
        const scrollThreshold = 500;
        let totalBannerHeight = 0;
        calculateTotalBannerHeight();
        adjustNavMargin();

        function calculateTotalBannerHeight() {
            totalBannerHeight = 0;

            if ($('body div#TopContent').length > 0) {
                $('body div#TopContent').prevAll('div.page-block').find('.notice-banner').each(function () {
                    let $this = $(this);
                    totalBannerHeight = totalBannerHeight + $this.outerHeight();
                })
            }
            else {
                $(".notice-banner").not('main .notice-banner').each(function () {
                    let $this = $(this);
                    totalBannerHeight = totalBannerHeight + $this.outerHeight();
                });
            }
        }

        function adjustNavMargin() {
            if (window.pageYOffset == 0) {
                $navIA.css('margin-top', totalBannerHeight + 'px');
            }
        }

        function calculateNavMarginTop(currentScrollPos, totalBannerHeight) {
            if (currentScrollPos != 0 && currentScrollPos > totalBannerHeight) {
                $navIA.css('margin-top', '0px');
            }
            else if (currentScrollPos < totalBannerHeight) {
                let top = totalBannerHeight - currentScrollPos;
                $navIA.css('margin-top', top + 'px');
            }
        }

        function handleScroll() {
            if (userScrolling) {
                $navIA.show();
                let currentScrollPos = window.pageYOffset;
                adjustNavMargin();
                if ($(window).width() > 1263) {
                    if (prevScrollPos > currentScrollPos || currentScrollPos < scrollThreshold) {
                        calculateNavMarginTop(currentScrollPos, totalBannerHeight);
                    }
                    else if (currentScrollPos > scrollThreshold) {
                        $navIA.css('margin-top', -currentScrollPos + 'px');
                    }
                    prevScrollPos = currentScrollPos;
                }
                else {
                    calculateNavMarginTop(currentScrollPos, totalBannerHeight);
                }
            }
        }

        function documentHeight() {
            let navOffsetHeight = document.querySelector('nav.newmain').offsetHeight;
            let scrollHeight;
            if (totalBannerHeight <= document.documentElement.scrollTop) {
                scrollHeight = window.innerHeight - navOffsetHeight;
            } else {
                scrollHeight = window.innerHeight - navOffsetHeight - totalBannerHeight + document.documentElement.scrollTop;
            }

            $navPanels.css("--doc-height", scrollHeight + "px");
        }
                
        documentHeight();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener("wheel", () => userScrolling = true);
        window.addEventListener("touchmove", () => userScrolling = true);
        window.addEventListener("mousedown", () => userScrolling = true);
        window.addEventListener("resize", documentHeight);
        window.addEventListener("scroll", documentHeight);

        if ($primaryNavTabs.length) {
            // Bind hover to primary tabs
            $primaryNavTabs.each(function () {
                let $thisTab = $(this);
                let tabIndex = $primaryNavTabs.index($thisTab);
                $thisTab.on('mouseenter', function () {
                    $primaryNavTabs.removeClass('open');
                    $thisTab.addClass('open');
                    setTimeout(function () {
                        $navPanels.removeClass('open');
                        if ($primaryNavTabs.eq(tabIndex).hasClass('open')) {
                            $navPanels.eq(tabIndex).addClass('open');
                        }
                    }, 100);
                }).on('mouseleave', function () {
                    setTimeout(function () {
                        if ($('.panel.in-panel').length == 0) {
                            $thisTab.removeClass('open');
                            $navPanels.eq(tabIndex).removeClass('open');
                        }
                    }, 100);
                });
            });

            // Bind hover to nav panels
            $navPanels.each(function () {
                let $thisPanel = $(this);
                $thisPanel.on('mouseenter', function () {
                    $thisPanel.addClass('in-panel')
                }).on('mouseleave', function () {
                    $thisPanel.removeClass('open in-panel');
                    let panelIndex = $navPanels.index($thisPanel);
                    $primaryNavTabs.eq(panelIndex).removeClass('open');
                });
            });
        }

        //bind hover for all secondary tabs
        if ($secondaryToggle.length) {
            $secondaryToggle.each(function () {
                let $thisTab = $(this);
                let tabIndex = $secondaryToggle.index($thisTab);
                $thisTab.on('mouseenter', function () {
                    $secondaryToggle.removeClass('open');
                    $thisTab.addClass('open');
                    setTimeout(function () {
                        $secondarynav.removeClass('open');
                        if ($secondaryToggle.eq(tabIndex).hasClass('open')) {
                            $secondarynav.eq(tabIndex).addClass('open');
                        }
                    }, 100);
                }).on('mouseleave', function () {
                    setTimeout(function () {
                        if ($('.secondary-subnav.in-secondarynav').length == 0) {
                            $thisTab.removeClass('open');
                            $secondarynav.eq(tabIndex).removeClass('open');
                        }
                    }, 100);
                });
            });

            $secondarynav.each(function () {
                let $thisPanel = $(this);
                $thisPanel.on('mouseenter', function () {
                    $thisPanel.addClass('in-secondarynav')
                }).on('mouseleave', function () {
                    $thisPanel.removeClass('open in-secondarynav');
                    let panelIndex = $secondarynav.index($thisPanel);
                    $secondaryToggle.eq(panelIndex).removeClass('open');
                });
            });
        }

        //bind hover for cart model
        if ($cartToggle.length) {
            $cartToggle.each(function () {
                let $thisTab = $(this);
                let tabIndex = $cartToggle.index($thisTab);
                $thisTab.on('mouseenter', function () {
                    $cartToggle.removeClass('open');
                    $thisTab.addClass('open');
                    setTimeout(function () {
                        $cartnav.removeClass('open');
                        if ($cartToggle.eq(tabIndex).hasClass('open')) {
                            $cartnav.eq(tabIndex).addClass('open');
                        }
                    }, 100);
                }).on('mouseleave', function () {
                    setTimeout(function () {
                        if ($('.cart-panel.in-cart').length == 0) {
                            $thisTab.removeClass('open');
                            $cartnav.eq(tabIndex).removeClass('open');
                        }
                    }, 100);
                });
            });

            $cartnav.each(function () {
                let $thisPanel = $(this);
                $thisPanel.on('mouseenter', function () {
                    $thisPanel.addClass('in-cart')
                }).on('mouseleave', function () {
                    $thisPanel.removeClass('open in-cart');
                    let panelIndex = $cartnav.index($thisPanel);
                    $cartToggle.eq(panelIndex).removeClass('open');
                });
            });
        }

        // Bind hover to dashboard
        $dashboardToggle.on('mouseenter', function () {
            $nav.addClass('show-dashboard');
        }).on('mouseleave', function () {
            setTimeout(function () {
                if ($('nav .dashboard.in-dash').length == 0) {
                    $nav.removeClass('show-dashboard');
                }
            }, 100);
        });
        $dashboard.on('mouseenter', function () {
            $dashboard.addClass('in-dash');
        }).on('mouseleave', function () {
            $dashboard.removeClass('in-dash');
            $nav.removeClass('show-dashboard');
        });

        // Bind hover to join/renew
        $joinRenewToggle.on('mouseenter', function () {
            $nav.addClass('show-joinrenew');
        }).on('mouseleave', function () {
            setTimeout(function () {
                if ($('nav .joinrenew.in-dash').length == 0) {
                    $nav.removeClass('show-joinrenew');
                }
            }, 100);
        });
        $joinRenew.on('mouseenter', function () {
            $joinRenew.addClass('in-dash');
        }).on('mouseleave', function () {
            $joinRenew.removeClass('in-dash');
            $nav.removeClass('show-joinrenew');
        });

        // Bind hamburger menu
        $hamburger.click(function () {
            $navExpandTabs.removeClass('open');
            $('ul.thirdLevel').removeClass('active');
            $('ul.thirdLevel').parent('li.innerLevel.open').toggleClass('open');
            $hamburger.toggleClass('is-active');
            if ($('.overlay').length > 0 && $hamburger.hasClass('is-active')) {
                $('.overlay').fadeIn();
                $('.menu').removeClass('animate__animated animate__fadeOutUpBig').addClass('animate__animated animate__fadeInDownBig');
                addScrollbar();
            }
            else {
                $('.overlay').fadeOut();
                $('.menu').removeClass('animate__animated animate__fadeInDownBig').addClass('animate__animated animate__fadeOutUpBig');
            }

            $navClassContainers.toggleClass('open-menu');
            $nav.removeClass('open-search');
            hideUserMenuPopup();
            calculateTotalBannerHeight();
            adjustNavMargin();
            calculateNavMarginTop(window.pageYOffset, totalBannerHeight);
        });

        // Bind mobile menu item expand/collapse
        $navExpandTabs.click(function (e) {
            e.stopPropagation();
            $(this).toggleClass('open');
            $(this).find($('ul.thirdLevel')).removeClass('active');
            $(this).find($('ul.thirdLevel')).parent('li.innerLevel.open').toggleClass('open');
            addScrollbar();
        });

        //hides user popup 
        function hideUserMenuPopup() {
            if ($('.popup-container').hasClass('animate__fadeInDown')) {
                $(".popup-container").removeClass('animate__fadeInDown').addClass('animate__fadeOutUp');
            }
        }

        //hide mobile menu
        function hideMobileMenu() {
            if ($nav.hasClass('open-menu')) {
                $navClassContainers.removeClass('open-menu');
                $hamburger.removeClass('is-active');
                $navExpandTabs.removeClass('open');
                $('ul.thirdLevel').removeClass('active');
                $('ul.thirdLevel').parent('li.innerLevel.open').toggleClass('open');
                $('.menu').removeClass('animate__fadeInDownBig').addClass('animate__fadeOutUpBig');
            }
        }

        // Bind mobile search panel
        $searchToggle.click(function () {
            $('.overlay').fadeOut();
            hideMobileMenu();
            $('.menu').removeClass('animate__fadeOutUpBig');
            hideUserMenuPopup();
            $nav.toggleClass('open-search');
            calculateTotalBannerHeight();
            adjustNavMargin();
            calculateNavMarginTop(window.pageYOffset, totalBannerHeight);
        });

        function calculatePopupContainerPosition() {
            let navHeight = $('nav.newmain').outerHeight();
            let buttonPosition = $(".user-toggle").offset();
            let popupContainer = $(".popup-container");
            let popupArrow = $(".popup-arrow");
            popupContainer.css({
                top: popupArrow.outerWidth() + navHeight,
                left: buttonPosition.left - popupContainer.outerWidth() + popupArrow.outerWidth() * 2,
                'display': 'block'
            });

            popupArrow.css({
                left: popupContainer.outerWidth() - popupArrow.outerWidth() * 2 + popupArrow.outerHeight() / 2
            });
        }

        $(window).resize(function () {
            calculateTotalBannerHeight();
            adjustNavMargin();
            calculateNavMarginTop(window.pageYOffset, totalBannerHeight);
            if ($('.popup-container').hasClass('animate__fadeInDown')) {
                calculatePopupContainerPosition();               
            }
            if ($('.menu').hasClass('animate__fadeOutUpBig')) {
                $('.menu').removeClass('animate__fadeOutUpBig');
            }
            addScrollbar();
        });
       
        function addScrollbar() {
            if ($hamburger.hasClass('is-active'))
            {
                let menuHeight = $('nav.newmain.open-menu .mobile-menu > ul').outerHeight() + $('nav.newmain.open-menu .mobile-menu > a').outerHeight(); 
                let mobileHeaderBluebarHeight = window.innerHeight - $('nav.newmain.open-menu .mobile-menu').outerHeight(); 
                let availableMenuViewableHeight = window.innerHeight - totalBannerHeight - mobileHeaderBluebarHeight; 
                if (menuHeight > availableMenuViewableHeight) {
                    $('nav.newmain.open-menu .mobile-menu').css('--scrollHeight', 400 + 'px');
                }
                else {
                    $('nav.newmain.open-menu .mobile-menu').css('--scrollHeight', 200 + 'px');
                }
            }
        }

        $(".user-toggle").click(function () {
            //closes mobile menu if opened
            hideMobileMenu();
            calculateTotalBannerHeight();
            adjustNavMargin();
            calculateNavMarginTop(window.pageYOffset, totalBannerHeight);
            //closes open search when clicked on user icon
            if ($nav.hasClass('open-search')) {
                $nav.toggleClass('open-search');
            }           

            if ($('.popup-container').hasClass('animate__fadeInDown')) {
                $('.popup-container').removeClass('animate__fadeInDown').addClass('animate__fadeOutUp');
                $('.overlay').fadeOut();
            }
            else {
                $('.overlay').fadeIn();
                $('.popup-container').removeClass('animate__fadeOutUp').addClass('animate__animated animate__fadeInDown');
                calculatePopupContainerPosition();               
            }
        });

        $(".overlay").click(function (e) {
            if (e.target == this) {
                hideUserMenuPopup();
                hideMobileMenu();
                $('.overlay').hide();
                calculateTotalBannerHeight();
                adjustNavMargin();
                calculateNavMarginTop(window.pageYOffset, totalBannerHeight);
            }
        });

        // Fonteva's cookie is not deleted after clearing the cart so check that there are items before updating the cart icon and panel
        if (document.cookie.indexOf(cookieName) >= 0) {
            let cookies = document.cookie.split(';');
            let cookieValue = "";

            for (let i = 0; i < cookies.length; i++) {
                if (cookies[i].indexOf(cookieName) >= 0) {
                    cookieValue = cookies[i].substring(cookies[i].indexOf('=') + 1).trim();
                }
            }

            if (cookieValue) {
                let session = JSON.parse(cookieValue);

                if (session && session.lines && session.lines.length > 0) {
                    let cartPanel = $('nav.newmain .cart-panel');

                    // Indicate that the cart is not empty
                    $("#empty-cart").hide();
                    $("#full-cart").show();

                    if (cartPanel) {
                        // The cart panel is shown so update the cart lines
                        let $cartLines = $('nav.newmain .cart-panel .cart-lines');
                        let lines = "";

                        for (let i = 0; i < session.lines.length; i++) {
                            lines += "<tr class=\"line\"><td class=\"name\">" + session.lines[i].OrderApi__Line_Description__c + "</td>";
                            lines += "<td class=\"price\">$" + session.lines[i].OrderApi__Total__c + "</td></tr>";
                        }

                        $cartLines.prepend(lines);
                        $cartLines.removeClass("hide");
                        $('nav.newmain .cart-panel .total .price').html("$" + session.total);
                        $('nav.newmain .cart-panel .checkout-link').attr('href', $('nav.newmain .cart-panel .checkout-link').attr('href') + session.encryptedSO);
                        $('nav.newmain .cart-panel .cart-buttons').removeClass("hide");
                        $('nav.newmain .cart-panel .empty').addClass("hide");
                    }
                }
            }
        }
    }
}

isacaDp.feature.navigation.switchToSitecore9 = {
    init: function () {
        var $sitecore9Link = $('a.switchToSitecore9');

        $sitecore9Link.click(function () {
            var expires = new Date();
            expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
            document.cookie = 'SitecoreVersion=sitecore9; path=/; Secure; SameSite=None; expires=' + expires.toUTCString();
            location.reload();
        });
    }
}

isacaDp.feature.navigation.switchToSitecore10 = {

    init: function () {
        var $sitecore10Link = $('a.switchToSitecore10');

        $sitecore10Link.click(function () {
            var expires = new Date();
            expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
            document.cookie = 'SitecoreVersion=sitecore10; path=/; Secure; SameSite=None; expires=' + expires.toUTCString();
            location.reload();
        });
    }
}

$(document).ready(function () {
    var $cart = isacaDp.feature.navigation.cartLink;
    var $itemTileCarousel = isacaDp.feature.navigation.itemTileCarousel;
    var $browseCollectionCarousel = isacaDp.feature.navigation.browseCollectionCarousel;
    var $navUI = isacaDp.feature.navigation.navUI;

    if (typeof ($cart) != "undefined") {
        $cart.init();
    }

    if (typeof ($navUI) != "undefined") {
        $navUI.init();
    }

    if ($('.item-tiles.carousel .browse-collection').length) {
        $('.item-tiles.carousel .browse-collection').each(function () {
            $itemTileCarousel.init($(this).parents('.item-tiles').attr('id'));
        });
    }

    if ($('.browse-container.carousel').length) {
        $browseCollectionCarousel.init();
    }

    if ($('a.switchToSitecore9').length) {
        isacaDp.feature.navigation.switchToSitecore9.init();
    }

    if ($('a.switchToSitecore10').length) {
        isacaDp.feature.navigation.switchToSitecore10.init();
    }


    if ($('.browse-container .browse-facet').length) {
        $(".browse-container .browse-facet").on("click", "h4", function () {
            var shown = $(this).hasClass("coveo-descending");

            if (shown) {
                $(this).removeClass("coveo-descending");
                $(this).parent().siblings().removeClass("coveo-facet-values-expand");
            } else {
                $(this).addClass("coveo-descending");
                $(this).parent().siblings().addClass("coveo-facet-values-expand");
            }
        });
    }

    // GTM Event Tracking
    $('.track-click').click(function () {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            "event": $(this).attr('data-track-event')
        });
    });

    //show more and show less toggle
    $('ul.levelTwoList.expandible').each(function () {
        var $ul = $(this);
        var numtoShow = $ul.data("numberof-items");
        var moretext = $ul.data("more-text");
        var lesstext = $ul.data("less-text");
        numtoShow = numtoShow - 1;
        var $lis = $ul.find("li:gt('" + numtoShow + "')");
        var isExpanded = $ul.hasClass('expanded');
        $lis[isExpanded ? 'show' : 'hide']();
        if ($lis.length > 0) {
            $ul.append($('<li class="expand">' + (isExpanded ? '<span class="subheading">' + lesstext + '<i class="fa-sharp fa-light fa-chevron-up"></i></span>' : '<span class="subheading">' + moretext + '<i class="fa-sharp fa-light fa-chevron-down"></i></span>') + '</li>')
                .click(function (event) {
                    var isExpanded = $ul.hasClass('expanded');
                    event.preventDefault();
                    $(this).html(isExpanded ? '<span class="subheading">' + moretext + '<i class="fa-sharp fa-light fa-chevron-down"></i></span>' : '<span class="subheading">' + lesstext + '<i class="fa-sharp fa-light fa-chevron-up"></i></span>');
                    $ul.toggleClass('expanded');
                    $lis.toggle();
                })
            );
        }
    });

    $("li.secondLevelMenu span").click(function () {
        if ($(this).closest("li").children("ul").length) {
            if ($(this).closest("li").children("ul").hasClass('active')) {
                $(this).closest("li").children("ul").removeClass("active");
                $(this).find("i").removeClass("fa-sharp fa-light fa-chevron-up").addClass("fa-sharp fa-light fa-chevron-down");
            }
            else {
                $(this).find("i").removeClass("fa-sharp fa-light fa-chevron-down").addClass("fa-sharp fa-light fa-chevron-up");
                $(this).closest("li").children("ul").toggleClass('active');
            }
        }
    });

    $("li.innerLevel .thirdLevelText, li.innerLevel .groupedThirdLevelText").click(function (e) {
        e.stopPropagation();
        if ($(this).parent("li.innerLevel").children("ul").length) {
            $(this).parent("li.innerLevel").toggleClass("open");
            $(this).parent("li.innerLevel").children("ul").toggleClass('active');
        }
    });
});
﻿﻿var FlatTable = {
    toggleDetails: function (e) {
        var $expander = $(e.target);
        var $details = $expander.closest('.flat-table__row').find('.flat-table__details');
        var show = !$expander.hasClass('flat-table__expander--is-expanded');
        $expander.toggleClass('flat-table__expander--is-expanded', show);
        show ? $details.slideDown() : $details.slideUp();
    },
    toggleTable: function (e) {
        var $table = $(e.target).parent();
        var $tableBody = $table.find('.flat-table__body');
        var show = $table.hasClass('flat-table__expandable');
        $tableBody[show ? 'slideDown' : 'slideUp'](function () {
            $table.toggleClass('flat-table__expandable', !show);
            $table.toggleClass('flat-table__collapsible', show);
        });
    },
    init: function (table) {
        var $table = $(table);
        if ($table.length) {
            $table.filter('.flat-table__collapsible,.flat-table__expandable').find('.flat-table__header').click(FlatTable.toggleTable);
            $table.find('.flat-table__expander').click(FlatTable.toggleDetails);
            var $headings = $table.find('.flat-table__headings').children();
            $table.find('.flat-table__row').each(function () {
                var $columns = $(this).children().not('.flat-table__no-heading').not('.flat-table__details');

                for (var i = 0; i < $headings.length; i++) {
                    var $column = $columns.eq(i);
                    var $heading = $headings.eq(i);
                    if ($column.length && $heading.length) {
                        $column.wrapInner('<span class="flat-table__row-value"></span>');
                        $column.prepend('<span class="flat-table__row-heading">' + $heading.html().trim() + ': </span>');
                    }
                }
            });
        }
    }
};
;
﻿var MyISACAHeader = {
    init: function (header, settingsId) {
        var $header = $(header);
        var host = "https://" + $(location).attr('host');
        if ($header.length) {
            $.ajax({
                url: host + "/api/myisaca/invoicesummary?settingsId=" + settingsId,
                method: "GET",
                success: MyISACAHeader.load.bind($header),
            });
            $header.on("update", MyISACAHeader.update.bind($header));
            $header.trigger("update");
            $(window).resize(function () {
                var timer = $header.data('timer');
                if (timer) {
                    clearTimeout(timer);
                }
                $header.data('timer', setTimeout(function () {
                    $header.trigger("update");
                }, 250));
            });
        }
    },

    load: function (data) {
        var $header = $(this);
        var $invoiceSummary = $header.find('.myisaca-header__invoice-summary');
        if (data) {
            $invoiceSummary.html(data);
        }
        if (!$invoiceSummary.children(":not('.processing-icon__controller')").length) {
            $invoiceSummary.hide();
        }
        $header.trigger("update");
    },

    update: function () {
        var $header = $(this);
        var $profile = $header.find(".myisaca-header__profile");

        var screenWidth = $(window).width();

        var twoColumn = false;
        var profileHorizontal = false;

        if (screenWidth >= 768) {
            if (screenWidth >= 1024) {
                twoColumn = $header.children(":visible").length != 1;
                if (!twoColumn) {
                    profileHorizontal = true;
                }
                if (screenWidth >= 1600) {
                    profileHorizontal = true;
                }
            }
            else {
                profileHorizontal = true;
            }
        }
        $header.toggleClass("myisaca-header--two-column", twoColumn);
        $profile.toggleClass("myisaca-header__profile--horizontal", profileHorizontal);

        var $user = $profile.find(".myisaca-header__user");
        var $children = $user.children("div").css("fontSize", "");

        var tooWide = function () {
            var result = twoColumn ? $profile.position().top < $profile.next().position().top : profileHorizontal ? $profile.width() > $header.width() : $user.width() > $profile.width();
            if (result) {
                $children.each(function () {
                    if ($(this).css("fontSize") == "10px") {
                        result = false;
                    }
                });
            }
            return result;
        }
        while (tooWide()) {
            var userWidth = $user.width() - 5;
            $children.each(function () {
                var $child = $(this);
                if (userWidth <= $child.width()) {
                    var fontSize = parseInt($child.css("fontSize")) - 1;
                    $child.css("fontSize", fontSize + "px");
                }
            });
        }
    }
};
;
﻿;
﻿var PostLink = {
    init: function (links) {
        var $links = $(links);
        $links.each(function () {
            var $link = $(this);
            var $form = $link.children('form');
            if (!$form.length) {
                var href = $link.attr("href").split("?");
                $link.attr("href", "#");
                $form = $('<form action="' + href[0] + '" method="post" target="' + $link.attr("target") + '" style="display:none;"></form>').appendTo($link);
                if (href.length == 2) {
                    var params = href[1].split("&");
                    $.each(params, function (i, param) {
                        var value = param.split("=");
                        $form.append('<input type="hidden" name="' + value[0] + '" value="' + value[1] + '" />');
                    });
                }
            }
            $link
                .off('click', PostLink.clickHandler)
                .on('click', PostLink.clickHandler);
        });
    },
    clickHandler: function (e) {
        e.preventDefault();
        var $form = $(this).children('form');
        if ($form.length) {
            $form.submit();
        }
    }
};
;

var CertificationDashboard = {
    toggleCPESummary: function (e) {
        var $expander = $(e.target).parent();
        var $cpeSummary = $expander.closest('.certification-type').find('.certification-type__cpe-cycles');
        var show = !$expander.hasClass('certification-type__cpe-expander--is-expanded');
        $expander.toggleClass('certification-type__cpe-expander--is-expanded', show);
        show ? $cpeSummary.slideDown() : $cpeSummary.slideUp();
    },
    init: function (dashboard) {
        var $dashboard = $(dashboard);
        $dashboard.find('.certification-type__cpe-expander').click(CertificationDashboard.toggleCPESummary);
        var $flatTables = $dashboard.find('.flat-table');
        if ($flatTables.length && FlatTable) {
            $flatTables.each(function () {
                FlatTable.init(this);
            });
        }
        var $postLinks = $dashboard.find('a[data-post-link="True"]');
        if ($postLinks.length && PostLink) {
            PostLink.init($postLinks);
        }

        const anchorLinks = document.querySelectorAll('.postBtnLink');
        anchorLinks.forEach(function (anchor) {
            anchor.addEventListener('click', function () {
                anchor.style.pointerEvents = "none";
            })
        })        

        const tabLinks = document.querySelectorAll('.tab-pages__link');
        tabLinks.forEach(function (tab) {
            tab.addEventListener('click', () => {
                const iframe = document.querySelector('#player');
                if (iframe) {
                    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                }                
            })
        })

        const btnLinks = document.querySelectorAll('.btn-primary');
        btnLinks.forEach(function (btn) {
            btn.addEventListener('click', () => {
                const iframe = document.querySelector('#player');
                if (iframe) {
                    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                }
            })
        })
    }
};;
﻿;

var CertificateProgramDashboard = {
    init: function (dashboard) {
        var $dashboard = $(dashboard);
        var $flatTables = $dashboard.find('.flat-table');
        if ($flatTables.length && FlatTable) {
            $flatTables.each(function () {
                FlatTable.init(this);
            });
        }
        var $postLinks = $dashboard.find('a[data-post-link="True"]');
        if ($postLinks.length && PostLink) {
            PostLink.init($postLinks);
        }
    }
};;
﻿var DownloadsDashboard = {
    init: function (dashboard) {
        var $dashboard = $(dashboard);
        if ($dashboard.find("download:not(:has(button))").length) {
            angular.bootstrap(document, ['download']);
        }
    }
};

function showDownloadInProgress() {
    document.getElementById('downloadMessage').style.display = "block";
};
﻿var LearningsDashboard = {
    init: function (dashboard) {
        var $dashboard = $(dashboard);
        $dashboard.find('.learnings-program__button.toggle').click(LearningsDashboard.toggleSubscription);  
          
    },

    toggleSubscription: function (e) {
        var $button = $(this);
        var show = !$button.hasClass("expanded");
        $button.toggleClass("expanded", show).toggleClass("collapsed", !show);
        $button.next().toggle(show);
    }
};;

﻿var CPEQuiz = {
    init: function (cpeQuiz) {
        var $cpeQuiz = $(cpeQuiz);
        $cpeQuiz.find('.cpe-quiz__form').submit(CPEQuiz.postResults);
        $cpeQuiz.find('[name="cpe-quiz__retry"]').click(CPEQuiz.getForm);
    },
    postResults: function (e) {
        e.preventDefault();
        var $cpeQuiz = $(this).closest('.cpe-quiz');
        var $form = $(this).hide();
        var $loader = $cpeQuiz.find('.cpe-quiz__loader').show();
        $.post({
            url: "/api/isacaforms/cpequiz/results",
            data: $form.serialize()
        })
            .done(function (results) {
                $(results).appendTo($cpeQuiz)
                    .find('[name="cpe-quiz__retry"]').click(CPEQuiz.getForm);
                $form.remove();
            })
            .fail(function () {
                $form.show();
                var $message = $form.find('.cpe-quiz__error-message').hide();
                if (!$message.length) {
                    $message = $('<div class="cpe-quiz__error-message">An error occurred while submitting the results. Please try again later.</div>').prependTo($form);
                }
                $message.show(1000);
            })
            .always(function () {
                $loader.hide();
                $('html, body').animate({ scrollTop: $cpeQuiz.offset().top }, 1000);
            });
    },
    getForm: function (e) {
        e.preventDefault();
        var $cpeQuiz = $(this).closest('.cpe-quiz');
        var $loader = $cpeQuiz.find('.cpe-quiz__loader').show();
        $cpeQuiz.find('.cpe-quiz__form').remove();
        $cpeQuiz.find('.cpe-quiz__results').remove();
        $.post({
            url: "/api/isacaforms/cpequiz/form",
            data: { dataId: $cpeQuiz.data('dataId') }
        })
            .done(function (form) {
                $(form).appendTo($cpeQuiz)
                    .submit(CPEQuiz.postResults);
                $loader.hide();
                $('html, body').animate({ scrollTop: $cpeQuiz.offset().top }, 1000);
            })
            .fail(function () {
                location.reload(true);
            });
    }
};
var CertificationPracticeQuiz = {
    init: function (certPracticeQuiz) {
        var $certPracticeQuiz = $(certPracticeQuiz);
        $certPracticeQuiz.find('.certification-practice-quiz__form').submit(CertificationPracticeQuiz.postResults);
        $certPracticeQuiz.find('[name="certification-practice-quiz__retry"]').click(CertificationPracticeQuiz.getForm);
    },
    postResults: function (e) {
        e.preventDefault();

        //Error Handling Make sure every question is answered

        var $practiceQuizGroup = document.getElementsByClassName("certification-practice-quiz__answers");
        var showErrorMessage = false;
        for (const group of $practiceQuizGroup) {
            // Access each element directly using element
            var unansweredQuestion = true;
            var answers = group.querySelectorAll("input");
            for (const answer of answers) {
                if (answer.checked) {
                    unansweredQuestion = false;
                }
            }           
            if (unansweredQuestion) {
                showErrorMessage = true;
                break;
            }
        }
        var submitErrorMessage = document.getElementById('submit-error-message');
        if (showErrorMessage) {
            submitErrorMessage.classList.remove("hide");
        } else {
            submitErrorMessage.classList.add("hide");
            var $certPracticeQuiz = $(this).closest('.certification-practice-quiz');
            var $form = $(this).hide();
            var $loader = $certPracticeQuiz.find('.certification-practice-quiz__loader').show();
            $.post({
                url: "/api/isacaforms/certificationpracticequiz/results",
                data: $form.serialize()
            })
                .done(function (results) {
                    $(results).appendTo($certPracticeQuiz)
                        .find('[name="certification-practice-quiz__retry"]').click(CertificationPracticeQuiz.getForm);
                    $form.remove();
                })
                .fail(function () {
                    $form.show();
                    var $message = $form.find('.certification-practice-quiz__error-message').hide();
                    if (!$message.length) {
                        $message = $('<div class="certification-practice-quiz__error-message">An error occurred while submitting the results. Please try again later.</div>').prependTo($form);
                    }
                    $message.show(1000);
                })
                .always(function () {
                    $loader.hide();
                    $('html, body').animate({ scrollTop: $certPracticeQuiz.offset().top }, 1000);
                });
        }
        
    },
    getForm: function (e) {
        e.preventDefault();
        var $certPracticeQuiz = $(this).closest('.certification-practice-quiz');
        var $loader = $certPracticeQuiz.find('.certification-practice-quiz__loader').show();
        $certPracticeQuiz.find('.certification-practice-quiz__form').remove();
        $certPracticeQuiz.find('.certification-practice-quiz__results').remove();
        $.post({
            url: "/api/isacaforms/certificationpracticequiz/form",
            data: { dataId: $certPracticeQuiz.data('dataId') }
        })
            .done(function (form) {
                $(form).appendTo($certPracticeQuiz)
                    .submit(CertificationPracticeQuiz.postResults);
                $loader.hide();
                $('html, body').animate({ scrollTop: $certPracticeQuiz.offset().top }, 1000);
            })
    }
};
﻿const tabChangedEvent = new Event("TabChanged");
const tabLoadedEvent = new Event("TabLoaded");
const conferenceTabLoadedEvent = new Event("ConferenceTabLoaded");
﻿var TabPages = {
    selectTab: function (name, url) {
        var $links = $(".tab-pages__link");
        $links.each(function () {
            var $link = $(this);
            $link.toggleClass("active", $link.data("tab-pages-name") == name);
        });
        document.title = name;
        var $content = $('.tab-pages__content[name="' + name + '"]');
        if (!$content.data('tab-pages-loaded')) {
            var xhr;
            var jqueryXhr = $.ajaxSettings.xhr;
            var getXhr = function () {
                xhr = jqueryXhr();
                return xhr;
            }
            $.ajax({
                url: url,
                xhr: getXhr,
                complete: function (jqXhr, status) {
                    if (status == "success") {
                        var $newContent = $($.parseHTML(jqXhr.responseText, true)).find('.tab-pages__content[name="' + name + '"]');
                        if ($newContent.length) {
                            $content.replaceWith($newContent);
                            return;
                        }
                    }
                    window.location.href = xhr.redirectURL || url;
                }
            });
        }
    },
    clickTab: function (e) {
        e.preventDefault();
        var $selected = $(this);
        var name = $selected.data("tab-pages-name");
        var url = $selected.attr("href");
        TabPages.selectTab(name, url);
        window.history.pushState(name, name, url);
        return false;
    },
    init: function (tabPages) {
        var $tabPages = $(tabPages);
        $tabPages.find("a.tab-pages__link").click(TabPages.clickTab);
        window.onpopstate = function (e) {
            if (e.state) {
                TabPages.selectTab(e.state, window.location.href);
            }
        }
    }
};;
﻿var ScrollLink = {
    init: function (scrollLink) {
        var $scrollLink = $(scrollLink);
        $scrollLink.find('.scroll-link__tag').click(function (e) {
            e.preventDefault();
            ScrollLink.slowScroll($(e.target).attr('href'));
        });

        if (window.location.hash) {
            $scrollLink.find('.scroll-link__anchor').each(function () {
                var $anchor = $(this);
                if (window.location.hash.substr(1).toLowerCase() === $anchor.attr('id')) {
                    ScrollLink.slowScroll($anchor);
                    setTimeout(function () {
                        ScrollLink.slowScroll($anchor);
                    }, 300);
                }
            });
        }
    },
    slowScroll: function (anchor) {
        var $anchor = $(anchor);       
        if ($anchor.length && $anchor[0].offsetParent != null) {
            var anchorTop = $anchor.offset().top;
            var nearBottom = $(document).height() - $(window).height();
            var scrollTo = anchorTop < nearBottom ? anchorTop : nearBottom;
            $('html,body').animate({ scrollTop: scrollTo }, 600);
        }
    }
};

$(document).ready(function () {
    ScrollLink.init($('.scroll-link'));
})
document.addEventListener("ConferenceTabLoaded", function () { ScrollLink.init($('.scroll-link')); });;
﻿var Tabs = {
    init: function (tabs, defaultTab) {
        var $tabs = $(tabs);

        if (defaultTab != null && defaultTab.length > 0) {
            Tabs.loadDefaultTab($tabs, defaultTab);
        } else if (window.location.hash) {
            Tabs.loadHashTab($tabs);
        } else {
            document.dispatchEvent(tabLoadedEvent);
		}

        $tabs.find('.tabs__link').click(function () {
            var $item = $(this).parent();
            if (!$item.hasClass('tabs__item--active')) {
                var $items = $tabs.find('.tabs__item').removeClass('tabs__item--active');
                var $content = $tabs.find('.tabs__content').removeClass('tabs__content--active');
                var index = $item.data('tabs-index');
                var activeTab = $items.filter('[data-tabs-index=' + index + ']').addClass('tabs__item--active');
                $content.filter('[data-tabs-index=' + index + ']').addClass('tabs__content--active');

                if ($item.parent().hasClass('more-tabs-dropdown')) {
                    var title = $tabs.find('.more-tabs-title');
                    title.text($(this).text());
                    title.parent().addClass("more-tabs-active");
                } else {
                    $tabs.find('.more-tabs').removeClass('more-tabs-active');
				}

                // check for slick carousel in tab content
                // hidden carousel cannot be sized correctly if it is not visible when initialized at page load
                // trigger a resize on these carousels when they become visible
                var $slick = $('.tabs__content--active .slick-slider');
                if ($slick.length) {
                    $slick.slick('setPosition');
                }

                // Update URL to current tab
                window.location.hash = activeTab.attr('data-tabs-id').replace("tab-", "");
                document.dispatchEvent(tabChangedEvent);
            }
            else {
                // if in a mobile layout
                if ($(window).width() < 1024) {
                    // allow tab to be closed
                    $item.removeClass('tabs__item--active');
                    var index = $item.data('tabs-index');
                    $tabs.find('.tabs__content').filter('[data-tabs-index=' + index + ']').removeClass('tabs__content--active');
                }
            }
            
        });
        const tabSetupCompleteEvent = new Event('tabSetupComplete');
        document.dispatchEvent(tabSetupCompleteEvent);
        /*This function replaces the hash change event. It allows loading of hash tab as well as scroll to the tab location
         by determining whether it is a jump anchor or other page link. */
        $('a').on("click", function () {
            var $anchorHash = $(this).attr('href');           
            if (typeof ($anchorHash) != "undefined" && $anchorHash != null && $anchorHash != "" && $anchorHash.startsWith("#")) {
                //update the url
                window.location.hash = $anchorHash;
                if ($tabs) {
                    Tabs.loadHashTab($tabs);
                }
            }
            else if (typeof ($anchorHash) != "undefined" && $anchorHash != null && $anchorHash != "" && $anchorHash.includes("#")) {
                var url;
                if (isUrlValid($anchorHash)) {
                    url = new URL($anchorHash, window.location.origin);
                    if (url.hostname === window.location.hostname) {
                        var $anchorHash = $(this).prop("hash");
                        window.location.hash = $anchorHash;
                        if ($tabs) {
                            Tabs.loadHashTab($tabs);
                        }
                    }
                }
            }
        });

        function isUrlValid(string) {
            try {
                new URL(string, window.location.origin);
                return true;
            } catch (err) {
                return false;
            }
        }

        $(window).on('resize', function () {
            // when screen is in desktop size
            if ($(window).width() > 1024) {
                // check if no sections active i.e. closed state on mobile
                if ($tabs.find('tabs__content--active').length == 0) {
                    // if true check if anchor tag in URL
                    if (window.location.hash) {
                        // if anchor exists set that tab to active for desktop size
                        var anchor = window.location.hash.replace('#', '');
                        var $anchorTab = $('.tabs__item[data-tabs-id="tab-' + anchor + '"]').addClass('tabs__item--active');
                        var $anchorTabContent = $('.tabs__content[data-tabs-id="content-' + anchor + '"]').addClass('tabs__content--active');
                    }
                    else {
                        // if there is no anchor then make first section active for desktop size
                        $tabs.find('.tabs__item').first().addClass('tabs__item--active');
                        $tabs.find('.tabs__content').first().addClass('tabs__content--active');
                    }
                }
            }
        });
    }, 
    loadDefaultTab: function ($tabs, defaultTab) {
        if (defaultTab) {
            var $anchorTab = $('.tabs__item[data-tabs-id="tab-' + defaultTab + '"]');
            var $anchorTabContent = $('.tabs__content[data-tabs-id="content-' + defaultTab + '"]');
            if ($anchorTab.length) {
                $tabs.find('.tabs__item').removeClass('tabs__item--active');
                $tabs.find('.tabs__content').removeClass('tabs__content--active');
                $anchorTab.addClass('tabs__item--active');
                $anchorTabContent.addClass('tabs__content--active');

                if ($(window).width() < 1024) {
                    $anchorTab = $('.mobile__tab[data-tabs-id="tab-' + defaultTab + '"]');
                }

                if ($anchorTab.parent().hasClass('more-tabs-dropdown')) {
                    var title = $tabs.find('.more-tabs-title');
                    title.text($anchorTab.first().find('a').text());
                    title.parent().addClass("more-tabs-active");
                }
                else {
                    $tabs.find('.more-tabs').removeClass('more-tabs-active');
                }

                document.dispatchEvent(tabLoadedEvent);
            }
        }
    },
    loadHashTab: function ($tabs) {
        if (window.location.hash) {
            var anchor = window.location.hash.replace('#', '');
            var $anchorTab = $('.tabs__item[data-tabs-id="tab-' + anchor + '"]');
            var $anchorTabContent = $('.tabs__content[data-tabs-id="content-' + anchor + '"]');
            if ($anchorTab.length) {
                $tabs.find('.tabs__item').removeClass('tabs__item--active');
                $tabs.find('.tabs__content').removeClass('tabs__content--active');
                $anchorTab.addClass('tabs__item--active');
                $anchorTabContent.addClass('tabs__content--active');

                if ($(window).width() < 1024) {
                    $anchorTab = $('.mobile__tab[data-tabs-id="tab-' + anchor + '"]');
                }

                if ($anchorTab.parent().hasClass('more-tabs-dropdown')) {
                    var title = $tabs.find('.more-tabs-title');
                    title.text($anchorTab.first().find('a').text());
                    title.parent().addClass("more-tabs-active");
                }
                if (!$tabs.attr("data-tabs-scroll") || $tabs.attr("data-tabs-scroll") == "true") {
                    Tabs.tabsSlowScroll($anchorTab);
                    setTimeout(function () {
                        Tabs.tabsSlowScroll($anchorTab);
                    }, 600);
                }

                document.dispatchEvent(tabLoadedEvent);
            }
        }
    },
    tabsSlowScroll: function (anchor) {
        var $anchor = $(anchor);
        if ($anchor.length) {
            var anchorTop = $anchor.offset().top;
            var currScroll = document.documentElement.scrollTop || document.body.scrollTop;
            var nearBottom = $(document).height() - $(window).height();
            var scrollTo = anchorTop < nearBottom ? anchorTop : nearBottom;
            var scrollTime = 600;
            if (Math.abs(currScroll - anchorTop) < 400) {
                scrollTime = 50;
            }
            $('html,body').animate({ scrollTop: scrollTo }, scrollTime);
        }
    }
};;
﻿document.addEventListener('DOMContentLoaded', function () {
    const customTooltip = document.getElementById('customTooltip');
    const shareIcon = document.getElementById('socialshare');
    const shareContainer = document.getElementById('shareContainer');
    const articleShare = document.querySelector('.article-share');   
    if (shareContainer && shareIcon) {
        shareIcon.addEventListener('mouseover', function () {
            if (!shareIcon.classList.contains('active')) {
                customTooltip.style.display = 'block';
            }
        });
        shareIcon.addEventListener('mouseout', function () {
            customTooltip.style.display = 'none';
        });

        shareIcon.addEventListener('click', handleClick);

        window.onload = function () {
            showSocialShare();
        };

        window.onresize = function () {
            showSocialShare();
            shareIcon.classList.remove("active");    
        };

        window.addEventListener('click', function (event) {
            if (!articleShare.contains(event.target) && shareIcon != null && shareIcon.classList.contains('active')) {
                handleClick(event);
            }
        });
    }
 

    function handleClick() {
        if (window.innerWidth > 767) {
            shareIcon.classList.toggle('active');
            if (shareIcon.classList.contains("active")) {
                customTooltip.style.display = "none";
            }
            const shareIcons = document.getElementById("shareSlider");        
            if (shareIcons != null) {                                           
                if (shareIcons.classList.contains('dismiss')) {
                    shareIcons.classList.remove('dismiss');
                    shareIcons.classList.add('selected');                 
                }
                else {
                    if (shareIcons.classList.contains('selected')) {
                        shareIcons.classList.remove('selected');
                        shareIcons.classList.add('dismiss');                        
                    }
                }
            }
        }
    }

    function showSocialShare() {
        customTooltip.style.display = 'none';
        const shareIcons = document.getElementById("shareIcons");
        const shareSlider = document.getElementById("shareSlider");
        if (shareIcons == null) {
            var src = "//static.addtoany.com/menu/page.js";
            var parent = document.querySelector(".sharetools")
            var popupParent = document.querySelector(".article-share");
            var mydiv = document.createElement("div");
            mydiv.className = "a2a_kit a2a_default_style sharetool_wrapper";
            mydiv.id = "shareIcons";
            
            if (window.innerWidth > 767) {
                shareSlider.classList.add("dismiss");
            }
            else {
                shareSlider.classList.remove("dismiss");
            }

            var myspan = document.createElement("span");

            var myaFacebook = document.createElement("a");
            myaFacebook.className = "a2a_button_facebook sharetool_facebook";
            myaFacebook.appendChild(myspan);
            mydiv.appendChild(myaFacebook);

            var myaTwitter = document.createElement("a");
            myaTwitter.className = "a2a_button_twitter sharetool_x-twitter";
            myaTwitter.appendChild(myspan);
            mydiv.appendChild(myaTwitter);

            var myaLinkedin = document.createElement("a");
            myaLinkedin.className = "a2a_button_linkedin sharetool_linkedin";
            myaLinkedin.appendChild(myspan);
            mydiv.appendChild(myaLinkedin);

            var myaEmail = document.createElement("a");
            myaEmail.className = "a2a_button_email sharetool_email";
            myaEmail.appendChild(myspan);
            mydiv.appendChild(myaEmail);

            var myaCopyUrl = document.createElement("a");
            myaCopyUrl.className = "sharetool_copylink";
            myaCopyUrl.appendChild(myspan);
            mydiv.appendChild(myaCopyUrl);

            const popup = document.createElement('div');
            popup.className = 'popup';
            popup.id = 'popup';

            const popupArrow = document.createElement('div');
            popupArrow.className = 'popup-arrow';

            const popupText = document.createElement('span');
            popupText.id = 'popupText';
            popupText.textContent = 'Click to copy link';

            popup.appendChild(popupArrow);
            popup.appendChild(popupText);

            popupParent.appendChild(popup);
            parent.appendChild(mydiv);

            function showPopup() {
                popup.style.display = 'block';
            }

            function hidePopup() {
                popup.style.display = 'none';
                popupText.textContent = 'Click to copy link';
            }

            function copyLink(e) {
                e.preventDefault();
                const shareUtms = "?utm_source=isaca_internal&utm_medium=share_link";
                const url = window.location.href + shareUtms;
                navigator.clipboard.writeText(url).then(function () {
                    popupText.textContent = 'Link copied!';
                }).catch(function (err) {
                    console.error('Failed to copy: ', err);
                });
            }

            // Add event listeners for the anchor
            myaCopyUrl.addEventListener('mouseover', showPopup);
            myaCopyUrl.addEventListener('mouseout', hidePopup);
            myaCopyUrl.addEventListener('click', copyLink);

            var script = document.createElement("script");
            script.src = src;
            script.type = "text/javascript";
            script.async = true;
            document.body.appendChild(script);
        }
        if (shareIcons) {
            if (window.innerWidth > 767) {
                shareSlider.classList.add("dismiss");
            }
            else {
                shareSlider.classList.remove("dismiss");
            }
        }
    }
});;
﻿const payAndApplyLinkElement = document.getElementById('associate_designation_modal_payAndApplyLink');
if (payAndApplyLinkElement) {
    payAndApplyLinkElement.addEventListener('click', function (event) {
        event.preventDefault();
        document.getElementById('associate_designation_consent_modal').style.display = 'flex';
    });
}

const closeButtonElement = document.querySelector('.associate-designation .close');
if (closeButtonElement) {
    closeButtonElement.addEventListener('click', function () {
        document.getElementById('associate_designation_consent_modal').style.display = 'none';
    });
}

const continueButtonElement = document.getElementById('associate_designation_modal_continueButton');

if (continueButtonElement) {
    continueButtonElement.addEventListener('click', function () {
        const errorMessageElement = document.getElementById('associate_designation_modal_errorMessage');

        // Disable the continue button to prevent multiple submissions
        continueButtonElement.setAttribute('disabled', 'disabled');
        continueButtonElement.classList.add('btn-disabled');

        const modalOverlay = document.querySelector('.associate-designation .modal-overlay');
        if (modalOverlay) {
            modalOverlay.style.display = 'block';
        }

        if (errorMessageElement) {
            errorMessageElement.style.display = 'none';
        }

        $.ajax({
            url: '/api/PageContent/Kuma_AssociateDesignationConsent_ProcessConsent',
            type: 'POST',
            data: {
                IsacaID: document.getElementById('associate_designation_modal_IsacaID').value,
                ExamCode: document.getElementById('associate_designation_modal_ExamCode').value
            },
            success: function (data) {
                if (data.success) {
                    window.location.href = data.redirectUrl;
                } else {
                    if (errorMessageElement) {
                        errorMessageElement.style.display = 'block';
                    }
                    continueButtonElement.removeAttribute('disabled');
                    continueButtonElement.classList.remove('btn-disabled');
                    modalOverlay.style.display = 'none';
                }
            },
            error: function () {
                if (errorMessageElement) {
                    errorMessageElement.style.display = 'block';
                }
                continueButtonElement.removeAttribute('disabled');
                continueButtonElement.classList.remove('btn-disabled');
                modalOverlay.style.display = 'none';
            }
        });
    });
};
﻿var accordionTabs = {
    init: function () {
        container = document.querySelector(".accordion-container");
        if (container) {
            var isFirstTabOpen = $(".accordion-container").data('firsttab-open');
            if (isFirstTabOpen != null && isFirstTabOpen != "") {
                isFirstTabOpen = isFirstTabOpen.toLowerCase() === 'true';
                if (isFirstTabOpen) {
                    var $id = $(".AccordionTab > div.accordion-title:first").attr('id');
                    $(".AccordionTab > div").removeClass("active");
                    $(".AccordionTab > div i").removeClass("fa-sharp fa-light fa-chevron-up").addClass("fa-sharp fa-light fa-chevron-down");
                    $(".AccordionContent").slideUp();
                    var selectedId = (window.location.hash || "").split("#")[1];
                    if (!selectedId) {
                        selectedId = $id;
                    }
                    $("div[id='" + selectedId + "']").addClass("active");
                    $(".AccordionTab > " + "div[id=" + selectedId + "].accordion-title:first i").removeClass("fa-sharp fa-light fa-chevron-down").addClass("fa-sharp fa-light fa-chevron-up");
                    $(".AccordionTab > " + "div[id=" + selectedId + "].accordion-title:first").siblings(".AccordionContent").slideDown();

                    var $target = $(".AccordionTab > " + "div[id=" + selectedId + "].accordion-title:first");
                    if (window.location.hash && $target && $target.length > 0) { // Scroll to the target tab only if the tab is clicked and a hash is present in the URL.
                        var headerHeight = $('.newmain.kuma').height();
                        var anchorTop = $target.offset().top;
                        var nearBottom = $(document).height() - $(window).height();
                        var scrollTo = (anchorTop < nearBottom ? anchorTop : nearBottom) - headerHeight;
                        $('html, body').animate({
                            scrollTop: scrollTo
                        }, 600);
                    }
                }
            }
        }

        $(".AccordionTab > div.accordion-title").on("click", function () {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this)
                    .siblings(".AccordionContent")
                    .slideUp();
                $(".AccordionTab > div i")
                    .removeClass("fa-sharp fa-light fa-chevron-up")
                    .addClass("fa-sharp fa-light fa-chevron-down");
                return false;
            } else {
                $(".AccordionTab > div i")
                    .removeClass("fa-sharp fa-light fa-chevron-up")
                    .addClass("fa-sharp fa-light fa-chevron-down");
                $(this)
                    .find("i")
                    .removeClass("fa-sharp fa-light fa-chevron-down")
                    .addClass("fa-sharp fa-light fa-chevron-up");
                $(".AccordionTab > div").removeClass("active");
                $(this).addClass("active");
                $(".AccordionContent").slideUp();
                $(this)
                    .siblings(".AccordionContent")
                    .slideDown();
                return false;
            }
        });

        $('a').on("click", function () {
            var $anchorHash = $(this).attr('href');
            if ($anchorHash != null && $anchorHash != "" && $anchorHash.includes("#")) {
                var $anchorId = $anchorHash.split("#")[1];
                var $target = $(".AccordionTab > " + "div[id=" + $anchorId + "].accordion-title:first");
                var $id = $(".AccordionTab > div.accordion-title.active").attr('id');

                function scrollToTab() {
                    var headerHeight = $('.newmain.kuma').height();
                    var anchorTop = $target.offset().top;
                    var nearBottom = $(document).height() - $(window).height();
                    var scrollTo = (anchorTop < nearBottom ? anchorTop : nearBottom) - headerHeight;
                    
                    $('html, body').animate({ scrollTop: scrollTo }, 600);
                }

                if ($target.length > 0) {
                    if ($id != $anchorId) { // Only trigger a click event if the clicked ID is different from the currently open one.
                        $target.trigger('click');
                    }

                    scrollToTab();

                    // Wait for the accordion animation to complete
                    setTimeout(scrollToTab, 400);
                }
            }
        });
    }
}
$(document).ready(function () {
    accordionTabs.init();
});
document.addEventListener("ConferenceTabLoaded", function () { accordionTabs.init(); });
;
﻿var HeroCarousel = {
    init: function (heroCarousel, rotationDelay, randomizeSlideOrder) {
        var $carousel = $(heroCarousel);
        if (randomizeSlideOrder) {
            var $slides = $carousel.children(".hero-carousel__slides").children();
            $slides.sort(function () {
                return 0.5 - Math.random();
            });
            $slides.each(function(i) {
                this.setAttribute("data-location-id", "Carousel Slide " + parseInt(i + 1, 10));
                this.setAttribute("role", "group");
            });
            $carousel.children(".hero-carousel__slides").empty().append($slides);
        }
        $carousel.children(".hero-carousel__slides").slick({
            autoplay: true,
            autoplaySpeed: rotationDelay,
            prevArrow: $carousel.children(".hero-carousel__control--prev"),
            nextArrow: $carousel.children(".hero-carousel__control--next"),
            adaptiveHeight: false,
            useTransform: false
        });
        $carousel.on("click", ".hero-carousel__control--prev", function () {
            HeroCarousel.pauseCarousel($carousel);
        });
        $carousel.on("click", ".hero-carousel__control--next", function () {
            HeroCarousel.pauseCarousel($carousel);
        });
        $carousel.on('init afterChange', function (event, slick) {
            HeroCarousel.updateAriaHidden($carousel);
        });
    },
    pauseCarousel: function ($carousel) {
        $carousel.children(".hero-carousel__slides").slick('slickSetOption', 'autoplay', false).slick('slickPause');
    },
    updateAriaHidden: function (slider) {
        var $slides = slider.find('.slick-slide');
        $slides.each(function () {
            var $slide = $(this);

            // Always hide cloned slides
            if ($slide.hasClass('slick-cloned')) {
                $slide.attr('aria-hidden', 'true');
            }
            // Set aria-hidden based on visibility for non-cloned slides
            else if ($slide.hasClass('slick-active')) {
                $slide.attr('aria-hidden', 'false');
            } else {
                $slide.attr('aria-hidden', 'true');
            }

            // Make buttons inside hidden slides unfocusable
            var isHidden = $slide.hasClass('slick-cloned') || !$slide.hasClass('slick-active');
            $slide.find('a, button, input, textarea, select, [tabindex]').attr('tabindex', isHidden ? '-1' : '0');
        });
    }
};

$(document).ready(function () {

    applyAnimations();
    
    function applyAnimations() {
        //letter by letter animation
        let carouselHeadLineText = document.querySelector(".headline-text");
        let carouselBodyText = document.querySelector(".body-text");
        let animationType = document.querySelector('.animate-type');
        let headlineElement = document.querySelector(".animate-headline");
        let bodyElement = document.querySelector(".animate-body");       

        if (carouselHeadLineText && headlineElement) {
            carouselHeadLineText.style.display = '';
            headlineElement.textContent = "";
            headlineElement.style.height = carouselHeadLineText.offsetHeight + "px";
            carouselHeadLineText.style.display = 'none';
        }

        if (carouselBodyText && bodyElement) {
            carouselBodyText.style.display = '';
            bodyElement.textContent = "";
            bodyElement.style.height = carouselBodyText.offsetHeight + "px";
            carouselBodyText.style.display = 'none';
        }

        if (animationType != null && animationType.textContent.toLowerCase() == "letter animation") {
            (async () => {
                await letterAnimation(headlineElement, carouselHeadLineText);
                await letterAnimation(bodyElement, carouselBodyText);
                await replaceAllTextContent(carouselHeadLineText, carouselBodyText, headlineElement, bodyElement);
            })();
        }
        else if (animationType != null && animationType.textContent.toLowerCase() == "word animation") {
            (async () => {
                await wordAnimation(headlineElement, carouselHeadLineText, fontSize = 'x-large');
                await wordAnimation(bodyElement, carouselBodyText, fontSize = 'x-small');
                await replaceAllTextContent(carouselHeadLineText, carouselBodyText, headlineElement, bodyElement);
            })();
        }

        function letterAnimation(element, data) {
            return new Promise(async (resolve) => {
                if (data && data.textContent !== "") {
                    const text = data.textContent;
                    const words = text.split(" ");
                    let index = 0;
                    await animateWordsSequentially();
                    async function animateWord(word, element) {
                        const letters = word.split('');
                        let letterIndex = 0;

                        return new Promise(innerResolve => {
                            async function animateLetter() {
                                if (letterIndex < letters.length) {
                                    const span = document.createElement('span');
                                    span.textContent = letters[letterIndex];
                                    element.appendChild(span);
                                    // Apply animation
                                    span.setAttribute('class', 'backInRight');
                                    letterIndex++;

                                    // Wait for the animation to complete for the current letter
                                    await new Promise(resolve => setTimeout(resolve, 50));
                                    animateLetter();
                                } else {
                                    innerResolve();
                                }
                            }

                            animateLetter();
                        });
                    }

                    async function animateWordsSequentially() {
                        for (const word of words) {
                            const wordWidth = calculateWordWidth(word, element);
                            const wordContainer = document.createElement('span');
                            wordContainer.style.width = wordWidth + "px";
                            element.appendChild(wordContainer);

                            await animateWord(word, wordContainer);

                            if (index < words.length - 1) {
                                // Add a space between words
                                const space = document.createTextNode(' ');
                                element.appendChild(space);
                            }

                            index++;
                        }
                    }

                    function calculateWordWidth(word, element) {
                        const tempSpan = document.createElement('span');
                        tempSpan.textContent = word;
                        element.appendChild(tempSpan);
                        const width = tempSpan.clientWidth;
                        tempSpan.remove();
                        return width;
                    }

                    resolve();
                } else {
                    resolve();
                }
            });
        }

        function handleAnimationEnd(element) {
            return new Promise(resolve => {
                //remove inline styles
                element.style.fontSize = '';
                element.style.letterSpacing = '';
                resolve();
            });
        }

        function wordAnimation(element, data, fontSize) {
            return new Promise(resolve => {
                if (data && data.textContent !== "") {
                    const text = data.textContent;
                    const words = text.split(" ");
                    let index = 0;

                    function animateWord(word) {
                        return new Promise(async innerResolve => {
                            const wordContainer = document.createElement('span');
                            wordContainer.textContent = word;
                            element.appendChild(wordContainer);

                            // Set initial styles
                            const fullWidth = wordContainer.clientWidth;
                            wordContainer.style.width = fullWidth + 'px';
                            wordContainer.style.fontSize = fontSize;

                            const tempSpan = document.createElement('span');
                            tempSpan.style.visibility = 'hidden';
                            document.body.appendChild(tempSpan);

                            // Measure the width of each letter and sum them up
                            const fullWidthWithLetterSpacing = word.split('').reduce((width, letter) => {
                                tempSpan.textContent = letter;
                                tempSpan.style.letterSpacing = '0';
                                width += tempSpan.offsetWidth;
                                return width;
                            }, 0);

                            // Calculate letter spacing and set styles
                            const letterSpacing = (fullWidth - fullWidthWithLetterSpacing) / (word.length - 1);
                            wordContainer.style.letterSpacing = letterSpacing + 'px';

                            // Apply animation
                            wordContainer.setAttribute('class', 'fadeInAnime');
                            await new Promise(resolve => setTimeout(resolve, 50));
                            wordContainer.addEventListener('animationend', async () => {
                                await handleAnimationEnd(wordContainer);
                                innerResolve();
                            }, { once: true });
                        });
                    }

                    async function animateWordsSequentially() {
                        for (const word of words) {
                            await animateWord(word);

                            if (index < words.length - 1) {
                                // Add a space between words
                                const space = document.createTextNode(' ');
                                element.appendChild(space);
                            }

                            index++;
                        }
                    }

                    animateWordsSequentially().then(() => {
                        resolve();
                    });
                } else {
                    resolve();
                }
            });
        }

        function replaceAllTextContent(carouselHeadLineText, carouselBodyText, headlineElement, bodyElement) {
            return new Promise(async (resolve) => {
                if (carouselHeadLineText.textContent != "") {
                    headlineElement.textContent = carouselHeadLineText.textContent;
                    headlineElement.removeAttribute("style");
                }
                if (carouselBodyText.textContent != "") {
                    bodyElement.textContent = carouselBodyText.textContent;
                    bodyElement.removeAttribute("style");
                }
                resolve();
            });
        }
    }
});

;
﻿$(document).ready(function () {
    if ($(".assetLink-component").length > 0) {
        var languageSelected = null;
        var pdfDropDown = document.getElementById('pdfDropdown');
        var downloadButton = document.getElementById('downloadButton');
        $(".assetLink-component .error-message").hide();

        $('#languageDD').on('change', function () {
            languageSelected = $('#languageDD').val();
          
            if (languageSelected != null || languageSelected != "") {
                $(".assetLink-component .error-message").hide();
                if (downloadButton) {
                    downloadButton.disabled = false;
                }
            }
            if (languageSelected == "" && downloadButton) {
                downloadButton.disabled = true;
            }
        });

        $("#submitForm").submit(function (event) {
            var valDDL = $("#languageDD").val();
            if (valDDL == "" || valDDL == null) {
                event.preventDefault();
                $(".assetLink-component .error-message").show();
            }
        });

        if (pdfDropDown) {
            document.getElementById('pdfDropdown').addEventListener('change', function () {
                var pdfId = this.value;
                var languageDropdown = document.getElementById('languageDD');
                var selectedPDF = document.getElementById('selectedPDF');                

                if (pdfId) {
                    selectedPDF.value = this.value;
                    fetch('/api/pagecontent/getlanguages', {
                        method: 'POST',
                        headers: {
                            'Accept': '*/*',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ pdfId: pdfId })
                    })
                        .then(response => response.json())
                        .then(data => {
                            // Clear existing options
                            languageDropdown.innerHTML = '<option value="">SELECT LANGUAGE</option>';

                            data.forEach(language => {
                                var option = document.createElement('option');
                                option.value = language.Name;
                                option.text = language.DisplayName;
                                languageDropdown.add(option);
                            });

                            languageDropdown.disabled = false;
                        })
                        .catch(error => {
                            console.error('Error fetching languages:', error);
                            languageDropdown.disabled = true;
                            downloadButton.disabled = true;
                        });
                } else {
                    languageDropdown.innerHTML = '<option value="">SELECT LANGUAGE</option>';
                    languageDropdown.disabled = true;
                    downloadButton.disabled = true;
                }
            });
        }
    }
});;
﻿var ConferenceNavTabPages = {
    selectTab: function (name, browserTitle, url) {
        $("div.mobile-hamburger").css({ "display": "none" }); //hide mobile menu on selection of any tab/menu item

        var $links = $(".tab-pages__link");
        $links.each(function () {
            var $link = $(this);
            $link.toggleClass("active", $link.data("tab-pages-name") == name);
        });

        var $content = $('.tab-pages__content[name="' + name + '"]');
        var xhr;
        var jqueryXhr = $.ajaxSettings.xhr;
        var getXhr = function () {
            xhr = jqueryXhr();
            return xhr;
        }

        document.title = browserTitle;
        localStorage.setItem('savedDocumentTitle', browserTitle);

        $.ajax({
            url: url,
            xhr: getXhr,
            complete: function (jqXhr, status) {
                if (status == "success") {
                    var $newContent = $($.parseHTML(jqXhr.responseText, true)).find('.tab-pages__content[name="' + name + '"]');
                    if ($newContent.length) {
                        $content.replaceWith($newContent);
                        document.dispatchEvent(conferenceTabLoadedEvent);
                        return;
                    }
                }
                window.location.href = xhr.redirectURL || url;
            }
        });
    },
    clickTab: function (e) {
        e.preventDefault();
        var $selected = $(this);
        var name = $selected.data("tab-pages-name");
        var browserName = $selected.data("tab-browser-name");
        var url = $selected.attr("href");
        var target = $selected.attr("target");
        if (target != null && target == "_blank") {
            window.open(url, "_blank");
        }
        else {
            ConferenceNavTabPages.selectTab(name, browserName, url);
            window.history.pushState(name, name, url);
        }
        return false;
    },
    init: function (tabPages) {
        var $tabPages = $(tabPages);
        var processedurl = getprocessedurl(window.location.href);
        var hrefParts = processedurl.split('/');
        var tabname = hrefParts[hrefParts.length - 2] //gets main tab name        
        var childname = hrefParts[hrefParts.length - 1]; //gets child submenu name

        const savedTitle = localStorage.getItem('savedDocumentTitle') || document.title;

        var $links = $("span.tab-pages__link--mobile");
        var mainTabs = [];
        $links.each(function () {
            var $link = $(this);
            mainTabs.push($link.data("tab-pages-name").toLowerCase());
        });
        $tabPages.find("a.tab-pages__link").click(ConferenceNavTabPages.clickTab);

        /*on page load of tab submenu items, highlight the main tab to which child tab(i.e. from flyout menu) belongs to and replace the content of main tab with child link content*/
        if (!mainTabs.includes(childname.replaceAll("-", " "))) {
            $links.each(function () {
                if ($(this).data("tab-pages-name").toLowerCase() == tabname.replaceAll("-", " ")) {
                    ConferenceNavTabPages.selectTab($(this).data("tab-pages-name"), savedTitle, window.location.href);
                    window.history.pushState(childname, childname, window.location.href);

                    /*make mobile menu active*/
                    var $parentSubHeadingInMobile = $("div.mobile-hamburger a[data-submenu-name='" + childname.replaceAll("-", " ") + "']").closest('ul').closest('li');
                    $parentSubHeadingInMobile.addClass("active");

                    return false;
                }
            });
        }
    }
}

function getprocessedurl(url) {
    var processedurl = url;
    /*Remove ? or # appends from url if any to perform initial operations to get main tab and child submenu name*/
    if (processedurl.indexOf("?") > 0) {
        processedurl = processedurl.substring(0, processedurl.indexOf("?"));
    }
    if (processedurl.indexOf("#") > 0) {
        processedurl = processedurl.substring(0, processedurl.indexOf("#"));
    }

    /*removes trailing slash if present in url*/
    if (processedurl.trim().substr(-1) === '/') {
        processedurl = processedurl.substring(0, processedurl.length - 1);
        processedurl = processedurl.slice(0, -1);
    }
    return processedurl;
}

function doesTabExist(allTabs, tabName) {
    return allTabs.some(function (tab) {
        return tab.tabName == tabName;
    })
}

/*on browser back navigation of ajax loaded tabs*/
window.onpopstate = function () {
    var $tabPages = $(".tabpages");
    if ($tabPages) {
        var processedurl = getprocessedurl(window.location.href);
        var hrefParts = processedurl.split('/');
        var tabname = hrefParts[hrefParts.length - 2] //gets main tab name        
        var childname = hrefParts[hrefParts.length - 1]; //gets child submenu name
        var $links = $("span.tab-pages__link--mobile");
        var mainTabs = [];
        $links.each(function () {
            var $link = $(this);
            var browserTitle = $link.data("tab-browser-name");
            var tabName = $link.data("tab-pages-name").toLowerCase();
            mainTabs.push({ tabName, browserTitle });
        });

        //clear active and display attributes
        const elements = document.querySelectorAll('div.mobile-hamburger li');
        elements.forEach((element) => {
            element.classList.remove('active');
        });
        const subelements = document.querySelectorAll('div.mobile-hamburger ul.menu');
        subelements.forEach((element) => {
            if (element.hasAttribute('style'))
                element.removeAttribute('style');
        });

        if (doesTabExist(mainTabs, childname.replaceAll("-", " "))) {
            var title = mainTabs
                .filter(x => x.tabName === childname.replaceAll("-", " "))
                .map(x => x.browserTitle);
            ConferenceNavTabPages.selectTab(childname.replaceAll("-", " "), title, window.location.href);
            /*make mobile menu parent active*/
            $("div.mobile-hamburger a[data-submenu-name='" + childname.replaceAll("-", " ") + "']").closest('ul').prev().trigger('click');

        }
        else {
            $links.each(function () {
                if ($(this).data("tab-pages-name").toLowerCase() == tabname.replaceAll("-", " ")) {
                    ConferenceNavTabPages.selectTab($(this).data("tab-pages-name"), $(this).data("tab-browser-name"), window.location.href);
                    /*make mobile menu parent and child active*/
                    $("div.mobile-hamburger a[data-submenu-name='" + tabname.replaceAll("-", " ") + "']").closest('ul').prev().trigger('click');
                    var $childElement = $("div.mobile-hamburger a[data-submenu-name='" + childname.replaceAll("-", " ") + "']");
                    if (!$childElement.hasClass("expand")) {
                        $("div.mobile-hamburger a[data-submenu-name='" + childname.replaceAll("-", " ") + "']").closest('ul').prev().trigger('click');
                    }
                }
            });
        }
    }
}

/* onclick of links from flyout menu*/
$(".tabpages .tabmenuItems a").click(function (e) {
    e.preventDefault();
    var childurl = $(this).attr('href');
    var childName = $(this).data("submenu-name");
    var name = $(this).data('tabPagesName');
    var browserName = $(this).data('tabBrowserName');
    var target = $(this).attr('target');
    if (childurl) {
        if (target != null && target == "_blank") {
            window.open(childurl, "_blank");
        }
        else {
            ConferenceNavTabPages.selectTab(name, browserName, childurl);
            window.history.pushState(childName, childName, childurl);
        }
        return false;
    }
});

if ($(".tabNavigation").length > 0) {
    $(window).resize(function () {
        $("div.mobile-hamburger").css({ "display": "none" });
    });

    //Hide the mobile flyout menu when clicked elsewhere on window      
    $(document).on("click", function (e) {
        if ($(e.target).closest("div.mobile-hamburger").length == 0 && $("div.mobile-hamburger").css('display') == 'block' && $(e.target).closest(".span.tab-pages__link--mobile").length == 0) {
            $("div.mobile-hamburger").css({ "display": "none" });
        }
    });

    $(".mobile-hamburger li span").click(function () {
        var link = $(this);
        var closest_ul = link.closest("ul");
        var parallel_active_links = closest_ul.find(".active")
        var closest_li = link.closest("li");
        var link_status = closest_li.hasClass("active");
        var count = 0;

        closest_ul.find("ul").slideUp(function () {
            if (++count == closest_ul.find("ul").length)
                parallel_active_links.removeClass("active");
        });

        if (!link_status) {
            closest_li.children("ul").slideDown();
            closest_li.addClass("active");
        }
    })
};

/*adds css to the nav menu corresponding tab when hover is with in the nav menu */
$(".dropdown-content.fullscreen").hover(function () {
    $(this).closest('.tabNavigation li.navlist').children('a.tab-pages__font-color').css({ "color": "#fff", "border-bottom-color": "hsla(0,0%,100%,.5)" });
}, function () {
    $(this).closest('.tabNavigation li.navlist').children('a.tab-pages__font-color').removeAttr("style");
});

/*dynamic margin-top calculation for flyout menu in mobile view*/
$("span.tab-pages__link--mobile").click(function (e) {
    e.stopPropagation();
    if ($("div.mobile-hamburger").css('display') == 'block') {
        $("div.mobile-hamburger").css({ "display": "none" });
    }
    else {
        var processedurl = getprocessedurl(window.location.href);
        var hrefParts = processedurl.split('/');
        var tabname = hrefParts[hrefParts.length - 2] //gets main tab name        
        var childname = hrefParts[hrefParts.length - 1]; //gets child submenu name
        var $links = $("span.tab-pages__link--mobile");
        var mainTabs = [];
        $links.each(function () {
            var $link = $(this);
            mainTabs.push($link.data("tab-pages-name").toLowerCase());
        });

        //clear active and display attributes
        const elements = document.querySelectorAll('div.mobile-hamburger li');
        elements.forEach((element) => {
            element.classList.remove('active');
        });
        const subelements = document.querySelectorAll('div.mobile-hamburger ul.menu');
        subelements.forEach((element) => {
            if (element.hasAttribute('style'))
                element.removeAttribute('style');
        });

        if (mainTabs.includes(childname.replaceAll("-", " "))) {
            /*make mobile menu parent active*/
            $("div.mobile-hamburger a[data-submenu-name='" + childname.replaceAll("-", " ") + "']").closest('ul').prev().trigger('click');
        }
        else {
            $links.each(function () {
                if ($(this).data("tab-pages-name").toLowerCase() == tabname.replaceAll("-", " ")) {
                    /*make mobile menu parent and child active*/
                    $("div.mobile-hamburger a[data-submenu-name='" + tabname.replaceAll("-", " ") + "']").closest('ul').prev().trigger('click');
                    var $childElement = $("div.mobile-hamburger a[data-submenu-name='" + childname.replaceAll("-", " ") + "']");
                    if (!$childElement.hasClass("expand")) {
                        $("div.mobile-hamburger a[data-submenu-name='" + childname.replaceAll("-", " ") + "']").closest('ul').prev().trigger('click');
                    }
                }
            });
        }
        var $link = document.getElementsByClassName("tab-pages__link--mobile active")[0].getAttribute("data-tab-pages-name");
        var tabContentHeight = $('.tab-pages__content[name="' + $link + '"]').height();
        $("div.mobile-hamburger").css({ "display": "block", "margin-top": "-" + tabContentHeight + "px" });
    }
});

;
﻿var videoplayer = {
    init: function (data) {
        window.onYouTubeIframeAPIReady = function () { document.dispatchEvent(new CustomEvent('onYouTubeIframeAPIReady', {})) };
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        var player = null;
        var tvPlayerHostname = 'https://' + document.location.hostname;
        document.addEventListener('onYouTubeIframeAPIReady', function () {
            if (window.YT) {
                data.forEach(function (item) {
                    window.YT.ready(function () {
                        player = new YT.Player(item.iframe, {
                            videoId: item.videoPlayerId,
                            playerVars: {
                                'origin': tvPlayerHostname, 
                                'rel' : 0
                            },
                            events: {
                                'onReady': onPlayerReady,
                                'onStateChange': onPlayerStateChange
                            }
                        });
                    });
                });
            }
        }, false);

        function onPlayerReady(event) {
        }

        function onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.PLAYING) {
                $('.featured-video .iframe-container .video-duration span').hide();
            }
        }

        $('.video-player').on('click', function (e) {
            e.preventDefault();
            // Cancel if the modal is active or if the close icon is clicked
            if (e.target.classList.contains('modal-close-icon') || e.target.classList.contains('is-active')) {
                return;
            }

            //remove video duration
            $('.featured-video .iframe-container .video-duration span').hide();

            let $this = $(this);
            let $thumbnail = $this.find('.thumbnail');

            // Apply styles to display modal if video player is a modal version
            if ($this.hasClass('is-modal')) {
                let windowScrollPosition = $(window).scrollTop();
                let $closeIcon = $this.children('.modal-close-icon');
                $this.addClass('is-active');
                $(window).scrollTop(0);
                $('body').css('overflow', 'hidden');
                $closeIcon.css('display', 'inline-block');
                // Wait a little to remove the thumbnail once video begins playing to prevent YouTube play icon from showing
                let $iframe = $(this).children().find(".iframe")[0];
                if ($iframe.src)
                {
                    if ($iframe.includes("?")) {
                        $iframe.src += "&autoplay=1";
                    }
                    else {
                        $iframe.src += "?autoplay=1";
                    }
                }
                else if ($($iframe).data('src')) {
                    // backup is to set src from data-src
                    if ($($iframe).data('src').includes("?")) {
                        $iframe.src = $($iframe).data('src') + "&autoplay=1";
                    }
                    else {
                        $iframe.src = $($iframe).data('src') + "?autoplay=1";
                    }
                }

                window.setTimeout(() => {
                    $thumbnail.fadeOut();
                }, 300);

                // Stop video and remove modal styles when modal close icon is clicked
                $closeIcon.on('click', () => {
                    let $iframe = $(this).children().find(".iframe")[0];
                    if ($iframe.src) {
                        if ($iframe.src.includes("?autoplay=1")) {
                            $iframe.src = $iframe.src.replace("?autoplay=1", "");
                        }
                        else {
                            $iframe.src = $iframe.src.replace("&autoplay=1", "");
                        }
                    }
                    else if ($($iframe).data('src')) {
                        // backup is to set src from data-src
                        if ($($iframe).data('src').includes("?")) {
                            $iframe.src = $($iframe).data('src') + "&autoplay=1";
                        }
                        else {
                            $iframe.src = $($iframe).data('src') + "?autoplay=1";
                        }
                    }
                    $closeIcon.css('display', 'none');
                    $('body').css('overflow', 'visible');
                    $(window).scrollTop(windowScrollPosition);
                    $this.removeClass('is-active');
                    $thumbnail.fadeIn();
                });
            }
            else {
                // Wait a little to remove the thumbnail once video begins playing to prevent YouTube play icon from showing
                let $iframe = $(this).children().find(".iframe")[0];
                if ($iframe.src) {
                    if ($iframe.src.includes("?")) {
                        $iframe.src += "&autoplay=1";
                    }
                    else {
                        $iframe.src += "?autoplay=1";
                    }
                }
                else if ($($iframe).data('src')) {
                    // backup is to set src from data-src
                    if ($($iframe).data('src').includes("?")) {
                        $iframe.src = $($iframe).data('src') + "&autoplay=1";
                    }
                    else {
                        $iframe.src = $($iframe).data('src') + "?autoplay=1";
                    }
                }
                window.setTimeout(() => {
                    $thumbnail.fadeOut();
                }, 300);
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    let $iframes = $(".featured-video .iframe");
    var data = [];
    if ($iframes.length > 0) {
        for (let i = 0; i < $iframes.length; i++) {
            var objPush = {};
            objPush.iframe = $iframes[i].getAttribute('id');
            objPush.videoPlayerId = $iframes[i].getAttribute('data-video-id');
            data.push(objPush);
        }
        videoplayer.init(data);
    }
});

document.addEventListener("ConferenceTabLoaded", function () {
    let $videoIframes = $("div.mobile-navtab").children().find(".iframe");
    for (let i = 0; i < $videoIframes.length; i++) {
        let $videoIframe = $videoIframes[i];
        if ($videoIframe.src != null && $videoIframe.src != "undefined" && ($videoIframe.src.indexOf("&autoplay=1") >= 0 || $videoIframe.src.indexOf("?autoplay=1") >= 0)) {
            $videoIframe.src = $videoIframe.src.replace("&autoplay=1", "");
        }
    };
    let $activeParentTab = $("div.mobile-navtab").find("span.active").parent();
    let $iframes = $activeParentTab.children().find(".featured-video .iframe");
    var data = [];
    if ($iframes.length > 0) {
        for (let i = 0; i < $iframes.length; i++) {
            var objPush = {};
            objPush.iframe = $iframes[i].getAttribute('id');
            objPush.videoPlayerId = $iframes[i].getAttribute('data-video-id');
            data.push(objPush);
        }
        videoplayer.init(data);
        onYouTubeIframeAPIReady();
    }
});;
﻿//const popups = [...document.getElementsByClassName('share-tool-menu')];
window.addEventListener('click', ({ target }) => {
    const popup = target.closest('.share-tool-menu.shared');
    const sharePopup = target.closest('#shareToolMenu');
    const shareLinkUI = document.querySelector('#shareToolMenu');
    const socialShareIconPath = document.querySelector('#shareToolIconPath');

    if (popup && !sharePopup) {
        if (shareLinkUI.classList.contains('show')) {
            shareLinkUI.classList.remove('show');
            socialShareIconPath.classList.remove('selected');
        } else {
            shareLinkUI.classList.add('show');
            socialShareIconPath.classList.add('selected');
        }
    } else if (!sharePopup) {
        if (shareLinkUI !== null && shareLinkUI.classList.contains('show')) {
            shareLinkUI.classList.remove('show');
        }
        if (socialShareIconPath !== null && socialShareIconPath.classList.contains('selected')) {
            socialShareIconPath.classList.remove('selected');
        }
    }
});

function showSocialShare(socialShareId) {
    var script = document.createElement("script");
    script.src = "//s7.addthis.com/js/300/addthis_widget.js#pubid=" + socialShareId;
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);
};
﻿$(document).ready(function () {
    if ($('.cpe-signin-sheet').length > 0) {
        let downloadForm = document.getElementById('downloadSigninSheet');
        let uploadForm = document.getElementById('cpeUploadSignInSheet')

        var today = new Date().toISOString().split('T')[0];
        document.getElementById('start-date').setAttribute("max", today);
        document.getElementById('end-date').setAttribute("max", today);

        downloadForm.addEventListener("submit", (e) => {
            if (!validateForm(downloadForm)) {
                e.preventDefault();
            }
            else {
                $.ajax({
                    url: this.action,
                    type: this.method,
                    success: function () {
                        downloadForm.reset();
                    },
                    error: function () {
                        let errorText = document.getElementById('downloadError');
                        errorText.classList.remove("hide");
                    }
                });
                return false;
            }
        });


        let btnSignInSheedUpload = document.getElementById('btnSignInSheedUpload');
        let btnSignInSheedUploadValidated = document.getElementById('btnSignInSheedUploadValidated');
        let maxHoursEarned = $('#hoursEarned').attr('max');

        //btnValidUpload
        btnSignInSheedUpload.addEventListener("click", (e) => {
            if (!validateForm(uploadForm)) {
                e.preventDefault();
                return false;
            }
            else {
                btnSignInSheedUploadValidated.click();
            }
        });

        $("input").focusout(function (e) {           
            if (validateInput(e.target)) {
                clearValidation(e.target);
                }            
        });

        $("select").focusout(function (e) {
            if (validateSelect(e.target)) {
                clearValidation(e.target);
            }
        });

        function validateInput(input) {
            let valid = false;
            if (input.value && (input.validity.badInput || input.validity.patternMismatch || input.validity.rangeUnderflow || input.validity.rangeOverflow || input.validity.typeMismatch || input.validity.tooShort || input.validity.tooLong)) {
                valid = false;
            } else if (input.required && (input.validity.valueMissing || (input.type == "text" && !input.value))) {
                valid = false;
            }
            else if (input.required && input.type == "number" && input.name == 'HoursEarned' && (input.value <= 0 || input.value >= maxHoursEarned)) {
                valid = false;
            }
            else if (input.required && input.type == "file") {
                var file = document.getElementById("file");
                var validExts = [".xlsx", ".xls"];                
                var fileExt = file.value.substring(file.value.lastIndexOf('.'));               
                if (file && file.value.length != 0 && file.size < 5248000 && validExts.indexOf(fileExt) > -1) {
                    valid = true;
                }
            }
            else if (input.required && input.type == "date" && input.id == "end-date") {                
                var startDate = document.getElementById("start-date").value;
                var endDate = document.getElementById("end-date").value;

                if (input.value && startDate && Date.parse(endDate) < Date.parse(startDate)) {
                    valid = false;                   
                }
                else {
                    valid = true;                    
                }
            }
            else {
                valid = true;
            }
            return valid;
        }

        function clearValidation(input) {
            if (input) {
                let validationContainer = input.closest(".form-group");
                if (input.classList.contains("invalid")) {
                    input.classList.remove("invalid");
                }
                if (!validationContainer) {
                    validationContainer = input.parentElement;
                }

                if (validationContainer) {
                    let validationMessage = validationContainer.querySelector(".invalid-feedback");

                    if (validationMessage && !validationMessage.classList.contains("hide")) {
                        validationMessage.classList.add("hide");
                    }
                }
            }
        }

        function validateForm(form) {
            let inputs = form.querySelectorAll("input.textBoxInput");
            let selects = form.querySelectorAll("select");
            let valid = true;

            if (inputs && inputs.length > 0) {
                for (let i = 0; i < inputs.length; i++) {
                    if (!validateInput(inputs[i])) {
                        valid = false;
                        inputs[i].classList.add("invalid");
                        let validationMessage = inputs[i].parentElement.querySelector(".invalid-feedback");

                        if (validationMessage) {
                            validationMessage.classList.remove("hide");
                        }
                    } else {
                        inputs[i].classList.remove("invalid");
                        let validationMessage = inputs[i].parentElement.querySelector(".invalid-feedback");

                        if (validationMessage) {
                            validationMessage.classList.add("hide");
                        }
                    }
                }
            }

            if (selects && selects.length > 0) {
                for (let i = 0; i < selects.length; i++) {
                    if (!validateSelect(selects[i])) {
                        valid = false;
                        selects[i].classList.add("invalid");
                        let validationMessage = selects[i].parentElement.querySelector(".invalid-feedback");

                        if (validationMessage) {
                            validationMessage.classList.remove("hide");
                        }
                    } else {
                        selects[i].classList.remove("invalid");
                        let validationMessage = selects[i].parentElement.querySelector(".invalid-feedback");

                        if (validationMessage) {
                            validationMessage.classList.add("hide");
                        }
                    }
                }
            }

            return valid;
        }

        function validateSelect(select) {
            let valid = false;

            if (select.required && select.validity.valueMissing) {
                valid = false;
            } else {
                if (select.name == 'DefaultMethodOfDelivery' && select.value == 'Select Method of Delivery') {
                    valid = false;
                }
                else {
                    valid = true;
                }
            }

            return valid;
        }
    }
});



;
﻿var countdownClock = {
    init: function () {
        let container;
        container = document.querySelector(".countdownclock");
        if (container) {
            const endDate = container.querySelector('.countdowntime').innerHTML;
            if (endDate != null) {
                const endTime = new Date(endDate).getTime();
                let timer = setInterval(function () {
                    let currentUTCDateTime = new Date().toISOString();
                    let currentTime = new Date(currentUTCDateTime).getTime();
                    let timeDifferenceInSeconds = Math.ceil((endTime - currentTime) / 1000);
                    let countDown = timeDifferenceInSeconds;
                    if (countDown > 0) {
                        const days = Math.floor(countDown / 86400);
                        const hours = Math.floor((countDown % 86400) / 3600);
                        const minutes = Math.floor((countDown % 3600) / 60);
                        const seconds = Math.floor(countDown % 60);

                        const formattedDays = days < 10 ? '0' + days : days;
                        const formattedHours = hours < 10 ? '0' + hours : hours;
                        const formatttedMinutes = minutes < 10 ? '0' + minutes : minutes;
                        const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

                        container.querySelector('.days').innerText = formattedDays;
                        container.querySelector('.hours').innerText = formattedHours;
                        container.querySelector('.minutes').innerText = formatttedMinutes;
                        container.querySelector('.seconds').innerText = formattedSeconds;
                        container.querySelector('.countdown').style.display = "block";
                        container.querySelector('.content').style.display = "none";
                    }
                    //when date is passed
                    if (countDown < 0) {
                        container.querySelector('.countdown').style.display = "none";
                        container.querySelector('.content').style.display = "block";
                        clearInterval(timer);
                    }
                }, 0)
            }
        }
    }
}

$(document).ready(function () {
    countdownClock.init();
});
document.addEventListener("ConferenceTabLoaded", function () { countdownClock.init(); });
;
﻿$(document).ready(function () {
   var $window = $(window);
    var testimonialSlider = $(".testimonial-carousel");
    const settings = {
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: false, 
        adaptiveHeight: true, 
        responsive: [            
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    };
    if (testimonialSlider) {
        testimonialSlider.slick(settings);
    }

    $window.on('resize', function () {
        if (testimonialSlider && !testimonialSlider.hasClass('slick-initialized'))
            return testimonialSlider.slick(settings);
    });    
});


;
﻿document.addEventListener('DOMContentLoaded', function () {
    var video = document.getElementById('videoCountDown');
    var fadeinRendering = document.getElementById('fadeInRendering');
    if (video != null && fadeinRendering != null) {
        video.addEventListener('ended', function () {
            fadeinRendering.classList.add('show');

        });
    }
});;
﻿var featuredVideoCarousel = {
    init: function () {
        $('.featured-video-carousel-wrapper .featured-video-carousel').on('init', function (event, slick) {
            addWatchNowEvent();
            addGtmClasses();
            removeOverlayOnClick();
            removeDurationIfNoThumbnail();
        });

        $('.featured-video-carousel-wrapper .featured-video-carousel').on('reInit', function (event, slick) {
            addWatchNowEvent();
            addGtmClasses();
            removeOverlayOnClick();
            removeDurationIfNoThumbnail();
        });

        $('.featured-video-carousel-wrapper .featured-video-carousel').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            swipe: false,
            centerMode: true,
            mobileFirst: true,
            centerPadding: '0px'
        });
        $('.featured-video-carousel-wrapper .video-tiles').on('init', function (event, slick) {
            addClickEventForTiles();
        });

        $('.featured-video-carousel-wrapper .video-tiles').on('reInit', function (event, slick) {
            addClickEventForTiles();
        });
        $('.featured-video-carousel-wrapper .video-tiles').on('breakpoint', function (event, slick) {
            addClickEventForTiles();
        });

        $('.featured-video-carousel-wrapper .video-tiles').slick({
            infinite: false,
            arrows: true,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            mobileFirst: true,
            centerMode: false,
            centerPadding: '0px',
            swipe: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        centerMode: false,
                        arrows: true,
                        dots: true          
                    }
                },
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
        $(window).on('orientationchange', function () {
            rebuildTiles();
            addWatchNowEvent();
            removeOverlayOnClick();
            addClickEventForTiles();
        });

        $(window).resize(function () {
            rebuildTiles();
            addWatchNowEvent();
            removeOverlayOnClick();
            addClickEventForTiles();
        });

        function rebuildTiles() {
            let $tiles = $('.featured-video-carousel-wrapper .video-tiles');

            if ($tiles.hasClass('slick-initialized')) {
                $tiles.slick('unslick');
            }

            if ($(window).width() > 480 && $(window).width() < 986) {

                $tiles.slick({
                    infinite: false,
                    arrows: true,
                    dots: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    swipe: true
                });
            } else if ($(window).width() <= 480) {

                $tiles.slick({
                    infinite: false,
                    arrows: true,
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    mobileFirst: true,
                    centerMode: false,
                    centerPadding: '0px',
                    swipe: true
                });
            }
        }

        function addClickEventForTiles() {
            $('.featured-video-carousel-wrapper .video-tiles .video-tile').each(function (i) {
                $(this).on('click', function () {
                    stopAllYTVideos();
                    resetAllThumbnails();
                    resetVideoDuration();

                    var slideId = $(this).attr('data-slide');
                    if (slideId) {
                        setTileAsFirstOnMobile(slideId);
                        $('.featured-video-carousel').slick('slickGoTo', slideId, false);
                    }

                    deselectTile();
                    $(this).addClass("selected");
                });
            });
        }

        function addWatchNowEvent() {
            $('.featured-video-carousel .video-slide .slide-text .watch-now').each(function (i) {
                $(this).on('click', function () {
                    var videoId = $(this).attr('data-video-Id');

                    if (videoId.length > 0) {
                        playYTVideo(videoId);

                        let $thumbnail = $('#' + videoId).parent().find('.thumbnail');
                        if ($thumbnail) {
                            window.setTimeout(() => {
                                $thumbnail.fadeOut();
                            }, 300);
                        }

                        let $videoDuration = $('#' + videoId).parent().find('.video-duration');
                        if ($videoDuration) {
                            $videoDuration.hide();
                        }
                    }
                });
            });
        }

        function setTileAsFirstOnMobile(slideId) {
            const isMobileDevice = window.navigator.userAgent.toLowerCase().includes("mobi");

            if (isMobileDevice) {
                var firstVisibleSlideId = $('.featured-video-carousel-wrapper .video-tiles .slick-active:first').find('.video-tile').attr('data-slide');

                if (parseInt(firstVisibleSlideId) < parseInt(slideId)) {
                    $('.featured-video-carousel-wrapper .video-tiles').slick("slickNext");
                }
            }
        }      

        function deselectTile() {
            $('.featured-video-carousel-wrapper .video-tiles .video-tile').each(function (i) {
                $(this).removeClass("selected");
            });
        }

        function playYTVideo(videoId) {
            if (videoId.length > 0) {

                try {
                    var player = YT.get(videoId);
                    if (player) {
                        player.playVideo();
                    }
                } catch (err) {
                }
            }
        }

        function stopAllYTVideos(videoId) {
            $('.featured-video-carousel .video-slide .slide-video iframe').each(function () {
                var videoId = $(this).attr('id');
                if (videoId.length > 0) {
                    try {
                        var player = YT.get(videoId);
                        if (player) {
                            player.stopVideo();
                        }
                    } catch (err) {
                    }
                }
            });
        }

        function resetAllThumbnails() {
            $('.featured-video-carousel .slide-video').each(function (i) {
                let $this = $(this);
                let $thumbnail = $this.find('.thumbnail');
                if ($thumbnail) {
                    $thumbnail.fadeIn();
                }
            });
        }

        function removeOverlayOnClick() {
            $('.featured-video-carousel .slide-video .thumbnail').each(function (i) {
                $(this).on('click', function () {

                    let $this = $(this);
                    window.setTimeout(() => {
                        $this.fadeOut();
                    }, 300);

                    var iframeId = $this.parent().find('iframe').attr('id');
                    if (iframeId.length > 0) {
                        try {
                            var player = YT.get(iframeId);
                            if (player) {
                                player.playVideo();
                            }
                        } catch (err) {
                        }
                    }

                    let $videoDuration = $this.parent().find('.video-duration');
                    if ($videoDuration) {
                        $videoDuration.hide();
                    }
                });
            });
        }

        function resetVideoDuration() {
            $('.featured-video-carousel .slick-slide .slide-video .video-duration').show();
        }
        function hideVideoDuration(parent) {
            let $videoDuration = parent.find('.video-duration');
            if ($videoDuration) {
                $videoDuration.hide();
            }
        }

        function removeDurationIfNoThumbnail() {
            $('.featured-video-carousel-wrapper .video-tiles-wrapper .video-tiles .video-tile').each(function (i) {
                let $img = $(this).find('img');
                if ($img.length < 1) {
                    hideVideoDuration($(this));
                }
            });
        }

        

        function addGtmClasses() {
            $('.featured-video-carousel-wrapper button.slick-prev').addClass("fvc-arrow-prev");
            $('.featured-video-carousel-wrapper button.slick-next').addClass("fvc-arrow-next");
            $('.featured-video-carousel-wrapper .slick-dots button').each(function (i) {
                var gtmClassName = "fvc-dot-" + $(this).text();
                $(this).addClass(gtmClassName);
            });
        }
    },

    initVideoPlayers: function (data) {
        window.onYouTubeIframeAPIReady = function () { document.dispatchEvent(new CustomEvent('onYouTubeIframeAPIReady', {})) };
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        var player = null;
        var tvPlayerHostname = 'https://' + document.location.hostname;
        document.addEventListener('onYouTubeIframeAPIReady', function () {
            if (window.YT) {
                data.forEach(function (item) {
                    window.YT.ready(function () {
                        player = new YT.Player(item.iframe, {
                            videoId: item.videoPlayerId,
                            playerVars: {
                                'origin': tvPlayerHostname,
                                'rel': 0
                            },
                            events: {
                                'onReady': onPlayerReady,
                                'onStateChange': onPlayerStateChange
                            }
                        });
                    });
                });
            }
        }, false);

        function onPlayerReady(event) {
        }

        function onPlayerStateChange(event) {

            if (event.data == YT.PlayerState.PLAYING) {
                $('.featured-video-carousel .slick-current .slide-video .video-duration').hide();
            }

            if (event.data == YT.PlayerState.ENDED) {

                var playNextVideo = $('#hfAutoPlayNextVideo').val();
                if (playNextVideo == 'true') {

                    var nextVideoId = $('.featured-video-carousel .slick-current .iframe').attr('data-video-next');
                    if (nextVideoId.length > 0) {
                        $('.featured-video-carousel-wrapper .featured-video-carousel').slick("slickNext");

                        let $thumbnail = $('.featured-video-carousel .slick-current .slide-video').find('.thumbnail');
                        if ($thumbnail) {
                            window.setTimeout(() => {
                                $thumbnail.fadeOut();
                            }, 300);
                        }
                        selectNextTile();

                        var videoId = 'videoCarousel' + nextVideoId;
                        try {
                            var newPlayer = YT.get(videoId);
                            if (newPlayer) {
                                newPlayer.playVideo();
                            }
                        } catch (err) {
                        }
                    }
                }
            }
        }

        function selectNextTile() {
            var isMobile = isMobileDevice();
            var isTablet = isTabletDevice();

            var $selectedTile = $('.featured-video-carousel-wrapper .video-tiles .video-tile.selected');
            var tileId = $selectedTile.attr('data-slide');

            if (tileId) {
                var nextTileId = parseInt(tileId) + 1;
                $selectedTile.removeClass('selected');
                $('.featured-video-carousel-wrapper .video-tiles').find("[data-slide='" + nextTileId + "']").addClass('selected');

                if (isMobile) {
                    $('.featured-video-carousel-wrapper .video-tiles').slick("slickNext");
                }
                else if (isTablet)
                {
                    if (nextTileId == 3) {
                        $('.featured-video-carousel-wrapper .video-tiles').slick("slickNext");
                    }
                }
            }
        }

        function isMobileDevice() {
            return window.navigator.userAgent.toLowerCase().includes("mobi");
        }

        function isTabletDevice() {

            if ($(window).width() < 1024 && $(window).width() > 481) {
                return true;
            }
            return false;
        }
    }
}
document.addEventListener("DOMContentLoaded", function () { featuredVideoCarousel.init(); });
document.addEventListener("ConferenceTabLoaded", function () { featuredVideoCarousel.init(); });

document.addEventListener("DOMContentLoaded", function () {
    let $iframes = $(".featured-video-carousel .iframe");
    var data = [];
    if ($iframes.length > 0) {
        for (let i = 0; i < $iframes.length; i++) {
            var objPush = {};
            objPush.iframe = $iframes[i].getAttribute('id');
            objPush.videoPlayerId = $iframes[i].getAttribute('data-video-id');
            data.push(objPush);
        }
        featuredVideoCarousel.initVideoPlayers(data);
    }
});;
﻿var FilterCollection = (function (document) {
    var active = 0;
    var container = null;
    var expandFilters = null;
    var facetGroups = null;
    var facetHeadings = null;
    var layoutButtons = null;
    var loadButton = null;
    var pageSize = 16;
    var resultCount = null;
    var resultList = null;
    var searchButton = null;
    var searchBox = null;
    var searchQuery = "";
    var selectFacets = null;
    var showing = 16;
    var tiles = null;

    window.onclick = function (event) {
        var selectFacetsdropdowns = document.getElementsByClassName("select-facet");
        var isClickInsideDropDown = false;
        for (var i = 0; i < selectFacetsdropdowns.length; i++) {
            if (selectFacetsdropdowns[i].contains(event.target)) {
                isClickInsideDropDown = true;
                break;
            }
        }
        if (!isClickInsideDropDown) {
            if (selectFacetsdropdowns.length > 0 && document.querySelector('.select-facets').children.length > 0) {
                var allElements = document.querySelectorAll(".facet.select-facet")
                for (var i = 0; i < allElements.length; i++) {
                    allElements[i].querySelector("h4").classList.remove("active");
                    allElements[i].querySelector("div.list").classList.add("hide");
                }
            }
        }
    };

    function changeLayout(layoutLink) {
        refreshState();

        if (!layoutLink.classList.contains("active")) {
            for (var i = 0; i < layoutButtons.length; i++) {
                if (layoutButtons[i].getAttribute("data-layout") == layoutLink.getAttribute("data-layout")) {
                    layoutLink.classList.add("active");
                    resultList.parentNode.classList.add("layout-" + layoutLink.getAttribute("data-layout"))
                } else if (layoutButtons[i].classList.contains("active")) {
                    layoutButtons[i].classList.remove("active");
                    resultList.parentNode.classList.remove("layout-" + layoutButtons[i].getAttribute("data-layout"))
                }
            }
        }
    }

    function filter() {
        refreshState();
        active = 0;
        var searched = false;
        var regexp = RegExp(searchQuery, "i");

        if (searchQuery.length > 0) {
            searched = true;
        }

        for (let i = 0; i < tiles.length; i++) {
            var filtered = false;
            var first = false;
            var match = false;
            var searchMatch = false;
            var tile = tiles[i];

            if (regexp.test(tile.innerHTML)) {
                searchMatch = true;
            }

            for (let j = 0; j < facetGroups.length; j++) {
                var groupFiltered = false;
                var groupMatch = false;
                let facets = facetGroups[j].querySelectorAll("input");

                for (let k = 0; k < facets.length; k++) {
                    if (facets[k].checked) {
                        if (!filtered) {
                            first = true;
                        }

                        filtered = true;
                        groupFiltered = true;
                        let name = facets[k].name.split('-')[0];
                        let value = facets[k].value;

                        if (tile.hasAttribute('data-' + name) && tile.getAttribute('data-' + name).indexOf(value) >= 0) {
                            groupMatch = true;
                        }
                    }

                    if (groupMatch) {
                        break;
                    }
                }

                if (first) {
                    first = false;
                    match = groupMatch;
                } else if (groupFiltered) {
                    match = match && groupMatch;
                }

                if (filtered && !match) {
                    break;
                }
            }

            if (tile.classList.contains("load-more")) {
                // Ignore the Load More button
            } else if ((!filtered || match) && (!searched || searchMatch)) {
                ++active;
                tile.classList.add("active");
            } else {
                tile.classList.remove("active");
            }
        }

        if (showing >= active || (showing < pageSize && active < pageSize)) {
            showing = active;
        } else if (showing == pageSize || (showing < pageSize && pageSize <= active)) {
            showing = pageSize;
        } else {
            showing = Math.floor(showing / pageSize) * pageSize;
        }

        setShowing();
        setLoadMore();
        setResults();
    }

    function page() {
        refreshState();

        var nextIndex = showing + pageSize;

        if (nextIndex < active) {
            showing = nextIndex;
        } else {
            showing = active;
        }

        setShowing();
        setLoadMore();
        setResults();
    }

    function refreshState() {
        resultList = document.querySelector('.collection .row');       
        expandFilters = document.querySelector(".expand-filters");
        facetGroups = document.querySelectorAll('.tile-facets .facet');
        facetHeadings = document.querySelectorAll('.tile-facets .facet h4');
        layoutButtons = document.querySelectorAll('a.tile-layout');
        loadButton = document.querySelector('.load-more');
        pageSize = parseInt(loadButton.getAttribute('data-page-size'));
        resultCount = document.querySelector('.results p');
        searchButton = document.querySelector('.filter-collection .search a');
        searchBox = document.querySelector('.filter-collection .search input');
        selectFacets = document.querySelector('.select-facets');

        /* when multiple filter sessions are added in each ajax tab of conference tabs navigation --> return active tab data */
        let conferenceTabs = document.querySelector(".tabNavigation");
        let allSessions = document.querySelectorAll('.collection.layout-sessions');
        if (conferenceTabs != null) {
            let activeTab = document.querySelector('.mobile-navtab span.tab-pages__link--mobile.active').parentElement;
            if (activeTab != null && activeTab.querySelector('.collection.layout-sessions') != null && allSessions.length > 1) {
                resultList = activeTab.querySelector('.collection .row');
                expandFilters = activeTab.querySelector(".expand-filters");               
                facetGroups = activeTab.querySelectorAll('.tile-facets .facet');
                facetHeadings = activeTab.querySelectorAll('.tile-facets .facet h4');
                loadButton = activeTab.querySelector('.load-more');
                searchButton = activeTab.querySelector('.filter-collection .search a');
                searchBox = activeTab.querySelector('.filter-collection .search input');
                searchQuery = searchBox.value;
            }
        }

        tiles = resultList.children;
        active = resultList.querySelectorAll(".tile.active").length;
    }

    function search() {
        if (searchBox.value != null && searchBox.value.length >= 3) {
            searchQuery = searchBox.value;
        } else {
            searchQuery = '';
        }

        filter();
    }

    function setLoadMore() {
        if (showing >= active) {
            loadButton.parentElement.append(loadButton);
            loadButton.classList.add("hide");
        } else {
            var element = loadButton.parentElement.querySelectorAll(".tile.active")[showing];
            loadButton.parentElement.insertBefore(loadButton, element);
            loadButton.classList.remove("hide");
        }
    }

    function setResults() {
        if (resultCount) {
            resultCount.innerHTML = '<span>' + showing + '</span> of <span>' + active + '</span> Results';
		}
    }

    function setShowing() {
        var available = showing;

        for (let i = 0; i < tiles.length; i++) {
            if (tiles[i].classList.contains("search") || tiles[i].classList.contains("load-more")) {
                // skip controls
            }
            else if (available > 0 && tiles[i].classList.contains("active")) {
                --available;
                tiles[i].classList.remove("hide");
            } else {
                tiles[i].classList.add("hide");
            }
        }
    }

    function setupFacets() {
        for (let i = 0; i < facetGroups.length; i++) {
            let hide = true;
            let facets = facetGroups[i].querySelectorAll("input");

            for (let j = 0; j < facets.length; j++) {
                let name = facets[j].name.split('-')[0];
                let value = facets[j].value;
                let exists = resultList.querySelectorAll(".tile[data-" + name + "*='" + value + "']");

                if (!exists || exists.length == 0) {
                    facets[j].parentElement.parentElement.classList.add("hide");
                } else {
                    hide = false;

                    facets[j].addEventListener("click", (e) => {
                        if (selectFacets) {
                            toggleFilterDependencies();
                        }

                        filter();
                    });
                }
            }

            if (hide) {
                facetGroups[i].classList.add("hide");
            }
        }
    }

    function setupHorizontalFacets() {
        let horizontalFilters = document.querySelectorAll(".horizontal-facet a");

        if (horizontalFilters && horizontalFilters.length > 0) {
            for (let i = 0; i < horizontalFilters.length; i++) {
                let filterName = horizontalFilters[i].getAttribute("data-filter");
                let filter = document.querySelector("input[name='" + filterName + "']");

                if (filter) {
                    horizontalFilters[i].addEventListener("click", (e) => {
                        filter.click();
                    });
                }
            }
		}
    }

    function setupLayout() {
        for (var i = 0; i < layoutButtons.length; i++) {
            layoutButtons[i].addEventListener("click", (e) => {
                e.preventDefault();

                changeLayout(e.currentTarget);
            });
        }
    }

    function setupSearch() {        
        searchButton.addEventListener("click", (e) => {
            e.preventDefault();

           // searchBox = document.querySelector('.filter-collection .search input');

            search();
        });

        searchBox.addEventListener("keyup", (e) => {
           // searchBox = document.querySelector('.filter-collection .search input');

            search();
        });                 
    }

    function setupToggles() {
        expandFilters.addEventListener("click", (e) => {
            toggleFilters();
        });

        if (selectFacets) {
            for (var i = 0; i < facetHeadings.length; i++) {
                facetHeadings[i].addEventListener("click", (e) => {
                    toggleSelectFacet(e.currentTarget);
                });
            }
        } else {
            for (var i = 0; i < facetHeadings.length; i++) {
                facetHeadings[i].addEventListener("click", (e) => {
                    toggleFacet(e.currentTarget);
                });
            }
        }
    }

    function toggleFacet(facetHeading) {
        refreshState();

        if (facetHeading.classList.contains("active")) {
            facetHeading.classList.remove("active");
            facetHeading.parentElement.querySelector("ul").classList.remove("active");
        } else {
            facetHeading.classList.add("active");
            facetHeading.parentElement.querySelector("ul").classList.add("active");
        }
    }

    function toggleFilterDependencies() {
        let selectedRegions = facetGroups[0].querySelectorAll("input:checked");
        let selectedCountries = facetGroups[1].querySelectorAll("input:checked");
        let countries = facetGroups[1].querySelectorAll("input");
        let states = facetGroups[2].querySelectorAll("input");

        if (selectedRegions && selectedRegions.length > 0) {
            for (let i = 0; i < countries.length; i++) {
                let dependency = countries[i].getAttribute("data-dependency");
                var match = false;

                for (let j = 0; j < selectedRegions.length; j++) {
                    let region = selectedRegions[j].value;

                    if (dependency != null && dependency.indexOf(region) >= 0) {
                        match = true;
                    }
                }

                if (dependency != null && !match) {
                    countries[i].parentElement.parentElement.classList.add("hide");
                } else {
                    countries[i].parentElement.parentElement.classList.remove("hide");
                }
            }
        } else {
            for (let i = 0; i < countries.length; i++) {
                countries[i].parentElement.parentElement.classList.remove("hide");
            }
        }

        let hiddenCountries = facetGroups[1].querySelectorAll("li.hide input");

        if ((selectedCountries && selectedCountries.length > 0)) {
            for (let i = 0; i < states.length; i++) {
                let dependency = states[i].getAttribute("data-dependency");
                var match = false;

                for (let j = 0; j < selectedCountries.length; j++) {
                    let country = selectedCountries[j].value;

                    if (dependency != null && dependency.indexOf(country) >= 0) {
                        match = true;
                    }
                }

                if (dependency != null && !match) {
                    states[i].parentElement.parentElement.classList.add("hide");
                } else {
                    states[i].parentElement.parentElement.classList.remove("hide");
                }
            }
        } else if ((hiddenCountries && hiddenCountries.length > 0)) {
            if ((hiddenCountries && hiddenCountries.length > 0)) {
                for (let i = 0; i < states.length; i++) {
                    let dependency = states[i].getAttribute("data-dependency");

                    if (dependency != null) {
                        let dependencies = dependency.split("|");
                        var hidden = 0;

                        for (let j = 0; j < dependencies.length; j++) {
                            for (let k = 0; k < hiddenCountries.length; k++) {
                                let country = hiddenCountries[k].value;

                                if (dependencies[j] == country) {
                                    hidden++;
                                    break;
                                }
                            }
                        }

                        if (hidden == dependencies.length) {
                            states[i].parentElement.parentElement.classList.add("hide");
                        } else {
                            states[i].parentElement.parentElement.classList.remove("hide");
                        }
                    }
                }
            }
        } else {
            for (let i = 0; i < states.length; i++) {
                states[i].parentElement.parentElement.classList.remove("hide");
            }
        }
    }

    function toggleSelectFacet(facetHeading) {
        refreshState();

        if (facetHeading.classList.contains("active")) {
            facetHeading.classList.remove("active");
            facetHeading.parentElement.parentElement.querySelector(".list").classList.add("hide");
        } else {
            facetHeading.classList.add("active");
            facetHeading.parentElement.parentElement.querySelector(".list").classList.remove("hide");
        }
    }

    function toggleFilters() {
        refreshState();

        if (expandFilters.classList.contains("active")) {
            for (var i = 0; i < facetGroups.length; i++) {
                facetGroups[i].classList.remove("active");
            }
            expandFilters.classList.remove("active");
        } else {
            for (var i = 0; i < facetGroups.length; i++) {
                if (!facetGroups[i].classList.contains("hide")) {
                    facetGroups[i].classList.add("active");
                }
                facetGroups[i].querySelector("h4").classList.remove("active");
                facetGroups[i].querySelector("ul").classList.remove("active");
            }
            expandFilters.classList.add("active");
        }
    }

    function start() {
        refreshState();

        showing = pageSize;

        setupFacets();
        setupHorizontalFacets();
        setupLayout();
        setupSearch();
        setupToggles();

        loadButton.addEventListener("click", (e) => {
            e.preventDefault();

            page();
        });
    }

    return {
        init: function () {
            container = document.querySelector(".filter-collection");

            if (container) {
                start();
            }
        }
    };
})(document);

if (document.readyState !== "loading") {
    FilterCollection.init();
    document.addEventListener("ConferenceTabLoaded", function () {
        FilterCollection.init();
    });
} else {
    document.addEventListener("DOMContentLoaded", function () {
        FilterCollection.init();
    });
    document.addEventListener("ConferenceTabLoaded", function () {
        FilterCollection.init();
    });
}


﻿var conferenceFullAgenda = {
    init: function () {
        container = document.querySelector(".conference-full-agenda");
        setTimeToSpecificTimezone(undefined);
        showHideTimeZoneDdl();

        const debounce = (func, delay) => {
            let debounceTimer
            return function () {
                const context = this
                const args = arguments
                clearTimeout(debounceTimer)
                debounceTimer = setTimeout(() => func.apply(context, args), delay)
            }
        }
        if (container) {
            var filterValue = getFilterValue();
            renderSessionItemPosition(filterValue); 
            var gutter = getGutter();
            var $grid = $('.grid').isotope({
                layoutMode: 'packery',
                packery: {
                    gutter: gutter
                },
                itemSelector: '.grid-item',
                filter: filterValue
            });

            $grid.on('layoutComplete', debounce(() => {
                renderSessionItemPosition(getFilterValue());
            }, 200));

            $grid.on('arrangeComplete', debounce(() => {
                renderSessionItemPosition(getFilterValue());
            }, 200));
           

            // change is-checked class on buttons & bind filter button click
            $('.conference-full-agenda .button-group').each(function (i, buttonGroup) {
                var $buttonGroup = $(buttonGroup);
                $buttonGroup.on('click', 'button', function () {

                    $buttonGroup.find('.is-checked').removeClass('is-checked').removeAttr("style");
                    var highlightColor = $(this).attr('data-highlight-color');
                    if (highlightColor) {
                        $(this).attr('style', 'background: ' + highlightColor);
                    }
                    $(this).addClass('is-checked');
                    var filterValue = getFilterValue();
                    $grid.isotope({ filter: filterValue });
                    showHideTimeZoneDdl();
                });
            });

            $('.conference-full-agenda .conference-buttons').each(function (i, buttonGroup) {
                var $buttonGroup = $(buttonGroup);
                $buttonGroup.on('click', 'button', function () {
                    $buttonGroup.find('.is-checked').removeClass('is-checked');
                    $(this).addClass('is-checked');
                    var filterValue = getFilterValue();
                    $grid.isotope({ filter: filterValue });
                    if ($(this).attr('id') == "virtual-sessions") {
                        
                        var timeZone = undefined;
                        $('.cfaDllTimeZones').each(function () {
                            if ($(this).is(":visible")) {
                                var optionValue = $(this).val();
                                if (optionValue != '0') {
                                    timeZone = optionValue;
                                }
                            }
                        });
                        setTimeToSpecificTimezone(timeZone);
                    } else {
                        setTimeToSpecificTimezone(undefined);
                    }
                    showHideTimeZoneDdl();
                });
            });

            function getFilterValue() {
                var filterDayValue = "";
                if ($(".btn-primary-nav.is-checked") && $(".btn-primary-nav.is-checked").attr('data-filter') != null && $(".btn-primary-nav.is-checked").attr('data-filter').length > 0) {
                    filterDayValue = '.' + $(".btn-primary-nav.is-checked").attr('data-filter');
                }

                $('div.perDaySession').css('display', 'none');
                $('div.perDaySession' + filterDayValue).css('display', 'block');

                var virtualSessionDays = $('div.virtual-sessions').attr('data-session-days');
                var selectedDay = (filterDayValue || "").replace('.', '');

                if (virtualSessionDays && virtualSessionDays.includes(selectedDay)) {
                    $('div.virtual-sessions > .noSessionVirtualText').css('display', 'none');
                }
                else {
                    $('div.virtual-sessions > .noSessionVirtualText').css('display', 'block');
                }

                var conferenceFilterChecked = $(".btn-conference.is-checked").attr('id');
                var conferenceFilterUnChecked = $(".btn-conference:not(.is-checked)").attr('id');

                $('.' + conferenceFilterChecked).css('display', 'block');
                $('.' + conferenceFilterUnChecked).css('display', 'none');

                return filterDayValue;
            }

            function getGutter() {
                if (isMobileDevice()) {
                    return 0;
                }
                return 5;
            }                       
        }
    },

    initTimeZones: function () {
        initChangeEventForTimeZoneDdl();
        function initChangeEventForTimeZoneDdl() {
                $('.conference-full-agenda .cfaDllTimeZones').each(function () {
                    $(this).on("change", function () {

                        timeZone = $(this).val();

                        // Dynamically set width of all time zone drop down menus
                        $('#select-width-hide #select-width-option').html($(this).find('option:selected').text());
                        var selectWidth = $('#select-width-hide').width();

                        selectAllTimeZoneDdls(timeZone, selectWidth);

                        if (timeZone === '0') {
                            timeZone = undefined;
                        }
                        setTimeToSpecificTimezone(timeZone);
                    });
                });
        }

        function selectAllTimeZoneDdls(value, selectWidth) {
            $('.conference-full-agenda .cfaDllTimeZones').each(function () {
                $(this).val(value).width(selectWidth);
            });
        }
    }
}

function renderSessionItemPosition(filterValue) {
    $(function () {
        // Iterate over each session element with data-session-start-time attribute and match the top position for timeslot.
        var sessionSelector = (filterValue || '') + ' [data-session-start-time]' + ':visible';
        $(sessionSelector).each(function () {
            var sessionElement = $(this);

            var sessionStartTime = sessionElement.data('session-start-time');

            var timeSlotSelector = (filterValue || '') + ' [data-timeslot="' + sessionStartTime + '"]:visible';
            var timeSlotElement = $(timeSlotSelector);

            if (timeSlotElement.length) {
                var timeSlotTopPosition = timeSlotElement.position().top;

                // the height of time slot is about 75px, adjust the top position based on the conditions:
                // - If timeSlotTopPosition is less than 75px, set it to 0px
                // - If timeSlotTopPosition is a multiple of 75, keep it as is, else adjust it to the nearest multiple of 75
                var newTopPosition = 0;
                if (timeSlotTopPosition < 75) {
                    newTopPosition = 0;
                }
                else if (timeSlotTopPosition % 75 === 0) {
                    newTopPosition = timeSlotTopPosition;
                } else {
                    newTopPosition = Math.floor(timeSlotTopPosition / 75) * 75;
                }
                sessionElement.css('top', newTopPosition + 'px');
            }
        });
    });
}

function isMobileDevice() {
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/Windows Phone/i)) {
        return true;
    }
    return false;
}

function setTimeToSpecificTimezone(timeZone) {

    var isVirtual = $('#cfaVirtual').val();
    var virtualBtnChecked = $('#virtual-sessions').hasClass('is-checked');
    var isInPerson = $('#cfaInPerson').val();
    var inPersonBtnChecked = $('#inperson-sessions').hasClass('is-checked');
    var eventTimezone = $('#cfaEventTimeZone').val();

    if ((isVirtual == "True" || virtualBtnChecked) && !timeZone) {
        timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    else if ((isInPerson == "True" || inPersonBtnChecked) && !!eventTimezone && !timeZone) {
        timeZone = eventTimezone;
    }
    else if (!timeZone)
    {
        timeZone = 'UTC';
    }

    if (timeZone) {
        $('.perDaySession:visible .grid-item.grid-item--timespan').each(function () {
            $('.conference-full-agenda').find('.dtInfo').each(function () {
                content = "";
                if ($(this) != null) {

                    var dateTime = $(this).attr('data-datetime');
                    var predefinedShortTimeZone = $(this).attr('data-shortclienttimezone');
                    var overlappedTime = $(this).attr('data-overlappedtime');
                    var dtInTimeZoneLast;
                    var dtFormatted = "";

                    if (dateTime && overlappedTime) {
                        dtFormatted = dateTime.substring(0, dateTime.indexOf('T') + 1) + overlappedTime + ".000Z";
                    } else if (dateTime) {
                        dtFormatted = dateTime + ".000Z";
                    }

                    if (dtFormatted) {

                        var is24hFormat = true;
                        if (timeZone.startsWith('America')) {
                            is24hFormat = false;
                        }
                        
                        var dtConverted = new Date(dtFormatted).toLocaleString('en-US', { timeZone: timeZone });
                        var dtInTimeZone = new Date(dtConverted);
                        var shortTimeZone = getTimezoneShort(timeZone, dtInTimeZone);
                        if (inPersonBtnChecked) {
                            shortTimeZone = predefinedShortTimeZone || getTimezoneShort(timeZone, dtInTimeZone);
                        }


                        if (isMobileDevice()) {
                            var lastStartTime = $(this).attr('data-laststarttime');

                            if (lastStartTime) {
                                var dtFormattedLast = dateTime.substring(0, dateTime.indexOf('T') + 1) + lastStartTime + ".000Z";
                                var dtConvertedLast = new Date(dtFormattedLast).toLocaleString('en-US', { timeZone: timeZone });
                                dtInTimeZoneLast = new Date(dtConvertedLast);
                            }
                        }

                        $(this).empty();
                        $(this).append(getSessionStartTimeHtml(dtInTimeZone, dtInTimeZoneLast, shortTimeZone, is24hFormat));
                    }
                }
            });

        });
    }
}

function getSessionStartTimeHtml(dateTime, dateTimeForMobile, shortClientTimeZone, is24hFormat) {
    var html = "";
    if (dateTime) {
        var dt = new Date(dateTime);
        html = html + "<span class=\"date\">" + dt.toLocaleString('en-US', { weekday: 'long' }) + "</span>";
        html = html + "<span class=\"date\">" + dt.toLocaleString('en-US', { day: 'numeric' }) + " " + dt.toLocaleString('en-US', { month: 'long' }) + "</span>";
        var startTime = formatTime(dt.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: !is24hFormat }));

        html = html + "<span class=\"time\">";
        if (dateTimeForMobile) {
            var dtForMobile = new Date(dateTimeForMobile);
            var lastStartTime = formatTime(dtForMobile.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: !is24hFormat }));
            
            html = html + "<span>" + startTime + " - " + lastStartTime + "</span>";
        }
        else {
            html = html + "<span>" + startTime + "</span>";
        }
        html = html + "<span>" + shortClientTimeZone + "</span>";
        html = html + "</span>";
    }
    return html;
}

function formatTime(time){
    if (time.startsWith('0')) {
        return time.substring(1);
    }
    return time;
}

function getTimezoneShort(timeZone, dt) {
    var shortTimeZone = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        timeZoneName: 'short'
    }).formatToParts(new Date(dt))
        .find(part => part.type == "timeZoneName")
        .value;

    if (shortTimeZone.includes("GMT")) {
        shortTimeZone = shortTimeZone.replace("GMT", "UTC");
    }
    return shortTimeZone;
}

function showHideTimeZoneDdl() {
    var isInPerson = $('#cfaInPerson').val();
    var inPersonBtnChecked = $('#inperson-sessions').hasClass('is-checked');

    if (inPersonBtnChecked || isInPerson == "True") {
        $('.perDaySession:visible .sessionInfo .ddlTimeZoneWrapper').hide();
        $('.inPersonDisplayTimezone').show();
    } else {
        $('.perDaySession:visible .sessionInfo .ddlTimeZoneWrapper').show();
        $('.inPersonDisplayTimezone').hide();
    }
}

document.addEventListener("DOMContentLoaded", function () { conferenceFullAgenda.init(); conferenceFullAgenda.initTimeZones(); });
document.addEventListener("ConferenceTabLoaded", function () { conferenceFullAgenda.init(); conferenceFullAgenda.initTimeZones(); });

webpackJsonp([0],{151:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=function(e){var t=e.LogOnUrl&&e.LogOnUrl.length>0?e.LogOnUrl:"/home/login",i="?returnUrl="+encodeURI(window.location.pathname),a=t+i;console.log("Session timed out, redirecting to: "+a),window.location.href=a};t.default=a},153:function(e,t,i){"use strict";i(154),i(326),i(331),i(333),i(335),i(336),window.jQuery("form:not(.js-validate)").validate({ignore:"*"})},334:function(e,t){e.exports=jQuery},335:function(e,t){},336:function(e,t,i){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}i(337),i(338),i(340),i(341);var n=i(342),r=a(n),s=i(344),o=a(s),l=i(345),c=a(l),d=i(347),u=a(d);window.jQuery.ajaxSetup(o.default),angular.module("ngApp",["ngAnimate","slickCarousel","720kb.datepicker","angularjs-datetime-picker","smart-table",r.default,u.default]).config(["$provide","$httpProvider",function(e,t){return(0,c.default)(e,t)}]),angular.bootstrap(document.getElementById("ngApp"),["ngApp"]),i(388),i(389),i(390),i(391),i(392),i(393),i(394),i(395),i(396),i(397),i(398),i(399),i(400),i(401),i(402),i(403),i(417),i(418)},337:function(e,t,i){"use strict";/*!
 * angular-slick-carousel
 * DevMark <hc.devmark@gmail.com>
 * https://github.com/devmark/angular-slick-carousel
 * Version: 3.1.7 - 2016-08-04T06:43:29.508Z
 * License: MIT
 */
angular.module("slickCarousel",[]).constant("slickCarouselConfig",{method:{},event:{}}).directive("slick",["$timeout","slickCarouselConfig",function(e,t){var i;return i=["slickGoTo","slickNext","slickPrev","slickPause","slickPlay","slickAdd","slickRemove","slickFilter","slickUnfilter","unslick"],["afterChange","beforeChange","breakpoint","destroy","edge","init","reInit","setPosition","swipe","lazyLoaded","lazyLoadError"],{scope:{settings:"=",enabled:"@",accessibility:"@",adaptiveHeight:"@",autoplay:"@",autoplaySpeed:"@",arrows:"@",asNavFor:"@",appendArrows:"@",prevArrow:"@",nextArrow:"@",centerMode:"@",centerPadding:"@",cssEase:"@",customPaging:"&",dots:"@",draggable:"@",fade:"@",focusOnSelect:"@",easing:"@",edgeFriction:"@",infinite:"@",initialSlide:"@",lazyLoad:"@",mobileFirst:"@",pauseOnHover:"@",pauseOnDotsHover:"@",respondTo:"@",responsive:"=?",rows:"@",slide:"@",slidesPerRow:"@",slidesToShow:"@",slidesToScroll:"@",speed:"@",swipe:"@",swipeToSlide:"@",touchMove:"@",touchThreshold:"@",useCSS:"@",variableWidth:"@",vertical:"@",verticalSwiping:"@",rtl:"@"},restrict:"AE",link:function(a,n,r){angular.element(n).css("display","none");var s,o,l,c,d,u;return o=function(){s=angular.extend(angular.copy(t),{enabled:"false"!==a.enabled,accessibility:"false"!==a.accessibility,adaptiveHeight:"true"===a.adaptiveHeight,autoplay:"true"===a.autoplay,autoplaySpeed:null!=a.autoplaySpeed?parseInt(a.autoplaySpeed,10):3e3,arrows:"false"!==a.arrows,asNavFor:a.asNavFor?a.asNavFor:void 0,appendArrows:a.appendArrows?angular.element(a.appendArrows):angular.element(n),prevArrow:a.prevArrow?angular.element(a.prevArrow):void 0,nextArrow:a.nextArrow?angular.element(a.nextArrow):void 0,centerMode:"true"===a.centerMode,centerPadding:a.centerPadding||"50px",cssEase:a.cssEase||"ease",customPaging:r.customPaging?function(e,t){return a.customPaging({slick:e,index:t})}:void 0,dots:"true"===a.dots,draggable:"false"!==a.draggable,fade:"true"===a.fade,focusOnSelect:"true"===a.focusOnSelect,easing:a.easing||"linear",edgeFriction:a.edgeFriction||.15,infinite:"false"!==a.infinite,initialSlide:parseInt(a.initialSlide)||0,lazyLoad:a.lazyLoad||"ondemand",mobileFirst:"true"===a.mobileFirst,pauseOnHover:"false"!==a.pauseOnHover,pauseOnDotsHover:"true"===a.pauseOnDotsHover,respondTo:null!=a.respondTo?a.respondTo:"window",responsive:a.responsive||void 0,rows:null!=a.rows?parseInt(a.rows,10):1,slide:a.slide||"",slidesPerRow:null!=a.slidesPerRow?parseInt(a.slidesPerRow,10):1,slidesToShow:null!=a.slidesToShow?parseInt(a.slidesToShow,10):1,slidesToScroll:null!=a.slidesToScroll?parseInt(a.slidesToScroll,10):1,speed:null!=a.speed?parseInt(a.speed,10):300,swipe:"false"!==a.swipe,swipeToSlide:"true"===a.swipeToSlide,touchMove:"false"!==a.touchMove,touchThreshold:a.touchThreshold?parseInt(a.touchThreshold,10):5,useCSS:"false"!==a.useCSS,variableWidth:"true"===a.variableWidth,vertical:"true"===a.vertical,verticalSwiping:"true"===a.verticalSwiping,rtl:"true"===a.rtl},a.settings)},l=function(){var e=window.jQuery(n);return e.hasClass("slick-initialized")&&(e.remove("slick-list"),e.slick("unslick")),e},c=function(){o();var t=window.jQuery(n);if(angular.element(n).hasClass("slick-initialized")){if(s.enabled)return t.slick("getSlick");l()}else{if(!s.enabled)return;t.on("init",function(e,t){if(void 0!==s.event.init&&s.event.init(e,t),void 0!==u)return t.slideHandler(u)}),e(function(){angular.element(n).css("display","block"),t.not(".slick-initialized").slick(s)})}a.internalControl=s.method||{},i.forEach(function(e){a.internalControl[e]=function(){var i;i=Array.prototype.slice.call(arguments),i.unshift(e),t.slick.apply(n,i)}}),t.on("afterChange",function(t,i,n){u=n,void 0!==s.event.afterChange&&e(function(){a.$apply(function(){s.event.afterChange(t,i,n)})})}),t.on("beforeChange",function(t,i,n,r){void 0!==s.event.beforeChange&&e(function(){e(function(){a.$apply(function(){s.event.beforeChange(t,i,n,r)})})})}),t.on("reInit",function(t,i){void 0!==s.event.reInit&&e(function(){a.$apply(function(){s.event.reInit(t,i)})})}),void 0!==s.event.breakpoint&&t.on("breakpoint",function(t,i,n){e(function(){a.$apply(function(){s.event.breakpoint(t,i,n)})})}),void 0!==s.event.destroy&&t.on("destroy",function(t,i){e(function(){a.$apply(function(){s.event.destroy(t,i)})})}),void 0!==s.event.edge&&t.on("edge",function(t,i,n){e(function(){a.$apply(function(){s.event.edge(t,i,n)})})}),void 0!==s.event.setPosition&&t.on("setPosition",function(t,i){e(function(){a.$apply(function(){s.event.setPosition(t,i)})})}),void 0!==s.event.swipe&&t.on("swipe",function(t,i,n){e(function(){a.$apply(function(){s.event.swipe(t,i,n)})})}),void 0!==s.event.lazyLoaded&&t.on("lazyLoaded",function(t,i,n,r){e(function(){a.$apply(function(){s.event.lazyLoaded(t,i,n,r)})})}),void 0!==s.event.lazyLoadError&&t.on("lazyLoadError",function(t,i,n,r){e(function(){a.$apply(function(){s.event.lazyLoadError(t,i,n,r)})})})},d=function(){l(),c()},n.one("$destroy",function(){l()}),a.$watch("settings",function(e,t){if(null!==e)return d()},!0)}}}])},344:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(151),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r={statusCode:{401:function(e){return(0,n.default)(e)}}};t.default=r},345:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(346),n=function(e,t){e.factory(a.Id,["$q",function(e){return(0,a.Interceptor)(e)}]),t.defaults.headers.common["X-Requested-With"]="XMLHttpRequest",t.interceptors.push(a.Id)};t.default=n},346:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.Interceptor=t.Id=void 0;var a=i(151),n=function(e){return e&&e.__esModule?e:{default:e}}(a);t.Id="AuthenticationInterceptor",t.Interceptor=function(e){return{responseError:function(t){return 401===t.status&&(0,n.default)(t.data),e.reject(t)}}}},347:function(e,t,i){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var n=i(348),r=a(n),s=i(352),o=a(s),l=i(355),c=a(l),d=i(358),u=a(d),p=i(360),h=a(p),f=i(362),v=a(f),y=i(363),g=a(y),b=i(365),m=a(b),C=i(367),D=a(C),_=i(369),w=a(_),$=i(371),T=a($),S=i(373),E=a(S),O=i(375),k=a(O),A=i(377),x=a(A),M=i(379),j=a(M),I=i(386),H=a(I),Q=angular.module("ng-components",[r.default,o.default,c.default,h.default,v.default,u.default,H.default,g.default,m.default,D.default,w.default,T.default,E.default,k.default,x.default,j.default]).name;t.default=Q},348:function(e,t,i){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),i(152);var n=i(350),r=a(n),s=i(351),o=a(s),l=angular.module("download",["ngFileSaver"]).directive("download",function(){"ngInject";return{retrict:"EA",controller:r.default,controllerAs:"$ctrl",scope:{btnClass:"@",errorClass:"@",downloadController:"@",productCode:"@",write:"=",fileName:"@",showLoadingModal:"=",token:"@"},bindToController:!0,transclude:{error:"?downloadError"},template:o.default}}).name;t.default=l},350:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n,r,s){"ngInject";a(this,e),this.$scope=t,this.$http=i,this.$sce=n,this.$fileSaver=r,this.$blob=s,this.errorMsg="",this.success=!1,this.error=!1,this.loading=!1,this.overlayId="ngid_"+this.$scope.$id+"_loadingOverlay"}return e.$inject=["$scope","$http","$sce","FileSaver","Blob"],n(e,[{key:"httpStartRequest",value:function(){this.errorMsg="",this.success=!1,this.error=!1,this.loading=!0,this.showLoadingModal&&window.jQuery("#"+this.overlayId).overlay()}},{key:"download",value:function(){var e=this;this.httpStartRequest(),this.$http({url:this.downloadController,method:"POST",responseType:"arraybuffer",headers:{"X-XSRF-Token":this.token},data:{productCode:this.productCode,write:this.write}}).then(function(t){var i=new e.$blob([t.data],{type:t.headers("content-type")});e.$fileSaver.saveAs(i,e.fileName),e.loading=!1,e.showLoadingModal&&window.jQuery("#"+e.overlayId).overlay(),document.dispatchEvent(new CustomEvent("Downloads"))},function(t){console.log(t.statusText),e.error=!0,e.loading=!1,e.showLoadingModal&&window.jQuery("#"+e.overlayId).overlay()})}},{key:"$onInit",value:function(){this.btnClass&&void 0===this.btnClass||(this.btnClass="feature-button",window.dataLayer=window.dataLayer||[],window.dataLayer.push({DownloadsFilename:this.fileName})),this.errorClass&&void 0===this.errorClass||(this.errorClass="h-http-error h-http-error--font-size-base")}}]),e}();t.default=r},351:function(e,t){e.exports='<button type="submit" ng-class="$ctrl.btnClass" ng-click="$ctrl.download()" ng-transclude></button>\r\n\r\n<p ng-class="$ctrl.errorClass" ng-transclude="error" ng-if="$ctrl.error">\r\n    {{ $ctrl.errorMsg }}\r\n</p>\r\n\r\n<div class="h-overlay" id="{{ $ctrl.overlayId }}" role="dialog" tabindex="-1" aria-modal="true" aria-hidden="{{ !$ctrl.loading }}" aria-live="polit">\r\n    <div class="c-overlay">\r\n        <div class="xc-flex__grid -center">\r\n            <div class="xc-flex__cell -col-10of12 -col-sm-8of12">\r\n                <div class="c-overlay__wrap">\r\n                    <loading-spinner></loading-spinner>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>'},352:function(e,t,i){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var n=i(353),r=a(n),s=i(354),o=a(s),l=angular.module("loading-spinner",[]).directive("loadingSpinner",function(){"ngInject";return{retrict:"EA",controller:r.default,controllerAs:"$ctrl",scope:{size:"@",rootClass:"@"},bindToController:!0,template:o.default}}).name;t.default=l},353:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t){"ngInject";a(this,e),this.$window=t,this.outerSize=40,this.midSize=0,this.innerSize=0,this.outerStyle={},this.midStyle={},this.innerStyle={}}return e.$inject=["$window"],n(e,[{key:"$onInit",value:function(){this.size&&(this.outerSize=this.size),this.midSize=this.outerSize-8,this.innerSize=this.outerSize-16,this.outerStyle={height:this.outerSize+"px",width:this.outerSize+"px"},this.midStyle={height:this.midSize+"px",width:this.midSize+"px"},this.innerStyle={height:this.innerSize+"px",width:this.innerSize+"px"}}}]),e}();t.default=r},354:function(e,t){e.exports='<div class="c-spinner" ng-class="$ctrl.rootClass" ng-style="$ctrl.outerStyle">\r\n    <div class="c-spinner__item">\r\n        <div class="c-spinner__outer" ng-style="$ctrl.outerStyle">\r\n            <div class="c-spinner__outer-item" ng-style="$ctrl.outerStyle"></div>\r\n            <div class="c-spinner__outer-item" ng-style="$ctrl.outerStyle"></div>\r\n            <div class="c-spinner__outer-item" ng-style="$ctrl.outerStyle"></div>\r\n            <div class="c-spinner__outer-item" ng-style="$ctrl.outerStyle"></div>\r\n        </div>\r\n    </div>\r\n    <div class="c-spinner__item">\r\n        <div class="c-spinner__mid" ng-style="$ctrl.midStyle">\r\n            <div class="c-spinner__mid-item" ng-style="$ctrl.midStyle"></div>\r\n            <div class="c-spinner__mid-item" ng-style="$ctrl.midStyle"></div>\r\n            <div class="c-spinner__mid-item" ng-style="$ctrl.midStyle"></div>\r\n            <div class="c-spinner__mid-item" ng-style="$ctrl.midStyle"></div>\r\n        </div>\r\n    </div>\r\n    <div class="c-spinner__item">\r\n        <div class="c-spinner__inner" ng-style="$ctrl.innerStyle">\r\n            <div class="c-spinner__inner-item" ng-style="$ctrl.innerStyle"></div>\r\n            <div class="c-spinner__inner-item" ng-style="$ctrl.innerStyle"></div>\r\n            <div class="c-spinner__inner-item" ng-style="$ctrl.innerStyle"></div>\r\n            <div class="c-spinner__inner-item" ng-style="$ctrl.innerStyle"></div>\r\n        </div>\r\n    </div>\r\n</div>'},355:function(e,t,i){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var n=i(356),r=a(n),s=i(357),o=a(s),l=angular.module("http-error",[]).directive("httpError",function(){"ngInject";return{retrict:"EA",controller:r.default,controllerAs:"$ctrl",bindToController:!0,template:o.default}}).name;t.default=l},356:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function e(t){"ngInject";a(this,e),this.$window=t};n.$inject=["$window"],t.default=n},357:function(e,t){e.exports='<p class="h-http-error">\r\n    <span class="h-http-error__accent">Uh oh, there was a problem loading your data.</span class="h-http-error__accent"><br />\r\n    If the problem persists, please contact us to resolve the error.\r\n</p>'},358:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(359),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("datepicker-input",[]).directive("datepickerInput",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},359:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n){"ngInject";a(this,e),this.$http=t,this.$window=i,this.$timeout=n,this.val="",this.filled=!1}return e.$inject=["$http","$window","$timeout"],n(e,[{key:"inputChange",value:function(){""!==this.val?this.filled=!0:this.filled=!1}},{key:"toggle",value:function(){this.val="",this.inputChange()}}]),e}();t.default=r},360:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(361),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("tablist",[]).directive("tablist",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$tablist",scope:{},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},361:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r={LEFT_ARROW:37,RIGHT_ARROW:39},s=function(){function e(t,i,n){"ngInject";a(this,e),this.$scope=t,this.$window=i,this.el=n[0],this.activeTab=0,this.tabs=[]}return e.$inject=["$scope","$window","$element"],n(e,[{key:"toggle",value:function(e){this.activeTab=e}},{key:"handleKeyboad",value:function(e,t){this.tabs.length>0&&(e.keyCode===r.LEFT_ARROW?this.focusNext(-1):e.keyCode===r.RIGHT_ARROW&&this.focusNext(1))}},{key:"focusNext",value:function(e){var t=this.activeTab+e;t>=this.tabs.length?(this.activeTab=0,this.tabs[0].focus()):t<0?(this.activeTab=this.tabs.length-1,this.tabs[this.tabs.length-1].focus()):(this.activeTab=t,this.tabs[t].focus())}},{key:"$postLink",value:function(){var e=this.el.querySelector('[role="tablist"]');e&&(this.tabs=e.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'))}}]),e}();t.default=s},362:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t){a(this,e),this.$http=t,this.dataPromise=null}return e.$inject=["$http"],n(e,[{key:"getDataFromAPI",value:function(){var e=this;return this.dataPromise||(this.dataPromise=this.$http.get("/api/chapterleader/getchaptersummary").then(function(t){return e.dataCache=t.data,t.data}).catch(function(e){throw e})),this.dataPromise}}]),e}();r.$inject=["$http"],angular.module("sharedDataModule",[]).service("sharedDataService",r),t.default="sharedDataModule"},363:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(364),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("chapter-dues-profile",[]).directive("chapterDuesProfile",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},364:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n){"ngInject";a(this,e),this.$http=t,this.$window=i,this.$timeout=n,this.data=[],this.spinner=!0,this.httpError=!1}return e.$inject=["$http","$window","$timeout"],n(e,[{key:"$onInit",value:function(){var e=this;this.$timeout(function(){e.$http({url:"/api/chapterleader/getchapterdues",method:"GET"}).then(function(t){e.data=t.data,e.spinner=!1},function(t){e.spinner=!1,e.httpError=!0})},1e3)}}]),e}();t.default=r},365:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(366),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("member-breakdown",[]).directive("memberBreakdown",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},366:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n,r){"ngInject";a(this,e),this.$http=t,this.$window=i,this.$timeout=n,this.sharedDataService=r,this.data=[],this.spinner=!0,this.HasCertificates=!1,this.httpError=!1}return e.$inject=["$http","$window","$timeout","sharedDataService"],n(e,[{key:"$onInit",value:function(){var e=this;this.sharedDataService.getDataFromAPI().then(function(t){e.data=t,e.data.Certs.filter(function(e){return!0===e.IsIsacaCertificate}).length>0&&(e.HasCertificates=!0),e.spinner=!1},function(t){e.spinner=!1,e.httpError=!0})}}]),e}();t.default=r},367:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(368),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("member-renewal",[]).directive("memberRenewal",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},368:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n,r){"ngInject";a(this,e),this.$http=t,this.$window=i,this.$timeout=n,this.sharedDataService=r,this.data=[],this.currentYear=(new Date).getFullYear(),this.context=0,this.contextLastYear=0,this.context2YrsAgo=0,this.spinner=!0,this.httpError=!1,this.slickConfig={enabled:!0,dots:!0,draggable:!1,cssEase:"linear",method:{}}}return e.$inject=["$http","$window","$timeout","sharedDataService"],n(e,[{key:"$onInit",value:function(){var e=this;this.sharedDataService.getDataFromAPI().then(function(t){e.data=t,e.data.CurrentYear&&(e.currentMonth=(new Date).getMonth(),console.log("checking current year advancement, if currentMonth >= 9: "+e.currentMonth),e.currentMonth>=9&&(e.data.CurrentYear=(parseInt(e.data.CurrentYear)+1).toString(),console.log("advanced year by 1, this.data.CurrentYear: "+e.data.CurrentYear))),e.context=e.data.MemberRenewalPercent.replace(/[^0-9.]/g,"")/100*180,e.contextLastYear=e.data.MemberRenewalPercentLastYear.replace(/[^0-9.]/g,"")/100*180,e.context2YrsAgo=e.data.MemberRenewalPercent2YrsAgo.replace(/[^0-9.]/g,"")/100*180,e.spinner=!1},function(t){e.spinner=!1,e.httpError=!0})}}]),e}();t.default=r},369:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(370),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("rebates-reimbursements",[]).directive("rebatesReimbursements",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},370:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n,r){"ngInject";a(this,e),this.$scope=t,this.$http=i,this.$window=n,this.$timeout=r,this.data={},this.spinner=!1,this.httpError=!1}return e.$inject=["$scope","$http","$window","$timeout"],n(e,[{key:"$onInit",value:function(){var e=this;this.spinner=!0,this.$timeout(function(){e.$http({url:"/api/chapterleader/getchapterrebates",method:"GET"}).then(function(t){e.spinner=!1,e.data=t.data,console.log(e.data)},function(t){e.spinner=!1,e.httpError=!0})},1e3)}}]),e}();t.default=r},371:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(372),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("leader-list",[]).directive("leaderList",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},372:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n,r){"ngInject";a(this,e),this.$http=t,this.$window=i,this.$element=n,this.$timeout=r,this.data=[],this.dataOverflow=[],this.isOverflow=!1,this.collapsed=!0,this.collapsing=!1,this.spinner=!0,this.httpError=!1}return e.$inject=["$http","$window","$element","$timeout"],n(e,[{key:"$onInit",value:function(){var e=this;this.$timeout(function(){e.$http({url:"/api/chapterleader/getchapterleaders",method:"GET"}).then(function(t){e.data=t.data,e.spinner=!1},function(t){e.spinner=!1,e.httpError=!0})},1e3)}}]),e}();t.default=r},373:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(374),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("renewal-message",[]).directive("renewalMessage",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{chapterId:"@"},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},374:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n,r){"ngInject";a(this,e),this.$scope=t,this.$http=i,this.$window=n,this.$timeout=r,this.spinner=!1,this.httpError=!1,this.success=!1,this.error=!1,this.texareaID="#renewalMessage",this.errorMsg=""}return e.$inject=["$scope","$http","$window","$timeout"],n(e,[{key:"$onInit",value:function(){var e=this;this.spinner=!0,this.$timeout(function(){e.$http({url:"/api/chapterleader/GetCLPRenewalMessage",method:"POST",data:{chapterId:e.chapterId}}).then(function(t){e.spinner=!1,window.jQuery(e.texareaID).val(t.data.RenewalMessage.replace("<p>","").replace(/<p>/g,"\r\n").replace(/<\/p>/g,"").replace(/(<([^>]+)>)/gi,""))},function(t){e.spinner=!1,e.error=!0,e.errorMsg=t})},1e3)}},{key:"updateMessage",value:function(){var e=this;this.spinner=!0,this.success=!1,this.error=!1;var t=window.jQuery(this.texareaID).val();this.$timeout(function(){e.$http({url:"/api/chapterleader/UploadCLPRenewalMessage",method:"POST",data:{chapterId:e.chapterId,message:t}}).then(function(t){t.data.SuccessStatus?(e.spinner=!1,e.success=!0):(e.spinner=!1,e.error=!0,e.errorMsg=t.data.ErrorStatus)},function(t){e.spinner=!1,e.error=!0,e.errorMsg=t})},1e3)}}]),e}();t.default=r},375:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(376),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("upload-cpe",[]).directive("uploadCpe",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{validColumns:"@",rowThreshold:"@",dateFormat:"@",eventStartDateRange:"@",qualifyingActivity:"@",methodofDelivery:"@",isacaMemberNumberDigits:"@",cpeHours:"@"},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},376:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n,r){"ngInject";a(this,e),this.$scope=t,this.$http=i,this.$window=n,this.$timeout=r,this.spinner=!0,this.httpError=!1,this.fileUploaded=!1,this.success=!1,this.error=!1,this.modalSuccess=!1,this.modalError=!1,this.overlayID="#loadingOverlay",this.fileUploadFormID="#uploadForm",this.fileUploadInputID="#fileUploadInput",this.errorMsg="",this.fileName="[File Name].XLSX"}return e.$inject=["$scope","$http","$window","$timeout"],n(e,[{key:"triggerClientUpload",value:function(){this.success=!1,this.error=!1,this.modalSuccess=!1,this.modalError=!1,window.jQuery(this.fileUploadInputID).trigger("click")}},{key:"displayFileName",value:function(){this.fileName=window.jQuery(this.fileUploadInputID).get(0).files[0].name,this.fileUploaded=!0,this.$scope.$apply()}},{key:"uploadFile",value:function(){var e=this;if(void 0!==window.FormData){this.spinner=!0,this.success=!1,this.error=!1,this.modalSuccess=!1,this.modalError=!1,window.jQuery(this.overlayID).overlay();var t=window.jQuery(this.fileUploadInputID).get(0).files[0],i=new FormData;i.append(t.name,t),i.append("validColumns",this.validColumns),i.append("rowThreshold",this.rowThreshold),i.append("dateFormat",this.dateFormat),i.append("eventStartDateRange",this.eventStartDateRange),i.append("qualifyingActivity",this.qualifyingActivity),i.append("methodofDelivery",this.methodofDelivery),i.append("iSACAMemberNumberDigits",this.isacaMemberNumberDigits),i.append("cpeHours",this.cpeHours),this.$timeout(function(){e.$http({url:"/api/chapterleader/UploadCPEFile",method:"POST",transformRequest:angular.identity,headers:{"Content-Type":void 0},data:i}).then(function(t){t.data.ErrorStatus?t.data.ErrorStatus&&!t.data.SuccessStatus?(e.errorMsg=t.data.ErrorStatus,e.spinner=!1,e.error=!0,e.modalError=!0):t.data.ErrorStatus&&t.data.SuccessStatus&&(e.errorMsg=t.data.ErrorStatus,e.spinner=!1,e.success=!0,e.error=!0,e.modalSuccess=!0):(e.spinner=!1,e.success=!0,e.modalSuccess=!0)},function(t){e.errorMsg=t,e.spinner=!1,e.error=!0,e.modalError=!0})},750)}else this.errorMsg="Uh oh! It looks like there was an issue with selecting your file. Try selecting your file again.",this.error=!0,this.modalError=!0,this.fileUploaded=!1}},{key:"toggleOverlay",value:function(){(this.success||this.error)&&window.jQuery(this.overlayID).overlay()}}]),e}();t.default=r},377:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),i(152);var a=i(378),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("upload-signin-sheet",["ngFileSaver"]).directive("uploadSigninSheet",function(){"ngInject";return{retrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{validColumns:"@",rowThreshold:"@",dateFormat:"@",eventStartDateRange:"@",qualifyingActivity:"@",methodofDelivery:"@",isacaMemberNumberDigits:"@",cpeHours:"@",autoImportText:"@",defaultSponsoringOrganizationName:"@",token:"@"},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},378:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n,r,s,o){"ngInject";a(this,e),this.$scope=t,this.$http=i,this.$window=n,this.$timeout=r,this.$fileSaver=s,this.$blob=o,this.enableConsoleLogs=!1,this.consoleWrite("js updated 1"),this.spinner=!0,this.httpError=!1,this.fileUploaded=!1,this.success=!1,this.error=!1,this.modalSuccess=!1,this.modalError=!1,this.overlayID="#loadingSignInSheetOverlay",this.fileUploadFormID="#cpeUploadSignInSheet",this.fileUploadInputID="#fileSignInSheetUploadInput",this.errorMsg="",this.fileName="[File Name].XLSX",this.hoursEarned=0,this.fullListOfDateFormats=[],this.fullListOfQualifyingActivities=[],this.fullListOfMethodOfDeliveries=[],this.defaultDateFormat="MM/dd/yyyy",this.defaultQualifyingActivity="IPROED",this.defaultMethodOfDelivery="Select Method of Delivery"}return e.$inject=["$scope","$http","$window","$timeout","FileSaver","Blob"],n(e,[{key:"init",value:function(){this.consoleWrite("init()"),this.defaultDateFormat="MM/dd/yyyy",this.defaultQualifyingActivity="IPROED",this.defaultMethodOfDelivery="Select Method of Delivery"}},{key:"consoleWrite",value:function(e){this.enableConsoleLogs&&console.log(e)}},{key:"triggerClientUpload",value:function(){this.consoleWrite("upload-signin-sheet.controller.js: triggerClientUpload()"),this.success=!1,this.error=!1,this.modalSuccess=!1,this.modalError=!1,window.jQuery(this.fileUploadInputID).trigger("click")}},{key:"displayFileName",value:function(){this.consoleWrite("upload-signin-sheet.controller.js: displayFileName()"),this.fileName=window.jQuery(this.fileUploadInputID).get(0).files[0].name,this.fileUploaded=!0,this.$scope.$apply()}},{key:"formatDate",value:function(e){e=new Date(e);var t=e.getFullYear(),i=(1+e.getMonth()).toString();i=i.length>1?i:"0"+i;var a=e.getDate().toString();return a=a.length>1?a:"0"+a,i+"/"+a+"/"+t}},{key:"uploadFile",value:function(){var e=this;if(this.consoleWrite("upload-signin-sheet.controller.js: uploadFile()"),void 0!==window.FormData){this.spinner=!0,this.success=!1,this.error=!1,this.modalSuccess=!1,this.modalError=!1,window.jQuery(this.overlayID).overlay(),this.autoImport=!0,this.autoImport=window.jQuery("#chkAutoImport").is(":checked"),this.consoleWrite("chkAutoImport.is(checked): "+this.autoImport);var t=window.jQuery(this.fileUploadInputID).get(0).files[0],i=new FormData;i.append(t.name,t),i.append("validColumns",this.validColumns),i.append("rowThreshold",this.rowThreshold),i.append("dateFormat",this.dateFormat),i.append("eventStartDateRange",this.eventStartDateRange),i.append("qualifyingActivity",this.qualifyingActivity),i.append("methodofDelivery",this.methodofDelivery),i.append("iSACAMemberNumberDigits",this.isacaMemberNumberDigits),i.append("cpeHours",this.cpeHours),i.append("autoImport",this.autoImport),this.consoleWrite("defaultSponsoringOrganizationName"+this.defaultSponsoringOrganizationName),i.append("defaultSponsoringOrganizationName",this.defaultSponsoringOrganizationName),this.consoleWrite("defaultEventName"+this.defaultEventName),i.append("defaultEventName",this.defaultEventName),i.append("defaultStartDate",this.formatDate(this.defaultStartDate)),i.append("defaultEndDate",this.formatDate(this.defaultEndDate)),i.append("defaultDateFormat",this.defaultDateFormat),i.append("defaultHoursEarned",this.hoursEarned),i.append("defaultQualifyingActivity",this.defaultQualifyingActivity),i.append("defaultMethodOfDelivery",this.defaultMethodOfDelivery);var a={};i.forEach(function(e,t){a[t]=e});var n=JSON.stringify(a);this.consoleWrite("fileData: "+JSON.stringify(n)),this.$timeout(function(){e.$http({url:"/api/chapterleader/CPEUploadSignInSheet",method:"POST",transformResponse:e.jsonBufferToObject,responseType:"arraybuffer",headers:{"X-XSRF-Token":e.token,"Content-Type":void 0,Accept:"*/*"},data:i}).then(function(t){e.spinner=!1,e.consoleWrite("response: "+JSON.stringify(t));var i=t.headers("Content-Disposition");if(e.consoleWrite("header Content-Disposition: "+JSON.stringify(i)),t.data.ErrorStatus||!1!==window.jQuery("#chkAutoImport").is(":checked")||null==i)t.data.ErrorStatus||!0!==window.jQuery("#chkAutoImport").is(":checked")?t.data.ErrorStatus&&!t.data.SuccessStatus?(e.consoleWrite("errors and no success"),e.errorMsg=t.data.ErrorStatus,e.error=!0,e.modalError=!0):t.data.ErrorStatus&&t.data.SuccessStatus&&(e.consoleWrite("errors but also a success"),e.errorMsg=t.data.ErrorStatus,e.error=!0,e.modalError=!0):(e.consoleWrite("started autoImport with no errors"),e.modalSuccess=!0);else{e.success=!0,e.consoleWrite("do not autoImport, just download file");var a=i.split(";")[1].trim().split("=")[1];e.consoleWrite("header filename1: "+a),a=a.replace('"',""),a=a.replace('"',""),e.consoleWrite("header filename2: "+a),e.consoleWrite("header content-type: "+t.headers("content-type"));var n=new e.$blob([t.data],{type:t.headers("content-type")});e.consoleWrite("executing this.$fileSaver.saveAs(file, fileName)"),e.$fileSaver.saveAs(n,a),e.modalSuccess=!1,e.toggleOverlay()}},function(t){e.errorMsg=t,e.spinner=!1,e.error=!0,e.modalError=!0})},750)}else this.errorMsg="Uh oh! It looks like there was an issue with selecting your file. Try selecting your file again.",this.error=!0,this.modalError=!0,this.fileUploaded=!1}},{key:"jsonBufferToObject",value:function(e,t,i){if(!t("Content-Type").startsWith("application/json"))return e;var a=new TextDecoder("utf-8"),n=a.decode(e);return JSON.parse(n)}},{key:"toggleOverlay",value:function(){this.consoleWrite("upload-signin-sheet.controller.js: toggleOverlay()"),(this.success||this.error)&&window.jQuery(this.overlayID).overlay()}}]),e}();t.default=r},379:function(e,t,i){"use strict";function a(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var n=i(380),r=a(n),s=i(381),o=a(s),l=i(382),c=a(l),d=i(383),u=a(d),p=i(384),h=a(p),f=i(385),v=a(f),y=angular.module("manage-cpe",["720kb.datepicker"]).service("dataManageCpeService",r.default).directive("manageCpe",function(){"ngInject";return{retrict:"EA",controller:o.default,controllerAs:"$ctrl",scope:!0,bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).directive("ngPagination",["$compile",function(e){"ngInject";return{retrict:"A",scope:!1,transclude:!0,link:function(t,i,a){var n=parseInt(a.paginationLimit),r=t.$parent.$tableCpeCtrl.Math.ceil(t.$parent.$tableCpeCtrl.tableCpe.cpeDataDetailsFiltered.length/t.$parent.$tableCpeCtrl.limitResults),s=new Array(r<n?r:n).fill(1),o="",l=function(e,t,i){return'<button class="'+(e[t]===i?"btn-tertiary btn-tertiary--dark btn-tertiary--no-margin":"btn-primary")+' m-right--small" ng-click="$tableCpeCtrl.setCurrentPage('+e[t]+')">'+e[t]+"</button>"};return s=s.reduce(function(e,t,i){return 0===i?e[i]=1:i===s.length-1?e[s.length-1]=r:e[i]=t+i,o+=l(e,i,1),e},[]),t.$watch("$ctrl.filterAppliedToggle",function(a,c){a=1,r=t.$parent.$tableCpeCtrl.Math.ceil(t.$parent.$tableCpeCtrl.tableCpe.cpeDataDetailsFiltered.length/t.$parent.$tableCpeCtrl.limitResults),s=new Array(r<n?r:n).fill(1),o="";var d=t.$parent.$tableCpeCtrl.Math.ceil(n/-2)+a;return o="",s=s.reduce(function(e,i,c){return 0===c?e[c]=1:c===s.length-1?e[s.length-1]=r:d<1?e[c]=1+c:a<=t.$parent.$tableCpeCtrl.Math.ceil(n/-2)+r?e[c]=t.$parent.$tableCpeCtrl.Math.ceil(n/-2)+a+c:e[c]=a+c-s.indexOf(a),o+=l(e,c,a),e},[]),i.html(e(o)(t))}),t.$watch("$tableCpeCtrl.currentPage",function(a,c){if(a===c)return!1;var d=t.$parent.$tableCpeCtrl.Math.ceil(n/-2)+a;return o="",s=s.reduce(function(e,i,c){return 0===c?e[c]=1:c===s.length-1?e[s.length-1]=r:d<1?e[c]=1+c:a<=t.$parent.$tableCpeCtrl.Math.ceil(n/-2)+r?e[c]=t.$parent.$tableCpeCtrl.Math.ceil(n/-2)+a+c:e[c]=a+c-s.indexOf(a),o+=l(e,c,a),e},[]),i.html(e(o)(t))}),i.html(e(o)(t))}}}]).directive("manageCpes",function(){"ngInject";return{retrict:"EA",template:u.default,scope:!1,bindToController:!0,replace:!0}}).directive("manageCpesUnpaginated",function(){"ngInject";return{retrict:"EA",template:v.default,scope:!1,bindToController:!0,replace:!0}}).directive("editCpe",function(){"ngInject";return{retrict:"EA",template:h.default,scope:!1,bindToController:!0,replace:!0}}).directive("tableCpe",function(){"ngInject";return{retrict:"EA",controller:c.default,controllerAs:"$tableCpeCtrl",scope:!0,bindToController:{limitResults:"@",cpeDataDetails:"="},transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)}),e.$on("filterApplied--expand",function(e,t){e.currentScope.$tableCpeCtrl.tableToggle=!1})}}}).directive("formatDate",["dateFilter",function(e){return{require:"ngModel",scope:{format:"<"},link:function(t,i,a,n){n.$parsers.push(function(i){return e(i,t.format)}),n.$formatters.push(function(i){return e(i,t.format)})}}}]).directive("disableArrows",function(){function e(e){38!==e.keyCode&&40!==e.keyCode||e.preventDefault()}return{link:function(t,i,a){i.on("keydown",e)}}}).filter("addColorClass",function(){return function(e,t){var i=angular.element("select > option[value='string:"+t.option.code+"']"),a=t.option.ThemeClass;return i.addClass(a),e}}).filter("convertJsonDate",function(){var e=/\/Date\(([0-9]*)\)\//;return function(t){var i=t.match(e);return i?new Date(parseInt(i[1])):t}}).filter("compareDates",function(){return function(e,t){var i=[];return void 0!==e&&angular.forEach(e,function(e,a){if(""===t.maxDate)i.push(e);else{new Date(e.EndDate)<new Date(t.maxDate)&&i.push(e)}}),i}}).filter("filterByQA",function(){return function(e,t){var i=[];return t?angular.forEach(e,function(e){e.QualifyingActivity===t&&i.push(e)}):i=e,i}}).filter("statusFilter",function(){return function(e,t){var i=[],a="";return void 0!==e&&(isNaN(t.cpeDataStatusFilter)||(a=t.cpeStatus[t.cpeDataStatusFilter]),angular.forEach(e,function(e,n){void 0===e.Status?t.cpeDataStatusFilter&&"1"!==a.code||i.push(e):t.cpeDataStatusFilter&&a.code!==e.Status.toString()&&a.description!==e.Status.toString().toLowerCase()||i.push(e)})),i}}).filter("certificationTypeByTitle",["certificationTypes",function(e){return function(t){var i="";return angular.forEach(e,function(e,a){t.toLowerCase().indexOf(e.certificationType.toLowerCase())>=0&&(i=e.certificationType)}),i}}]).filter("startFrom",function(){return function(e,t){return t=t<0?0:t,e?(t=+t,e.slice(t)):[]}}).filter("rangeSpread",function(){return function(e,t,i){if(void 0!==t&&void 0!==i){var a;if(t=parseInt(t),i=parseInt(i),t===i)return[t];for(a=t<=i?1:-1;t!==i;)e.push(t),a<0&&t===i+1&&e.push(i),a>0&&t===i-1&&e.push(i),t+=a}return e}}).filter("deliveryMethodsByActivity",function(){return function(e,t){var i=[];return null===t||void 0===t?i:(angular.forEach(e,function(e){e.code.split("/")[0]===t&&i.push(e)}),i)}}).name;t.default=y},380:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i){"ngInject";a(this,e),this.$http=t,this.$q=i,this.currentCycleCpeDataTable=[],this.pastCycleDataTable=[],this.notificationsText={},this.notificationsText.UnknownError="An unknown error has occurred",this.notificationsText.CPENotUpdated="CPE not updated",this.notificationsText.CompleteFields="Please complete fields",this.notificationsText.TooManyHours="Too many hours",this.notificationsText.MustHaveHours="Must have hours",this.notificationsText.CPEUpdated="CPE updated",this.notificationsText.CPEDeleted="CPE deleted"}return e.$inject=["$http","$q"],n(e,[{key:"getCPEDetails",value:function(e){}},{key:"getData",value:function(e,t){this.$http.get(e).then(t,function(e){return angular.isObject(e.data)||!e.data.message?this.$q.reject(this.notificationsText.UnknownError):this.$q.reject(e.data.statusText)})}},{key:"updateOrInsertCpe",value:function(e,t,i){var a=this;0===e.indexOf("/assets/")?this.$http.get(e).then(i,function(e){return angular.isObject(e.data)||!e.data.message?(console.log("error: "+JSON.stringify(e.data)),e.message=a.notificationsText.UnknownError,a.$q.reject(e)):a.$q.reject(e.data.statusText)}).catch(function(e){i(e)}):t.Seqn&&t.Seqn>0&&t.ID?this.$http.put(e,t).then(i,function(e){return angular.isObject(e.data)||!e.data.message?(console.log("error: "+JSON.stringify(e.data)),e.message=a.notificationsText.UnknownError,a.$q.reject(e)):a.$q.reject(e.data.statusText)}).catch(function(e){i(e)}):(t.Seqn&&t.Seqn>0&&t.ID,this.$http.post(e,t).then(i,function(e){return angular.isObject(e.data)||!e.data.message?(console.log("error: "+JSON.stringify(e.data)),e.message=a.notificationsText.UnknownError,a.$q.reject(e)):a.$q.reject(e.data.statusText)}).catch(function(e){i(e)}))}},{key:"deleteCpe",value:function(e,t){var i=this;this.$http.delete(e).then(t,function(e){return angular.isObject(e.data)||!e.data.message?(console.log("error: "+JSON.stringify(e.data)),e.message=i.notificationsText.UnknownError,i.$q.reject(e)):i.$q.reject(e.data.statusText)}).catch(function(e){t(e)})}}]),e}();t.default=r},381:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n,r,s,o,l){"ngInject";a(this,e),this.$http=i,this.$window=n,this.$timeout=r,this.dataManageCpeService=s,this.$filter=o,this.$scope=t,this.$scope.cpeEditForm={},this.$location=l,this.fullListOfQualifyingActivities=[],this.fullListOfDeliveryMethods=[],this.relatedDeliveryMethods=[],this.userSpecificCertificationTypes=[],this.cpeDataCertificationTypes=[],this.filterOptionsYear=[],this.filterOptionsCertifications=[],this.filterOptionsSource=[],this.filterOptionsQualifyingActivity=[],this.pastFilterOptionsYear=[],this.pastFilterOptionsCertifications=[],this.pastFilterOptionsSource=[],this.pastFilterOptionsQualifyingActivity=[],this.pastCycleStartYear=0,this.currentCycleEndYear=0,this.currentCycleStartYear=0,this.cpeDataYearFilter="",this.cpeDataQualifyFilter="",this.cpeDataCertificationFilter="",this.cpeDataSourceFilter="",this.pendingCpes=[],this.appliedCpes=[],this.pastCycleDataTable=[],this.controllerName="managecpe",this.errorMessage="",this.spinner=!1,this.error=!1,this.oldestDate="",this.currentYear=(new Date).getFullYear(),this.cpeModalActive="",this.refreshManageCPETables=!1,this.form={},this.currentDate=Date.now(),this.hoursLimit=[],this.cpeData={HoursObj:[]},this.quickAddObj=[],this.csxDisallowedQualifyingActivities="",this.csxHideNotification=!0,this.labels={},this.labels.StartDate="Start Date",this.labels.EndDate="End Date",this.labels.Certification="Certification",this.labels.Title="Title",this.labels.Hours="Hours",this.labels.Source="Source",this.labels.Actions="Actions",this.labels.EntryDetails="Entry Details",this.labels.CpeId="CPE ID",this.labels.CreatedBy="Created By",this.labels.CpeStartDate="CPE Start Date",this.labels.CpeEndDate="CPE End Date",this.labels.CreatedDate="Created Date",this.labels.Activity="Activity",this.labels.QualifyingActivity="Qualifying Activity",this.labels.MethodOfDelivery="Method of Delivery",this.labels.Sponsor="Sponsoring Organization",this.labels.MaximumCpeHoursAvailable="Maximum CPE Hours Available",this.labels.DeleteConfirmationMessage="Are you sure you want to delete this CPE entry?",this.labels.Confirm="Confirm",this.labels.Decline="Decline",this.labels.Apply="Apply CPE to Certification",this.labels.Edit="Edit",this.labels.Delete="Delete",this.labels.Locked="Locked",this.notificationsText=[],this.notificationsText.UknownError="An unknown error has occurred",this.notificationsText.FormConnectivityError="There was an error posting your data to our server.  Please ensure your browser, computer, and/or network are not blocking the request.",this.notificationsText.FormServerError="There was an error processing your data on our server.  Please submit the form at a later date or contact customer service.",this.notificationsText.CPENotUpdated="CPE not updated",this.notificationsText.CompleteFields="Please complete fields",this.notificationsText.TooManyHours="You have entered more than the maximum allowed hours ({0}) for this CPE entry. Verify the number of hours entered is correct.",this.notificationsText.MustHaveHours="Must have hours",this.notificationsText.CPEUpdated="CPE updated",this.notificationsText.CPEDeleted="CPE deleted",this.notificationsText.TitleRequired="Title/Description is required",this.notificationsText.OrganizationRequired="Sponsoring Organization is required",this.notificationsText.StartDateRequired="Start Date is required",this.notificationsText.StartDateInFuture="Start Date cannot be in the future",this.notificationsText.StartDateOutOfBounds="Start Date must be within your current cycle",this.notificationsText.EndDateRequired="End Date is required",this.notificationsText.EndDateInFuture="End Date cannot be in the future",this.notificationsText.EndDateOutOfBounds="End Date must be within your current cycle",this.notificationsText.EndBeforeStart="End Date must be after Start Date",this.notificationsText.ActivityRequired="Qualifying Activity is required",this.notificationsText.MethodRequired="Method of Delivery is required",this.notificationsText.CantEnterWhileUnpaid='You are unable to enter/apply CPE for this year and you still have outstanding maintenance fees. Please visit <a href="/myisaca/certifications">https://www.isaca.org/myisaca/certifications</a> to view your invoice and make payment.',this.notificationsText.HoursDisabledDefault="Qualifying Activity does not apply to this certification",this.notificationsText.HoursDisabledEndDate="End Date does not apply to this certification",this.notificationsText.HoursDisabledNonPracticing="You do not owe cpe at this time due to non-practicing status",this.validity={},this.validity.titleRequired="titleRequired",this.validity.organizationRequired="organizationRequired",this.validity.startDateRequired="startDateRequired",this.validity.startOutOfBounds="startOutOfBounds",this.validity.endDateRequired="endDateRequired",this.validity.endOutOfBounds="endOutOfBounds",this.validity.endBeforeStart="endBeforeStart",this.validity.activityRequired="activityRequired",this.validity.methodRequired="methodRequired",this.isPastCyclesLoaded=!1,this.loadCurrentCycleCpeDataTableOnInit=!1,this.lazyLoadPastCycles=!0,this.filterAppliedToggle=!1,this.manageCpeSitecoreItem={},this.defaultMaxHours=400,this.showModalMessage=!1,this.defaultLoginUrl="/home/login",this.unauthorizedStatusCode=401,this.loggedInUserFullName=""}return e.$inject=["$scope","$http","$window","$timeout","dataManageCpeService","$filter","$location"],n(e,[{key:"$onInit",value:function(){var e=this;this.$timeout(function(){e.loadCurrentCycleCpeDataTableOnInit&&e.loadCurrentCycleCpeDataTables(),e.lazyLoadPastCycles?e.isPastCyclesLoaded=!1:e.loadPastCycleDataTable()},200)}},{key:"init",value:function(e,t,i,a,n,r,s,o){this.hoursLimit=[],this.NonPracticingCertifications=[],this.fullListOfQualifyingActivities=t,this.fullListOfDeliveryMethods=this.relatedDeliveryMethods=i,this.userSpecificCertificationTypes=e,this.pastCycleStartYear=a,this.currentCycleEndYear=r,this.currentCycleStartYear=n,this.loggedInUserFullName=s,o.UnkownError&&(this.notificationsText.UnkownError=o.UnkownError),o.CpeNotUpdated&&(this.notificationsText.CPENotUpdated=o.CpeNotUpdated),o.CompleteFields&&(this.notificationsText.CompleteFields=o.CompleteFields),o.TooManyHours&&(this.notificationsText.TooManyHours=o.TooManyHours),o.MustHaveHours&&(this.notificationsText.MustHaveHours=o.MustHaveHours),o.CpeUpdated&&(this.notificationsText.CPEUpdated=o.CpeUpdated),o.CpeDeleted&&(this.notificationsText.CPEDeleted=o.CpeDeleted),o.TitleRequired&&(this.notificationsText.TitleRequired=o.TitleRequired),o.OrganizationRequired&&(this.notificationsText.OrganizationRequired=o.OrganizationRequired),o.StartDateRequired&&(this.notificationsText.StartDateRequired=o.StartDateRequired),o.StartDateInFuture&&(this.notificationsText.StartDateInFuture=o.StartDateInFuture),o.StartDateOutOfBounds&&(this.notificationsText.StartDateOutOfBounds=o.StartDateOutOfBounds),o.EndDateRequired&&(this.notificationsText.EndDateRequired=o.EndDateRequired),o.EndDateInFuture&&(this.notificationsText.EndDateInFuture=o.EndDateInFuture),o.EndDateOutOfBounds&&(this.notificationsText.EndDateOutOfBounds=o.EndDateOutOfBounds),o.EndBeforeStart&&(this.notificationsText.EndBeforeStart=o.EndBeforeStart),o.ActivityRequired&&(this.notificationsText.ActivityRequired=o.ActivityRequired),o.MethodRequired&&(this.notificationsText.MethodRequired=o.MethodRequired),o.StartDate&&(this.labels.StartDate=o.StartDate),o.Certification&&(this.labels.Certification=o.Certification),o.Title&&(this.labels.Title=o.Title),o.Hours&&(this.labels.Hours=o.Hours),o.SourceTable&&(this.labels.SourceTable=o.SourceTable),o.Actions&&(this.labels.Actions=o.Actions),o.EntryDetails&&(this.labels.EntryDetails=o.EntryDetails),o.CPEID&&(this.labels.CpeId=o.CPEID),o.CreatedBy&&(this.labels.CreatedBy=o.CreatedBy),o.CPEStartDate&&(this.labels.CpeStartDate=o.CPEStartDate),o.CPEEndDate&&(this.labels.CpeEndDate=o.CPEEndDate),o.CreatedDate&&(this.labels.CreatedDate=o.CreatedDate),o.Activity&&(this.labels.Activity=o.Activity),o.QualifyingActivityTable&&(this.labels.QualifyingActivity=o.QualifyingActivityTable),o.MethodOfDelivery&&(this.labels.MethodOfDelivery=o.MethodOfDelivery),o.Sponsor&&(this.labels.Sponsor=o.Sponsor),o.MaximumCPEHoursAvailable&&(this.labels.MaximumCpeHoursAvailable=o.MaximumCPEHoursAvailable),o.DeleteConfirmationMessage&&(this.labels.DeleteConfirmationMessage=o.DeleteConfirmationMessage),o.ConfirmLabel&&(this.labels.Confirm=o.ConfirmLabel),o.DeclineLabel&&(this.labels.Decline=o.DeclineLabel),o.ApplyLabel&&(this.labels.Apply=o.ApplyLabel),o.EditCPELabel&&(this.labels.Edit=o.EditCPELabel),o.DeleteCPELabel&&(this.labels.Delete=o.DeleteCPELabel),o.LockedLabel&&(this.labels.Locked=o.LockedLabel)}},{key:"initCpeTableData",value:function(e,t){angular.forEach(e,function(e,t){e.CertificationType="",e.Hours=e.MaxHoursAvailable}),this.pendingCpes=e,this.appliedCpes=t,this.resetFilterOptions()}},{key:"redirectToLoginAndAppendReturnUrl",value:function(e){e&&0!==e.length||(e=this.defaultLoginUrl);var t=e+"?returnUrl="+encodeURI(this.$window.location.pathname);console.log("session timed out, redirect to: "+t)}},{key:"loadCurrentCycleCpeDataTables",value:function(){this.loadUnappliedCpeDataTable(),this.loadAppliedCpeDataTable()}},{key:"loadUnappliedCpeDataTable",value:function(){var e=this;this.spinner=!0;this.$timeout(function(){e.$http({url:"/api/ManageCPE/GetUnappliedCPEs",method:"GET"}).then(function(t){200===t.status&&t.data&&t.data.length>0?(console.log("fetched "+e.checkArrayLength(t.data)+" 'Unapplied/Pending CPE' item(s)"),e.appliedCpes=t.data,e.resetFilterOptions(),e.error=!1):(e.errorMessage=t.data,e.error=!0),e.spinner=!1},function(t){e.errorMessage="There was an error fetching your data.",e.spinner=!1,e.error=!0,console.log(t)})},0)}},{key:"loadAppliedCpeDataTable",value:function(){var e=this;this.spinner=!0;this.$timeout(function(){e.$http({url:"/api/ManageCPE/GetPastCpes",method:"GET"}).then(function(t){200===t.status&&t.data&&t.data.length>0?(console.log("fetched "+e.checkArrayLength(t.data)+" 'Applied CPE' item(s)"),e.appliedCpes=t.data,e.resetFilterOptions(),e.error=!1):(e.errorMessage=t.data,e.error=!0),e.spinner=!1},function(t){e.errorMessage="There was an error fetching your data.",e.spinner=!1,e.error=!0,console.log(t)})},0)}},{key:"loadPastCycleDataTable",value:function(){var e=this;this.spinner=!0;this.$timeout(function(){e.$http({url:"/api/ManageCPE/GetPastCpes",method:"GET"}).then(function(t){200===t.status&&t.data.Success?(e.pastCycleDataTable=t.data.result,e.pastCycleDataTable.filter(function(t){return!e.pastFilterOptionsCertifications.find(function(e){return e===t.CertificationType})&&(e.pastFilterOptionsCertifications.push(t.CertificationType),!0)}),e.pastCycleDataTable.filter(function(t){var i=new Date(t.EndDate).getFullYear().toString();return!e.pastFilterOptionsYear.find(function(e){return e===i})&&(e.pastFilterOptionsYear.push(i),!0)}),e.pastCycleDataTable.filter(function(t){return!e.pastFilterOptionsSource.find(function(e){return e===t.OriginatingSource})&&(e.pastFilterOptionsSource.push(t.OriginatingSource),!0)}),e.pastCycleDataTable.filter(function(t){if(e.pastFilterOptionsQualifyingActivity.find(function(e){return e.code===t.QualifyingActivity}))return!1;var i=e.fullListOfQualifyingActivities.find(function(e){return e.code===t.QualifyingActivity});return i&&e.pastFilterOptionsQualifyingActivity.push(i),!0}),e.isPastCyclesLoaded=!0,e.error=!1):t.status===e.unauthorizedStatusCode?e.redirectToLoginAndAppendReturnUrl(t.data.LogOnUrl):(e.errorMessage=t.data,e.error=!0),e.spinner=!1},function(t){e.errorMessage="There was an error fetching your data.",e.spinner=!1,e.error=!0,console.log(t),t.status===e.unauthorizedStatusCode&&e.redirectToLoginAndAppendReturnUrl(t.data.LogOnUrl)})},0)}},{key:"toggleSpinner",value:function(){this.spinner=!this.spinner}},{key:"applyFilters",value:function(){this.cpeDataYearFilter=angular.copy(this.cpeDataYearFilterEditing),this.cpeDataCertificationFilter=angular.copy(this.cpeDataCertificationFilterEditing),this.cpeDataSourceFilter=angular.copy(this.cpeDataSourceFilterEditing),this.cpeDataQualifyFilter=angular.copy(this.cpeDataQualifyFilterEditing),this.expandAllTables()&&this.$scope.$broadcast("filterApplied--expand"),this.filterAppliedToggle=!this.filterAppliedToggle,this.$scope.$broadcast("filterApplied")}},{key:"expandAllTables",value:function(){if(2===window.jQuery(".manage-cpe__toggle").length){var e=window.jQuery(".manage-cpe__toggle")[0].classList.contains("manage-cpe__toggle--hide"),t=window.jQuery(".manage-cpe__toggle")[1].classList.contains("manage-cpe__toggle--hide");if(e&&t)return!0}return!1}},{key:"clearFilters",value:function(){this.cpeDataYearFilterEditing="",this.cpeDataQualifyFilterEditing="",this.cpeDataCertificationFilterEditing="",this.cpeDataSourceFilterEditing="",this.applyFilters()}},{key:"clearForms",value:function(){this.$scope.cpeAddForm.cpeTitle.$setValidity(this.validity.titleRequired,!0),this.$scope.cpeAddForm.cpeSponsoring.$setValidity(this.validity.organizationRequired,!0),this.$scope.cpeAddForm.cpeStartDate.$setValidity(this.validity.startDateRequired,!0),this.$scope.cpeAddForm.cpeStartDate.$setValidity(this.validity.startOutOfBounds,!0),this.$scope.cpeAddForm.cpeEndDate.$setValidity(this.validity.endDateRequired,!0),this.$scope.cpeAddForm.cpeEndDate.$setValidity(this.validity.endOutOfBounds,!0),this.$scope.cpeAddForm.cpeEndDate.$setValidity(this.validity.endBeforeStart,!0),this.$scope.cpeAddForm.cpeQualifyingActivity.$setValidity(this.validity.activityRequired,!0),this.$scope.cpeAddForm.cpeMethodOfDelivery.$setValidity(this.validity.methodRequired,!0),this.$scope.cpeEditForm.cpeTitle.$setValidity(this.validity.titleRequired,!0),this.$scope.cpeEditForm.cpeSponsoring.$setValidity(this.validity.organizationRequired,!0),this.$scope.cpeEditForm.cpeStartDate.$setValidity(this.validity.startDateRequired,!0),this.$scope.cpeEditForm.cpeStartDate.$setValidity(this.validity.startOutOfBounds,!0),this.$scope.cpeEditForm.cpeEndDate.$setValidity(this.validity.endDateRequired,!0),this.$scope.cpeEditForm.cpeEndDate.$setValidity(this.validity.endOutOfBounds,!0),this.$scope.cpeEditForm.cpeEndDate.$setValidity(this.validity.endBeforeStart,!0),this.$scope.cpeEditForm.cpeQualifyingActivity.$setValidity(this.validity.activityRequired,!0),this.$scope.cpeEditForm.cpeMethodOfDelivery.$setValidity(this.validity.methodRequired,!0),this.cpeData={HoursObj:[],MaxHoursAvailable:this.defaultMaxHours},this.HoursObj=[],this.cpeDetail={},this.notificationError=!1,this.cpeCertNotifications=!1,this.hasOwnProperty("cpeDetail")&&(this.cpeDetail.errors=[]),this.$scope.cpeAddForm.$setPristine(),this.$scope.cpeAddForm.$setUntouched(),this.$scope.cpeAddForm.$setValidity(),this.$scope.cpeEditForm.$setPristine(),this.$scope.cpeEditForm.$setUntouched(),this.$scope.cpeEditForm.$setValidity(),window.jQuery("input.input--error").removeClass("input--error"),window.jQuery("input.input--filled").removeClass("input--filled"),window.jQuery("input.input--valid").removeClass("input--valid"),window.jQuery("select.input--error").removeClass("input--error"),window.jQuery("select.input-text--filled").removeClass("input-text--filled"),window.jQuery("label.label--text--error").removeClass("label--text--error"),window.jQuery("label.label-text--error").removeClass("label-text--error"),window.jQuery("span.control-clear:not(.control-clear--hide)").addClass("control-clear--hide"),angular.forEach(this.cpeDataCertificationTypes,function(e,t){e.disableHoursInput&&(e.disableHoursInput=!1)}),this.scrollTopOfCpeModal()}},{key:"activityChange",value:function(e){this.setMaxHoursCertTypeByQA(),this.checkMaxHours(),1===this.fullListOfDeliveryMethods.length&&(this.cpeData.MethodOfDelivery=this.fullListOfDeliveryMethods[0].code),this.csxHideNotification=-1===this.csxDisallowedQualifyingActivities.indexOf(e),this.cpeData.QualActCategory=this.setEditingQualActCategory(e),this.$scope.cpeAddForm.cpeQualifyingActivity.$setValidity(this.validity.activityRequired,!0),this.removeError(this.notificationsText.ActivityRequired),window.jQuery('select[name="cpeQualifyingActivity"]').removeClass("input--error").addClass("input--valid"),window.jQuery('label[name="cpeQualifyingActivity"]').removeClass("label-text--error"),angular.forEach(this.cpeDataCertificationTypes,function(t,i){if(t.disallowedQualifyingActivities.indexOf(e)>-1){t.disableHoursInput=!0,t.disableHoursInputText=this.notificationsText.HoursDisabledDefault;var a=window.jQuery("#cpe-addapply-hours-"+t.certificationType);a&&a.length>0&&(a.val("0"),this.cpeData.HoursObj&&(this.cpeData.HoursObj[i]=0));var n=window.jQuery("#cpe-edit-hours-"+t.certificationType);n&&n.length>0&&(n.val("0"),this.cpeData.Hours=0)}else t.disableHoursInput=!1},this)}},{key:"methodChange",value:function(){this.$scope.cpeAddForm.cpeMethodOfDelivery.$setValidity(this.validity.methodRequired,!0),this.removeError(this.notificationsText.MethodRequired),window.jQuery('select[name="cpeMethodOfDelivery"]').removeClass("input--error").addClass("input--valid"),window.jQuery('label[name="cpeDelivery"]').removeClass("label-text--error")}},{key:"disableMethod",value:function(e){var t=!1;return this.cpeData.QualifyingActivity&&e.qualifyingActivities&&e.qualifyingActivities.indexOf(this.cpeData.QualifyingActivity)<0&&(t=!0),t}},{key:"checkArrayLength",value:function(e){return e?e&&window.jQuery.isArray(e)?e.length:"1 object":"undefined"}},{key:"openAddCpeModal",value:function(){this.cpeModalActive="add",this.cpeData={HoursObj:[],MaxHoursAvailable:this.defaultMaxHours},this.setMaxHoursCertTypeByQA(),this.checkMaxHours(),this.cpeDataCertificationTypes=angular.copy(this.userSpecificCertificationTypes),angular.forEach(this.cpeDataCertificationTypes,function(e,t){this.cpeData.HoursObj[t]=0,"CSX-P"===e.certificationType&&(this.csxDisallowedQualifyingActivities=e.disallowedQualifyingActivities),e.disableHoursInputText=this.notificationsText.HoursDisabledDefault},this),angular.forEach(this.cpeDataCertificationTypes,function(e,t){this.cpeData.HoursObj[t]=0},this),document.querySelector("body").classList.add("tingle-enabled"),this.pauseVideo()}},{key:"openApplyCpeModal",value:function(e){if(this.cpeModalActive="apply",this.cpeData=angular.copy(e),this.cpeData.StartDate){var t=new Date(this.cpeData.StartDate);this.cpeData.StartDate=t.getUTCMonth()+1+"/"+t.getUTCDate()+"/"+t.getUTCFullYear()}if(this.cpeData.EndDate){var i=new Date(this.cpeData.EndDate);this.cpeData.EndDate=i.getUTCMonth()+1+"/"+i.getUTCDate()+"/"+i.getUTCFullYear()}this.cpeData.DerivedFromItem=this.cpeData.Seqn,this.activityChange(),this.cpeData.QualActCategory=this.setEditingQualActCategory(this.cpeData.QualifyingActivity),this.cpeData.MethodOfDelivery=this.setEditingMethodOfDelivery(this.cpeData.MethodOfDelivery),this.cpeData.HoursObj=[],this.cpeDataCertificationTypes=angular.copy(this.userSpecificCertificationTypes);for(var a=0;a<this.cpeDataCertificationTypes.length;a++)this.cpeData.HoursObj[a]=0;document.querySelector("body").classList.add("tingle-enabled"),this.setMaxHoursCertTypeByQA(),this.checkMaxHours(),this.pauseVideo(),angular.forEach(this.cpeDataCertificationTypes,function(e,t){var i=new Date(e.PaidThru),a=i.getUTCMonth()+1+"/"+i.getUTCDate()+"/"+i.getUTCFullYear();e.PaidThru&&new Date(this.cpeData.EndDate.toString())>new Date(a)?(e.disableHoursInput=!0,e.description=this.notificationsText.CantEnterWhileUnpaid,e.disableHoursInputText=this.notificationsText.HoursDisabledEndDate):e.disableHoursInputText=this.notificationsText.HoursDisabledDefault},this)}},{key:"openEditCpeModal",value:function(e){if(this.cpeModalActive="edit",this.HoursObj=[e.Hours],this.cpeData=angular.copy(e),this.cpeData.DerivedFromItem&&0!==this.cpeData.DerivedFromItem.length&&"0"!==this.cpeData.DerivedFromItem||(this.cpeData.MaxHoursAvailable=this.defaultMaxHours),this.cpeData.StartDate){var t=new Date(this.cpeData.StartDate);this.cpeData.StartDate=t.getUTCMonth()+1+"/"+t.getUTCDate()+"/"+t.getUTCFullYear()}if(this.cpeData.EndDate){var i=new Date(this.cpeData.EndDate);this.cpeData.EndDate=i.getUTCMonth()+1+"/"+i.getUTCDate()+"/"+i.getUTCFullYear()}this.cpeData.MethodOfDelivery=this.setEditingMethodOfDelivery(this.cpeData.MethodOfDelivery),this.setEditingCertifcationType(this.cpeData.CertificationType),this.hasOwnProperty("cpeDetail")&&(this.cpeDetail.errors=[]),this.activityChange(),document.querySelector("body").classList.add("tingle-enabled"),this.setMaxHoursCertTypeByQA(),this.checkMaxHours(),this.pauseVideo()}},{key:"getQualifyingActivityDisplay",value:function(e){var t=e,i=this.fullListOfQualifyingActivities.find(function(t){return t.code===e});return i&&(t=i.description),t}},{key:"getMethodOfDeliveryDisplay",value:function(e){e=this.setEditingMethodOfDelivery(e);var t=e,i=this.fullListOfDeliveryMethods.find(function(t){return t.code===e});return i&&(t=i.description),t}},{key:"setEditingQualActCategory",value:function(e){var t="",i=this.fullListOfQualifyingActivities.find(function(t){return t.code===e});return i&&(t=i.code),t}},{key:"setEditingMethodOfDelivery",value:function(e){var t=e;if(e){var i=e.indexOf("/");i>-1&&(t=e.substring(i+1))}return t}},{key:"setEditingCertifcationType",value:function(e){this.cpeDataCertificationTypes=[];var t=this;t.certType=e,angular.forEach(this.userSpecificCertificationTypes,function(e,i){e.certificationType===t.certType&&t.cpeDataCertificationTypes.push(e)},t)}},{key:"postCpe",value:function(e,t,i){var a=angular.copy(t),n=a.Seqn&&a.Seqn.length>0&&"0"!==a.Seqn,r=n&&(!a.ID||!a.CertificationType),s=n&&!r;if(this.HoursObj&&this.HoursObj.length>0&&(a.HoursObj=this.HoursObj),this.cpeCertNotifications=!1,this.removeErrors(),!this.validate(e)){window.app.hideLoading(),this.scrollTopOfCpeModal();var o=this.cpeData.QualifyingActivity;return angular.forEach(this.cpeDataCertificationTypes,function(e,t){if(e.disallowedQualifyingActivities.indexOf(o)>-1){e.disableHoursInput=!0,e.disableHoursInputText=this.notificationsText.HoursDisabledDefault;var i=window.jQuery("#cpe-addapply-hours-"+e.certificationType);i&&i.length>0&&(i.val("0"),this.cpeData.HoursObj&&(this.cpeData.HoursObj[t]=0));var a=window.jQuery("#cpe-edit-hours-"+e.certificationType);a&&a.length>0&&(a.val("0"),this.cpeData.Hours=0)}else e.disableHoursInput=!1},this),!1}if(this.cpeDetail.errors=[this.notificationsText.CompleteFields],window.app.showLoading(),s&&a.CertificationType)a.HoursObj=[],a.HoursObj.push({CertificationType:a.CertificationType,Hours:this.HoursObj[0]});else if(angular.isArray(a.HoursObj)){var l=angular.copy(a.HoursObj);a.HoursObj=[];var c=0;angular.forEach(this.userSpecificCertificationTypes,function(e){-1===e.disallowedQualifyingActivities.indexOf(a.QualifyingActivity)&&a.HoursObj.push({CertificationType:e.certificationType,Hours:l[c]}),c++})}this.form=angular.element(document.getElementsByName("cpeAddForm")[0]);var d="",u={};s?(d="/api/managecpe/EditCPE",u.Seqn=a.Seqn,a.OriginatingSource&&(u.OriginatingSource=a.OriginatingSource)):r?(d="/api/managecpe/ApplyCPE",u.Seqn=a.Seqn,a.OriginatingSource?u.OriginatingSource=a.OriginatingSource:u.OriginatingSource="ISACA"):(d="/api/managecpe/AddCPE",u.Seqn="0"),u.ID=a.ID,u.Title=a.Title,u.SponsoringOrganization=a.SponsoringOrganization,u.DerivedFromItem=a.DerivedFromItem,u.StartDate=a.StartDate,u.EarnedDate=a.EndDate,u.QualifyingActivity=a.QualifyingActivity;var p=this.fullListOfQualifyingActivities.find(function(e){return e.code===a.QualifyingActivity});p&&p.code&&(u.QualActCategory=p.code),u.MethodOfDelivery=a.MethodOfDelivery,u.MaxHoursAvailable=a.MaxHoursAvailable,u.CertificationsHours=[],angular.forEach(a.HoursObj,function(e,t){var i={};i.Key=e.CertificationType,i.Value=e.Hours,u.CertificationsHours.push(i)});var h=this;this.dataManageCpeService.updateOrInsertCpe(d,u,function(e){200===e.status&&e.data.Success?void 0!==i&&i?(window.app.hideLoading(),h.cpeData={HoursObj:[]},h.HoursObj=[],h.clearForms(),h.openAddCpeModal()):window.location.reload():e.status===h.unauthorizedStatusCode?h.redirectToLoginAndAppendReturnUrl(e.data.LogOnUrl):(window.app.hideLoading(),h.showModalMessage&&(window.app.showModalMessage(h.notificationsText.CPENotUpdated,"modal-message__wrapper--error"),h.$timeout(function(){window.app.hideModalMessage()},2500)),e.data&&e.data.errors?h.cpeDetail.errors=e.data.errors:e.data.result?h.cpeDetail.errors=[e.data.result]:e.status&&500===e.status?h.cpeDetail.errors=[h.notificationsText.FormServerError]:h.cpeDetail.errors=[h.notificationsText.FormConnectivityError],h.notificationError=!0,h.scrollTopOfCpeModal())})}},{key:"scrollTopOfCpeModal",value:function(){window.scrollTo(0,0)}},{key:"isShortDateDifferent",value:function(e,t){return new Date(e).toDateString()!==new Date(t).toDateString()}},{key:"addFilterOptionCertification",value:function(e){if(e.CgeitHours){!this.filterOptionsCertifications.find(function(e){return"CGEIT"===e})&&this.filterOptionsCertifications.push("CGEIT")}if(e.CisaHours){!this.filterOptionsCertifications.find(function(e){return"CISA"===e})&&this.filterOptionsCertifications.push("CISA")}if(e.CismHours){!this.filterOptionsCertifications.find(function(e){return"CISM"===e})&&this.filterOptionsCertifications.push("CISM")}if(e.CriscHours){!this.filterOptionsCertifications.find(function(e){return"CRISC"===e})&&this.filterOptionsCertifications.push("CRISC")}if(e.CsxpHours){!this.filterOptionsCertifications.find(function(e){return"CSX-P"===e})&&this.filterOptionsCertifications.push("CSX-P")}if(e.CdpseHours){!this.filterOptionsCertifications.find(function(e){return"CDPSE"===e})&&this.filterOptionsCertifications.push("CDPSE")}}},{key:"addFilterOptionYear",value:function(e){!this.filterOptionsYear.find(function(t){return t===e.toString()})&&this.filterOptionsYear.push(e.toString())}},{key:"addFilterOptionSource",value:function(e){if(e){!this.filterOptionsSource.find(function(t){return t===e})&&this.filterOptionsSource.push(e)}}},{key:"addFilterOptionQualifyingActivity",value:function(e){if(!this.filterOptionsQualifyingActivity.find(function(t){return t.code===e})){var t=this.fullListOfQualifyingActivities.find(function(t){return t.code===e});t&&this.filterOptionsQualifyingActivity.push(t)}}},{key:"resetFilterOptions",value:function(){this.filterOptionsCertifications=[],this.filterOptionsYear=[],this.filterOptionsSource=[],this.filterOptionsQualifyingActivity=[];var e=this;angular.forEach(this.pendingCpes,function(t){var i=new Date(t.EndDate).getFullYear().toString();if(e.filterOptionsYear.find(function(e){return e===i})||e.filterOptionsYear.push(i),e.filterOptionsSource.find(function(e){return"ISACA"===e})||e.filterOptionsSource.push("ISACA"),!e.filterOptionsQualifyingActivity.find(function(e){return e.code===t.QualifyingActivity})){var a=e.fullListOfQualifyingActivities.find(function(e){return e.code===t.QualifyingActivity});a&&e.filterOptionsQualifyingActivity.push(a)}}),angular.forEach(this.appliedCpes,function(t){var i=new Date(t.EndDate).getFullYear().toString();if(e.filterOptionsCertifications.find(function(e){return e===t.CertificationType})||e.filterOptionsCertifications.push(t.CertificationType),e.filterOptionsYear.find(function(e){return e===i})||e.filterOptionsYear.push(i),e.filterOptionsSource.find(function(e){return e===t.OriginatingSource})||e.filterOptionsSource.push(t.OriginatingSource),!e.filterOptionsQualifyingActivity.find(function(e){return e.code===t.QualifyingActivity})){var a=e.fullListOfQualifyingActivities.find(function(e){return e.code===t.QualifyingActivity});a&&e.filterOptionsQualifyingActivity.push(a)}})}},{key:"openDeleteCpePopup",value:function(e){this.cpeData=e,this.cpeModalActive="delete"}},{key:"deleteCpe",value:function(e){this.cpeData=e;var t=window.jQuery("#table-cpe__delete_popup").data("endpoint"),i=this;this.dataManageCpeService.deleteCpe(t+"?seqn="+e.Seqn+"&id="+e.ID,function(e){var t=i.appliedCpes.indexOf(i.cpeData);200===e.status&&e.data.Success?(i.appliedCpes.splice(t,1),i.closeActiveModal(i.$scope.$$childTail),i.filterAppliedToggle=!i.filterAppliedToggle,i.resetFilterOptions(),i.$scope.$broadcast("cpeDeleted"),i.showModalMessage&&(window.app.showModalMessage(i.notificationsText.CPEDeleted,"modal-message__wrapper--success"),i.$timeout(function(){window.app.hideModalMessage()},2500))):e.status===i.unauthorizedStatusCode?i.redirectToLoginAndAppendReturnUrl(e.data.LogOnUrl):(window.app.hideLoading(),i.showModalMessage&&(window.app.showModalMessage(i.notificationsText.CPENotUpdated,"modal-message__wrapper--error"),i.$timeout(function(){window.app.hideModalMessage()},2500)),e.data&&e.data.errors?i.cpeDetail&&(i.cpeDetail.errors=e.data.errors):i.cpeDetail&&(i.cpeDetail.errors=[e.data.result]),i.notificationError=!0,i.closeActiveModal(i.$scope.$$childTail))})}},{key:"setMaxHoursCertTypeByQA",value:function(){var e=(new Date).getFullYear();this.cpeData.EndDate&&(e=new Date(this.cpeData.EndDate).getFullYear()),angular.forEach(this.userSpecificCertificationTypes,function(t,i){if(this.cpeData.QualifyingActivity){var a=e+"-"+t.certificationType+"-"+t.limitType+"-"+this.cpeData.QualifyingActivity,n=Object.keys(this.hoursLimit).map(function(e){return this.hoursLimit[e]}),r=n.filter(function(e){return e.name===a});r.length>0?t.maxHoursByQA=r[0].maximumHours:t.maxHoursByQA=""}else t.maxHoursByQA=""},this)}},{key:"checkMaxHours",value:function(e){var t=!1;"edit"===e?this.cpeDataCertificationTypes[0].maxHoursByQA&&this.cpeData.Hours&&this.cpeData.Hours>this.cpeDataCertificationTypes[0].maxHoursByQA&&(t=!0):angular.forEach(this.cpeData.HoursObj,function(e,i){this.userSpecificCertificationTypes[i].maxHoursByQA&&e>this.userSpecificCertificationTypes[i].maxHoursByQA&&(t=!0)},this),this.showMaxHoursNotification=t}},{key:"pauseVideo",value:function(){var e=document.querySelector("#player");e&&e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}',"*")}},{key:"closeActiveModal",value:function(e){window.location.reload()}},{key:"certStatusChange",value:function(){var e=this.cpeData.QualifyingActivity;this.cpeDataCertificationTypes=angular.copy(this.userSpecificCertificationTypes),angular.forEach(this.cpeDataCertificationTypes,function(t,i){if("NON-PRACTICING"===t.CertStatus)this.cpeData.HoursObj[i]=0,t.disableHoursInput=!0,t.disableHoursInputText=this.notificationsText.HoursDisabledNonPracticing;else if(t.disallowedQualifyingActivities.indexOf(e)>-1){t.disableHoursInput=!0,t.disableHoursInputText=this.notificationsText.HoursDisabledDefault;var a=window.jQuery("#cpe-addapply-hours-"+t.certificationType);a&&a.length>0&&(a.val("0"),this.cpeData.HoursObj[i]=0);var n=window.jQuery("#cpe-edit-hours-"+t.certificationType);n&&n.length>0&&(n.val("0"),this.cpeData.HoursObj[i]=0)}else t.disableHoursInput=!1},this)}},{key:"isNonPracticing",value:function(e){for(var t=0;t<this.userSpecificCertificationTypes.length;t++)if("NON-PRACTICING"===this.userSpecificCertificationTypes[t].CertStatus&&this.userSpecificCertificationTypes[t].certificationType===e)return this.NonPracticingCertifications.push(this.userSpecificCertificationTypes[t].certificationType),!0}},{key:"loadPastCycles",value:function(){this.isPastCyclesLoaded||(this.spinner=!0,this.$timeout(function(){this.loadPastCycleDataTable()}.bind(this),0))}},{key:"initializeCpeDetailErrors",value:function(){this.hasOwnProperty("cpeDetail")||(this.cpeDetail={}),this.cpeDetail.hasOwnProperty("errors")&&void 0!==this.cpeDetail.errors||(this.cpeDetail.errors=[])}},{key:"addError",value:function(e){this.initializeCpeDetailErrors(),this.cpeDetail.errors.indexOf(e)<0&&this.cpeDetail.errors.push(e),this.notificationError=!0}},{key:"removeError",value:function(e){this.initializeCpeDetailErrors(),this.cpeDetail.errors.indexOf(e)>=0&&this.cpeDetail.errors.splice(this.cpeDetail.errors.indexOf(e),1),this.cpeDetail.errors&&0!==this.cpeDetail.errors.length||(this.notificationError=!1)}},{key:"removeErrors",value:function(){this.initializeCpeDetailErrors(),this.cpeDetail.errors=[],this.notificationError=!1}},{key:"validate",value:function(e){var t=!0;return this.hasOwnProperty("cpeDetail")&&this.cpeDetail.hasOwnProperty("errors")&&void 0!==this.cpeDetail.errors&&this.cpeDetail.errors.length>0?t=!1:!0===this.notificationError?t=!1:(t=this.validateTitle(e)&&t,t=this.validateOrganization(e)&&t,t=this.validateStartDate(e)&&t,t=this.validateEndDate(e)&&t,t=this.validateActivity(e)&&t,t=this.validateMethod(e)&&t,t=this.validateHoursEntered(e)&&t),t}},{key:"validateTitle",value:function(e){return void 0!==this.cpeData.Title&&this.cpeData.Title?(this.$scope[e].cpeTitle.$setValidity(this.validity.titleRequired,!0),this.removeError(this.notificationsText.TitleRequired),window.jQuery('input[name="cpeTitle"]').removeClass("input--error"),window.jQuery('label[name="cpeTitle"]').removeClass("label-text--error"),!0):(this.$scope[e].cpeTitle.$setValidity(this.validity.titleRequired,!1),this.addError(this.notificationsText.TitleRequired),window.app.hideLoading(),!1)}},{key:"validateOrganization",value:function(e){return void 0!==this.cpeData.SponsoringOrganization&&this.cpeData.SponsoringOrganization?(this.$scope[e].cpeSponsoring.$setValidity(this.validity.organizationRequired,!0),this.removeError(this.notificationsText.OrganizationRequired),window.jQuery('input[name="cpeSponsoring"]').removeClass("input--error"),window.jQuery('label[name="cpeSponsoring"]').removeClass("label-text--error"),!0):(this.$scope[e].cpeSponsoring.$setValidity(this.validity.organizationRequired,!1),this.addError(this.notificationsText.OrganizationRequired),window.app.hideLoading(),!1)}},{key:"validateStartDate",value:function(e){if(this.removeError(this.notificationsText.StartDateRequired),this.removeError(this.notificationsText.StartDateInFuture),this.removeError(this.notificationsText.StartDateOutOfBounds),this.$scope[e].cpeStartDate.$setValidity(this.validity.startDateRequired,!0),this.$scope[e].cpeStartDate.$setValidity(this.validity.startOutOfBounds,!0),window.jQuery('input[name="cpeStartDate"]').removeClass("input--error"),window.jQuery('label[name="cpeStartDate"]').removeClass("label-text--error"),void 0===this.cpeData.StartDate||!this.cpeData.StartDate)return this.$scope[e].cpeStartDate.$setValidity(this.validity.startDateRequired,!1),this.addError(this.notificationsText.StartDateRequired),window.jQuery('input[name="cpeStartDate"]').addClass("input--error"),window.jQuery('label[name="cpeStartDate"]').addClass("label-text--error"),window.app.hideLoading(),!1;if(this.currentCycleStartYear&&this.currentCycleEndYear){if(new Date(this.cpeData.StartDate)>new Date(Date.now()))return this.$scope[e].cpeStartDate.$setValidity(this.validity.startOutOfBounds,!1),this.addError(this.notificationsText.StartDateInFuture),window.jQuery('input[name="cpeStartDate"]').addClass("input--error"),window.jQuery('label[name="cpeStartDate"]').addClass("label-text--error"),window.app.hideLoading(),!1}return!0}},{key:"validateEndDate",value:function(e){if(this.removeError(this.notificationsText.EndDateRequired),this.removeError(this.notificationsText.EndDateInFuture),this.removeError(this.notificationsText.EndBeforeStart),this.$scope[e].cpeEndDate.$setValidity(this.validity.endDateRequired,!0),this.$scope[e].cpeEndDate.$setValidity(this.validity.endOutOfBounds,!0),this.$scope[e].cpeEndDate.$setValidity(this.validity.endBeforeStart,!0),window.jQuery('input[name="cpeEndDate"]').removeClass("input--error"),window.jQuery('label[name="cpeEndDate"]').removeClass("label-text--error"),void 0===this.cpeData.EndDate||!this.cpeData.EndDate)return this.$scope[e].cpeEndDate.$setValidity(this.validity.endDateRequired,!1),this.addError(this.notificationsText.EndDateRequired),window.jQuery('input[name="cpeEndDate"]').addClass("input--error"),window.jQuery('label[name="cpeEndDate"]').addClass("label-text--error"),window.app.hideLoading(),!1;var t=new Date(this.cpeData.EndDate);if(this.currentCycleStartYear&&this.currentCycleEndYear){var i=new Date(this.cpeData.StartDate),a=new Date(Date.now());if(t>a)return this.$scope[e].cpeEndDate.$setValidity(this.validity.endOutOfBounds,!1),this.addError(this.notificationsText.EndDateInFuture),window.jQuery('input[name="cpeEndDate"]').addClass("input--error"),window.jQuery('label[name="cpeEndDate"]').addClass("label-text--error"),window.app.hideLoading(),!1;if(t.getFullYear()<this.currentCycleStartYear&&t.getFullYear()!==a.getFullYear())return this.$scope[e].cpeEndDate.$setValidity(this.validity.endOutOfBounds,!1),this.addError(this.notificationsText.EndDateOutOfBounds),window.jQuery('input[name="cpeEndDate"]').addClass("input--error"),window.jQuery('label[name="cpeEndDate"]').addClass("label-text--error"),window.app.hideLoading(),!1;if(t.getFullYear()>this.currentCycleEndYear)return this.$scope[e].cpeEndDate.$setValidity(this.validity.endOutOfBounds,!1),this.addError(this.notificationsText.EndDateOutOfBounds),window.jQuery('input[name="cpeEndDate"]').addClass("input--error"),window.jQuery('label[name="cpeEndDate"]').addClass("label-text--error"),window.app.hideLoading(),!1;if(t<i)return this.$scope[e].cpeEndDate.$setValidity(this.validity.endBeforeStart,!1),this.addError(this.notificationsText.EndBeforeStart),window.jQuery('input[name="cpeEndDate"]').addClass("input--error"),window.jQuery('label[name="cpeEndDate"]').addClass("label-text--error"),window.app.hideLoading(),!1}if("cpeAddForm"===e){var n=this.cpeData.QualifyingActivity;angular.forEach(this.cpeDataCertificationTypes,function(e,t){var i=new Date(e.PaidThru),a=i.getUTCMonth()+1+"/"+i.getUTCDate()+"/"+i.getUTCFullYear();if(e.PaidThru&&new Date(this.cpeData.EndDate.toString())>new Date(a)){e.disableHoursInput=!0,e.description=this.notificationsText.CantEnterWhileUnpaid,e.disableHoursInputText=this.notificationsText.HoursDisabledEndDate;var r=window.jQuery("#cpe-addapply-hours-"+e.certificationType);r&&r.length>0&&(r.val("0"),this.cpeData.HoursObj[t]=0);var s=window.jQuery("#cpe-edit-hours-"+e.certificationType);s&&s.length>0&&(s.val("0"),this.cpeData.HoursObj[t]=0)}else e.disallowedQualifyingActivities.indexOf(n)>-1?(e.disableHoursInput=!0,e.disableHoursInputText=this.notificationsText.HoursDisabledDefault):(e.disableHoursInput=!1,e.disableHoursInputText=this.notificationsText.HoursDisabledDefault,e.description===this.notificationsText.CantEnterWhileUnpaid&&angular.forEach(this.userSpecificCertificationTypes,function(t){t.certType===e.certType&&(e.description=t.description)},this))},this)}return!0}},{key:"validateActivity",value:function(e){return void 0===this.cpeData.QualifyingActivity||"?"===this.cpeData.QualifyingActivity?(this.$scope[e].cpeQualifyingActivity.$setValidity(this.validity.activityRequired,!1),this.addError(this.notificationsText.ActivityRequired),window.jQuery('select[name="cpeQualifyingActivity"]').addClass("input--error").removeClass("input--valid"),window.jQuery('label[name="cpeQualifyingActivity"]').addClass("label-text--error"),window.app.hideLoading(),!1):(this.$scope[e].cpeQualifyingActivity.$setValidity(this.validity.activityRequired,!0),this.removeError(this.notificationsText.ActivityRequired),window.jQuery('select[name="cpeQualifyingActivity"]').removeClass("input--error").addClass("input--valid"),window.jQuery('label[name="cpeQualifyingActivity"]').removeClass("label-text--error"),!0)}},{key:"validateMethod",value:function(e){return void 0===this.cpeData.MethodOfDelivery||"?"===this.cpeData.MethodOfDelivery?(this.$scope[e].cpeMethodOfDelivery.$setValidity(this.validity.methodRequired,!1),this.addError(this.notificationsText.MethodRequired),window.jQuery('select[name="cpeMethodOfDelivery"]').addClass("input--error").removeClass("input--valid"),window.jQuery('label[name="cpeDelivery"]').addClass("label-text--error"),window.app.hideLoading(),!1):(this.$scope[e].cpeMethodOfDelivery.$setValidity(this.validity.methodRequired,!0),this.removeError(this.notificationsText.MethodRequired),window.jQuery('select[name="cpeMethodOfDelivery"]').removeClass("input--error").addClass("input--valid"),window.jQuery('label[name="cpeDelivery"]').removeClass("label-text--error"),!0)}},{key:"validateHoursEntered",value:function(e){var t="cpeAddForm"===e?this.cpeData.HoursObj:parseInt(window.jQuery("#cpe-edit-hours-"+this.cpeData.CertificationType).val());if("cpeEditForm"===e&&0===t)return this.addError(this.notificationsText.MustHaveHours),!1;var i=this.cpeData.MaxHoursAvailable?this.cpeData.MaxHoursAvailable:this.defaultMaxHours,a=window.jQuery('input[name="cpeHours"]').filter(function(){return window.jQuery(this).val()>i}),n=!1;return"cpeAddForm"===e&&this.certStatusChange(),a.length?(this.removeError(this.notificationsText.MustHaveHours),this.addError(this.notificationsText.TooManyHours.replace("{0}",i)),window.jQuery('input[name="cpeHours"]').removeClass("input--error").siblings("label").removeClass("label-text--error"),a.addClass("input--error").siblings("label").addClass("label-text--error"),window.app.hideLoading(),!1):("cpeAddForm"===e?angular.forEach(t,function(e){e&&(n=!0)}):n=0!==t,t&&!n?(this.removeError(this.notificationsText.TooManyHours.replace("{0}",i)),this.addError(this.notificationsText.MustHaveHours),window.jQuery('input[name="cpeHours"]').addClass("input--error").siblings("label").addClass("label-text--error"),window.app.hideLoading(),!1):(window.jQuery('input[name="cpeHours"]').removeClass("input--error").siblings("label").removeClass("label-text--error"),this.removeError(this.notificationsText.MustHaveHours),this.removeError(this.notificationsText.TooManyHours.replace("{0}",i)),!0))}}]),e}();t.default=r},382:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i){"ngInject";a(this,e),this.$scope=t,this.dataManageCpeService=i,this.limitResults=10,this.currentPage=1,this.Math=window.Math,this.dataUrl="",this.maxDate="",this.controllerName="tablecpe"}return e.$inject=["$scope","dataManageCpeService"],n(e,[{key:"$onInit",value:function(){this.$scope.$on("filterApplied",function(e,t){e.currentScope.$tableCpeCtrl.currentPage=1}),this.$scope.$on("cpeDeleted",function(e,t){e.currentScope.$tableCpeCtrl.cpeDataDetails.length%e.currentScope.$tableCpeCtrl.limitResults==0&&e.currentScope.$tableCpeCtrl.currentPage>1&&(e.currentScope.$tableCpeCtrl.currentPage-=1)})}},{key:"getCurrentPage",value:function(){return this.currentPage}},{key:"setCurrentPage",value:function(e){this.currentPage=e}},{key:"initCpeTableData",value:function(e){e&&(this.cpeDataDetails=e)}},{key:"checkDataLength",value:function(e,t){for(var i in e){if(e.hasOwnProperty(t)){if(""!==e[t]&&"string"==typeof e[t])return!0}else if(e.hasOwnProperty(i)&&""!==e[i][t]&&"string"==typeof e[i][t])return!0;return!1}}},{key:"orderByCpe",value:function(e){this.sortCpeAsc=!this.sortCpeAsc,this.sortCpeDetail=e}},{key:"exportCSVFile",value:function(e,t){}},{key:"checkArrayLength",value:function(e){return e?e&&window.jQuery.isArray(e)?e.length:"1 object":"undefined"}},{key:"getColspan",value:function(e,t){var i=6;return this.checkDataLength(e,t)&&(i+=1),i}}]),e}();t.default=r},383:function(e,t){e.exports='<div class="table-cpe" ng-class="{\'table-cpe--hide\': $tableCpeCtrl.tableToggle}">\n    <div>\r\n        \x3c!-- TODO: move this to manageCpeCtrl (top level controller)? --\x3e\r\n        <div id="table-cpe__delete_popup" class="popup__container" ng-class="{\'popup__container--visible\': $ctrl.cpeModalActive === \'delete\' }" data-endpoint="/api/sitecore/manage-cps/delete">\r\n            <div class="popup">\r\n                <h5 class="popup__headline">{{$ctrl.labels.DeleteConfirmationMessage}}<br /><br />{{$ctrl.cpeData.Title}}?</h5>\r\n                <div class="buttons">\n                    <button class="btn-primary" ng-click="$ctrl.deleteCpe($ctrl.cpeData)">{{$ctrl.labels.Confirm}}</button>\r\n                    <button class="btn-tertiary btn-tertiary--dark" ng-click="$ctrl.closeActiveModal()">{{$ctrl.labels.Decline}}</button>\n                </div>\r\n            </div>\r\n            <div class="popup__overlay" ng-click="$ctrl.closeActiveModal()"></div>\r\n        </div>\r\n        <table ng-init="$tableCpeCtrl.sortCpeDetail = \'EndDate\'; $tableCpeCtrl.sortCpeAsc = true;">\r\n            <thead class="table-cpe__thead">\r\n                <tr>\r\n                    <th class="table-cpe__th" ng-click="$tableCpeCtrl.orderByCpe(\'EndDate\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'EndDate\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'EndDate\' && !$tableCpeCtrl.sortCpeAsc, }">{{$ctrl.labels.EndDate}}</span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-if="$tableCpeCtrl.checkDataLength($tableCpeCtrl.cpeDataDetails, \'CertificationType\')" ng-click="$tableCpeCtrl.orderByCpe(\'CertificationType\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'CertificationType\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'CertificationType\' && !$tableCpeCtrl.sortCpeAsc, }" title="Certification">{{$ctrl.labels.Certification}}</span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-click="$tableCpeCtrl.orderByCpe(\'Title\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'Title\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'Title\' && !$tableCpeCtrl.sortCpeAsc, }">{{$ctrl.labels.Title}}</span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-click="$tableCpeCtrl.orderByCpe(\'Hours\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'Hours\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'Hours\' && !$tableCpeCtrl.sortCpeAsc, }">{{$ctrl.labels.Hours}}</span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-click="$tableCpeCtrl.orderByCpe(\'OriginatingSource\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'OriginatingSource\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'OriginatingSource\' && !$tableCpeCtrl.sortCpeAsc, }">{{$ctrl.labels.Source}}</span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-if="$tableCpeCtrl.editApply !== \'\'">\r\n                        <span class="table-cpe__subhead">{{$ctrl.labels.Actions}}</span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-if="$tableCpeCtrl.editApply === \'\'"></th>\r\n                    <th class="table-cpe__th"></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody class="table-cpe__tbody" ng-repeat="cpeDetail in $tableCpeCtrl.tableCpe.cpeDataDetailsFiltered = ($tableCpeCtrl.cpeDataDetails | filterByQA: $ctrl.cpeDataQualifyFilter | filter: {CertificationType : $ctrl.cpeDataCertificationFilter} | filter: {EndDate : $ctrl.cpeDataYearFilter} | filter: { OriginatingSource: $ctrl.cpeDataSourceFilter}) | orderBy: $tableCpeCtrl.sortCpeDetail : $tableCpeCtrl.sortCpeAsc | startFrom: $tableCpeCtrl.limitResults*($tableCpeCtrl.currentPage-1) | limitTo: $tableCpeCtrl.limitResults" ng-init="toggleCpeDetails = true;">\r\n                <tr class="table-cpe__tr">\r\n                    <td>\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.EndDate}}:</h6>\r\n                        <h5 class="table-cpe__subhead table-cpe__subhead--date">{{cpeDetail.EndDate | date: \'dd MMM yyyy\':\'UTC+0\'}}</h5>\r\n                    </td>\r\n                    <td ng-if="$tableCpeCtrl.checkDataLength(cpeDetail, \'CertificationType\')">\r\n                        \x3c!--This only works for specific classes that we currently have access to but if more are added you can style them in _manageCpe.scss file--\x3e\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.Certification}}:</h6>\r\n                        <p class="table-cpe__title table-cpe__title--{{cpeDetail.CertificationType | lowercase}}">{{cpeDetail.CertificationType}}</p>\r\n                    </td>\r\n                    <td>\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.Title}}:</h6>\r\n                        <h5 class="table-cpe__title" title="{{cpeDetail.Title}}">{{cpeDetail.Title}}</h5>\r\n                    </td>\r\n                    <td>\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.Hours}}:</h6>\r\n                        <h5 class="table-cpe__title">{{cpeDetail.Hours || 0}}</h5>\r\n                    </td>\r\n                    <td>\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.Source}}:</h6>\r\n                        <h5 class="table-cpe__title">{{cpeDetail.OriginatingSource}}</h5>\r\n                    </td>\r\n                    <td ng-if="$tableCpeCtrl.editApply !== \'\'">\r\n                        \x3c!-- cpeDetail.Status indicates if the CPE is locked and cannot be edited. 2 == locked, anything else is editable --\x3e\r\n                        <button ng-if="$tableCpeCtrl.editApply === \'apply\'" class="table-cpe__actions table-cpe__actions--apply setting__link" ng-click="$ctrl.openApplyCpeModal(cpeDetail);">{{$ctrl.labels.Apply}}</button>\r\n                        <button ng-if="$tableCpeCtrl.editApply === \'edit\' && cpeDetail.Status !== 2 && !$ctrl.isNonPracticing(cpeDetail.CertificationType);" class="table-cpe__actions table-cpe__actions--edit" ng-click="$ctrl.openEditCpeModal(cpeDetail)">{{$ctrl.labels.Edit}}</button>\r\n                        <button ng-if="$tableCpeCtrl.editApply === \'edit\' && cpeDetail.Status !== 2 && !$ctrl.isNonPracticing(cpeDetail.CertificationType);" class="table-cpe__actions table-cpe__actions--delete" ng-click="$ctrl.openDeleteCpePopup(cpeDetail);">{{$ctrl.labels.Delete}}</button>\r\n                        <span ng-if="cpeDetail.Status === 2" class="table-cpe__actions table-cpe__actions--locked">{{$ctrl.labels.Locked}}</span>\r\n                    </td>\r\n                    <td ng-if="$tableCpeCtrl.editApply === \'\'"></td>\r\n                    <td class="table-cpe__expand" ng-class="{\'table-cpe__expand--hide\': !toggleCpeDetails}" ng-click="toggleCpeDetails = !toggleCpeDetails"></td>\r\n                </tr>\r\n                <tr class="table-cpe__more-details" ng-class="{\'table-cpe__more-details--hide\': toggleCpeDetails}">\r\n                    \x3c!-- More Detail info user can access --\x3e\r\n                    \x3c!-- There is no username attached to the ID --\x3e\r\n                    <td colspan="{{$tableCpeCtrl.getColspan(cpeDetail, \'CertificationType\')}}">\r\n                        <table>\r\n                            <tbody>\r\n                                <tr class="more-details__wrapper">\r\n                                    <td class="more-details__container">\r\n                                        <h5 class="table-cpe__subhead-secondary">{{$ctrl.labels.EntryDetails}}</h5>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CpeId}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.Seqn}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content-stack">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CreatedBy}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.CreatedBy}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content" ng-if="$tableCpeCtrl.editApply !== \'apply\'">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CreatedDate}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.CreatedDate | date: \'dd MMM yyyy\':\'UTC+0\'}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content-stack">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CpeStartDate}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.StartDate | date: \'dd MMM yyyy\':\'UTC+0\'}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CpeEndDate}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.EndDate | date: \'dd MMM yyyy\':\'UTC+0\'}}</div>\r\n                                        </div>\r\n                                    </td>\r\n                                    <td class="more-details__container">\r\n                                        <h5 class="table-cpe__subhead-secondary">{{$ctrl.labels.Activity}}</h5>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.QualifyingActivity}}:</div>\r\n                                            \x3c!-- use QualifyingActivityDisplay in BE (generated by sitecore) --\x3e\r\n                                            <div class="more-details__info">{{cpeDetail.QualifyingActivityDisplay}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.MethodOfDelivery}}:</div>\r\n                                            \x3c!-- use QualifyingActivityDisplay in BE (generated by sitecore) --\x3e\r\n                                            <div class="more-details__info">{{cpeDetail.MethodOfDeliveryDisplay}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.Sponsor}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.SponsoringOrganization}}</div>\r\n                                        </div>\r\n                                    </td>\r\n                                    <td class="more-details__container">\r\n                                        <h5 class="table-cpe__subhead-secondary">{{$ctrl.labels.Hours}}</h5>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.MaximumCpeHoursAvailable}}:</div>\r\n                                            <div class="more-details__info more-details__info--right">{{cpeDetail.MaxHoursAvailable}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content" ng-if="cpeDetail.CertificationType">\r\n                                            <div class="more-details__title">\r\n                                                <h5 class="table-cpe__title table-cpe__title--{{cpeDetail.CertificationType | lowercase}}">{{cpeDetail.CertificationType}}</h5>\r\n                                            </div>\r\n                                            <div class="more-details__info more-details__info--right">\r\n                                                <h5 class="table-cpe__title table-cpe__title--{{cpeDetail.CertificationType | lowercase}}">{{cpeDetail.Hours}}</h5>\r\n                                            </div>\r\n                                        </div>\r\n                                    </td>\r\n                                </tr>\r\n                            </tbody>\r\n                        </table>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n            <tfoot class="table-cpe__tfoot">\n                <tr>\r\n                    <td colspan="8" class="table-cpe__pagination" ng-if="$tableCpeCtrl.Math.ceil($tableCpeCtrl.tableCpe.cpeDataDetailsFiltered.length/$tableCpeCtrl.limitResults) > 1">\r\n                        <nav pagination-limit="7" ng-pagination></nav>\r\n                    </td>\r\n                </tr>\r\n            </tfoot>\r\n        </table>\r\n    </div>\r\n</div>\n'},384:function(e,t){e.exports='<div>\r\n    <div class="c-overlay__close edit-cpe__close" ng-click="$ctrl.closeActiveModal(\'cpeEditForm\')">\r\n        <button class="c-btn-close">\r\n            <span class="c-btn-close__text">×</span>\r\n            <span class="srt">close</span>\r\n        </button>\r\n    </div>\r\n    \x3c!-- endpoints that begin with \'/assets/\' will be retrieved using GET --\x3e\r\n    <form id="cpeEditForm" name="cpeEditForm" class="edit-cpe__container" novalidate data-endpoint="/assets/data/edit-response.json">\r\n        <div class="form__wrapper">\r\n            <div class="form__container flex__grid -middle -column">\r\n                <h1 class="hero__headline hero__headline--dark flex__cell -10of12 -large-6of12">Edit CPE</h1>\r\n                <div class="flex__cell -10of12 -large-6of12" ng-show="$ctrl.notificationError">\r\n                    <div class="notification notification--error" ng-class="{\'notification--active\': $ctrl.notificationError}">\r\n                        <p ng-repeat="cpeCertError in $ctrl.cpeDetail.errors">{{cpeCertError}}</p>\r\n                    </div>\r\n                </div>\r\n                <h6 class="form__headline form__headline--center form__headline--form__input">All Fields Required</h6>\r\n                <h6 class="form__headline form__headline--center form__headline--form__input">CPE Details</h6>\r\n                <div class="form__input flex__cell -10of12 -large-6of12">\r\n                    <input class="input-text" name="cpeTitle" id="cpe-title" type="text" ng-model="$ctrl.cpeData.Title" ng-class="{\'input-text--filled\': $ctrl.cpeData.Title}" ng-disabled="$ctrl.cpeData.DerivedFromItem!==0 && $ctrl.cpeData.DerivedFromItem!==\'0\'" ng-input-controls required maxlength="255">\r\n                    <label class="label-text" for="cpe-title">Title/Description</label>\r\n                </div>\r\n                <div class="form__input flex__cell -10of12 -large-6of12">\r\n                    <input class="input-text" name="cpeSponsoring" id="cpe-sponsoring" type="text" ng-model="$ctrl.cpeData.SponsoringOrganization" ng-class="{\'input-text--filled\': $ctrl.cpeData.SponsoringOrganization}" ng-disabled="$ctrl.cpeData.DerivedFromItem!==0 && $ctrl.cpeData.DerivedFromItem!==\'0\'" ng-input-controls required maxlength="255">\r\n                    <label class="label-text" for="cpe-sponsoring">Sponsoring Organization</label>\r\n                </div>\r\n                <div class="flatpickr__container flex__cell -10of12 -large-6of12">\r\n                    <div class="form__input flex__cell -12of12">\r\n                        <div class="input-controls">\r\n                            <span class="control-clear" ng-show="$ctrl.cpeData.StartDate && $ctrl.cpeModalActive===\'add\'" ng-click="$ctrl.cpeData.StartDate = null"></span>\r\n                        </div>\r\n                        <label class="form-label--left" name="cpeStartDate" for="cpe-start-date" ng-class="{\'label-disabled\': $ctrl.cpeData.DerivedFromItem!==0}">Start Date</label>\r\n                        <datepicker date-format="M/d/yyyy" class="date-picker-wrap">\r\n                            <input class="input-select"\r\n                                   name="cpeStartDate"\r\n                                   id="cpe-start-date"\r\n                                   ng-model="$ctrl.cpeData.StartDate"\r\n                                   ng-class="{\'input-text--filled\': $ctrl.cpeData.StartDate}"\r\n                                   ng-change="$ctrl.validateStartDate(\'cpeEditForm\')"\r\n                                   ng-disabled="$ctrl.cpeData.DerivedFromItem!==0 && $ctrl.cpeData.DerivedFromItem!==\'0\'"\r\n                                   readonly\r\n                                   required>\r\n                        </datepicker>\r\n                    </div>\r\n                    <div class="form__input flex__cell -12of12">\r\n                        <div class="input-controls">\r\n                            <span class="control-clear" ng-show="$ctrl.cpeData.EndDate && $ctrl.cpeModalActive===\'add\'" ng-click="cpeData.EndDate = null"></span>\r\n                        </div>\r\n                        <label class="form-label--left" name="cpeEndDate" for="cpe-end-date" ng-class="{\'label-disabled\': !$ctrl.cpeData.StartDate || $ctrl.cpeData.DerivedFromItem!==\'0\'}">End Date</label>\r\n                        <datepicker date-format="M/d/yyyy" class="date-picker-wrap">\r\n                            <input class="input-select"\r\n                                   name="cpeEndDate"\r\n                                   id="cpe-end-date"\r\n                                   ng-model="$ctrl.cpeData.EndDate"\r\n                                   ng-class="{\'input-text--filled\': $ctrl.cpeData.EndDate}"\r\n                                   ng-change="$ctrl.validateEndDate(\'cpeEditForm\')"\r\n                                   fp-options="{maxDate: currentDate, dateFormat: \'M/d/yyyy\'}"\r\n                                   fp-min="cpeData.StartDate"\r\n                                   ng-disabled="!$ctrl.cpeData.StartDate || $ctrl.cpeData.DerivedFromItem!==\'0\'"\r\n                                   readonly\r\n                                   required>\r\n                        </datepicker>\r\n                    </div>\r\n                </div>\r\n                <div class="form__input form__input--select flex__cell -10of12 -large-6of12">\r\n                    <select class="input-select"\r\n                            name="cpeQualifyingActivity"\r\n                            id="cpe-qualifying-activity"\r\n                            ng-model="$ctrl.cpeData.QualifyingActivity"\r\n                            ng-options="option.code as option.description for option in $ctrl.fullListOfQualifyingActivities"\r\n                            ng-change="$ctrl.activityChange($ctrl.cpeData.QualifyingActivity)"\r\n                            ng-disabled="$ctrl.cpeData.DerivedFromItem!==0 && $ctrl.cpeData.DerivedFromItem!==\'0\'"\r\n                            required></select>\r\n                    <label class="label-text" name="cpeQualifyingActivity" for="cpe-qualifying-activity">Qualifying Activity</label>\r\n                </div>\r\n                <div class="form__input form__input--select flex__cell -10of12 -large-6of12">\r\n                    <select class="input-select"\r\n                            name="cpeMethodOfDelivery"\r\n                            id="cpe-delivery"\r\n                            ng-model="$ctrl.cpeData.MethodOfDelivery"\r\n                            ng-options="option.code as option.description disable when $ctrl.disableMethod(option) for option in $ctrl.relatedDeliveryMethods"\r\n                            ng-disabled="!$ctrl.cpeData.QualifyingActivity || $ctrl.cpeData.DerivedFromItem!==\'0\'"\r\n                            required></select>\r\n                    <label class="label-text" name="cpeDelivery" for="cpe-delivery">Method of Delivery</label>\r\n                </div>\r\n                <div class="form__input form__input flex__cell -10of12 -large-6of12" ng-if="$ctrl.cpeData.MaxHoursAvailable && $ctrl.cpeData.MaxHoursAvailable < $ctrl.defaultMaxHours">\r\n                    Max Hours Allowed: <div style="display:inline-block;" ng-bind="$ctrl.cpeData.MaxHoursAvailable"></div>\r\n                </div>\r\n                <div class="flex__cell -10of12 -large-6of12">\r\n                    <h3>Certification Receiving Hours</h3>\r\n                    <p>Enter the number of qualifying CPE hours for the certification of your choosing from the list below</p>\r\n                </div>\r\n                <div class="flex__cell -10of12 -large-6of12" ng-show="$ctrl.cpeCertNotifications">\r\n                    <div class="notification">\r\n                        <p ng-repeat="cpeNotification in $ctrl.cpeDetail.notifications">{{cpeNotification}}</p>\r\n                    </div>\r\n                </div>\r\n                <div class="cpe-certification__wrapper">\r\n                    <div class="cpe-certification__container" ng-repeat="certification in $ctrl.cpeDataCertificationTypes track by $index">\r\n                        <div class="cpe-certification__image">\r\n                            <img ng-src="{{certification.icon}}" alt="{{certification.certificationType}}">\r\n                        </div>\r\n                        <div class="cpe-certification__copy">\r\n                            <p>{{certification.description}}</p>\r\n                        </div>\r\n                        <div class="cpe-certification__input">\r\n                            <div class="form__input" ng-hide="certification.disableHoursInput">\r\n                                <div class="input-controls">\r\n                                    <span class="control-clear" ng-show="$ctrl.HoursObj[$index]" ng-click="$ctrl.HoursObj[$index] = 0"></span>\r\n                                </div>\r\n                                <input class="input-text input-number js-cpe-cert-input"\r\n                                       name="cpeHours"\r\n                                       id="cpe-edit-hours-{{certification.certificationType}}"\r\n                                       type="number"\r\n                                       min="0"\r\n                                       step="0.25"\r\n                                       ng-model="$ctrl.HoursObj[$index]"\r\n                                       ng-change="$ctrl.validateHoursEntered(\'cpeEditForm\')"\r\n                                       ng-class="{\'input-text--filled\': $ctrl.cpeData.Hours}"\n                                       disable-arrows\n                                       onwheel="return false;">\r\n                                <label class="label-text" for="cpe-edit-hours-{{certification.certificationType}}">Hours</label>\r\n                            </div>\r\n                            <div class="form__input" ng-show="certification.disableHoursInput">\r\n                                <label for="cpe-edit-hours-{{certification.certificationType}}" style="color: red;">Qualifying Activity does not apply to this certification</label>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class="form__container flex__grid -middle -column">\r\n                <div class="form__input flex__cell -10of12 -large-6of12">\r\n                    <button type="submit" id="btnEditCpeContinue" name="scButton" value="Continue" class="form__btn btn-primary btn--full" ng-click="$ctrl.postCpe(\'cpeEditForm\',$ctrl.cpeData);">Save & Close</button>\r\n                    <a id="btnStop" name="scButton" class="btn-tertiary btn-tertiary--dark btn-tertiary--stacked btn--full btn--center" href="" ng-click="$ctrl.closeActiveModal(\'cpeEditForm\')">Cancel</a><br />\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>\r\n'},385:function(e,t){e.exports='<div class="table-cpe" ng-class="{\'table-cpe--hide\': $tableCpeCtrl.tableToggle}">\r\n    <div>\r\n        \x3c!-- TODO: move this to manageCpeCtrl (top level controller)? --\x3e\r\n        <div id="table-cpe__delete_popup" class="popup__container" ng-class="{\'popup__container--visible\': $ctrl.cpeModalActive === \'delete\' }" data-endpoint="/api/sitecore/manage-cps/delete">\r\n            <div class="popup">\r\n                <h5 class="popup__headline">{{$ctrl.labels.DeleteConfirmationMessage}}<br /><br />{{$ctrl.cpeData.Title}}?</h5>\r\n                <div class="buttons">\n                    <button class="btn-primary" ng-click="$ctrl.deleteCpe($ctrl.cpeData)">{{$ctrl.labels.Confirm}}</button>\r\n                    <button class="btn-tertiary btn-tertiary--dark" ng-click="$ctrl.closeActiveModal()">{{$ctrl.labels.Decline}}</button>\r\n                </div>\n            </div>\r\n            <div class="popup__overlay" ng-click="$ctrl.closeActiveModal()"></div>\r\n        </div>\r\n        <table ng-init="$tableCpeCtrl.sortCpeDetail = \'EndDate\'; $tableCpeCtrl.sortCpeAsc = true;">\r\n            <thead class="table-cpe__thead">\r\n                <tr>\r\n                    <th class="table-cpe__th" ng-click="$tableCpeCtrl.orderByCpe(\'EndDate\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'EndDate\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'EndDate\' && !$tableCpeCtrl.sortCpeAsc, }">{{$ctrl.labels.EndDate}}<span></span></span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-if="$tableCpeCtrl.checkDataLength($tableCpeCtrl.cpeDataDetails, \'CertificationType\')" ng-click="$tableCpeCtrl.orderByCpe(\'CertificationType\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'CertificationType\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'CertificationType\' && !$tableCpeCtrl.sortCpeAsc, }" title="Certification">{{$ctrl.labels.Certification}}<span></span></span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-click="$tableCpeCtrl.orderByCpe(\'Title\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'Title\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'Title\' && !$tableCpeCtrl.sortCpeAsc, }">{{$ctrl.labels.Title}}<span></span></span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-click="$tableCpeCtrl.orderByCpe(\'Hours\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'Hours\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'Hours\' && !$tableCpeCtrl.sortCpeAsc, }">{{$ctrl.labels.Hours}}<span></span></span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-click="$tableCpeCtrl.orderByCpe(\'OriginatingSource\');">\r\n                        <span class="table-cpe__subhead table-cpe__sort" ng-class="{\'table-cpe__sort--asc\': $tableCpeCtrl.sortCpeDetail === \'OriginatingSource\' && $tableCpeCtrl.sortCpeAsc, \'table-cpe__sort--desc\': $tableCpeCtrl.sortCpeDetail === \'OriginatingSource\' && !$tableCpeCtrl.sortCpeAsc, }">{{$ctrl.labels.Source}}<span></span></span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-if="$tableCpeCtrl.editApply !== \'\'">\r\n                        <span class="table-cpe__subhead">{{$ctrl.labels.Actions}}</span>\r\n                    </th>\r\n                    <th class="table-cpe__th" ng-if="$tableCpeCtrl.editApply === \'\'"></th>\r\n                    <th class="table-cpe__th"></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody class="table-cpe__tbody" ng-repeat="cpeDetail in $tableCpeCtrl.tableCpe.cpeDataDetailsFiltered = ($tableCpeCtrl.cpeDataDetails | filterByQA: $ctrl.cpeDataQualifyFilter | filter: {CertificationType : $ctrl.cpeDataCertificationFilter} | filter: {EndDate : $ctrl.cpeDataYearFilter} | filter: { OriginatingSource: $ctrl.cpeDataSourceFilter}) | orderBy: $tableCpeCtrl.sortCpeDetail : $tableCpeCtrl.sortCpeAsc" ng-init="toggleCpeDetails = true;">\r\n                <tr class="table-cpe__tr">\r\n                    <td>\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.EndDate}}:</h6>\r\n                        <h5 class="table-cpe__subhead table-cpe__subhead--date">{{cpeDetail.EndDate | date: \'dd MMM yyyy\':\'UTC+0\'}}</h5>\r\n                    </td>\r\n                    <td ng-if="$tableCpeCtrl.checkDataLength(cpeDetail, \'CertificationType\')">\r\n                        \x3c!--This only works for specific classes that we currently have access to but if more are added you can style them in _manageCpe.scss file--\x3e\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.Certification}}:</h6>\r\n                        <p class="table-cpe__title table-cpe__title--{{cpeDetail.CertificationType | lowercase}}">{{cpeDetail.CertificationType}}</p>\r\n                    </td>\r\n                    <td>\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.Title}}:</h6>\r\n                        <h5 class="table-cpe__title" title="{{cpeDetail.Title}}">{{cpeDetail.Title}}</h5>\r\n                    </td>\r\n                    <td>\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.Hours}}:</h6>\r\n                        <h5 class="table-cpe__title">{{cpeDetail.Hours || 0}}</h5>\r\n                    </td>\r\n                    <td>\r\n                        <h6 class="body--tight show--small">{{$ctrl.labels.Source}}:</h6>\r\n                        <h5 class="table-cpe__title">{{cpeDetail.OriginatingSource}}</h5>\r\n                    </td>\r\n                    <td ng-if="$tableCpeCtrl.editApply !== \'\'">\r\n                        \x3c!-- cpeDetail.Status indicates if the CPE is locked and cannot be edited. 2 == locked, anything else is editable --\x3e\r\n                        <button ng-if="$tableCpeCtrl.editApply === \'apply\'" class="table-cpe__actions table-cpe__actions--apply setting__link" ng-click="$ctrl.openApplyCpeModal(cpeDetail);">{{$ctrl.labels.Apply}}<span></span></button>\r\n                        <button ng-if="$tableCpeCtrl.editApply === \'edit\' && cpeDetail.Status !== 2 && !$ctrl.isNonPracticing(cpeDetail.CertificationType);" class="table-cpe__actions table-cpe__actions--edit" ng-click="$ctrl.openEditCpeModal(cpeDetail)">{{$ctrl.labels.Edit}}<span></span></button>\r\n                        <button ng-if="$tableCpeCtrl.editApply === \'edit\' && cpeDetail.Status !== 2 && !$ctrl.isNonPracticing(cpeDetail.CertificationType);" class="table-cpe__actions table-cpe__actions--delete" ng-click="$ctrl.openDeleteCpePopup(cpeDetail);">{{$ctrl.labels.Delete}}<span></span></button>\r\n                        <span ng-if="cpeDetail.Status === 2" class="table-cpe__actions table-cpe__actions--locked">{{$ctrl.labels.Locked}}<span></span></span>\r\n                    </td>\r\n                    <td ng-if="$tableCpeCtrl.editApply === \'\'"></td>\r\n                    <td class="table-cpe__expand" ng-class="{\'table-cpe__expand--hide\': !toggleCpeDetails}" ng-click="toggleCpeDetails = !toggleCpeDetails"></td>\r\n                </tr>\r\n                <tr class="table-cpe__more-details" ng-class="{\'table-cpe__more-details--hide\': toggleCpeDetails}">\r\n                    \x3c!-- More Detail info user can access --\x3e\r\n                    \x3c!-- There is no username attached to the ID --\x3e\r\n                    <td colspan="{{$tableCpeCtrl.getColspan(cpeDetail, \'CertificationType\')}}">\r\n                        <table>\r\n                            <tbody>\r\n                                <tr class="more-details__wrapper">\r\n                                    <td class="more-details__container">\r\n                                        <h5 class="table-cpe__subhead-secondary">{{$ctrl.labels.EntryDetails}}</h5>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CpeId}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.Seqn}}</div>\r\n                                        </div>\r\n                                        <div ng-class="($tableCpeCtrl.editApply !== \'apply\') ? \'more-details__content-stack\' : \'more-details__content\'">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CreatedBy}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.CreatedBy}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content" ng-if="$tableCpeCtrl.editApply !== \'apply\'">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CreatedDate}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.CreatedDate | date: \'dd MMM yyyy\':\'UTC+0\'}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content-stack">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CpeStartDate}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.StartDate | date: \'dd MMM yyyy\':\'UTC+0\'}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.CpeEndDate}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.EndDate | date: \'dd MMM yyyy\':\'UTC+0\'}}</div>\r\n                                        </div>\r\n                                    </td>\r\n                                    <td class="more-details__container">\r\n                                        <h5 class="table-cpe__subhead-secondary">{{$ctrl.labels.Activity}}</h5>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.QualifyingActivity}}:</div>\r\n                                            \x3c!-- use QualifyingActivityDisplay in BE (generated by sitecore) --\x3e\r\n                                            <div class="more-details__info">{{cpeDetail.QualifyingActivityDisplay}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.MethodOfDelivery}}:</div>\r\n                                            \x3c!-- use QualifyingActivityDisplay in BE (generated by sitecore) --\x3e\r\n                                            <div class="more-details__info">{{cpeDetail.MethodOfDeliveryDisplay}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.Sponsor}}:</div>\r\n                                            <div class="more-details__info">{{cpeDetail.SponsoringOrganization}}</div>\r\n                                        </div>\r\n                                    </td>\r\n                                    <td class="more-details__container">\r\n                                        <h5 class="table-cpe__subhead-secondary">{{$ctrl.labels.Hours}}</h5>\r\n                                        <div class="more-details__content">\r\n                                            <div class="more-details__title">{{$ctrl.labels.MaximumCpeHoursAvailable}}:</div>\r\n                                            <div class="more-details__info more-details__info--right">{{cpeDetail.MaxHoursAvailable}}</div>\r\n                                        </div>\r\n                                        <div class="more-details__content" ng-if="cpeDetail.CertificationType">\r\n                                            <div class="more-details__title">\r\n                                                <h5 class="table-cpe__title table-cpe__title--{{cpeDetail.CertificationType | lowercase}}">{{cpeDetail.CertificationType}}</h5>\r\n                                            </div>\r\n                                            <div class="more-details__info more-details__info--right">\r\n                                                <h5 class="table-cpe__title table-cpe__title--{{cpeDetail.CertificationType | lowercase}}">{{cpeDetail.Hours}}</h5>\r\n                                            </div>\r\n                                        </div>\r\n                                    </td>\r\n                                </tr>\r\n                            </tbody>\r\n                        </table>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n'},386:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=i(387),n=function(e){return e&&e.__esModule?e:{default:e}}(a),r=angular.module("online-learning",[]).filter("unixTimestampToHumanReadableDate",function(){return function(e){return new Date(1e3*Number(e)).toLocaleString("en-US",{month:"short",day:"numeric",year:"numeric"})}}).filter("unixTimestampToHumanReadableTime",function(){return function(e){return new Date(1e3*Number(e)).toLocaleString("en-US",{hour:"numeric",minute:"numeric",hour12:!0})}}).directive("viltsWebinarsSummitsList",function(){"ngInject";return{restrict:"EA",controller:n.default,controllerAs:"$ctrl",scope:{srcData:"@",itemsPerPage:"@",filterSelectProperty:"@",filterSelectProperties:"@",filterWebinarSelectProperties:"@",sortSelection:"@"},bindToController:!0,transclude:!0,link:function(e,t,i,a,n){n(e,function(e,i){t.append(e)})}}}).name;t.default=r},387:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(){function e(t,i,n){"ngInject";a(this,e),this.$http=t,this.$window=i,this.$timeout=n,this.data=[],this.vilt=[],this.qae=[],this.webinarSummit=[],this.labCourses=[],this.onDemandCourses=[],this.showVilt=!1,this.showQae=!1,this.showWebinarSummit=!1,this.showLabCourses=!1,this.showOnDemandCourses=!1,this.updatedWebinarSummit=[],this.sortOptions=[],this.webinarSortOptions=[],this.dataLength=0,this.defaultSelectedOption=""}return e.$inject=["$http","$window","$timeout"],n(e,[{key:"sortData",value:function(e){var t=this.data,i=e;this.sortOptions.indexOf(e)>=0&&(t.sort(function(t,a){"Most Recent"!==e&&"Oldest"!==e||(e="Start Date");var n=t[e],r=a[e];if("string"==typeof n&&"string"==typeof r){var s=Date.parse(n),o=Date.parse(r);if(isNaN(s)||isNaN(o))n=n.toLowerCase(),r=r.toLowerCase();else{if("Oldest"===i)return s>o?1:s<o?-1:0;if("Most Recent"===i)return s>o?-1:s<o?1:0}}if("Oldest"===i){if(n<r)return-1;if(n>r)return 1}else if("Most Recent"===i){if(n<r)return 1;if(n>r)return-1}}),this.data=t,this.createArrayGroups())}},{key:"createArrayGroups",value:function(){this.vilt.length>0&&(this.vilt=[]),this.qae.length>0&&(this.qae=[]),this.labCourses.length>0&&(this.labCourses=[]),this.onDemandCourses.length>0&&(this.onDemandCourses=[]),this.webinarSummit.length>0&&(this.webinarSummit=[]);for(var e in this.data)"vilt"===this.data[e]["Event Type"]&&this.vilt.push(this.data[e]),"qae"===this.data[e]["Event Type"]&&this.qae.push(this.data[e]),"ondemand"===this.data[e]["Event Type"]&&(this.data[e]["Product Code"].toUpperCase().startsWith("LMS_LAB")?this.labCourses.push(this.data[e]):this.onDemandCourses.push(this.data[e])),"webinar"!==this.data[e]["Event Type"]&&"summit"!==this.data[e]["Event Type"]||this.webinarSummit.push(this.data[e]);this.updatedWebinarSummit=this.webinarSummit,this.vilt.length>0&&(this.showVilt=!0),this.qae.length>0&&(this.showQae=!0),this.webinarSummit.length>0&&(this.showWebinarSummit=!0),this.labCourses.length>0&&(this.showLabCourses=!0),this.onDemandCourses.length>0&&(this.showOnDemandCourses=!0)}},{key:"$onInit",value:function(){this.data=JSON.parse(this.srcData.replace(/'/g,'"')),this.dataLength=this.data.length,this.sortOptions=this.filterSelectProperties.split(","),this.webinarSortOptions=this.filterWebinarSelectProperties.split(","),this.defaultSelectedOption=this.sortSelection,this.sortData(this.defaultSelectedOption)}}]),e}();t.default=r},388:function(e,t,i){"use strict";function a(e){e.attr("aria-expanded",function(e,t){return"true"===t?"false":"true"}),window.jQuery(e.data("target")).attr("aria-hidden",function(e,t){return"true"===t?"false":"true"}),"true"===e.attr("aria-expanded")?e.addClass("expanded"):e.removeClass("expanded")}!function(e){e("[data-collapse-toggle]").on("click",function(){a(e(this)),e(e(this).data("target")).collapseToggle()}),e.fn.collapseToggle=function(){this.slideToggle("fast"),this.focus()}}(jQuery)},389:function(e,t,i){"use strict";!function(e){var t=function(e,t){e.on("modal-closed",function(){t&&t.focus(),e.off("modal-closed keydown")})},i=function(e){var t=e.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');if(!(!t.length>0)){t[0].focus();var i=function(e){document.activeElement===t[0]&&(e.preventDefault(),t[t.length-1].focus())},a=function(e){document.activeElement===t[t.length-1]&&(e.preventDefault(),t[0].focus())};e.on("keydown",function(n){switch(n.keyCode){case 9:if(1===t.length){n.preventDefault();break}n.shiftKey?i(n):a(n);break;case 27:n.stopPropagation(),n.preventDefault(),e.overlay()}})}};if(e.fn.overlay=function(a){e(this).toggleClass("-visible"),e(this).hasClass("-visible")?(i(e(this)),e(this).attr("aria-hidden","false"),e("body").addClass("h-overlay__open"),t(e(this),a)):(e(this).attr("aria-hidden","true"),!e(".h-overlay.-visible").length>0&&e("body").removeClass("h-overlay__open"),e(this).trigger("modal-closed"))},e(".h-overlay.-visible").length>0){for(var a=1;a<e(".h-overlay.-visible").length;a++)e(e(".h-overlay.-visible")[a]).overlay();i(e(e(".h-overlay.-visible")[0])),e("body").addClass("h-overlay__open"),e(e(".h-overlay.-visible")[0]).attr("aria-hidden",!1)}}(jQuery)},390:function(e,t,i){"use strict";!function(e){e("[data-modal]").on("click",function(){e(e(this).data("target")).overlay(e(this))})}(jQuery)},391:function(e,t,i){"use strict";window.jQuery(".clp-resources-hero").slick({dots:!0})},392:function(e,t,i){"use strict";function a(e,t){e.attr("data-target")&&""!==e.data("target")&&window.jQuery(e.data("target")).overlay(),"agree"===e.data("terms")&&t.toggleClass("-no-access")}!function(e){var t=e("[data-terms]"),i=e('[data-terms="toggle"]');t.length>0&&t.on("click",function(){a(e(this),i)})}(jQuery)},393:function(e,t,i){"use strict";function a(e){window.jQuery.ajax({url:"/api/chapterleader/downloadredirect?id="+e,type:"GET",success:function(e){window.open(e,"_self")},error:function(){window.alert("File Download Failed")}})}!function(e){var t=e("[data-download]");t.length>0&&t.on("click",function(t){t.preventDefault(),a(e(this).data("download"))})}(jQuery)},394:function(e,t,i){"use strict";!function(e){e(".c-expand-collapse__drawer-tab").click(function(t){t.preventDefault();var i=e(this),a=!i.hasClass("is-active");i.toggleClass("is-active"),i.children(".fa").toggleClass("fa-plus"),i.children(".fa").toggleClass("fa-minus"),i.next().slideToggle(350),a&&e("html, body").animate({scrollTop:i.next().offset().top-80},1e3)})}(jQuery)},395:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(t,"__esModule",{value:!0});var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r="dropdown-toggle",s="target",o=window.jQuery("[data-"+r+"]"),l=function(){function e(t){a(this,e),this.$el=t,this.$target=window.jQuery(this.$el.data(s)),this.match=this.$el.data(r),this.init()}return n(e,[{key:"init",value:function(){this.setupListeners()}},{key:"setupListeners",value:function(){var e=this;this.$el.on("change",function(){return e.checkVal()})}},{key:"checkVal",value:function(){this.$el.val().toString()===this.match?this.$target.prop("disabled",!1):this.$target.prop("disabled",!0)}}]),e}();window.jQuery.each(o,function(e,t){return new l(window.jQuery(t))}),t.default=l},396:function(e,t,i){"use strict";function a(e){e.remove()}function n(e,t,i){var a="";if(i){var n=new Date;n.setTime(n.getTime()+24*i*60*60*1e3),a="; expires="+n.toGMTString()}document.cookie=e+"="+t+a+";path=/;secure"}function r(e){for(var t=e+"=",i=document.cookie.split(";"),a=0;a<i.length;a++){for(var n=i[a];" "===n.charAt(0);)n=n.substring(1,n.length);if(0===n.indexOf(t))return n.substring(t.length,n.length)}return null}function s(e){n(e,"",-1)}function o(e,t){e.removeClass(t),e.find(".privacy-col").removeClass(t),e.find(".isaca-consent-text-toggle").removeClass(t),e.find(".isaca-consent-text").removeClass(t)}!function(e){var t="mobile-toggle",i=e("[data-privacy-display]");if(i.length>0){var l=e("[data-privacy-accept]"),c=e("[data-privacy-delete]");if(l.length>0){for(var d=[],u=!0,p=0;p<l.length;p++)d[e(l[p]).data("id")]=r(e(l[p]).data("id"));for(var h in d)"true"===d[h]?a(e('[data-privacy-display="'+h+'"]')):u=!1;u&&a(i),l.on("click",function(){o(e(this).closest(".isaca-consent-privacy"),t),n(e(this).data("id"),"true",e(this).data("cookie-policy-expiration")),a(e('[data-privacy-display="'+e(this).data("id")+'"]'))})}else a(i);c.length>0&&c.on("click",function(){s(e(this).data("id"))});e("[data-privacy-details]").on("click",function(){e(this).closest(".isaca-consent-privacy").hasClass(t)?e(this).hasClass(t)?(e(this).removeClass(t),e(this).closest(".isaca-consent-privacy").removeClass(t),e(e(this).data("parent")).removeClass(t),e(e(this).data("target")).removeClass(t)):(e(this).closest(".isaca-consent-privacy").find(".privacy-col").removeClass(t),e(this).closest(".isaca-consent-privacy").find(".isaca-consent-text-toggle").removeClass(t),e(this).closest(".isaca-consent-privacy").find(".isaca-consent-text").removeClass(t),e(this).addClass(t),e(this).closest(".isaca-consent-privacy").addClass(t),e(e(this).data("parent")).addClass(t),e(e(this).data("target")).addClass(t)):(e(this).addClass(t),e(this).closest(".isaca-consent-privacy").addClass(t),e(e(this).data("parent")).addClass(t),e(e(this).data("target")).addClass(t))});e("[data-privacy-details-close]").on("click",function(){o(e(this).closest(".isaca-consent-privacy"),t)})}}(jQuery)},397:function(e,t,i){"use strict";function a(e,t){var i=window.jQuery(e).text().substring(t);window.jQuery(e).html(window.jQuery(e).text().substring(0,t)+'<span class="c-char-limit -visible">...</span>\n    <span class="c-char-limit">'+i+'</span>\n    <button type="button" class="c-btn c-btn--link c-char-limit--btn">\n        Show \n        <span class="c-char-limit -visible">more</span>\n        <span class="c-char-limit">less</span>\n    </button>')}!function(e){for(var t=e("[data-char-limit]"),i=0;i<t.length;i++)e(t[i]).text().length>e(t[i]).data("char-limit")&&(a(e(t[i]),e(t[i]).data("char-limit")),e(t[i]).find(".c-char-limit--btn").on("click",function(){e(this).parents("[data-char-limit]").find(".c-char-limit").toggleClass("-visible")}))}(jQuery)},398:function(e,t,i){"use strict";!function(e){var t=function(e){e.is(":checkbox")?e.prop("checked",!1):e.val("")},i=function(e){e.is(":checkbox")?e.hasClass("input-checkbox")&&e.parent().hasClass("input-checkbox__wrapper")&&e.parent().toggleClass("input-checkbox__wrapper--disabled"):e.prop("disabled")&&e.removeClass("input--filled input--valid")},a=function(e,a,n){var r=e.prop("disabled"),s="onEnable"===e.data("ignore-toggle-disabled"),o="onDisable"===e.data("ignore-toggle-disabled");switch(a){case"disable":case"enable":n?o||e.prop("disabled",n):s||e.prop("disabled",n);break;default:r?s||e.prop("disabled",function(){return!e.prop("disabled")}):o||e.prop("disabled",function(){return!e.prop("disabled")})}i(e),e.prop("disabled")&&t(e)},n=function(t,i,n){t.each(function(t,r){var s=e(r);n?a(s,i,!0):a(s,i,!1)})},r=e("[data-toggle-disabled]");r.on("change",function(){var t=e(this),i=t.prop("checked"),a=t.data("toggle-disabled"),r=e(t.data("target")).find(":input");n(r,a,i)}),r.each(function(t,i){var a=e(i);if(a.prop("checked")){var r=a.data("toggle-disabled"),s=e(a.data("target")).find(":input");n(s,r,!0)}})}(jQuery)},399:function(e,t,i){"use strict";!function(e){function t(t,i,a){i.append('<option value=""></option>'),e.each(t,function(e,t){var n="";"N/A"===e?(n="selected",i.addClass("input--filled input--valid")):a&&i.data("preselect-state")===e&&(n="selected",i.addClass("input--filled input--valid")),i.append('<option value="'+e+'" '+n+">"+t+"</option>")})}var a=[],n=i(91).hasErrors,r=i(91).default,s=e("[data-state-autofill]"),o=s.closest("form"),l="",c={},d=function(t,i,a){var n=e(t);"CA"!==i&&"US"!==i?n.prop("disabled",!0):a||n.prop("disabled",!1)},u=function i(s,u,p){var h=e(u),f=n(o);if(h.empty(),p&&r(o),d(h,s,!1),f&&o.valid(),""!==s){l=s;var v=void 0!==h.data("preselect-state")&&""!==h.data("preselect-state");if(c.hasOwnProperty(s))return t(c[s],h,v),void d(h,s,!1);if(-1!==a.indexOf(h.attr("id")))return;a.push(h.attr("id")),e.ajax({url:"/api/checkout/GetSubdivisions",type:"POST",data:{countryCode:s},dataType:"json",success:function(e){l===s&&(c[s]=e.States,t(e.States,h,v))},error:function(e){console.log("Error - "+e.status+": "+e.statusText)},complete:function(){var t=a.indexOf(h.attr("id"));t>-1&&a.splice(t,1),l===s?d(h,s,!1):(d(h,l,!1),i(l,u,p)),h.attr("id").indexOf("home")>-1&&e("#homeAddressCountries").change(),h.attr("id").indexOf("business")>-1&&e("#businessAddressCountries").change(),h.change()}})}};s.each(function(){var t=e(this),i=t.val(),a=e(t.data("target").replace(".","\\."));void 0!==i&&""!==i&&(d(a,i,!0),u(i,a,!1)),t.closest("form").on("submit",function(){a.prop("disabled",!1)})}),s.on("change keyup",function(t){if("change"===t.type||"keyup"===t.type&&9!==t.which&&27!==t.which){var i=e(this).val(),a=e(e(this).data("target").replace(".","\\.")),n=void 0===e(this).data("reset-form")||!!e(this).data("reset-form");void 0!==i&&u(i,a,n)}})}(jQuery)},400:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r="data-checkbox-required",s="data-checkbox-validation-control",o=function(e,t){return window.jQuery(window.jQuery(e).find("["+t+"]"))},l=function(){function e(t,i,n){a(this,e),this.buttons=t,this.checkboxes=i,this.controls=n,this.init()}return n(e,[{key:"init",value:function(){var e=this;this.validate(),this.checkboxes.on("change.checkboxValidation",function(){return e.validate()}),this.controls.on("change.checkboxValidation",function(t){return e.checkValidationControl(window.jQuery(t.target))})}},{key:"validate",value:function(){var e=!0;this.checkboxes.each(function(t,i){window.jQuery(i).is(":checked")||(e=!1)}),this.toggleBtn(e)}},{key:"checkValidationControl",value:function(e){var t=!0,i=window.jQuery(e.data(s.replace("data-",""))),a=e.data("checkbox-control-data"),n=a.split(","),r=e.val();n.forEach(function(e){r===e&&(t=!1)}),t?this.toggleValidationOn(i):this.toggleValidationOff(i)}},{key:"toggleValidationOn",value:function(e){e[0].hasAttribute(r)||(this.destroyListeners(),e[0].setAttribute(r,""),this.checkboxes=window.jQuery(e).closest("form").find("["+r+"]"),this.init())}},{key:"toggleValidationOff",value:function(e){this.destroyListeners(),e[0].removeAttribute(r),this.checkboxes=this.checkboxes.not(e[0]),this.init()}},{key:"destroyListeners",value:function(){this.checkboxes.off("change.checkboxValidation"),this.controls.off("change.checkboxValidation")}},{key:"toggleBtn",value:function(e){this.buttons.prop("disabled",!e)}}]),e}();window.jQuery("form").each(function(e,t){if(o(t,"data-checkbox-validation").length>0){var i=new l(o(t,"data-checkbox-validation"),o(t,r),o(t,s));window.jQuery(t).data("validation",i)}})},401:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=function(e,t){return window.jQuery(window.jQuery(e).find("["+t+"]"))},s=function(){function e(t,i,n){a(this,e),this.buttons=t,this.inputs=i,this.clearCtrl=n,this.init()}return n(e,[{key:"init",value:function(){var e=this,t=this;this.validate(),this.inputs.on("input.inputValidation",function(){return e.validate()}),this.clearCtrl.on("click.inputClear",function(){t.clear(this)})}},{key:"clear",value:function(e){var t=window.jQuery(e).data("target")||null;if(t){window.jQuery("#"+t.replace("#","")).val(""),this.validate()}}},{key:"validate",value:function(){var e=!0;this.inputs.each(function(t,i){null!==window.jQuery(i).val()&&""!==window.jQuery(i).val()||(e=!1)}),this.toggleBtn(e)}},{key:"toggleBtn",value:function(e){this.buttons.prop("disabled",!e)}}]),e}();window.jQuery("form").each(function(e,t){r(t,"data-input-validation").length>0&&new s(r(t,"data-input-validation"),r(t,"data-input-required"),r(t,"data-input-clear"))})},402:function(e,t,i){"use strict";!function(e){var t=function(e){return""!==e&&void 0!==e},i=function(e){var i=e.data("max"),a=t(e.val())?Number(e.val()):0,n=a+Number(e.data("step"));t(i)?n<=i&&(e.val(n),document.getElementById(e[0].id).dispatchEvent(new Event("change"))):e.val(n)},a=function(e){var i=e.data("min"),a=t(e.val())?Number(e.val()):0,n=a-Number(e.data("step"));t(i)?n>=i&&e.val(n):e.val(n)};e("[data-input-number]").on("keydown",function(n){var r=n.which||n.keyCode,s=!1,o=9999,l=9999,c=9999;return t(e(this).data("min"))?e(this).data("min")<0&&(o=109):o=109,t(e(this).data("int"))?e(this).data("int")||(l=110,c=190):(l=110,c=190),(!n.shiftKey&&!n.altKey&&!n.ctrlKey&&r>=48&&r<=57||r>=96&&r<=105||r===c||r===l||r===o||8===r||9===r||13===r||35===r||36===r||37===r||39===r||46===r||45===r)&&(s=!0),38===r?i(e(this)):40===r&&a(e(this)),s}),e("[data-input-increment]").on("click",function(){var t=e(e(this).data("input-increment"));i(t)}),e("[data-input-decrement").on("click",function(){var t=e(e(this).data("input-decrement"));a(t)}),e("[data-input-ctrl]").on("focus",function(){e(this).parent().addClass("active")}),e("[data-input-ctrl]").on("blur",function(){e(this).parent().removeClass("active")})}(jQuery)},403:function(e,t,i){"use strict";var a=i(404),n=function(e){return e&&e.__esModule?e:{default:e}}(a);!function(e){for(var t=e("div[id^='videoPlayer']"),i={},a=0;a<t.length;a++){var r={};r.videoId=t[a].dataset.videoId,void 0===i[t[a]]&&(i[t[a].id]=(0,n.default)(t[a].id,r))}e(".video-player").on("click",function(t){if(t.preventDefault(),!t.target.classList.contains("modal-close-icon")&&!t.target.classList.contains("is-active")){var a=e(this),n=a.find(".iframe")[0],r=a.find(".thumbnail");if(a.hasClass("is-modal")){var s=e(window).scrollTop(),o=a.children(".modal-close-icon");a.addClass("is-active"),e(window).scrollTop(0),e("body").css("overflow","hidden"),o.css("display","inline-block"),o.on("click",function(){i[n.id].stopVideo().then(function(){}),o.css("display","none"),e("body").css("overflow","visible"),e(window).scrollTop(s),a.removeClass("is-active"),r.fadeIn()})}i[n.id].playVideo().then(function(){window.setTimeout(function(){r.fadeOut()},300)}),i[n.id].on("stateChange",function(e){0===e.data&&window.setTimeout(function(){r.fadeIn()},3e3)})}})}(jQuery)},417:function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var n=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),r=i(91),s="zip-validation",o=function(){function e(t){a(this,e),t.data("zip-target")&&t.data(s)&&(this.$el=t,this.$target=window.jQuery(""+t.data("zip-target")),this.countryCodes=t.data(s).split(","),this.init())}return n(e,[{key:"init",value:function(){this.setupListeners()}},{key:"setupListeners",value:function(){this.$el.on("click.validationToggle",this.checkVals.bind(this)),this.$el.on("keyup.validationToggle",this.checkVals.bind(this))}},{key:"checkVals",value:function(){var e=this.$el.closest("form"),t=this.$el.val(),i=!1;if(this.countryCodes&&this.countryCodes.length>0)for(var a=0;a<this.countryCodes.length;a++)if(this.countryCodes[a]===t){i=!0;break}void 0!==this.$target.rules&&(i?this.$target.rules("add","required"):this.$target.rules("remove","required"),(0,r.hasErrors)(e)&&e.valid())}},{key:"destroy",value:function(){this.$el.off("click.validationToggle"),this.$el.off("keyup.validationToggle")}}]),e}();!function(){window.jQuery("[data-"+s+"]").each(function(e,t){return new o(window.jQuery(t))})}()},418:function(e,t,i){"use strict";!function(e){var t=window.innerWidth,i=window.innerHeight;e(".menu-btn").on("click",function(){var t=e(this);return window.navApp.closeSearch(),window.navApp.closeProfile(),window.navApp.toggleMenu(t),!1}),e(".primaryNavigation__item--backBtn a").on("click",function(){var t=e(this);return window.navApp.hideSubmenu(t),!1}),e(".primaryNavigation__slider-item > a, .myIsaca__slider-item > a").on("click",function(){var t=e(this),i=t.parent().attr("class");if(i=i.split("__"),0!==t.next("."+i[0]+"__slider-menu").children().length)return window.navApp.toggleSlider(t,i[0]),!1}),e(".utilityNavigation__item--search").on("click",function(){var t=e(this);return window.navApp.closeMenu(),window.navApp.closeProfile(),window.navApp.toggleSearch(t),!1}),window.navApp={toggleMenu:function(t){e("body").toggleClass("overflow"),t.hasClass("menu-btn--active")&&(e(".primaryNavigation__secondary").removeClass("primaryNavigation__secondary--active"),e(".primaryNavigation__slider-item").removeClass("primaryNavigation__slider-item--active"),e(".primaryNavigation__slider-menu").removeClass("primaryNavigation__slider-menu--active")),t.toggleClass("menu-btn--active"),e(".primaryNavigation").toggleClass("primaryNavigation--active"),e(".primaryNavigation").find(".primaryNavigation__container").removeClass("primaryNavigation__container--submenu-open")},showSubmenu:function(t){e(".primaryNavigation__overlay").addClass("primaryNavigation__overlay--active"),t.next(".primaryNavigation__secondary").addClass("primaryNavigation__secondary--active")},hideSubmenuDesktop:function(t){e(t).closest(".primaryNavigation__container").scrollTop(0),e(t).closest(".primaryNavigation__container").addClass("primaryNavigation__container--submenu-open"),e(".primaryNavigation__overlay").removeClass("primaryNavigation__overlay--active"),t.next(".primaryNavigation__secondary").removeClass("primaryNavigation__secondary--active")},hideSubmenu:function(t){e(t).closest(".primaryNavigation__container").removeClass("primaryNavigation__container--submenu-open"),t.parent().parent(".primaryNavigation__secondary").removeClass("primaryNavigation__secondary--active")},toggleSlider:function(e,t){e.parent().toggleClass(t+"__slider-item--active"),e.next("."+t+"__slider-menu").toggleClass(t+"__slider-menu--active")},toggleSearch:function(t){e("body").toggleClass("overflow"),t.toggleClass("utilityNavigation__item--search--active"),e(".search").toggleClass("search--active"),e(".search").hasClass("search--active")&&setTimeout(function(){e("#main-search").focus()},100)},toggleProfile:function(t){e("body").toggleClass("overflow"),t.toggleClass("utilityNavigation__item--myIsaca--active"),e(".myIsaca").toggleClass("myIsaca--active")},closeMenu:function(){e(".menu-btn").hasClass("menu-btn--active")&&(e("body").removeClass("overflow"),e(".primaryNavigation__secondary").removeClass("primaryNavigation__secondary--active"),e(".primaryNavigation__slider-item").removeClass("primaryNavigation__slider-item--active"),e(".primaryNavigation__slider-menu").removeClass("primaryNavigation__slider-menu--active"),e(".menu-btn").removeClass("menu-btn--active"),e(".primaryNavigation").removeClass("primaryNavigation--active"))},closeSearch:function(){e(".search").hasClass("search--active")&&(e("body").removeClass("overflow"),e(".utilityNavigation__item--search").removeClass("utilityNavigation__item--search--active"),e(".search").removeClass("search--active"))},closeProfile:function(){e(".myIsaca").hasClass("myIsaca--active")&&(e("body").removeClass("overflow"),e(".utilityNavigation__item--myIsaca").removeClass("utilityNavigation__item--myIsaca--active"),e(".myIsaca").removeClass("myIsaca--active"))}};var a={init:function(){e(".primaryNavigation--desktop").is(":visible")?this.bindDesktopEventHandlers():this.bindMobileEventHandlers()},reinitMobile:function(){this.unbindDesktopEventHandlers(),this.bindMobileEventHandlers()},reinitDesktop:function(){this.unbindMobileEventHandlers(),this.bindDesktopEventHandlers(),e(".myIsaca").hasClass("myIsaca--active")?e(".primaryNavigation__overlay").addClass("primaryNavigation__overlay--active"):e(".primaryNavigation__overlay").removeClass("primaryNavigation__overlay--active")},bindMobileEventHandlers:function(){for(var e=0;e<this.mobileEventHandlers.length;e++)this.bindEvent(this.mobileEventHandlers[e])},bindDesktopEventHandlers:function(){for(var e=0;e<this.desktopEventHandlers.length;e++)this.bindEvent(this.desktopEventHandlers[e])},unbindMobileEventHandlers:function(){for(var e=0;e<this.mobileEventHandlers.length;e++)this.unbindEvent(this.mobileEventHandlers[e])},unbindDesktopEventHandlers:function(){for(var e=0;e<this.desktopEventHandlers.length;e++)this.unbindEvent(this.desktopEventHandlers[e])},bindEvent:function(e){e.$el.on(e.event,e.handler)},unbindEvent:function(e){e.$el.off(e.event,e.handler)},mobileEventHandlers:[{$el:e(".primaryNavigation__primary > li > a"),event:"click",handler:function(){var t=e(this);return window.navApp.showSubmenu(t),!1}},{$el:e(".utilityNavigation__item--myIsaca"),event:"click",handler:function(){var t=e(this);return window.navApp.closeMenu(),window.navApp.closeSearch(),window.navApp.toggleProfile(t),!1}},{$el:e(".primaryNavigation__tertiary-title"),event:"click",handler:function(t){t.preventDefault(),window.location=e(this).children("a").attr("href")}}],desktopEventHandlers:[{$el:e(".primaryNavigation__primary > li > a"),event:"mouseenter",handler:function(){var t=e(this);0!==e(".fullpage-wrapper").length&&e.fn.fullpage.setAllowScrolling(!1),window.navApp.closeSearch(),window.navApp.showSubmenu(t)}},{$el:e(".primaryNavigation__item-link"),event:"mouseleave",handler:function(){var t=e(this);0!==e(".fullpage-wrapper").length&&e.fn.fullpage.setAllowScrolling(!0),window.navApp.hideSubmenuDesktop(t)}},{$el:e(".primaryNavigation__secondary"),event:"mouseenter",handler:function(){var t=e(this);return 0!==e(".fullpage-wrapper").length&&e.fn.fullpage.setAllowScrolling(!1),e(".primaryNavigation__overlay").addClass("primaryNavigation__overlay--active"),t.addClass("primaryNavigation__secondary--active"),t.parent().children(".primaryNavigation__item-link").addClass("primaryNavigation__item-link--active"),!1}},{$el:e(".primaryNavigation__secondary"),event:"mouseleave",handler:function(){var t=e(this);return 0!==e(".fullpage-wrapper").length&&e.fn.fullpage.setAllowScrolling(!0),e(".primaryNavigation__overlay").removeClass("primaryNavigation__overlay--active"),t.removeClass("primaryNavigation__secondary--active"),t.parent().children(".primaryNavigation__item-link").removeClass("primaryNavigation__item-link--active"),!1}},{$el:e(".utilityNavigation__item--myIsaca"),event:"mouseenter",handler:function(){if(window.innerWidth<1024)return!1;var t=e(this);return 0!==e(".fullpage-wrapper").length&&e.fn.fullpage.setAllowScrolling(!1),window.navApp.closeSearch(),e(".primaryNavigation__overlay").addClass("primaryNavigation__overlay--active"),t.addClass("utilityNavigation__item--myIsaca--active"),e(".myIsaca").addClass("myIsaca--active"),!1}},{$el:e(".myIsaca"),event:"mouseenter",handler:function(){var t=e(".utilityNavigation__item--myIsaca");0!==e(".fullpage-wrapper").length&&e.fn.fullpage.setAllowScrolling(!1),e(".primaryNavigation__overlay").addClass("primaryNavigation__overlay--active"),t.addClass("utilityNavigation__item--myIsaca--active"),e(".myIsaca").addClass("myIsaca--active")}},{$el:e(".utilityNavigation__item--myIsaca"),event:"mouseleave",handler:function(){if(window.innerWidth<1024)return!1;var t=e(this);return 0!==e(".fullpage-wrapper").length&&e.fn.fullpage.setAllowScrolling(!0),e(".primaryNavigation__overlay").removeClass("primaryNavigation__overlay--active"),t.removeClass("utilityNavigation__item--myIsaca--active"),e(".myIsaca").removeClass("myIsaca--active"),!1}},{$el:e(".myIsaca"),event:"mouseleave",handler:function(){var t=e(".utilityNavigation__item--myIsaca");return 0!==e(".fullpage-wrapper").length&&e.fn.fullpage.setAllowScrolling(!0),e(".primaryNavigation__overlay").removeClass("primaryNavigation__overlay--active"),t.removeClass("utilityNavigation__item--myIsaca--active"),e(".myIsaca").removeClass("myIsaca--active"),!1}}]};a.init(),e(window).resize(function(){var e=window.innerWidth,n=window.innerHeight;t<1024&&e>=1024||i<window.DesktopHeight&&n>=window.DesktopHeight?a.reinitDesktop():(t>=1024&&e<1024||i>=window.DesktopHeight&&n<window.DesktopHeight)&&a.reinitMobile(),t=e,i=n})}(jQuery)},91:function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e){var t=e.validate();a(e).each(function(){t.settings.success(window.jQuery(this))}),t.resetForm()};var a=function(e){return e.find(".field-validation-error span")};t.hasErrors=function(e){return a(e).length>0}}},[153]);

﻿$(document).ready(function () {
    if ($(".browse-facet").length || $(".browse-layout").length || $(".browse-paging").length) {
        var browseFacets = [];
        var browsePage = 0;
        var browsePageSize = 16;
        var browseSorted = "";
        var browseCollectionClass = ".browse-collection:not(.slick-slider)";
        var $browseCollection = $(browseCollectionClass);
        var $browseFacet = $(".browse-facet");
        var $browseLayout = $(".browse-layout");
        var $browsePaging = $(".browse-paging");
        var $browseResults = $(".browse-results");
        var $browseSort = $(".browse-sort");

        ResetBrowseFiltering();

        if ($browseFacet.length) {
            var $facets = $browseFacet.find("label");
            var facetCount = $facets.length;
            var facetsHidden = 0;

            $facets.each(function (index) {
                var facet = $(this).data("facet");
                var filter = $(this).data("filter-value");
                var exists = $browseCollection.children("[data-" + facet + "*='" + filter + "']");

                if (exists.length == 0) {
                    ++facetsHidden;
                    $(this).parent().hide();
                }
            });

            if (facetCount == facetsHidden) {
                $browseFacet.hide();
            } else {
                $browseFacet.on("click", "label", function () {
                    var facet = $(this).data("facet");
                    var filter = $(this).data("filter-value");
                    $browseCollection = $(browseCollectionClass);

                    if (facet && filter) {
                        var facetObject = { facet: facet, filter: filter };

                        if ($(this).hasClass("active")) {
                            $(this).removeClass("active");
                            $(this).children("input:checkbox").prop("checked", false);
                            var i = -1;
                            for (var j = 0; j < browseFacets.length; j++) {
                                if (browseFacets[j].facet === facet && browseFacets[j].filter === filter) {
                                    i = j;
                                    break;
                                }
                            }

                            if (i >= 0)
                                browseFacets.splice(i, 1);
                        } else {
                            $(this).addClass("active");
                            $(this).children("input:checkbox").prop("checked", true);
                            browseFacets.push(facetObject);
                        }

                        if (browseFacets.length > 0) {
                            $browseCollection.children().each(function () {
                                var match = false;
                                var child = this;

                                $(browseFacets).each(function () {
                                    if ($(child).length > 0 && $(child).data(this.facet) && $(child).data(this.facet).includes(this.filter)) {
                                        match = true;
                                    }
                                });

                                if (match) {
                                    $(this).removeClass("hide").addClass("active");
                                } else {
                                    $(this).addClass("hide").removeClass("active");
                                }
                            });
                        } else {
                            ResetBrowseFiltering();
                        }

                        if ($browseResults.length > 0) {
                            ResetBrowseResults();
                        }

                        if (browsePage > 0) {
                            ResetBrowsePaging();
                        }
                    }
                });
            }
        }

        if ($browseLayout.length > 0) {
            if ($browseLayout.data("default-layout")) {
                SwitchBrowseLayout($browseLayout.data("default-layout"));
            }

            $browseLayout.on("click", "a", function () {
                $browseCollection = $(browseCollectionClass);

                SwitchBrowseLayout($(this).data("layout"));
            });
        }

        if ($browsePaging.length > 0) {
            browsePageSize = parseInt($browsePaging.data("page-size"), 10);
            ResetBrowsePaging();

            $browsePaging.on("click", "a", function () {
                var index = 0;
                $browseCollection = $(browseCollectionClass);
                var size = $browseCollection.children(".active").length;
                var pages = Math.ceil(size / browsePageSize);

                if ($(this).data("page") == "left") {
                    browsePage = parseInt($browsePaging.children(".active").first().data("page"), 10) - 1;
                    if (browsePage <= 1) { browsePage = 1; }
                    $browsePaging.children(".active").removeClass("active");
                    $browsePaging.children("[data-page='" + browsePage + "']").addClass("active");
                } else if ($(this).data("page") == "right") {
                    browsePage = parseInt($browsePaging.children(".active").first().data("page"), 10) + 1;
                    if (browsePage > pages) { browsePage = pages; }
                    $browsePaging.children(".active").removeClass("active");
                    $browsePaging.children("[data-page='" + browsePage + "']").addClass("active");
                } else {
                    browsePage = parseInt($(this).data("page"), 10);
                    $browsePaging.children(".active").removeClass("active");
                    $(this).addClass("active");
                }

                if (browsePage <= 1) {
                    $browsePaging.children(".arrows[data-page='left']").addClass("inactive");
                    $browsePaging.children(".arrows[data-page='right']").removeClass("inactive");
                } else if (browsePage < pages) {
                    $browsePaging.children(".arrows.inactive").removeClass("inactive");
                } else {
                    $browsePaging.children(".arrows[data-page='left']").removeClass("inactive");
                    $browsePaging.children(".arrows[data-page='right']").addClass("inactive");
                }

                var pageMin = (browsePage - 1) * browsePageSize;
                var pageMax = browsePage * browsePageSize;

                $browseCollection.children(".active").each(function () {
                    if (index < pageMin || index >= pageMax) {
                        $(this).addClass("hide");
                    } else {
                        $(this).removeClass("hide");
                    }

                    ++index;
                });

                if ($browseResults.length > 0) {
                    var count = $browseCollection.children(".active").length;
                    var max = pageMax;

                    if (max > count) {
                        max = count;
                    }

                    $browseResults.text((pageMin + 1) + "-" + max + " of " + count);
                }
            });
        }

        if ($browseResults.length > 0) {
            ResetBrowseResults();
        }

        if ($browseSort.length) {
            var defaultSortOption = $browseSort.children("a.coveo-selected").first();

            if (defaultSortOption.length) {
                browseSorted = defaultSortOption.data("sort-value");
            }

            $browseSort.on("click", "a", function () {
                var sort = $(this).data("sort-value");

                if (sort == browseSorted) {
                    if ($(this).hasClass("coveo-descending")) {
                        $(this).removeClass("coveo-descending");
                        $(this).addClass("coveo-ascending");
                    } else {
                        $(this).addClass("coveo-descending");
                        $(this).removeClass("coveo-ascending");
                    }
                } else {
                    $browseSort.children().removeClass("coveo-selected").removeClass("coveo-ascending").removeClass("coveo-descending");
                    $(this).addClass("coveo-selected");
                    $(this).addClass("coveo-descending");
                }

                browseSorted = sort;
                $browseCollection = $(browseCollectionClass);

                if ($browseCollection.length > 0) {
                    if ($(this).hasClass("coveo-descending")) {
                        $browseCollection.children().sort(function (a, b) {
                            return +b.getAttribute("data-" + sort) - +a.getAttribute("data-" + sort);
                        }).appendTo($browseCollection);
                    } else {
                        $browseCollection.children().sort(function (a, b) {
                            return +a.getAttribute("data-" + sort) - +b.getAttribute("data-" + sort);
                        }).appendTo($browseCollection);
                    }

                    var size = $browseCollection.children(".active").length;

                    if (size > browsePageSize) {
                        $browseCollection = $(browseCollectionClass);
                        $browseCollection.children(".active").removeClass("hide");
                        ResetBrowsePaging();
                    }
                }
            });
        }

        function ResetBrowseFiltering() {
            browseFacets = [];
            $browseCollection.children().addClass("active").removeClass("hide");
        }

        function ResetBrowsePaging() {
            var i = 0;
            browsePage = 1;
            var size = $browseCollection.children(".active").length;

            if (size > browsePageSize) {
                var pages = Math.ceil(size / browsePageSize);
                var html = "<a data-page=\"left\" class=\"arrows inactive\"><i class=\"fa-sharp fa-thin fa-angle-left\"></i></a>";

                $browseCollection.children(".active").each(function () {
                    if (i >= browsePageSize) {
                        $(this).addClass("hide");
                    }

                    ++i;
                });

                html += "<a data-page=\"1\" class=\"active\">1</a>";
                for (i = 2; i <= pages; i++) {
                    html += "<a data-page=\"" + i + "\">" + i + "</a>";
                }

                if (size > 1) {
                    html += "<a data-page=\"right\" class=\"arrows\"><i class=\"fa-sharp fa-thin fa-angle-right\"></i></a>";
                } else {
                    html += "<a data-page=\"right\" class=\"arrows inactive\"><i class=\"fa-sharp fa-thin fa-angle-right\"></i></a>";
                }

                ResetBrowseResults();
                $browsePaging.html(html);
            } else if ($browsePaging.html().length > 0) {
                $browsePaging.html("");
            }
        }

        function ResetBrowseResults() {
            if ($browseResults.length > 0) {
                browseSize = $browseCollection.children(".active").length;

                if ($browsePaging.length > 0) {
                    browsePageSize = parseInt($browsePaging.data("page-size"), 10);
                }

                if (browseSize > 0 && browseSize > browsePageSize)
                    $browseResults.text("1-" + browsePageSize + " of " + browseSize);
                else if (browseSize > 0)
                    $browseResults.text("1-" + browseSize + " of " + browseSize);
            }
        }

        function SwitchBrowseLayout(layoutClass) {
            $browseLayout.children().each(function () {
                var oldClass = $(this).data("layout");

                if (oldClass && oldClass != layoutClass)
                    $browseCollection.removeClass(oldClass).children("." + oldClass).removeClass(oldClass);
            });

            $browseCollection.addClass(layoutClass).children().addClass(layoutClass);
        }
    }
});
﻿if (window.location.search && URLSearchParams) {
	let campaign = [];
	let domain = ".isaca.org";
	const urlParams = new URLSearchParams(window.location.search);

	if (urlParams) {
		urlParams.forEach((value, key) => {
			if (key && key.startsWith("utm_") && value) {
				campaign.push(key + ":" + value.replace(/[^a-z0-9 _-]/gi, ''));
			}
		});

		if (!window.location.hostname.includes(".isaca.org")) {
			domain = window.location.hostname;
		}

		if (campaign.length > 0) {
			document.cookie = "ISACA_Campaign=" + campaign.join("|") + ";domain=" + domain + "; path=/";
		}
	}
}
(function ($) {
	var GenericModal = {
		init: function (settings) {
            GenericModal.config = {
                openModalBtn: $('[data-modal="open-modal"]'),
                speakersCls: ['generic-modal', 'speakers-modal'],
                speakersApiUrl: "/api/pagecontent/getspeakermodal?itemID="
			};

			// Allow overriding the default config
			$.extend(GenericModal.config, settings);

			GenericModal.setup();
		},

		setup: function () {
			// Open the modal with the open button.
			GenericModal.config.openModalBtn.each(function () {
				var $link = $(this);
				$link.click(function () {
                    var apiUrl = "";

                    if ($link.data("type") == "speakers") {
                        apiUrl = GenericModal.config.speakersApiUrl + $link.data("id");
                    }

                    $.ajax({
                        url: apiUrl,
                        success: function (result) {
                            if ($link.data("type") == "speakers") {
                                openModalBigContent(result, GenericModal.config.speakersCls);
                            }
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            console.log(xhr.status + ":" + thrownError)
                            openModalTinyNoFooter("<h4>There was an error retrieving content</h4>");
                        }
                    });
				})
			});
		},      
    };

    var SessionModal = {
        init: function (settings) {
            SessionModal.config = {
                openModalBtn: $('[data-modal="open-session-modal"]'),
                sessionsCls: ['generic-modal', 'sessions-modal'],
                sessionsApiUrl: "/api/conferencefullagenda/getsessionmodal?itemID="
            };

            // Allow overriding the default config
            $.extend(SessionModal.config, settings);

            SessionModal.setup();
        },

        setup: function () {
            // Open the modal with the open button.
            SessionModal.config.openModalBtn.each(function () {
                var $link = $(this);
                $link.click(function () {
                    var apiUrl = "";
                    var location = "";

                    if ($link.data("type") == "sessions") {
                        var sessionStartEnd = getDateTimeInTimezone($link.data("start"), $link.data("end"));
                        apiUrl = SessionModal.config.sessionsApiUrl + $link.data("id") + "&dt=" + sessionStartEnd;

                        //encode + sign, it represents white space
                        apiUrl = apiUrl.replace("+", "%2B");
                    }

                    $.ajax({
                        url: apiUrl,
                        success: function (result) {
                            if ($link.data("type") == "sessions") {
                                openModalForAgenda(result, SessionModal.config.sessionsCls);
                            }
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            console.log(xhr.status + ":" + thrownError)
                            openModalTinyNoFooter("<h4>There was an error retrieving content</h4>");
                        }
                    });
                })
            });


            function getDateTimeInTimezone(start, end) {
                var timeZone = $('.perDaySession:visible').find('.cfaDllTimeZones:first').val();
                var isVirtual = $('#cfaVirtual').val();
                var virtualBtnChecked = $('#virtual-sessions').hasClass('is-checked');
                var isInPerson = $('#cfaInPerson').val();
                var inPersonBtnChecked = $('#inperson-sessions').hasClass('is-checked');
                var eventTimezone = $('#cfaEventTimeZone').val();

                if ((isVirtual == "True" || virtualBtnChecked) && timeZone === '0') {
                    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                }
                else if ((isInPerson == "True" || inPersonBtnChecked) && !!eventTimezone) {
                    timeZone = eventTimezone;
                }
                else if (timeZone === '0') {
                    timeZone = 'UTC';
                }

                var is12hFormat = false;
                if (timeZone.startsWith('America')) {
                    is12hFormat = true;
                }

                var dtStart = new Date(start + ".000Z").toLocaleString('en-US', { timeZone: timeZone });
                var dtStartInTimeZone = new Date(dtStart);
                var tzShort = getTimezoneShort(timeZone, dtStartInTimeZone);

                var startTime = dtStartInTimeZone.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: is12hFormat });

                if (startTime.startsWith('0')) {
                    startTime = startTime.substring(1);
                }

                var dtEnd = new Date(end + ".000Z").toLocaleString('en-US', { timeZone: timeZone });
                var dtEndInTimeZone = new Date(dtEnd);
                var endTime = dtEndInTimeZone.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: is12hFormat });

                if (endTime.startsWith('0')) {
                    endTime = endTime.substring(1);
                }

                return dtStartInTimeZone.toLocaleString('en-US', { weekday: 'long' }) + ", " + dtStartInTimeZone.toLocaleString('en-US', { day: 'numeric' }) + " "
                    + dtStartInTimeZone.toLocaleString('en-US', { month: 'long' }) + " | " + startTime + " - " + endTime + " " + tzShort;
            }

            function getTimezoneShort(timeZone, dt) {
                var shortTimeZone = new Intl.DateTimeFormat('en-US', {
                    timeZone: timeZone,
                    timeZoneName: 'short'
                }).formatToParts(new Date(dt))
                    .find(part => part.type == "timeZoneName")
                    .value;

                if (shortTimeZone.includes("GMT")) {
                    shortTimeZone = shortTimeZone.replace("GMT", "UTC");
                }
                return shortTimeZone;
            }
        }
    };

    // Modal Tiny no footer
    function openModalTinyNoFooter(content) {
        var modalTinyNoFooter = new tingle.modal({
            onClose: function () {
                console.log('close');
            },
            onOpen: function () {
                console.log('open');
            },
            beforeOpen: function () {
                console.log('before open');
            },
            beforeClose: function () {
                console.log('before close');
                return true;
            },
            cssClass: ['class1', 'class2']
        });

        modalTinyNoFooter.setContent(content);
        modalTinyNoFooter.open();
    }

    // Modal tiny with btn
    function openModalTinyBtn(content) {
        var modalTinyBtn = new tingle.modal({
            footer: true
        });

        modalTinyBtn.addFooterBtn('Primary action', 'tingle-btn tingle-btn--primary tingle-btn--pull-right', function () {
            alert('click on primary button!');
        });

        modalTinyBtn.addFooterBtn('Cancel', 'tingle-btn tingle-btn--default tingle-btn--pull-right', function () {
            modalTinyBtn.close();
        });

        modalTinyBtn.addFooterBtn('Danger!', 'tingle-btn tingle-btn--danger', function () {
            alert('click on danger button!');
        });

        modalTinyBtn.setContent(content);
        modalTinyBtn.open();
    }

    // Modal big
    function openModalBigContent(content, cssCls) {
        var modalBigContent = new tingle.modal({
            cssClass: cssCls,
            onClose: function () {
                modalBigContent.destroy();
            },
            beforeOpen: function () {
                // move close button inside modal for desktops only
                if ($(window).width() > 1024) {
                    var closeBtn = $('.tingle-modal__close');
                    if (closeBtn.length > 0) {
                        var tModal = $('.tingle-modal-box');
                        if (tModal.length > 0) {
                            tModal[0].appendChild(closeBtn[0]);
                        }
                    }
                }
            }
        });

        modalBigContent.setContent(content);
        modalBigContent.open();
    }

    function openModalForAgenda(content, cssCls) {
        var modalBigContent = new tingle.modal({
            cssClass: cssCls,
            onClose: function () {
                modalBigContent.destroy();
            },
            beforeOpen: function () {
                var closeBtn = $('.tingle-modal__close');
                if (closeBtn.length > 0) {
                    var tModal = $('.tingle-modal-box__content');
                    if (tModal.length > 0) {
                        tModal[0].appendChild(closeBtn[0]);
                    }
                }
            }
        });

        modalBigContent.setContent(content);
        modalBigContent.open();
    }

    // Modal big with sticky footer
    function openModalStickyFooter(content) {
        var modalStickyFooter = new tingle.modal({
            footer: true,
            stickyFooter: true
        });

        modalStickyFooter.addFooterBtn('I agree', 'tingle-btn tingle-btn--primary tingle-btn--pull-right', function () {
            modalStickyFooter.close();
        });

        modalStickyFooter.addFooterBtn('Cancel', 'tingle-btn tingle-btn--default tingle-btn--pull-right', function () {
            modalStickyFooter.close();
        });

        modalStickyFooter.setContent(content);
        modalStickyFooter.open();
    }

    // Force close button
    function openModalButtonOnly(content) {
        var modalButtonOnly = new tingle.modal({
            closeMethods: [],
            footer: true,
            stickyFooter: true
        });

        modalButtonOnly.addFooterBtn('I agree', 'tingle-btn tingle-btn--primary tingle-btn--pull-right', function () {
            modalButtonOnly.close();
        });

        modalButtonOnly.addFooterBtn('Cancel', 'tingle-btn tingle-btn--default tingle-btn--pull-right', function () {
            modalButtonOnly.close();
        });

        modalButtonOnly.setContent(content);
        modalButtonOnly.open();
    }

    // Modal suprise - Example
    function openModalSurprise() {
        var modalSurprise = new tingle.modal({
            onClose: function () {
                modalSurprise.destroy();
            }
        });
        modalSurprise.setContent('<iframe width="100%" height="400" src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1" frameborder="0" allowfullscreen></iframe>');
        modalSurprise.open();
    }

    $(document).ready(function () {
        GenericModal.init();
        SessionModal.init();
    });

    $(document).on("ConferenceTabLoaded", function () {
        GenericModal.init();
        SessionModal.init();
    });
})(jQuery);

﻿/*!
 * Isotope PACKAGED v3.0.6
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * https://isotope.metafizzy.co
 * Copyright 2010-2018 Metafizzy
 */

/**
 * Bridget makes jQuery widgets
 * v2.0.1
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */

(function (window, factory) {
    // universal module definition
    /*jshint strict: false */ /* globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('jquery-bridget/jquery-bridget', ['jquery'], function (jQuery) {
            return factory(window, jQuery);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('jquery')
        );
    } else {
        // browser global
        window.jQueryBridget = factory(
            window,
            window.jQuery
        );
    }

}(window, function factory(window, jQuery) {
    'use strict';

    // ----- utils ----- //

    var arraySlice = Array.prototype.slice;

    // helper function for logging errors
    // $.error breaks jQuery chaining
    var console = window.console;
    var logError = typeof console == 'undefined' ? function () { } :
        function (message) {
            console.error(message);
        };

    // ----- jQueryBridget ----- //

    function jQueryBridget(namespace, PluginClass, $) {
        $ = $ || jQuery || window.jQuery;
        if (!$) {
            return;
        }

        // add option method -> $().plugin('option', {...})
        if (!PluginClass.prototype.option) {
            // option setter
            PluginClass.prototype.option = function (opts) {
                // bail out if not an object
                if (!$.isPlainObject(opts)) {
                    return;
                }
                this.options = $.extend(true, this.options, opts);
            };
        }

        // make jQuery plugin
        $.fn[namespace] = function (arg0 /*, arg1 */) {
            if (typeof arg0 == 'string') {
                // method call $().plugin( 'methodName', { options } )
                // shift arguments by 1
                var args = arraySlice.call(arguments, 1);
                return methodCall(this, arg0, args);
            }
            // just $().plugin({ options })
            plainCall(this, arg0);
            return this;
        };

        // $().plugin('methodName')
        function methodCall($elems, methodName, args) {
            var returnValue;
            var pluginMethodStr = '$().' + namespace + '("' + methodName + '")';

            $elems.each(function (i, elem) {
                // get instance
                var instance = $.data(elem, namespace);
                if (!instance) {
                    logError(namespace + ' not initialized. Cannot call methods, i.e. ' +
                        pluginMethodStr);
                    return;
                }

                var method = instance[methodName];
                if (!method || methodName.charAt(0) == '_') {
                    logError(pluginMethodStr + ' is not a valid method');
                    return;
                }

                // apply method, get return value
                var value = method.apply(instance, args);
                // set return value if value is returned, use only first value
                returnValue = returnValue === undefined ? value : returnValue;
            });

            return returnValue !== undefined ? returnValue : $elems;
        }

        function plainCall($elems, options) {
            $elems.each(function (i, elem) {
                var instance = $.data(elem, namespace);
                if (instance) {
                    // set options & init
                    instance.option(options);
                    instance._init();
                } else {
                    // initialize new instance
                    instance = new PluginClass(elem, options);
                    $.data(elem, namespace, instance);
                }
            });
        }

        updateJQuery($);

    }

    // ----- updateJQuery ----- //

    // set $.bridget for v1 backwards compatibility
    function updateJQuery($) {
        if (!$ || ($ && $.bridget)) {
            return;
        }
        $.bridget = jQueryBridget;
    }

    updateJQuery(jQuery || window.jQuery);

    // -----  ----- //

    return jQueryBridget;

}));

/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

(function (global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */
    if (typeof define == 'function' && define.amd) {
        // AMD - RequireJS
        define('ev-emitter/ev-emitter', factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS - Browserify, Webpack
        module.exports = factory();
    } else {
        // Browser globals
        global.EvEmitter = factory();
    }

}(typeof window != 'undefined' ? window : this, function () {



    function EvEmitter() { }

    var proto = EvEmitter.prototype;

    proto.on = function (eventName, listener) {
        if (!eventName || !listener) {
            return;
        }
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) {
            listeners.push(listener);
        }

        return this;
    };

    proto.once = function (eventName, listener) {
        if (!eventName || !listener) {
            return;
        }
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;

        return this;
    };

    proto.off = function (eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
            return;
        }
        var index = listeners.indexOf(listener);
        if (index != -1) {
            listeners.splice(index, 1);
        }

        return this;
    };

    proto.emitEvent = function (eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
            return;
        }
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];

        for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i]
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }

        return this;
    };

    proto.allOff = function () {
        delete this._events;
        delete this._onceEvents;
    };

    return EvEmitter;

}));

/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

(function (window, factory) {
    /* jshint strict: false */ /* globals define, module */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('get-size/get-size', factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else {
        // browser global
        window.getSize = factory();
    }

})(window, function factory() {
    'use strict';

    // -------------------------- helpers -------------------------- //

    // get a number from a string, not a percentage
    function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }

    function noop() { }

    var logError = typeof console == 'undefined' ? noop :
        function (message) {
            console.error(message);
        };

    // -------------------------- measurements -------------------------- //

    var measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];

    var measurementsLength = measurements.length;

    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }

    // -------------------------- getStyle -------------------------- //

    /**
     * getStyle, get style of element, check for Firefox bug
     * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
     */
    function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) {
            logError('Style returned ' + style +
                '. Are you running this code in a hidden iframe on Firefox? ' +
                'See https://bit.ly/getsizebug1');
        }
        return style;
    }

    // -------------------------- setup -------------------------- //

    var isSetup = false;

    var isBoxSizeOuter;

    /**
     * setup
     * check isBoxSizerOuter
     * do on first getSize() rather than on page load for Firefox bug
     */
    function setup() {
        // setup once
        if (isSetup) {
            return;
        }
        isSetup = true;

        // -------------------------- box sizing -------------------------- //

        /**
         * Chrome & Safari measure the outer-width on style.width on border-box elems
         * IE11 & Firefox<29 measures the inner-width
         */
        var div = document.createElement('div');
        div.style.width = '200px';
        div.style.padding = '1px 2px 3px 4px';
        div.style.borderStyle = 'solid';
        div.style.borderWidth = '1px 2px 3px 4px';
        div.style.boxSizing = 'border-box';

        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;

        body.removeChild(div);
    }

    // -------------------------- getSize -------------------------- //

    function getSize(elem) {
        setup();

        // use querySeletor if elem is string
        if (typeof elem == 'string') {
            elem = document.querySelector(elem);
        }

        // do not proceed on non-objects
        if (!elem || typeof elem != 'object' || !elem.nodeType) {
            return;
        }

        var style = getStyle(elem);

        // if hidden, everything is 0
        if (style.display == 'none') {
            return getZeroSize();
        }

        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;

        var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

        // get all measurements
        for (var i = 0; i < measurementsLength; i++) {
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        }

        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;

        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) {
            size.width = styleWidth +
                // add padding and border unless it's already including it
                (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        }

        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) {
            size.height = styleHeight +
                // add padding and border unless it's already including it
                (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        }

        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);

        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;

        return size;
    }

    return getSize;

});

/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

(function (window, factory) {
    /*global define: false, module: false */
    'use strict';
    // universal module definition
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('desandro-matches-selector/matches-selector', factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else {
        // browser global
        window.matchesSelector = factory();
    }

}(window, function factory() {
    'use strict';

    var matchesMethod = (function () {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) {
            return 'matches';
        }
        // check un-prefixed
        if (ElemProto.matchesSelector) {
            return 'matchesSelector';
        }
        // check vendor prefixes
        var prefixes = ['webkit', 'moz', 'ms', 'o'];

        for (var i = 0; i < prefixes.length; i++) {
            var prefix = prefixes[i];
            var method = prefix + 'MatchesSelector';
            if (ElemProto[method]) {
                return method;
            }
        }
    })();

    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };

}));

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

(function (window, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */

    if (typeof define == 'function' && define.amd) {
        // AMD
        define('fizzy-ui-utils/utils', [
            'desandro-matches-selector/matches-selector'
        ], function (matchesSelector) {
            return factory(window, matchesSelector);
        });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('desandro-matches-selector')
        );
    } else {
        // browser global
        window.fizzyUIUtils = factory(
            window,
            window.matchesSelector
        );
    }

}(window, function factory(window, matchesSelector) {



    var utils = {};

    // ----- extend ----- //

    // extends objects
    utils.extend = function (a, b) {
        for (var prop in b) {
            a[prop] = b[prop];
        }
        return a;
    };

    // ----- modulo ----- //

    utils.modulo = function (num, div) {
        return ((num % div) + div) % div;
    };

    // ----- makeArray ----- //

    var arraySlice = Array.prototype.slice;

    // turn element or nodeList into an array
    utils.makeArray = function (obj) {
        if (Array.isArray(obj)) {
            // use object if already an array
            return obj;
        }
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) {
            return [];
        }

        var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        if (isArrayLike) {
            // convert nodeList to array
            return arraySlice.call(obj);
        }

        // array of single index
        return [obj];
    };

    // ----- removeFrom ----- //

    utils.removeFrom = function (ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) {
            ary.splice(index, 1);
        }
    };

    // ----- getParent ----- //

    utils.getParent = function (elem, selector) {
        while (elem.parentNode && elem != document.body) {
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) {
                return elem;
            }
        }
    };

    // ----- getQueryElement ----- //

    // use element as selector string
    utils.getQueryElement = function (elem) {
        if (typeof elem == 'string') {
            return document.querySelector(elem);
        }
        return elem;
    };

    // ----- handleEvent ----- //

    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function (event) {
        var method = 'on' + event.type;
        if (this[method]) {
            this[method](event);
        }
    };

    // ----- filterFindElements ----- //

    utils.filterFindElements = function (elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        var ffElems = [];

        elems.forEach(function (elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) {
                return;
            }
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) {
                ffElems.push(elem);
            }
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for (var i = 0; i < childElems.length; i++) {
                ffElems.push(childElems[i]);
            }
        });

        return ffElems;
    };

    // ----- debounceMethod ----- //

    utils.debounceMethod = function (_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + 'Timeout';

        _class.prototype[methodName] = function () {
            var timeout = this[timeoutName];
            clearTimeout(timeout);

            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function () {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };

    // ----- docReady ----- //

    utils.docReady = function (callback) {
        var readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') {
            // do async to allow for other scripts to run. metafizzy/flickity#441
            setTimeout(callback);
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    };

    // ----- htmlInit ----- //

    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function (str) {
        return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };

    var console = window.console;
    /**
     * allow user to initialize classes via [data-namespace] or .js-namespace class
     * htmlInit( Widget, 'widgetName' )
     * options are parsed from data-namespace-options
     */
    utils.htmlInit = function (WidgetClass, namespace) {
        utils.docReady(function () {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = 'data-' + dashedNamespace;
            var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
            var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems)
                .concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + '-options';
            var jQuery = window.jQuery;

            elems.forEach(function (elem) {
                var attr = elem.getAttribute(dataAttr) ||
                    elem.getAttribute(dataOptionsAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) {
                        console.error('Error parsing ' + dataAttr + ' on ' + elem.className +
                            ': ' + error);
                    }
                    return;
                }
                // initialize
                var instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) {
                    jQuery.data(elem, namespace, instance);
                }
            });

        });
    };

    // -----  ----- //

    return utils;

}));

/**
 * Outlayer Item
 */

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD - RequireJS
        define('outlayer/item', [
            'ev-emitter/ev-emitter',
            'get-size/get-size'
        ],
            factory
        );
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS - Browserify, Webpack
        module.exports = factory(
            require('ev-emitter'),
            require('get-size')
        );
    } else {
        // browser global
        window.Outlayer = {};
        window.Outlayer.Item = factory(
            window.EvEmitter,
            window.getSize
        );
    }

}(window, function factory(EvEmitter, getSize) {
    'use strict';

    // ----- helpers ----- //

    function isEmptyObj(obj) {
        for (var prop in obj) {
            return false;
        }
        prop = null;
        return true;
    }

    // -------------------------- CSS3 support -------------------------- //


    var docElemStyle = document.documentElement.style;

    var transitionProperty = typeof docElemStyle.transition == 'string' ?
        'transition' : 'WebkitTransition';
    var transformProperty = typeof docElemStyle.transform == 'string' ?
        'transform' : 'WebkitTransform';

    var transitionEndEvent = {
        WebkitTransition: 'webkitTransitionEnd',
        transition: 'transitionend'
    }[transitionProperty];

    // cache all vendor properties that could have vendor prefix
    var vendorProperties = {
        transform: transformProperty,
        transition: transitionProperty,
        transitionDuration: transitionProperty + 'Duration',
        transitionProperty: transitionProperty + 'Property',
        transitionDelay: transitionProperty + 'Delay'
    };

    // -------------------------- Item -------------------------- //

    function Item(element, layout) {
        if (!element) {
            return;
        }

        this.element = element;
        // parent layout class, i.e. Masonry, Isotope, or Packery
        this.layout = layout;
        this.position = {
            x: 0,
            y: 0
        };

        this._create();
    }

    // inherit EvEmitter
    var proto = Item.prototype = Object.create(EvEmitter.prototype);
    proto.constructor = Item;

    proto._create = function () {
        // transition objects
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        };

        this.css({
            position: 'absolute'
        });
    };

    // trigger specified handler for event type
    proto.handleEvent = function (event) {
        var method = 'on' + event.type;
        if (this[method]) {
            this[method](event);
        }
    };

    proto.getSize = function () {
        this.size = getSize(this.element);
    };

    /**
     * apply CSS styles to element
     * @param {Object} style
     */
    proto.css = function (style) {
        var elemStyle = this.element.style;

        for (var prop in style) {
            // use vendor property if available
            var supportedProp = vendorProperties[prop] || prop;
            elemStyle[supportedProp] = style[prop];
        }
    };

    // measure position, and sets it
    proto.getPosition = function () {
        var style = getComputedStyle(this.element);
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        var xValue = style[isOriginLeft ? 'left' : 'right'];
        var yValue = style[isOriginTop ? 'top' : 'bottom'];
        var x = parseFloat(xValue);
        var y = parseFloat(yValue);
        // convert percent to pixels
        var layoutSize = this.layout.size;
        if (xValue.indexOf('%') != -1) {
            x = (x / 100) * layoutSize.width;
        }
        if (yValue.indexOf('%') != -1) {
            y = (y / 100) * layoutSize.height;
        }
        // clean up 'auto' or other non-integer values
        x = isNaN(x) ? 0 : x;
        y = isNaN(y) ? 0 : y;
        // remove padding from measurement
        x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
        y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

        this.position.x = x;
        this.position.y = y;
    };

    // set settled position, apply padding
    proto.layoutPosition = function () {
        var layoutSize = this.layout.size;
        var style = {};
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');

        // x
        var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
        var xProperty = isOriginLeft ? 'left' : 'right';
        var xResetProperty = isOriginLeft ? 'right' : 'left';

        var x = this.position.x + layoutSize[xPadding];
        // set in percentage or pixels
        style[xProperty] = this.getXValue(x);
        // reset other property
        style[xResetProperty] = '';

        // y
        var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
        var yProperty = isOriginTop ? 'top' : 'bottom';
        var yResetProperty = isOriginTop ? 'bottom' : 'top';

        var y = this.position.y + layoutSize[yPadding];
        // set in percentage or pixels
        style[yProperty] = this.getYValue(y);
        // reset other property
        style[yResetProperty] = '';

        this.css(style);
        this.emitEvent('layout', [this]);
    };

    proto.getXValue = function (x) {
        var isHorizontal = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && !isHorizontal ?
            ((x / this.layout.size.width) * 100) + '%' : x + 'px';
    };

    proto.getYValue = function (y) {
        var isHorizontal = this.layout._getOption('horizontal');
        return this.layout.options.percentPosition && isHorizontal ?
            ((y / this.layout.size.height) * 100) + '%' : y + 'px';
    };

    proto._transitionTo = function (x, y) {
        this.getPosition();
        // get current x & y from top/left
        var curX = this.position.x;
        var curY = this.position.y;

        var didNotMove = x == this.position.x && y == this.position.y;

        // save end position
        this.setPosition(x, y);

        // if did not move and not transitioning, just go to layout
        if (didNotMove && !this.isTransitioning) {
            this.layoutPosition();
            return;
        }

        var transX = x - curX;
        var transY = y - curY;
        var transitionStyle = {};
        transitionStyle.transform = this.getTranslate(transX, transY);

        this.transition({
            to: transitionStyle,
            onTransitionEnd: {
                transform: this.layoutPosition
            },
            isCleaning: true
        });
    };

    proto.getTranslate = function (x, y) {
        // flip cooridinates if origin on right or bottom
        var isOriginLeft = this.layout._getOption('originLeft');
        var isOriginTop = this.layout._getOption('originTop');
        x = isOriginLeft ? x : -x;
        y = isOriginTop ? y : -y;
        return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
    };

    // non transition + transform support
    proto.goTo = function (x, y) {
        this.setPosition(x, y);
        this.layoutPosition();
    };

    proto.moveTo = proto._transitionTo;

    proto.setPosition = function (x, y) {
        this.position.x = parseFloat(x);
        this.position.y = parseFloat(y);
    };

    // ----- transition ----- //

    /**
     * @param {Object} style - CSS
     * @param {Function} onTransitionEnd
     */

    // non transition, just trigger callback
    proto._nonTransition = function (args) {
        this.css(args.to);
        if (args.isCleaning) {
            this._removeStyles(args.to);
        }
        for (var prop in args.onTransitionEnd) {
            args.onTransitionEnd[prop].call(this);
        }
    };

    /**
     * proper transition
     * @param {Object} args - arguments
     *   @param {Object} to - style to transition to
     *   @param {Object} from - style to start transition from
     *   @param {Boolean} isCleaning - removes transition styles after transition
     *   @param {Function} onTransitionEnd - callback
     */
    proto.transition = function (args) {
        // redirect to nonTransition if no transition duration
        if (!parseFloat(this.layout.options.transitionDuration)) {
            this._nonTransition(args);
            return;
        }

        var _transition = this._transn;
        // keep track of onTransitionEnd callback by css property
        for (var prop in args.onTransitionEnd) {
            _transition.onEnd[prop] = args.onTransitionEnd[prop];
        }
        // keep track of properties that are transitioning
        for (prop in args.to) {
            _transition.ingProperties[prop] = true;
            // keep track of properties to clean up when transition is done
            if (args.isCleaning) {
                _transition.clean[prop] = true;
            }
        }

        // set from styles
        if (args.from) {
            this.css(args.from);
            // force redraw. http://blog.alexmaccaw.com/css-transitions
            var h = this.element.offsetHeight;
            // hack for JSHint to hush about unused var
            h = null;
        }
        // enable transition
        this.enableTransition(args.to);
        // set styles that are transitioning
        this.css(args.to);

        this.isTransitioning = true;

    };

    // dash before all cap letters, including first for
    // WebkitTransform => -webkit-transform
    function toDashedAll(str) {
        return str.replace(/([A-Z])/g, function ($1) {
            return '-' + $1.toLowerCase();
        });
    }

    var transitionProps = 'opacity,' + toDashedAll(transformProperty);

    proto.enableTransition = function (/* style */) {
        // HACK changing transitionProperty during a transition
        // will cause transition to jump
        if (this.isTransitioning) {
            return;
        }

        // make `transition: foo, bar, baz` from style object
        // HACK un-comment this when enableTransition can work
        // while a transition is happening
        // var transitionValues = [];
        // for ( var prop in style ) {
        //   // dash-ify camelCased properties like WebkitTransition
        //   prop = vendorProperties[ prop ] || prop;
        //   transitionValues.push( toDashedAll( prop ) );
        // }
        // munge number to millisecond, to match stagger
        var duration = this.layout.options.transitionDuration;
        duration = typeof duration == 'number' ? duration + 'ms' : duration;
        // enable transition styles
        this.css({
            transitionProperty: transitionProps,
            transitionDuration: duration,
            transitionDelay: this.staggerDelay || 0
        });
        // listen for transition end event
        this.element.addEventListener(transitionEndEvent, this, false);
    };

    // ----- events ----- //

    proto.onwebkitTransitionEnd = function (event) {
        this.ontransitionend(event);
    };

    proto.onotransitionend = function (event) {
        this.ontransitionend(event);
    };

    // properties that I munge to make my life easier
    var dashedVendorProperties = {
        '-webkit-transform': 'transform'
    };

    proto.ontransitionend = function (event) {
        // disregard bubbled events from children
        if (event.target !== this.element) {
            return;
        }
        var _transition = this._transn;
        // get property name of transitioned property, convert to prefix-free
        var propertyName = dashedVendorProperties[event.propertyName] || event.propertyName;

        // remove property that has completed transitioning
        delete _transition.ingProperties[propertyName];
        // check if any properties are still transitioning
        if (isEmptyObj(_transition.ingProperties)) {
            // all properties have completed transitioning
            this.disableTransition();
        }
        // clean style
        if (propertyName in _transition.clean) {
            // clean up style
            this.element.style[event.propertyName] = '';
            delete _transition.clean[propertyName];
        }
        // trigger onTransitionEnd callback
        if (propertyName in _transition.onEnd) {
            var onTransitionEnd = _transition.onEnd[propertyName];
            onTransitionEnd.call(this);
            delete _transition.onEnd[propertyName];
        }

        this.emitEvent('transitionEnd', [this]);
    };

    proto.disableTransition = function () {
        this.removeTransitionStyles();
        this.element.removeEventListener(transitionEndEvent, this, false);
        this.isTransitioning = false;
    };

    /**
     * removes style property from element
     * @param {Object} style
    **/
    proto._removeStyles = function (style) {
        // clean up transition styles
        var cleanStyle = {};
        for (var prop in style) {
            cleanStyle[prop] = '';
        }
        this.css(cleanStyle);
    };

    var cleanTransitionStyle = {
        transitionProperty: '',
        transitionDuration: '',
        transitionDelay: ''
    };

    proto.removeTransitionStyles = function () {
        // remove transition
        this.css(cleanTransitionStyle);
    };

    // ----- stagger ----- //

    proto.stagger = function (delay) {
        delay = isNaN(delay) ? 0 : delay;
        this.staggerDelay = delay + 'ms';
    };

    // ----- show/hide/remove ----- //

    // remove element from DOM
    proto.removeElem = function () {
        this.element.parentNode.removeChild(this.element);
        // remove display: none
        this.css({ display: '' });
        this.emitEvent('remove', [this]);
    };

    proto.remove = function () {
        // just remove element if no transition support or no transition
        if (!transitionProperty || !parseFloat(this.layout.options.transitionDuration)) {
            this.removeElem();
            return;
        }

        // start transition
        this.once('transitionEnd', function () {
            this.removeElem();
        });
        this.hide();
    };

    proto.reveal = function () {
        delete this.isHidden;
        // remove display: none
        this.css({ display: '' });

        var options = this.layout.options;

        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
        onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;

        this.transition({
            from: options.hiddenStyle,
            to: options.visibleStyle,
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
        });
    };

    proto.onRevealTransitionEnd = function () {
        // check if still visible
        // during transition, item may have been hidden
        if (!this.isHidden) {
            this.emitEvent('reveal');
        }
    };

    /**
     * get style property use for hide/reveal transition end
     * @param {String} styleProperty - hiddenStyle/visibleStyle
     * @returns {String}
     */
    proto.getHideRevealTransitionEndProperty = function (styleProperty) {
        var optionStyle = this.layout.options[styleProperty];
        // use opacity
        if (optionStyle.opacity) {
            return 'opacity';
        }
        // get first property
        for (var prop in optionStyle) {
            return prop;
        }
    };

    proto.hide = function () {
        // set flag
        this.isHidden = true;
        // remove display: none
        this.css({ display: '' });

        var options = this.layout.options;

        var onTransitionEnd = {};
        var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
        onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;

        this.transition({
            from: options.visibleStyle,
            to: options.hiddenStyle,
            // keep hidden stuff hidden
            isCleaning: true,
            onTransitionEnd: onTransitionEnd
        });
    };

    proto.onHideTransitionEnd = function () {
        // check if still hidden
        // during transition, item may have been un-hidden
        if (this.isHidden) {
            this.css({ display: 'none' });
            this.emitEvent('hide');
        }
    };

    proto.destroy = function () {
        this.css({
            position: '',
            left: '',
            right: '',
            top: '',
            bottom: '',
            transition: '',
            transform: ''
        });
    };

    return Item;

}));

/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */

(function (window, factory) {
    'use strict';
    // universal module definition
    /* jshint strict: false */ /* globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD - RequireJS
        define('outlayer/outlayer', [
            'ev-emitter/ev-emitter',
            'get-size/get-size',
            'fizzy-ui-utils/utils',
            './item'
        ],
            function (EvEmitter, getSize, utils, Item) {
                return factory(window, EvEmitter, getSize, utils, Item);
            }
        );
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS - Browserify, Webpack
        module.exports = factory(
            window,
            require('ev-emitter'),
            require('get-size'),
            require('fizzy-ui-utils'),
            require('./item')
        );
    } else {
        // browser global
        window.Outlayer = factory(
            window,
            window.EvEmitter,
            window.getSize,
            window.fizzyUIUtils,
            window.Outlayer.Item
        );
    }

}(window, function factory(window, EvEmitter, getSize, utils, Item) {
    'use strict';

    // ----- vars ----- //

    var console = window.console;
    var jQuery = window.jQuery;
    var noop = function () { };

    // -------------------------- Outlayer -------------------------- //

    // globally unique identifiers
    var GUID = 0;
    // internal store of all Outlayer intances
    var instances = {};


    /**
     * @param {Element, String} element
     * @param {Object} options
     * @constructor
     */
    function Outlayer(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) {
                console.error('Bad element for ' + this.constructor.namespace +
                    ': ' + (queryElement || element));
            }
            return;
        }
        this.element = queryElement;
        // add jQuery
        if (jQuery) {
            this.$element = jQuery(this.element);
        }

        // options
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);

        // add id for Outlayer.getFromElement
        var id = ++GUID;
        this.element.outlayerGUID = id; // expando
        instances[id] = this; // associate via id

        // kick it off
        this._create();

        var isInitLayout = this._getOption('initLayout');
        if (isInitLayout) {
            this.layout();
        }
    }

    // settings are for internal use only
    Outlayer.namespace = 'outlayer';
    Outlayer.Item = Item;

    // default options
    Outlayer.defaults = {
        containerStyle: {
            position: 'relative'
        },
        initLayout: true,
        originLeft: true,
        originTop: true,
        resize: true,
        resizeContainer: true,
        // item options
        transitionDuration: '0.4s',
        hiddenStyle: {
            opacity: 0,
            transform: 'scale(0.001)'
        },
        visibleStyle: {
            opacity: 1,
            transform: 'scale(1)'
        }
    };

    var proto = Outlayer.prototype;
    // inherit EvEmitter
    utils.extend(proto, EvEmitter.prototype);

    /**
     * set options
     * @param {Object} opts
     */
    proto.option = function (opts) {
        utils.extend(this.options, opts);
    };

    /**
     * get backwards compatible option value, check old name
     */
    proto._getOption = function (option) {
        var oldOption = this.constructor.compatOptions[option];
        return oldOption && this.options[oldOption] !== undefined ?
            this.options[oldOption] : this.options[option];
    };

    Outlayer.compatOptions = {
        // currentName: oldName
        initLayout: 'isInitLayout',
        horizontal: 'isHorizontal',
        layoutInstant: 'isLayoutInstant',
        originLeft: 'isOriginLeft',
        originTop: 'isOriginTop',
        resize: 'isResizeBound',
        resizeContainer: 'isResizingContainer'
    };

    proto._create = function () {
        // get items from children
        this.reloadItems();
        // elements that affect layout, but are not laid out
        this.stamps = [];
        this.stamp(this.options.stamp);
        // set container style
        utils.extend(this.element.style, this.options.containerStyle);

        // bind resize method
        var canBindResize = this._getOption('resize');
        if (canBindResize) {
            this.bindResize();
        }
    };

    // goes through all children again and gets bricks in proper order
    proto.reloadItems = function () {
        // collection of item elements
        this.items = this._itemize(this.element.children);
    };


    /**
     * turn elements into Outlayer.Items to be used in layout
     * @param {Array or NodeList or HTMLElement} elems
     * @returns {Array} items - collection of new Outlayer Items
     */
    proto._itemize = function (elems) {

        var itemElems = this._filterFindItemElements(elems);
        var Item = this.constructor.Item;

        // create new Outlayer Items for collection
        var items = [];
        for (var i = 0; i < itemElems.length; i++) {
            var elem = itemElems[i];
            var item = new Item(elem, this);
            items.push(item);
        }

        return items;
    };

    /**
     * get item elements to be used in layout
     * @param {Array or NodeList or HTMLElement} elems
     * @returns {Array} items - item elements
     */
    proto._filterFindItemElements = function (elems) {
        return utils.filterFindElements(elems, this.options.itemSelector);
    };

    /**
     * getter method for getting item elements
     * @returns {Array} elems - collection of item elements
     */
    proto.getItemElements = function () {
        return this.items.map(function (item) {
            return item.element;
        });
    };

    // ----- init & layout ----- //

    /**
     * lays out all items
     */
    proto.layout = function () {
        this._resetLayout();
        this._manageStamps();

        // don't animate first layout
        var layoutInstant = this._getOption('layoutInstant');
        var isInstant = layoutInstant !== undefined ?
            layoutInstant : !this._isLayoutInited;
        this.layoutItems(this.items, isInstant);

        // flag for initalized
        this._isLayoutInited = true;
    };

    // _init is alias for layout
    proto._init = proto.layout;

    /**
     * logic before any new layout
     */
    proto._resetLayout = function () {
        this.getSize();
    };


    proto.getSize = function () {
        this.size = getSize(this.element);
    };

    /**
     * get measurement from option, for columnWidth, rowHeight, gutter
     * if option is String -> get element from selector string, & get size of element
     * if option is Element -> get size of element
     * else use option as a number
     *
     * @param {String} measurement
     * @param {String} size - width or height
     * @private
     */
    proto._getMeasurement = function (measurement, size) {
        var option = this.options[measurement];
        var elem;
        if (!option) {
            // default to 0
            this[measurement] = 0;
        } else {
            // use option as an element
            if (typeof option == 'string') {
                elem = this.element.querySelector(option);
            } else if (option instanceof HTMLElement) {
                elem = option;
            }
            // use size of element, if element
            this[measurement] = elem ? getSize(elem)[size] : option;
        }
    };

    /**
     * layout a collection of item elements
     * @api public
     */
    proto.layoutItems = function (items, isInstant) {
        items = this._getItemsForLayout(items);

        this._layoutItems(items, isInstant);

        this._postLayout();
    };

    /**
     * get the items to be laid out
     * you may want to skip over some items
     * @param {Array} items
     * @returns {Array} items
     */
    proto._getItemsForLayout = function (items) {
        return items.filter(function (item) {
            return !item.isIgnored;
        });
    };

    /**
     * layout items
     * @param {Array} items
     * @param {Boolean} isInstant
     */
    proto._layoutItems = function (items, isInstant) {
        this._emitCompleteOnItems('layout', items);

        if (!items || !items.length) {
            // no items, emit event with empty array
            return;
        }

        var queue = [];

        items.forEach(function (item) {
            // get x/y object from method
            var position = this._getItemLayoutPosition(item);
            // enqueue
            position.item = item;
            position.isInstant = isInstant || item.isLayoutInstant;
            queue.push(position);
        }, this);

        this._processLayoutQueue(queue);
    };

    /**
     * get item layout position
     * @param {Outlayer.Item} item
     * @returns {Object} x and y position
     */
    proto._getItemLayoutPosition = function ( /* item */) {
        return {
            x: 0,
            y: 0
        };
    };

    /**
     * iterate over array and position each item
     * Reason being - separating this logic prevents 'layout invalidation'
     * thx @paul_irish
     * @param {Array} queue
     */
    proto._processLayoutQueue = function (queue) {
        this.updateStagger();
        queue.forEach(function (obj, i) {
            this._positionItem(obj.item, obj.x, obj.y, obj.isInstant, i);
        }, this);
    };

    // set stagger from option in milliseconds number
    proto.updateStagger = function () {
        var stagger = this.options.stagger;
        if (stagger === null || stagger === undefined) {
            this.stagger = 0;
            return;
        }
        this.stagger = getMilliseconds(stagger);
        return this.stagger;
    };

    /**
     * Sets position of item in DOM
     * @param {Outlayer.Item} item
     * @param {Number} x - horizontal position
     * @param {Number} y - vertical position
     * @param {Boolean} isInstant - disables transitions
     */
    proto._positionItem = function (item, x, y, isInstant, i) {
        if (isInstant) {
            // if not transition, just set CSS
            item.goTo(x, y);
        } else {
            item.stagger(i * this.stagger);
            item.moveTo(x, y);
        }
    };

    /**
     * Any logic you want to do after each layout,
     * i.e. size the container
     */
    proto._postLayout = function () {
        this.resizeContainer();
    };

    proto.resizeContainer = function () {
        var isResizingContainer = this._getOption('resizeContainer');
        if (!isResizingContainer) {
            return;
        }
        var size = this._getContainerSize();
        if (size) {
            this._setContainerMeasure(size.width, true);
            this._setContainerMeasure(size.height, false);
        }
    };

    /**
     * Sets width or height of container if returned
     * @returns {Object} size
     *   @param {Number} width
     *   @param {Number} height
     */
    proto._getContainerSize = noop;

    /**
     * @param {Number} measure - size of width or height
     * @param {Boolean} isWidth
     */
    proto._setContainerMeasure = function (measure, isWidth) {
        if (measure === undefined) {
            return;
        }

        var elemSize = this.size;
        // add padding and border width if border box
        if (elemSize.isBorderBox) {
            measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
                elemSize.borderLeftWidth + elemSize.borderRightWidth :
                elemSize.paddingBottom + elemSize.paddingTop +
                elemSize.borderTopWidth + elemSize.borderBottomWidth;
        }

        measure = Math.max(measure, 0);
        this.element.style[isWidth ? 'width' : 'height'] = measure + 'px';
    };

    /**
     * emit eventComplete on a collection of items events
     * @param {String} eventName
     * @param {Array} items - Outlayer.Items
     */
    proto._emitCompleteOnItems = function (eventName, items) {
        var _this = this;
        function onComplete() {
            _this.dispatchEvent(eventName + 'Complete', null, [items]);
        }

        var count = items.length;
        if (!items || !count) {
            onComplete();
            return;
        }

        var doneCount = 0;
        function tick() {
            doneCount++;
            if (doneCount == count) {
                onComplete();
            }
        }

        // bind callback
        items.forEach(function (item) {
            item.once(eventName, tick);
        });
    };

    /**
     * emits events via EvEmitter and jQuery events
     * @param {String} type - name of event
     * @param {Event} event - original event
     * @param {Array} args - extra arguments
     */
    proto.dispatchEvent = function (type, event, args) {
        // add original event to arguments
        var emitArgs = event ? [event].concat(args) : args;
        this.emitEvent(type, emitArgs);

        if (jQuery) {
            // set this.$element
            this.$element = this.$element || jQuery(this.element);
            if (event) {
                // create jQuery event
                var $event = jQuery.Event(event);
                $event.type = type;
                this.$element.trigger($event, args);
            } else {
                // just trigger with type if no event available
                this.$element.trigger(type, args);
            }
        }
    };

    // -------------------------- ignore & stamps -------------------------- //


    /**
     * keep item in collection, but do not lay it out
     * ignored items do not get skipped in layout
     * @param {Element} elem
     */
    proto.ignore = function (elem) {
        var item = this.getItem(elem);
        if (item) {
            item.isIgnored = true;
        }
    };

    /**
     * return item to layout collection
     * @param {Element} elem
     */
    proto.unignore = function (elem) {
        var item = this.getItem(elem);
        if (item) {
            delete item.isIgnored;
        }
    };

    /**
     * adds elements to stamps
     * @param {NodeList, Array, Element, or String} elems
     */
    proto.stamp = function (elems) {
        elems = this._find(elems);
        if (!elems) {
            return;
        }

        this.stamps = this.stamps.concat(elems);
        // ignore
        elems.forEach(this.ignore, this);
    };

    /**
     * removes elements to stamps
     * @param {NodeList, Array, or Element} elems
     */
    proto.unstamp = function (elems) {
        elems = this._find(elems);
        if (!elems) {
            return;
        }

        elems.forEach(function (elem) {
            // filter out removed stamp elements
            utils.removeFrom(this.stamps, elem);
            this.unignore(elem);
        }, this);
    };

    /**
     * finds child elements
     * @param {NodeList, Array, Element, or String} elems
     * @returns {Array} elems
     */
    proto._find = function (elems) {
        if (!elems) {
            return;
        }
        // if string, use argument as selector string
        if (typeof elems == 'string') {
            elems = this.element.querySelectorAll(elems);
        }
        elems = utils.makeArray(elems);
        return elems;
    };

    proto._manageStamps = function () {
        if (!this.stamps || !this.stamps.length) {
            return;
        }

        this._getBoundingRect();

        this.stamps.forEach(this._manageStamp, this);
    };

    // update boundingLeft / Top
    proto._getBoundingRect = function () {
        // get bounding rect for container element
        var boundingRect = this.element.getBoundingClientRect();
        var size = this.size;
        this._boundingRect = {
            left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
            top: boundingRect.top + size.paddingTop + size.borderTopWidth,
            right: boundingRect.right - (size.paddingRight + size.borderRightWidth),
            bottom: boundingRect.bottom - (size.paddingBottom + size.borderBottomWidth)
        };
    };

    /**
     * @param {Element} stamp
    **/
    proto._manageStamp = noop;

    /**
     * get x/y position of element relative to container element
     * @param {Element} elem
     * @returns {Object} offset - has left, top, right, bottom
     */
    proto._getElementOffset = function (elem) {
        var boundingRect = elem.getBoundingClientRect();
        var thisRect = this._boundingRect;
        var size = getSize(elem);
        var offset = {
            left: boundingRect.left - thisRect.left - size.marginLeft,
            top: boundingRect.top - thisRect.top - size.marginTop,
            right: thisRect.right - boundingRect.right - size.marginRight,
            bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
        };
        return offset;
    };

    // -------------------------- resize -------------------------- //

    // enable event handlers for listeners
    // i.e. resize -> onresize
    proto.handleEvent = utils.handleEvent;

    /**
     * Bind layout to window resizing
     */
    proto.bindResize = function () {
        window.addEventListener('resize', this);
        this.isResizeBound = true;
    };

    /**
     * Unbind layout to window resizing
     */
    proto.unbindResize = function () {
        window.removeEventListener('resize', this);
        this.isResizeBound = false;
    };

    proto.onresize = function () {
        this.resize();
    };

    utils.debounceMethod(Outlayer, 'onresize', 100);

    proto.resize = function () {
        // don't trigger if size did not change
        // or if resize was unbound. See #9
        if (!this.isResizeBound || !this.needsResizeLayout()) {
            return;
        }

        this.layout();
    };

    /**
     * check if layout is needed post layout
     * @returns Boolean
     */
    proto.needsResizeLayout = function () {
        var size = getSize(this.element);
        // check that this.size and size are there
        // IE8 triggers resize on body size change, so they might not be
        var hasSizes = this.size && size;
        return hasSizes && size.innerWidth !== this.size.innerWidth;
    };

    // -------------------------- methods -------------------------- //

    /**
     * add items to Outlayer instance
     * @param {Array or NodeList or Element} elems
     * @returns {Array} items - Outlayer.Items
    **/
    proto.addItems = function (elems) {
        var items = this._itemize(elems);
        // add items to collection
        if (items.length) {
            this.items = this.items.concat(items);
        }
        return items;
    };

    /**
     * Layout newly-appended item elements
     * @param {Array or NodeList or Element} elems
     */
    proto.appended = function (elems) {
        var items = this.addItems(elems);
        if (!items.length) {
            return;
        }
        // layout and reveal just the new items
        this.layoutItems(items, true);
        this.reveal(items);
    };

    /**
     * Layout prepended elements
     * @param {Array or NodeList or Element} elems
     */
    proto.prepended = function (elems) {
        var items = this._itemize(elems);
        if (!items.length) {
            return;
        }
        // add items to beginning of collection
        var previousItems = this.items.slice(0);
        this.items = items.concat(previousItems);
        // start new layout
        this._resetLayout();
        this._manageStamps();
        // layout new stuff without transition
        this.layoutItems(items, true);
        this.reveal(items);
        // layout previous items
        this.layoutItems(previousItems);
    };

    /**
     * reveal a collection of items
     * @param {Array of Outlayer.Items} items
     */
    proto.reveal = function (items) {
        this._emitCompleteOnItems('reveal', items);
        if (!items || !items.length) {
            return;
        }
        var stagger = this.updateStagger();
        items.forEach(function (item, i) {
            item.stagger(i * stagger);
            item.reveal();
        });
    };

    /**
     * hide a collection of items
     * @param {Array of Outlayer.Items} items
     */
    proto.hide = function (items) {
        this._emitCompleteOnItems('hide', items);
        if (!items || !items.length) {
            return;
        }
        var stagger = this.updateStagger();
        items.forEach(function (item, i) {
            item.stagger(i * stagger);
            item.hide();
        });
    };

    /**
     * reveal item elements
     * @param {Array}, {Element}, {NodeList} items
     */
    proto.revealItemElements = function (elems) {
        var items = this.getItems(elems);
        this.reveal(items);
    };

    /**
     * hide item elements
     * @param {Array}, {Element}, {NodeList} items
     */
    proto.hideItemElements = function (elems) {
        var items = this.getItems(elems);
        this.hide(items);
    };

    /**
     * get Outlayer.Item, given an Element
     * @param {Element} elem
     * @param {Function} callback
     * @returns {Outlayer.Item} item
     */
    proto.getItem = function (elem) {
        // loop through items to get the one that matches
        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            if (item.element == elem) {
                // return item
                return item;
            }
        }
    };

    /**
     * get collection of Outlayer.Items, given Elements
     * @param {Array} elems
     * @returns {Array} items - Outlayer.Items
     */
    proto.getItems = function (elems) {
        elems = utils.makeArray(elems);
        var items = [];
        elems.forEach(function (elem) {
            var item = this.getItem(elem);
            if (item) {
                items.push(item);
            }
        }, this);

        return items;
    };

    /**
     * remove element(s) from instance and DOM
     * @param {Array or NodeList or Element} elems
     */
    proto.remove = function (elems) {
        var removeItems = this.getItems(elems);

        this._emitCompleteOnItems('remove', removeItems);

        // bail if no items to remove
        if (!removeItems || !removeItems.length) {
            return;
        }

        removeItems.forEach(function (item) {
            item.remove();
            // remove item from collection
            utils.removeFrom(this.items, item);
        }, this);
    };

    // ----- destroy ----- //

    // remove and disable Outlayer instance
    proto.destroy = function () {
        // clean up dynamic styles
        var style = this.element.style;
        style.height = '';
        style.position = '';
        style.width = '';
        // destroy items
        this.items.forEach(function (item) {
            item.destroy();
        });

        this.unbindResize();

        var id = this.element.outlayerGUID;
        delete instances[id]; // remove reference to instance by id
        delete this.element.outlayerGUID;
        // remove data for jQuery
        if (jQuery) {
            jQuery.removeData(this.element, this.constructor.namespace);
        }

    };

    // -------------------------- data -------------------------- //

    /**
     * get Outlayer instance from element
     * @param {Element} elem
     * @returns {Outlayer}
     */
    Outlayer.data = function (elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.outlayerGUID;
        return id && instances[id];
    };


    // -------------------------- create Outlayer class -------------------------- //

    /**
     * create a layout class
     * @param {String} namespace
     */
    Outlayer.create = function (namespace, options) {
        // sub-class Outlayer
        var Layout = subclass(Outlayer);
        // apply new options and compatOptions
        Layout.defaults = utils.extend({}, Outlayer.defaults);
        utils.extend(Layout.defaults, options);
        Layout.compatOptions = utils.extend({}, Outlayer.compatOptions);

        Layout.namespace = namespace;

        Layout.data = Outlayer.data;

        // sub-class Item
        Layout.Item = subclass(Item);

        // -------------------------- declarative -------------------------- //

        utils.htmlInit(Layout, namespace);

        // -------------------------- jQuery bridge -------------------------- //

        // make into jQuery plugin
        if (jQuery && jQuery.bridget) {
            jQuery.bridget(namespace, Layout);
        }

        return Layout;
    };

    function subclass(Parent) {
        function SubClass() {
            Parent.apply(this, arguments);
        }

        SubClass.prototype = Object.create(Parent.prototype);
        SubClass.prototype.constructor = SubClass;

        return SubClass;
    }

    // ----- helpers ----- //

    // how many milliseconds are in each unit
    var msUnits = {
        ms: 1,
        s: 1000
    };

    // munge time-like parameter into millisecond number
    // '0.4s' -> 40
    function getMilliseconds(time) {
        if (typeof time == 'number') {
            return time;
        }
        var matches = time.match(/(^\d*\.?\d*)(\w*)/);
        var num = matches && matches[1];
        var unit = matches && matches[2];
        if (!num.length) {
            return 0;
        }
        num = parseFloat(num);
        var mult = msUnits[unit] || 1;
        return num * mult;
    }

    // ----- fin ----- //

    // back in global
    Outlayer.Item = Item;

    return Outlayer;

}));

/**
 * Isotope Item
**/

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('isotope-layout/js/item', [
            'outlayer/outlayer'
        ],
            factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('outlayer')
        );
    } else {
        // browser global
        window.Isotope = window.Isotope || {};
        window.Isotope.Item = factory(
            window.Outlayer
        );
    }

}(window, function factory(Outlayer) {
    'use strict';

    // -------------------------- Item -------------------------- //

    // sub-class Outlayer Item
    function Item() {
        Outlayer.Item.apply(this, arguments);
    }

    var proto = Item.prototype = Object.create(Outlayer.Item.prototype);

    var _create = proto._create;
    proto._create = function () {
        // assign id, used for original-order sorting
        this.id = this.layout.itemGUID++;
        _create.call(this);
        this.sortData = {};
    };

    proto.updateSortData = function () {
        if (this.isIgnored) {
            return;
        }
        // default sorters
        this.sortData.id = this.id;
        // for backward compatibility
        this.sortData['original-order'] = this.id;
        this.sortData.random = Math.random();
        // go thru getSortData obj and apply the sorters
        var getSortData = this.layout.options.getSortData;
        var sorters = this.layout._sorters;
        for (var key in getSortData) {
            var sorter = sorters[key];
            this.sortData[key] = sorter(this.element, this);
        }
    };

    var _destroy = proto.destroy;
    proto.destroy = function () {
        // call super
        _destroy.apply(this, arguments);
        // reset display, #741
        this.css({
            display: ''
        });
    };

    return Item;

}));

/**
 * Isotope LayoutMode
 */

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('isotope-layout/js/layout-mode', [
            'get-size/get-size',
            'outlayer/outlayer'
        ],
            factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('get-size'),
            require('outlayer')
        );
    } else {
        // browser global
        window.Isotope = window.Isotope || {};
        window.Isotope.LayoutMode = factory(
            window.getSize,
            window.Outlayer
        );
    }

}(window, function factory(getSize, Outlayer) {
    'use strict';

    // layout mode class
    function LayoutMode(isotope) {
        this.isotope = isotope;
        // link properties
        if (isotope) {
            this.options = isotope.options[this.namespace];
            this.element = isotope.element;
            this.items = isotope.filteredItems;
            this.size = isotope.size;
        }
    }

    var proto = LayoutMode.prototype;

    /**
     * some methods should just defer to default Outlayer method
     * and reference the Isotope instance as `this`
    **/
    var facadeMethods = [
        '_resetLayout',
        '_getItemLayoutPosition',
        '_manageStamp',
        '_getContainerSize',
        '_getElementOffset',
        'needsResizeLayout',
        '_getOption'
    ];

    facadeMethods.forEach(function (methodName) {
        proto[methodName] = function () {
            return Outlayer.prototype[methodName].apply(this.isotope, arguments);
        };
    });

    // -----  ----- //

    // for horizontal layout modes, check vertical size
    proto.needsVerticalResizeLayout = function () {
        // don't trigger if size did not change
        var size = getSize(this.isotope.element);
        // check that this.size and size are there
        // IE8 triggers resize on body size change, so they might not be
        var hasSizes = this.isotope.size && size;
        return hasSizes && size.innerHeight != this.isotope.size.innerHeight;
    };

    // ----- measurements ----- //

    proto._getMeasurement = function () {
        this.isotope._getMeasurement.apply(this, arguments);
    };

    proto.getColumnWidth = function () {
        this.getSegmentSize('column', 'Width');
    };

    proto.getRowHeight = function () {
        this.getSegmentSize('row', 'Height');
    };

    /**
     * get columnWidth or rowHeight
     * segment: 'column' or 'row'
     * size 'Width' or 'Height'
    **/
    proto.getSegmentSize = function (segment, size) {
        var segmentName = segment + size;
        var outerSize = 'outer' + size;
        // columnWidth / outerWidth // rowHeight / outerHeight
        this._getMeasurement(segmentName, outerSize);
        // got rowHeight or columnWidth, we can chill
        if (this[segmentName]) {
            return;
        }
        // fall back to item of first element
        var firstItemSize = this.getFirstItemSize();
        this[segmentName] = firstItemSize && firstItemSize[outerSize] ||
            // or size of container
            this.isotope.size['inner' + size];
    };

    proto.getFirstItemSize = function () {
        var firstItem = this.isotope.filteredItems[0];
        return firstItem && firstItem.element && getSize(firstItem.element);
    };

    // ----- methods that should reference isotope ----- //

    proto.layout = function () {
        this.isotope.layout.apply(this.isotope, arguments);
    };

    proto.getSize = function () {
        this.isotope.getSize();
        this.size = this.isotope.size;
    };

    // -------------------------- create -------------------------- //

    LayoutMode.modes = {};

    LayoutMode.create = function (namespace, options) {

        function Mode() {
            LayoutMode.apply(this, arguments);
        }

        Mode.prototype = Object.create(proto);
        Mode.prototype.constructor = Mode;

        // default options
        if (options) {
            Mode.options = options;
        }

        Mode.prototype.namespace = namespace;
        // register in Isotope
        LayoutMode.modes[namespace] = Mode;

        return Mode;
    };

    return LayoutMode;

}));

/*!
 * Masonry v4.2.1
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('masonry-layout/masonry', [
            'outlayer/outlayer',
            'get-size/get-size'
        ],
            factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('outlayer'),
            require('get-size')
        );
    } else {
        // browser global
        window.Masonry = factory(
            window.Outlayer,
            window.getSize
        );
    }

}(window, function factory(Outlayer, getSize) {



    // -------------------------- masonryDefinition -------------------------- //

    // create an Outlayer layout class
    var Masonry = Outlayer.create('masonry');
    // isFitWidth -> fitWidth
    Masonry.compatOptions.fitWidth = 'isFitWidth';

    var proto = Masonry.prototype;

    proto._resetLayout = function () {
        this.getSize();
        this._getMeasurement('columnWidth', 'outerWidth');
        this._getMeasurement('gutter', 'outerWidth');
        this.measureColumns();

        // reset column Y
        this.colYs = [];
        for (var i = 0; i < this.cols; i++) {
            this.colYs.push(0);
        }

        this.maxY = 0;
        this.horizontalColIndex = 0;
    };

    proto.measureColumns = function () {
        this.getContainerWidth();
        // if columnWidth is 0, default to outerWidth of first item
        if (!this.columnWidth) {
            var firstItem = this.items[0];
            var firstItemElem = firstItem && firstItem.element;
            // columnWidth fall back to item of first element
            this.columnWidth = firstItemElem && getSize(firstItemElem).outerWidth ||
                // if first elem has no width, default to size of container
                this.containerWidth;
        }

        var columnWidth = this.columnWidth += this.gutter;

        // calculate columns
        var containerWidth = this.containerWidth + this.gutter;
        var cols = containerWidth / columnWidth;
        // fix rounding errors, typically with gutters
        var excess = columnWidth - containerWidth % columnWidth;
        // if overshoot is less than a pixel, round up, otherwise floor it
        var mathMethod = excess && excess < 1 ? 'round' : 'floor';
        cols = Math[mathMethod](cols);
        this.cols = Math.max(cols, 1);
    };

    proto.getContainerWidth = function () {
        // container is parent if fit width
        var isFitWidth = this._getOption('fitWidth');
        var container = isFitWidth ? this.element.parentNode : this.element;
        // check that this.size and size are there
        // IE8 triggers resize on body size change, so they might not be
        var size = getSize(container);
        this.containerWidth = size && size.innerWidth;
    };

    proto._getItemLayoutPosition = function (item) {
        item.getSize();
        // how many columns does this brick span
        var remainder = item.size.outerWidth % this.columnWidth;
        var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
        // round if off by 1 pixel, otherwise use ceil
        var colSpan = Math[mathMethod](item.size.outerWidth / this.columnWidth);
        colSpan = Math.min(colSpan, this.cols);
        // use horizontal or top column position
        var colPosMethod = this.options.horizontalOrder ?
            '_getHorizontalColPosition' : '_getTopColPosition';
        var colPosition = this[colPosMethod](colSpan, item);
        // position the brick
        var position = {
            x: this.columnWidth * colPosition.col,
            y: colPosition.y
        };
        // apply setHeight to necessary columns
        var setHeight = colPosition.y + item.size.outerHeight;
        var setMax = colSpan + colPosition.col;
        for (var i = colPosition.col; i < setMax; i++) {
            this.colYs[i] = setHeight;
        }

        return position;
    };

    proto._getTopColPosition = function (colSpan) {
        var colGroup = this._getTopColGroup(colSpan);
        // get the minimum Y value from the columns
        var minimumY = Math.min.apply(Math, colGroup);

        return {
            col: colGroup.indexOf(minimumY),
            y: minimumY,
        };
    };

    /**
     * @param {Number} colSpan - number of columns the element spans
     * @returns {Array} colGroup
     */
    proto._getTopColGroup = function (colSpan) {
        if (colSpan < 2) {
            // if brick spans only one column, use all the column Ys
            return this.colYs;
        }

        var colGroup = [];
        // how many different places could this brick fit horizontally
        var groupCount = this.cols + 1 - colSpan;
        // for each group potential horizontal position
        for (var i = 0; i < groupCount; i++) {
            colGroup[i] = this._getColGroupY(i, colSpan);
        }
        return colGroup;
    };

    proto._getColGroupY = function (col, colSpan) {
        if (colSpan < 2) {
            return this.colYs[col];
        }
        // make an array of colY values for that one group
        var groupColYs = this.colYs.slice(col, col + colSpan);
        // and get the max value of the array
        return Math.max.apply(Math, groupColYs);
    };

    // get column position based on horizontal index. #873
    proto._getHorizontalColPosition = function (colSpan, item) {
        var col = this.horizontalColIndex % this.cols;
        var isOver = colSpan > 1 && col + colSpan > this.cols;
        // shift to next row if item can't fit on current row
        col = isOver ? 0 : col;
        // don't let zero-size items take up space
        var hasSize = item.size.outerWidth && item.size.outerHeight;
        this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;

        return {
            col: col,
            y: this._getColGroupY(col, colSpan),
        };
    };

    proto._manageStamp = function (stamp) {
        var stampSize = getSize(stamp);
        var offset = this._getElementOffset(stamp);
        // get the columns that this stamp affects
        var isOriginLeft = this._getOption('originLeft');
        var firstX = isOriginLeft ? offset.left : offset.right;
        var lastX = firstX + stampSize.outerWidth;
        var firstCol = Math.floor(firstX / this.columnWidth);
        firstCol = Math.max(0, firstCol);
        var lastCol = Math.floor(lastX / this.columnWidth);
        // lastCol should not go over if multiple of columnWidth #425
        lastCol -= lastX % this.columnWidth ? 0 : 1;
        lastCol = Math.min(this.cols - 1, lastCol);
        // set colYs to bottom of the stamp

        var isOriginTop = this._getOption('originTop');
        var stampMaxY = (isOriginTop ? offset.top : offset.bottom) +
            stampSize.outerHeight;
        for (var i = firstCol; i <= lastCol; i++) {
            this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
        }
    };

    proto._getContainerSize = function () {
        this.maxY = Math.max.apply(Math, this.colYs);
        var size = {
            height: this.maxY
        };

        if (this._getOption('fitWidth')) {
            size.width = this._getContainerFitWidth();
        }

        return size;
    };

    proto._getContainerFitWidth = function () {
        var unusedCols = 0;
        // count unused columns
        var i = this.cols;
        while (--i) {
            if (this.colYs[i] !== 0) {
                break;
            }
            unusedCols++;
        }
        // fit container to columns that have been used
        return (this.cols - unusedCols) * this.columnWidth - this.gutter;
    };

    proto.needsResizeLayout = function () {
        var previousWidth = this.containerWidth;
        this.getContainerWidth();
        return previousWidth != this.containerWidth;
    };

    return Masonry;

}));

/*!
 * Masonry layout mode
 * sub-classes Masonry
 * https://masonry.desandro.com
 */

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('isotope-layout/js/layout-modes/masonry', [
            '../layout-mode',
            'masonry-layout/masonry'
        ],
            factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('../layout-mode'),
            require('masonry-layout')
        );
    } else {
        // browser global
        factory(
            window.Isotope.LayoutMode,
            window.Masonry
        );
    }

}(window, function factory(LayoutMode, Masonry) {
    'use strict';

    // -------------------------- masonryDefinition -------------------------- //

    // create an Outlayer layout class
    var MasonryMode = LayoutMode.create('masonry');

    var proto = MasonryMode.prototype;

    var keepModeMethods = {
        _getElementOffset: true,
        layout: true,
        _getMeasurement: true
    };

    // inherit Masonry prototype
    for (var method in Masonry.prototype) {
        // do not inherit mode methods
        if (!keepModeMethods[method]) {
            proto[method] = Masonry.prototype[method];
        }
    }

    var measureColumns = proto.measureColumns;
    proto.measureColumns = function () {
        // set items, used if measuring first item
        this.items = this.isotope.filteredItems;
        measureColumns.call(this);
    };

    // point to mode options for fitWidth
    var _getOption = proto._getOption;
    proto._getOption = function (option) {
        if (option == 'fitWidth') {
            return this.options.isFitWidth !== undefined ?
                this.options.isFitWidth : this.options.fitWidth;
        }
        return _getOption.apply(this.isotope, arguments);
    };

    return MasonryMode;

}));

/**
 * fitRows layout mode
 */

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('isotope-layout/js/layout-modes/fit-rows', [
            '../layout-mode'
        ],
            factory);
    } else if (typeof exports == 'object') {
        // CommonJS
        module.exports = factory(
            require('../layout-mode')
        );
    } else {
        // browser global
        factory(
            window.Isotope.LayoutMode
        );
    }

}(window, function factory(LayoutMode) {
    'use strict';

    var FitRows = LayoutMode.create('fitRows');

    var proto = FitRows.prototype;

    proto._resetLayout = function () {
        this.x = 0;
        this.y = 0;
        this.maxY = 0;
        this._getMeasurement('gutter', 'outerWidth');
    };

    proto._getItemLayoutPosition = function (item) {
        item.getSize();

        var itemWidth = item.size.outerWidth + this.gutter;
        // if this element cannot fit in the current row
        var containerWidth = this.isotope.size.innerWidth + this.gutter;
        if (this.x !== 0 && itemWidth + this.x > containerWidth) {
            this.x = 0;
            this.y = this.maxY;
        }

        var position = {
            x: this.x,
            y: this.y
        };

        this.maxY = Math.max(this.maxY, this.y + item.size.outerHeight);
        this.x += itemWidth;

        return position;
    };

    proto._getContainerSize = function () {
        return { height: this.maxY };
    };

    return FitRows;

}));

/**
 * vertical layout mode
 */

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define('isotope-layout/js/layout-modes/vertical', [
            '../layout-mode'
        ],
            factory);
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            require('../layout-mode')
        );
    } else {
        // browser global
        factory(
            window.Isotope.LayoutMode
        );
    }

}(window, function factory(LayoutMode) {
    'use strict';

    var Vertical = LayoutMode.create('vertical', {
        horizontalAlignment: 0
    });

    var proto = Vertical.prototype;

    proto._resetLayout = function () {
        this.y = 0;
    };

    proto._getItemLayoutPosition = function (item) {
        item.getSize();
        var x = (this.isotope.size.innerWidth - item.size.outerWidth) *
            this.options.horizontalAlignment;
        var y = this.y;
        this.y += item.size.outerHeight;
        return { x: x, y: y };
    };

    proto._getContainerSize = function () {
        return { height: this.y };
    };

    return Vertical;

}));

/*!
 * Isotope v3.0.6
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * https://isotope.metafizzy.co
 * Copyright 2010-2018 Metafizzy
 */

(function (window, factory) {
    // universal module definition
    /* jshint strict: false */ /*globals define, module, require */
    if (typeof define == 'function' && define.amd) {
        // AMD
        define([
            'outlayer/outlayer',
            'get-size/get-size',
            'desandro-matches-selector/matches-selector',
            'fizzy-ui-utils/utils',
            'isotope-layout/js/item',
            'isotope-layout/js/layout-mode',
            // include default layout modes
            'isotope-layout/js/layout-modes/masonry',
            'isotope-layout/js/layout-modes/fit-rows',
            'isotope-layout/js/layout-modes/vertical'
        ],
            function (Outlayer, getSize, matchesSelector, utils, Item, LayoutMode) {
                return factory(window, Outlayer, getSize, matchesSelector, utils, Item, LayoutMode);
            });
    } else if (typeof module == 'object' && module.exports) {
        // CommonJS
        module.exports = factory(
            window,
            require('outlayer'),
            require('get-size'),
            require('desandro-matches-selector'),
            require('fizzy-ui-utils'),
            require('isotope-layout/js/item'),
            require('isotope-layout/js/layout-mode'),
            // include default layout modes
            require('isotope-layout/js/layout-modes/masonry'),
            require('isotope-layout/js/layout-modes/fit-rows'),
            require('isotope-layout/js/layout-modes/vertical')
        );
    } else {
        // browser global
        window.Isotope = factory(
            window,
            window.Outlayer,
            window.getSize,
            window.matchesSelector,
            window.fizzyUIUtils,
            window.Isotope.Item,
            window.Isotope.LayoutMode
        );
    }

}(window, function factory(window, Outlayer, getSize, matchesSelector, utils,
    Item, LayoutMode) {



    // -------------------------- vars -------------------------- //

    var jQuery = window.jQuery;

    // -------------------------- helpers -------------------------- //

    var trim = String.prototype.trim ?
        function (str) {
            return str.trim();
        } :
        function (str) {
            return str.replace(/^\s+|\s+$/g, '');
        };

    // -------------------------- isotopeDefinition -------------------------- //

    // create an Outlayer layout class
    var Isotope = Outlayer.create('isotope', {
        layoutMode: 'masonry',
        isJQueryFiltering: true,
        sortAscending: true
    });

    Isotope.Item = Item;
    Isotope.LayoutMode = LayoutMode;

    var proto = Isotope.prototype;

    proto._create = function () {
        this.itemGUID = 0;
        // functions that sort items
        this._sorters = {};
        this._getSorters();
        // call super
        Outlayer.prototype._create.call(this);

        // create layout modes
        this.modes = {};
        // start filteredItems with all items
        this.filteredItems = this.items;
        // keep of track of sortBys
        this.sortHistory = ['original-order'];
        // create from registered layout modes
        for (var name in LayoutMode.modes) {
            this._initLayoutMode(name);
        }
    };

    proto.reloadItems = function () {
        // reset item ID counter
        this.itemGUID = 0;
        // call super
        Outlayer.prototype.reloadItems.call(this);
    };

    proto._itemize = function () {
        var items = Outlayer.prototype._itemize.apply(this, arguments);
        // assign ID for original-order
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            item.id = this.itemGUID++;
        }
        this._updateItemsSortData(items);
        return items;
    };


    // -------------------------- layout -------------------------- //

    proto._initLayoutMode = function (name) {
        var Mode = LayoutMode.modes[name];
        // set mode options
        // HACK extend initial options, back-fill in default options
        var initialOpts = this.options[name] || {};
        this.options[name] = Mode.options ?
            utils.extend(Mode.options, initialOpts) : initialOpts;
        // init layout mode instance
        this.modes[name] = new Mode(this);
    };


    proto.layout = function () {
        // if first time doing layout, do all magic
        if (!this._isLayoutInited && this._getOption('initLayout')) {
            this.arrange();
            return;
        }
        this._layout();
    };

    // private method to be used in layout() & magic()
    proto._layout = function () {
        // don't animate first layout
        var isInstant = this._getIsInstant();
        // layout flow
        this._resetLayout();
        this._manageStamps();
        this.layoutItems(this.filteredItems, isInstant);

        // flag for initalized
        this._isLayoutInited = true;
    };

    // filter + sort + layout
    proto.arrange = function (opts) {
        // set any options pass
        this.option(opts);
        this._getIsInstant();
        // filter, sort, and layout

        // filter
        var filtered = this._filter(this.items);
        this.filteredItems = filtered.matches;

        this._bindArrangeComplete();

        if (this._isInstant) {
            this._noTransition(this._hideReveal, [filtered]);
        } else {
            this._hideReveal(filtered);
        }

        this._sort();
        this._layout();
    };
    // alias to _init for main plugin method
    proto._init = proto.arrange;

    proto._hideReveal = function (filtered) {
        this.reveal(filtered.needReveal);
        this.hide(filtered.needHide);
    };

    // HACK
    // Don't animate/transition first layout
    // Or don't animate/transition other layouts
    proto._getIsInstant = function () {
        var isLayoutInstant = this._getOption('layoutInstant');
        var isInstant = isLayoutInstant !== undefined ? isLayoutInstant :
            !this._isLayoutInited;
        this._isInstant = isInstant;
        return isInstant;
    };

    // listen for layoutComplete, hideComplete and revealComplete
    // to trigger arrangeComplete
    proto._bindArrangeComplete = function () {
        // listen for 3 events to trigger arrangeComplete
        var isLayoutComplete, isHideComplete, isRevealComplete;
        var _this = this;
        function arrangeParallelCallback() {
            if (isLayoutComplete && isHideComplete && isRevealComplete) {
                _this.dispatchEvent('arrangeComplete', null, [_this.filteredItems]);
            }
        }
        this.once('layoutComplete', function () {
            isLayoutComplete = true;
            arrangeParallelCallback();
        });
        this.once('hideComplete', function () {
            isHideComplete = true;
            arrangeParallelCallback();
        });
        this.once('revealComplete', function () {
            isRevealComplete = true;
            arrangeParallelCallback();
        });
    };

    // -------------------------- filter -------------------------- //

    proto._filter = function (items) {
        var filter = this.options.filter;
        filter = filter || '*';
        var matches = [];
        var hiddenMatched = [];
        var visibleUnmatched = [];

        var test = this._getFilterTest(filter);

        // test each item
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.isIgnored) {
                continue;
            }
            // add item to either matched or unmatched group
            var isMatched = test(item);
            // item.isFilterMatched = isMatched;
            // add to matches if its a match
            if (isMatched) {
                matches.push(item);
            }
            // add to additional group if item needs to be hidden or revealed
            if (isMatched && item.isHidden) {
                hiddenMatched.push(item);
            } else if (!isMatched && !item.isHidden) {
                visibleUnmatched.push(item);
            }
        }

        // return collections of items to be manipulated
        return {
            matches: matches,
            needReveal: hiddenMatched,
            needHide: visibleUnmatched
        };
    };

    // get a jQuery, function, or a matchesSelector test given the filter
    proto._getFilterTest = function (filter) {
        if (jQuery && this.options.isJQueryFiltering) {
            // use jQuery
            return function (item) {
                return jQuery(item.element).is(filter);
            };
        }
        if (typeof filter == 'function') {
            // use filter as function
            return function (item) {
                return filter(item.element);
            };
        }
        // default, use filter as selector string
        return function (item) {
            return matchesSelector(item.element, filter);
        };
    };

    // -------------------------- sorting -------------------------- //

    /**
     * @params {Array} elems
     * @public
     */
    proto.updateSortData = function (elems) {
        // get items
        var items;
        if (elems) {
            elems = utils.makeArray(elems);
            items = this.getItems(elems);
        } else {
            // update all items if no elems provided
            items = this.items;
        }

        this._getSorters();
        this._updateItemsSortData(items);
    };

    proto._getSorters = function () {
        var getSortData = this.options.getSortData;
        for (var key in getSortData) {
            var sorter = getSortData[key];
            this._sorters[key] = mungeSorter(sorter);
        }
    };

    /**
     * @params {Array} items - of Isotope.Items
     * @private
     */
    proto._updateItemsSortData = function (items) {
        // do not update if no items
        var len = items && items.length;

        for (var i = 0; len && i < len; i++) {
            var item = items[i];
            item.updateSortData();
        }
    };

    // ----- munge sorter ----- //

    // encapsulate this, as we just need mungeSorter
    // other functions in here are just for munging
    var mungeSorter = (function () {
        // add a magic layer to sorters for convienent shorthands
        // `.foo-bar` will use the text of .foo-bar querySelector
        // `[foo-bar]` will use attribute
        // you can also add parser
        // `.foo-bar parseInt` will parse that as a number
        function mungeSorter(sorter) {
            // if not a string, return function or whatever it is
            if (typeof sorter != 'string') {
                return sorter;
            }
            // parse the sorter string
            var args = trim(sorter).split(' ');
            var query = args[0];
            // check if query looks like [an-attribute]
            var attrMatch = query.match(/^\[(.+)\]$/);
            var attr = attrMatch && attrMatch[1];
            var getValue = getValueGetter(attr, query);
            // use second argument as a parser
            var parser = Isotope.sortDataParsers[args[1]];
            // parse the value, if there was a parser
            sorter = parser ? function (elem) {
                return elem && parser(getValue(elem));
            } :
                // otherwise just return value
                function (elem) {
                    return elem && getValue(elem);
                };

            return sorter;
        }

        // get an attribute getter, or get text of the querySelector
        function getValueGetter(attr, query) {
            // if query looks like [foo-bar], get attribute
            if (attr) {
                return function getAttribute(elem) {
                    return elem.getAttribute(attr);
                };
            }

            // otherwise, assume its a querySelector, and get its text
            return function getChildText(elem) {
                var child = elem.querySelector(query);
                return child && child.textContent;
            };
        }

        return mungeSorter;
    })();

    // parsers used in getSortData shortcut strings
    Isotope.sortDataParsers = {
        'parseInt': function (val) {
            return parseInt(val, 10);
        },
        'parseFloat': function (val) {
            return parseFloat(val);
        }
    };

    // ----- sort method ----- //

    // sort filteredItem order
    proto._sort = function () {
        if (!this.options.sortBy) {
            return;
        }
        // keep track of sortBy History
        var sortBys = utils.makeArray(this.options.sortBy);
        if (!this._getIsSameSortBy(sortBys)) {
            // concat all sortBy and sortHistory, add to front, oldest goes in last
            this.sortHistory = sortBys.concat(this.sortHistory);
        }
        // sort magic
        var itemSorter = getItemSorter(this.sortHistory, this.options.sortAscending);
        this.filteredItems.sort(itemSorter);
    };

    // check if sortBys is same as start of sortHistory
    proto._getIsSameSortBy = function (sortBys) {
        for (var i = 0; i < sortBys.length; i++) {
            if (sortBys[i] != this.sortHistory[i]) {
                return false;
            }
        }
        return true;
    };

    // returns a function used for sorting
    function getItemSorter(sortBys, sortAsc) {
        return function sorter(itemA, itemB) {
            // cycle through all sortKeys
            for (var i = 0; i < sortBys.length; i++) {
                var sortBy = sortBys[i];
                var a = itemA.sortData[sortBy];
                var b = itemB.sortData[sortBy];
                if (a > b || a < b) {
                    // if sortAsc is an object, use the value given the sortBy key
                    var isAscending = sortAsc[sortBy] !== undefined ? sortAsc[sortBy] : sortAsc;
                    var direction = isAscending ? 1 : -1;
                    return (a > b ? 1 : -1) * direction;
                }
            }
            return 0;
        };
    }

    // -------------------------- methods -------------------------- //

    // get layout mode
    proto._mode = function () {
        var layoutMode = this.options.layoutMode;
        var mode = this.modes[layoutMode];
        if (!mode) {
            // TODO console.error
            throw new Error('No layout mode: ' + layoutMode);
        }
        // HACK sync mode's options
        // any options set after init for layout mode need to be synced
        mode.options = this.options[layoutMode];
        return mode;
    };

    proto._resetLayout = function () {
        // trigger original reset layout
        Outlayer.prototype._resetLayout.call(this);
        this._mode()._resetLayout();
    };

    proto._getItemLayoutPosition = function (item) {
        return this._mode()._getItemLayoutPosition(item);
    };

    proto._manageStamp = function (stamp) {
        this._mode()._manageStamp(stamp);
    };

    proto._getContainerSize = function () {
        return this._mode()._getContainerSize();
    };

    proto.needsResizeLayout = function () {
        return this._mode().needsResizeLayout();
    };

    // -------------------------- adding & removing -------------------------- //

    // HEADS UP overwrites default Outlayer appended
    proto.appended = function (elems) {
        var items = this.addItems(elems);
        if (!items.length) {
            return;
        }
        // filter, layout, reveal new items
        var filteredItems = this._filterRevealAdded(items);
        // add to filteredItems
        this.filteredItems = this.filteredItems.concat(filteredItems);
    };

    // HEADS UP overwrites default Outlayer prepended
    proto.prepended = function (elems) {
        var items = this._itemize(elems);
        if (!items.length) {
            return;
        }
        // start new layout
        this._resetLayout();
        this._manageStamps();
        // filter, layout, reveal new items
        var filteredItems = this._filterRevealAdded(items);
        // layout previous items
        this.layoutItems(this.filteredItems);
        // add to items and filteredItems
        this.filteredItems = filteredItems.concat(this.filteredItems);
        this.items = items.concat(this.items);
    };

    proto._filterRevealAdded = function (items) {
        var filtered = this._filter(items);
        this.hide(filtered.needHide);
        // reveal all new items
        this.reveal(filtered.matches);
        // layout new items, no transition
        this.layoutItems(filtered.matches, true);
        return filtered.matches;
    };

    /**
     * Filter, sort, and layout newly-appended item elements
     * @param {Array or NodeList or Element} elems
     */
    proto.insert = function (elems) {
        var items = this.addItems(elems);
        if (!items.length) {
            return;
        }
        // append item elements
        var i, item;
        var len = items.length;
        for (i = 0; i < len; i++) {
            item = items[i];
            this.element.appendChild(item.element);
        }
        // filter new stuff
        var filteredInsertItems = this._filter(items).matches;
        // set flag
        for (i = 0; i < len; i++) {
            items[i].isLayoutInstant = true;
        }
        this.arrange();
        // reset flag
        for (i = 0; i < len; i++) {
            delete items[i].isLayoutInstant;
        }
        this.reveal(filteredInsertItems);
    };

    var _remove = proto.remove;
    proto.remove = function (elems) {
        elems = utils.makeArray(elems);
        var removeItems = this.getItems(elems);
        // do regular thing
        _remove.call(this, elems);
        // bail if no items to remove
        var len = removeItems && removeItems.length;
        // remove elems from filteredItems
        for (var i = 0; len && i < len; i++) {
            var item = removeItems[i];
            // remove item from collection
            utils.removeFrom(this.filteredItems, item);
        }
    };

    proto.shuffle = function () {
        // update random sortData
        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            item.sortData.random = Math.random();
        }
        this.options.sortBy = 'random';
        this._sort();
        this._layout();
    };

    /**
     * trigger fn without transition
     * kind of hacky to have this in the first place
     * @param {Function} fn
     * @param {Array} args
     * @returns ret
     * @private
     */
    proto._noTransition = function (fn, args) {
        // save transitionDuration before disabling
        var transitionDuration = this.options.transitionDuration;
        // disable transition
        this.options.transitionDuration = 0;
        // do it
        var returnValue = fn.apply(this, args);
        // re-enable transition for reveal
        this.options.transitionDuration = transitionDuration;
        return returnValue;
    };

    // ----- helper methods ----- //

    /**
     * getter method for getting filtered item elements
     * @returns {Array} elems - collection of item elements
     */
    proto.getFilteredItemElements = function () {
        return this.filteredItems.map(function (item) {
            return item.element;
        });
    };

    // -----  ----- //

    return Isotope;

}));

﻿/*!
 * Packery layout mode PACKAGED v2.0.1
 * sub-classes Packery
 */

!function (a, b) { "function" == typeof define && define.amd ? define("packery/js/rect", b) : "object" == typeof module && module.exports ? module.exports = b() : (a.Packery = a.Packery || {}, a.Packery.Rect = b()) }(window, function () { function a(b) { for (var c in a.defaults) this[c] = a.defaults[c]; for (c in b) this[c] = b[c] } a.defaults = { x: 0, y: 0, width: 0, height: 0 }; var b = a.prototype; return b.contains = function (a) { var b = a.width || 0, c = a.height || 0; return this.x <= a.x && this.y <= a.y && this.x + this.width >= a.x + b && this.y + this.height >= a.y + c }, b.overlaps = function (a) { var b = this.x + this.width, c = this.y + this.height, d = a.x + a.width, e = a.y + a.height; return this.x < d && b > a.x && this.y < e && c > a.y }, b.getMaximalFreeRects = function (b) { if (!this.overlaps(b)) return !1; var c, d = [], e = this.x + this.width, f = this.y + this.height, g = b.x + b.width, h = b.y + b.height; return this.y < b.y && (c = new a({ x: this.x, y: this.y, width: this.width, height: b.y - this.y }), d.push(c)), e > g && (c = new a({ x: g, y: this.y, width: e - g, height: this.height }), d.push(c)), f > h && (c = new a({ x: this.x, y: h, width: this.width, height: f - h }), d.push(c)), this.x < b.x && (c = new a({ x: this.x, y: this.y, width: b.x - this.x, height: this.height }), d.push(c)), d }, b.canFit = function (a) { return this.width >= a.width && this.height >= a.height }, a }), function (a, b) { if ("function" == typeof define && define.amd) define("packery/js/packer", ["./rect"], b); else if ("object" == typeof module && module.exports) module.exports = b(require("./rect")); else { var c = a.Packery = a.Packery || {}; c.Packer = b(c.Rect) } }(window, function (a) { function b(a, b, c) { this.width = a || 0, this.height = b || 0, this.sortDirection = c || "downwardLeftToRight", this.reset() } var c = b.prototype; c.reset = function () { this.spaces = []; var b = new a({ x: 0, y: 0, width: this.width, height: this.height }); this.spaces.push(b), this.sorter = d[this.sortDirection] || d.downwardLeftToRight }, c.pack = function (a) { for (var b = 0; b < this.spaces.length; b++) { var c = this.spaces[b]; if (c.canFit(a)) { this.placeInSpace(a, c); break } } }, c.columnPack = function (a) { for (var b = 0; b < this.spaces.length; b++) { var c = this.spaces[b], d = c.x <= a.x && c.x + c.width >= a.x + a.width && c.height >= a.height - .01; if (d) { a.y = c.y, this.placed(a); break } } }, c.rowPack = function (a) { for (var b = 0; b < this.spaces.length; b++) { var c = this.spaces[b], d = c.y <= a.y && c.y + c.height >= a.y + a.height && c.width >= a.width - .01; if (d) { a.x = c.x, this.placed(a); break } } }, c.placeInSpace = function (a, b) { a.x = b.x, a.y = b.y, this.placed(a) }, c.placed = function (a) { for (var b = [], c = 0; c < this.spaces.length; c++) { var d = this.spaces[c], e = d.getMaximalFreeRects(a); e ? b.push.apply(b, e) : b.push(d) } this.spaces = b, this.mergeSortSpaces() }, c.mergeSortSpaces = function () { b.mergeRects(this.spaces), this.spaces.sort(this.sorter) }, c.addSpace = function (a) { this.spaces.push(a), this.mergeSortSpaces() }, b.mergeRects = function (a) { var b = 0, c = a[b]; a: for (; c;) { for (var d = 0, e = a[b + d]; e;) { if (e == c) d++; else { if (e.contains(c)) { a.splice(b, 1), c = a[b]; continue a } c.contains(e) ? a.splice(b + d, 1) : d++ } e = a[b + d] } b++, c = a[b] } return a }; var d = { downwardLeftToRight: function (a, b) { return a.y - b.y || a.x - b.x }, rightwardTopToBottom: function (a, b) { return a.x - b.x || a.y - b.y } }; return b }), function (a, b) { "function" == typeof define && define.amd ? define("packery/js/item", ["outlayer/outlayer", "./rect"], b) : "object" == typeof module && module.exports ? module.exports = b(require("outlayer"), require("./rect")) : a.Packery.Item = b(a.Outlayer, a.Packery.Rect) }(window, function (a, b) { var c = document.documentElement.style, d = "string" == typeof c.transform ? "transform" : "WebkitTransform", e = function () { a.Item.apply(this, arguments) }, f = e.prototype = Object.create(a.Item.prototype), g = f._create; f._create = function () { g.call(this), this.rect = new b }; var h = f.moveTo; return f.moveTo = function (a, b) { var c = Math.abs(this.position.x - a), d = Math.abs(this.position.y - b), e = this.layout.dragItemCount && !this.isPlacing && !this.isTransitioning && 1 > c && 1 > d; return e ? void this.goTo(a, b) : void h.apply(this, arguments) }, f.enablePlacing = function () { this.removeTransitionStyles(), this.isTransitioning && d && (this.element.style[d] = "none"), this.isTransitioning = !1, this.getSize(), this.layout._setRectSize(this.element, this.rect), this.isPlacing = !0 }, f.disablePlacing = function () { this.isPlacing = !1 }, f.removeElem = function () { this.element.parentNode.removeChild(this.element), this.layout.packer.addSpace(this.rect), this.emitEvent("remove", [this]) }, f.showDropPlaceholder = function () { var a = this.dropPlaceholder; a || (a = this.dropPlaceholder = document.createElement("div"), a.className = "packery-drop-placeholder", a.style.position = "absolute"), a.style.width = this.size.width + "px", a.style.height = this.size.height + "px", this.positionDropPlaceholder(), this.layout.element.appendChild(a) }, f.positionDropPlaceholder = function () { this.dropPlaceholder.style[d] = "translate(" + this.rect.x + "px, " + this.rect.y + "px)" }, f.hideDropPlaceholder = function () { this.layout.element.removeChild(this.dropPlaceholder) }, e }), function (a, b) { "function" == typeof define && define.amd ? define("packery/js/packery", ["get-size/get-size", "outlayer/outlayer", "./rect", "./packer", "./item"], b) : "object" == typeof module && module.exports ? module.exports = b(require("get-size"), require("outlayer"), require("./rect"), require("./packer"), require("./item")) : a.Packery = b(a.getSize, a.Outlayer, a.Packery.Rect, a.Packery.Packer, a.Packery.Item) }(window, function (a, b, c, d, e) { function f(a, b) { return a.position.y - b.position.y || a.position.x - b.position.x } function g(a, b) { return a.position.x - b.position.x || a.position.y - b.position.y } function h(a, b) { var c = b.x - a.x, d = b.y - a.y; return Math.sqrt(c * c + d * d) } c.prototype.canFit = function (a) { return this.width >= a.width - 1 && this.height >= a.height - 1 }; var i = b.create("packery"); i.Item = e; var j = i.prototype; j._create = function () { b.prototype._create.call(this), this.packer = new d, this.shiftPacker = new d, this.isEnabled = !0, this.dragItemCount = 0; var a = this; this.handleDraggabilly = { dragStart: function () { a.itemDragStart(this.element) }, dragMove: function () { a.itemDragMove(this.element, this.position.x, this.position.y) }, dragEnd: function () { a.itemDragEnd(this.element) } }, this.handleUIDraggable = { start: function (b, c) { c && a.itemDragStart(b.currentTarget) }, drag: function (b, c) { c && a.itemDragMove(b.currentTarget, c.position.left, c.position.top) }, stop: function (b, c) { c && a.itemDragEnd(b.currentTarget) } } }, j._resetLayout = function () { this.getSize(), this._getMeasurements(); var a, b, c; this._getOption("horizontal") ? (a = 1 / 0, b = this.size.innerHeight + this.gutter, c = "rightwardTopToBottom") : (a = this.size.innerWidth + this.gutter, b = 1 / 0, c = "downwardLeftToRight"), this.packer.width = this.shiftPacker.width = a, this.packer.height = this.shiftPacker.height = b, this.packer.sortDirection = this.shiftPacker.sortDirection = c, this.packer.reset(), this.maxY = 0, this.maxX = 0 }, j._getMeasurements = function () { this._getMeasurement("columnWidth", "width"), this._getMeasurement("rowHeight", "height"), this._getMeasurement("gutter", "width") }, j._getItemLayoutPosition = function (a) { if (this._setRectSize(a.element, a.rect), this.isShifting || this.dragItemCount > 0) { var b = this._getPackMethod(); this.packer[b](a.rect) } else this.packer.pack(a.rect); return this._setMaxXY(a.rect), a.rect }, j.shiftLayout = function () { this.isShifting = !0, this.layout(), delete this.isShifting }, j._getPackMethod = function () { return this._getOption("horizontal") ? "rowPack" : "columnPack" }, j._setMaxXY = function (a) { this.maxX = Math.max(a.x + a.width, this.maxX), this.maxY = Math.max(a.y + a.height, this.maxY) }, j._setRectSize = function (b, c) { var d = a(b), e = d.outerWidth, f = d.outerHeight; (e || f) && (e = this._applyGridGutter(e, this.columnWidth), f = this._applyGridGutter(f, this.rowHeight)), c.width = Math.min(e, this.packer.width), c.height = Math.min(f, this.packer.height) }, j._applyGridGutter = function (a, b) { if (!b) return a + this.gutter; b += this.gutter; var c = a % b, d = c && 1 > c ? "round" : "ceil"; return a = Math[d](a / b) * b }, j._getContainerSize = function () { return this._getOption("horizontal") ? { width: this.maxX - this.gutter } : { height: this.maxY - this.gutter } }, j._manageStamp = function (a) { var b, d = this.getItem(a); if (d && d.isPlacing) b = d.rect; else { var e = this._getElementOffset(a); b = new c({ x: this._getOption("originLeft") ? e.left : e.right, y: this._getOption("originTop") ? e.top : e.bottom }) } this._setRectSize(a, b), this.packer.placed(b), this._setMaxXY(b) }, j.sortItemsByPosition = function () { var a = this._getOption("horizontal") ? g : f; this.items.sort(a) }, j.fit = function (a, b, c) { var d = this.getItem(a); d && (this.stamp(d.element), d.enablePlacing(), this.updateShiftTargets(d), b = void 0 === b ? d.rect.x : b, c = void 0 === c ? d.rect.y : c, this.shift(d, b, c), this._bindFitEvents(d), d.moveTo(d.rect.x, d.rect.y), this.shiftLayout(), this.unstamp(d.element), this.sortItemsByPosition(), d.disablePlacing()) }, j._bindFitEvents = function (a) { function b() { d++, 2 == d && c.dispatchEvent("fitComplete", null, [a]) } var c = this, d = 0; a.once("layout", b), this.once("layoutComplete", b) }, j.resize = function () { this.isResizeBound && this.needsResizeLayout() && (this.options.shiftPercentResize ? this.resizeShiftPercentLayout() : this.layout()) }, j.needsResizeLayout = function () { var b = a(this.element), c = this._getOption("horizontal") ? "innerHeight" : "innerWidth"; return b[c] != this.size[c] }, j.resizeShiftPercentLayout = function () { var b = this._getItemsForLayout(this.items), c = this._getOption("horizontal"), d = c ? "y" : "x", e = c ? "height" : "width", f = c ? "rowHeight" : "columnWidth", g = c ? "innerHeight" : "innerWidth", h = this[f]; if (h = h && h + this.gutter) { this._getMeasurements(); var i = this[f] + this.gutter; b.forEach(function (a) { var b = Math.round(a.rect[d] / h); a.rect[d] = b * i }) } else { var j = a(this.element)[g] + this.gutter, k = this.packer[e]; b.forEach(function (a) { a.rect[d] = a.rect[d] / k * j }) } this.shiftLayout() }, j.itemDragStart = function (a) { if (this.isEnabled) { this.stamp(a); var b = this.getItem(a); b && (b.enablePlacing(), b.showDropPlaceholder(), this.dragItemCount++, this.updateShiftTargets(b)) } }, j.updateShiftTargets = function (a) { this.shiftPacker.reset(), this._getBoundingRect(); var b = this._getOption("originLeft"), d = this._getOption("originTop"); this.stamps.forEach(function (a) { var e = this.getItem(a); if (!e || !e.isPlacing) { var f = this._getElementOffset(a), g = new c({ x: b ? f.left : f.right, y: d ? f.top : f.bottom }); this._setRectSize(a, g), this.shiftPacker.placed(g) } }, this); var e = this._getOption("horizontal"), f = e ? "rowHeight" : "columnWidth", g = e ? "height" : "width"; this.shiftTargetKeys = [], this.shiftTargets = []; var h, i = this[f]; if (i = i && i + this.gutter) { var j = Math.ceil(a.rect[g] / i), k = Math.floor((this.shiftPacker[g] + this.gutter) / i); h = (k - j) * i; for (var l = 0; k > l; l++)this._addShiftTarget(l * i, 0, h) } else h = this.shiftPacker[g] + this.gutter - a.rect[g], this._addShiftTarget(0, 0, h); var m = this._getItemsForLayout(this.items), n = this._getPackMethod(); m.forEach(function (a) { var b = a.rect; this._setRectSize(a.element, b), this.shiftPacker[n](b), this._addShiftTarget(b.x, b.y, h); var c = e ? b.x + b.width : b.x, d = e ? b.y : b.y + b.height; if (this._addShiftTarget(c, d, h), i) for (var f = Math.round(b[g] / i), j = 1; f > j; j++) { var k = e ? c : b.x + i * j, l = e ? b.y + i * j : d; this._addShiftTarget(k, l, h) } }, this) }, j._addShiftTarget = function (a, b, c) { var d = this._getOption("horizontal") ? b : a; if (!(0 !== d && d > c)) { var e = a + "," + b, f = -1 != this.shiftTargetKeys.indexOf(e); f || (this.shiftTargetKeys.push(e), this.shiftTargets.push({ x: a, y: b })) } }, j.shift = function (a, b, c) { var d, e = 1 / 0, f = { x: b, y: c }; this.shiftTargets.forEach(function (a) { var b = h(a, f); e > b && (d = a, e = b) }), a.rect.x = d.x, a.rect.y = d.y }; var k = 120; j.itemDragMove = function (a, b, c) { function d() { f.shift(e, b, c), e.positionDropPlaceholder(), f.layout() } var e = this.isEnabled && this.getItem(a); if (e) { b -= this.size.paddingLeft, c -= this.size.paddingTop; var f = this, g = new Date; this._itemDragTime && g - this._itemDragTime < k ? (clearTimeout(this.dragTimeout), this.dragTimeout = setTimeout(d, k)) : (d(), this._itemDragTime = g) } }, j.itemDragEnd = function (a) { function b() { d++, 2 == d && (c.element.classList.remove("is-positioning-post-drag"), c.hideDropPlaceholder(), e.dispatchEvent("dragItemPositioned", null, [c])) } var c = this.isEnabled && this.getItem(a); if (c) { clearTimeout(this.dragTimeout), c.element.classList.add("is-positioning-post-drag"); var d = 0, e = this; c.once("layout", b), this.once("layoutComplete", b), c.moveTo(c.rect.x, c.rect.y), this.layout(), this.dragItemCount = Math.max(0, this.dragItemCount - 1), this.sortItemsByPosition(), c.disablePlacing(), this.unstamp(c.element) } }, j.bindDraggabillyEvents = function (a) { this._bindDraggabillyEvents(a, "on") }, j.unbindDraggabillyEvents = function (a) { this._bindDraggabillyEvents(a, "off") }, j._bindDraggabillyEvents = function (a, b) { var c = this.handleDraggabilly; a[b]("dragStart", c.dragStart), a[b]("dragMove", c.dragMove), a[b]("dragEnd", c.dragEnd) }, j.bindUIDraggableEvents = function (a) { this._bindUIDraggableEvents(a, "on") }, j.unbindUIDraggableEvents = function (a) { this._bindUIDraggableEvents(a, "off") }, j._bindUIDraggableEvents = function (a, b) { var c = this.handleUIDraggable; a[b]("dragstart", c.start)[b]("drag", c.drag)[b]("dragstop", c.stop) }; var l = j.destroy; return j.destroy = function () { l.apply(this, arguments), this.isEnabled = !1 }, i.Rect = c, i.Packer = d, i }), function (a, b) { "function" == typeof define && define.amd ? define(["isotope-layout/js/layout-mode", "packery/js/packery"], b) : "object" == typeof module && module.exports ? module.exports = b(require("isotope-layout/js/layout-mode"), require("packery")) : b(a.Isotope.LayoutMode, a.Packery) }(window, function (a, b) { var c = a.create("packery"), d = c.prototype, e = { _getElementOffset: !0, _getMeasurement: !0 }; for (var f in b.prototype) e[f] || (d[f] = b.prototype[f]); var g = d._resetLayout; d._resetLayout = function () { this.packer = this.packer || new b.Packer, this.shiftPacker = this.shiftPacker || new b.Packer, g.apply(this, arguments) }; var h = d._getItemLayoutPosition; d._getItemLayoutPosition = function (a) { return a.rect = a.rect || new b.Rect, h.call(this, a) }; var i = d.needsResizeLayout; d.needsResizeLayout = function () { return this._getOption("horizontal") ? this.needsVerticalResizeLayout() : i.call(this) }; var j = d._getOption; return d._getOption = function (a) { return "horizontal" == a ? void 0 !== this.options.isHorizontal ? this.options.isHorizontal : this.options.horizontal : j.apply(this.isotope, arguments) }, c });